(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.dm.bQ === region.ed.bQ)
	{
		return 'on line ' + region.dm.bQ;
	}
	return 'on lines ' + region.dm.bQ + ' through ' + region.ed.bQ;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hx,
		impl.jr,
		impl.i8,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		hT: func(record.hT),
		dn: record.dn,
		dd: record.dd
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.hT;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.dn;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.dd) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hx,
		impl.jr,
		impl.i8,
		function(sendToApp, initialModel) {
			var view = impl.jz;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.hx,
		impl.jr,
		impl.i8,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.dk && impl.dk(sendToApp)
			var view = impl.jz;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.dP);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.x) && (_VirtualDom_doc.title = title = doc.x);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.$8;
	var onUrlRequest = impl.ig;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		dk: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.fi === next.fi
							&& curr.ex === next.ex
							&& curr.e2.a === next.e2.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		hx: function(flags)
		{
			return A3(impl.hx, flags, _Browser_getUrl(), key);
		},
		jz: impl.jz,
		jr: impl.jr,
		i8: impl.i8
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { hu: 'hidden', a$: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { hu: 'mozHidden', a$: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { hu: 'msHidden', a$: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { hu: 'webkitHidden', a$: 'webkitvisibilitychange' }
		: { hu: 'hidden', a$: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		fx: _Browser_getScene(),
		f4: {
			gd: _Browser_window.pageXOffset,
			ge: _Browser_window.pageYOffset,
			gc: _Browser_doc.documentElement.clientWidth,
			ht: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		gc: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		ht: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			fx: {
				gc: node.scrollWidth,
				ht: node.scrollHeight
			},
			f4: {
				gd: node.scrollLeft,
				ge: node.scrollTop,
				gc: node.clientWidth,
				ht: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			fx: _Browser_getScene(),
			f4: {
				gd: x,
				ge: y,
				gc: _Browser_doc.documentElement.clientWidth,
				ht: _Browser_doc.documentElement.clientHeight
			},
			hb: {
				gd: x + rect.left,
				ge: y + rect.top,
				gc: rect.width,
				ht: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.a.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.a.b, xhr)); });
		$elm$core$Maybe$isJust(request.e) && _Http_track(router, xhr, request.e.a);

		try {
			xhr.open(request.c, request.js, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.js));
		}

		_Http_configureRequest(xhr, request);

		request.dP.a && xhr.setRequestHeader('Content-Type', request.dP.a);
		xhr.send(request.dP.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.b; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.d.a || 0;
	xhr.responseType = request.a.d;
	xhr.withCredentials = request.gq;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		js: xhr.responseURL,
		i5: xhr.status,
		i6: xhr.statusText,
		b: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			i_: event.loaded,
			dl: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			iE: event.loaded,
			dl: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = '';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $author$project$MainMsg$ChangedUrl = function (a) {
	return {$: 15, a: a};
};
var $author$project$MainMsg$ClickedLink = function (a) {
	return {$: 16, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.H) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.J);
		} else {
			var treeLen = builder.H * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.M) : builder.M;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.H);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.J) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.J);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{M: nodeList, H: (len / $elm$core$Array$branchFactor) | 0, J: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {er: fragment, ex: host, ij: path, e2: port_, fi: protocol, fj: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$MainMsg$ToAudEndDatePicker = function (a) {
	return {$: 86, a: a};
};
var $author$project$MainMsg$ToAudStartDatePicker = function (a) {
	return {$: 85, a: a};
};
var $author$project$MainMsg$ToCallEndDatePicker = function (a) {
	return {$: 89, a: a};
};
var $author$project$MainMsg$ToCallStartDatePicker = function (a) {
	return {$: 88, a: a};
};
var $author$project$MainMsg$ToFittingDatePicker = function (a) {
	return {$: 91, a: a};
};
var $author$project$MainMsg$ToProjectEndDatePicker = function (a) {
	return {$: 90, a: a};
};
var $author$project$MainMsg$ToProjectStartDatePicker = function (a) {
	return {$: 87, a: a};
};
var $author$project$MainMsg$ToShootDatePicker = function (a) {
	return {$: 92, a: a};
};
var $author$project$MainMsg$ToSubDatePicker = function (a) {
	return {$: 84, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Route$PageNotFound = {$: 17};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {a5: frag, ba: params, aY: unvisited, bj: value, bk: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.aY;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.bj);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.bj);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.ij),
					$elm$url$Url$Parser$prepareQuery(url.fj),
					url.er,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$Account = {$: 6};
var $author$project$Route$AccountSubPage = function (a) {
	return {$: 19, a: a};
};
var $author$project$Route$AccountVerification = F2(
	function (a, b) {
		return {$: 22, a: a, b: b};
	});
var $author$project$Route$AgencyProfile = {$: 15};
var $author$project$Route$AgencyRegistration = {$: 5};
var $author$project$Route$AgentProfile = {$: 16};
var $author$project$Route$AgentsSignupPage = function (a) {
	return {$: 27, a: a};
};
var $author$project$Route$CollaboratorsSignupPage = function (a) {
	return {$: 26, a: a};
};
var $author$project$Route$Dashboard = {$: 13};
var $author$project$Route$DayOfPage = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Route$DirectorRegistration = {$: 4};
var $author$project$Route$Inbox = {$: 10};
var $author$project$Route$Job = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$JobIndex = {$: 8};
var $author$project$Route$Login = {$: 0};
var $author$project$Route$MarketingDirectorRegistration = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$MarketingTalentRegistration = function (a) {
	return {$: 2, a: a};
};
var $author$project$Route$MyJobs = {$: 9};
var $author$project$Route$Project = function (a) {
	return {$: 21, a: a};
};
var $author$project$Route$Role = function (a) {
	return {$: 12, a: a};
};
var $author$project$Route$RoleIndex = {$: 11};
var $author$project$Route$ScheduleIndex = {$: 23};
var $author$project$Route$SchedulePage = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Route$TalentProfile = {$: 14};
var $author$project$Route$TalentRegistration = {$: 1};
var $author$project$Route$TalentSearch = {$: 20};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.bk;
		var unvisited = _v0.aY;
		var params = _v0.ba;
		var frag = _v0.a5;
		var value = _v0.bj;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.bk;
			var unvisited = _v1.aY;
			var params = _v1.ba;
			var frag = _v1.a5;
			var value = _v1.bj;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.bk;
		var unvisited = _v0.aY;
		var params = _v0.ba;
		var frag = _v0.a5;
		var value = _v0.bj;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.bk;
			var unvisited = _v0.aY;
			var params = _v0.ba;
			var frag = _v0.a5;
			var value = _v0.bj;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$routeParser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$Login, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Login,
			$elm$url$Url$Parser$s('login')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$DirectorRegistration,
			$elm$url$Url$Parser$s('casting-signup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$MarketingDirectorRegistration,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('casting-signup'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$MarketingTalentRegistration,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('talent-signup'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgencyRegistration,
			$elm$url$Url$Parser$s('agency-signup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TalentRegistration,
			$elm$url$Url$Parser$s('talent-signup')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RoleIndex,
			$elm$url$Url$Parser$s('roles')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Project,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('projects'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TalentSearch,
			$elm$url$Url$Parser$s('talent-search')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Account,
			$elm$url$Url$Parser$s('account/profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AccountSubPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('account'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TalentProfile,
			$elm$url$Url$Parser$s('talent-profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgencyProfile,
			$elm$url$Url$Parser$s('agency-profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgentProfile,
			$elm$url$Url$Parser$s('agent-profile')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Inbox,
			$elm$url$Url$Parser$s('inbox')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Dashboard,
			$elm$url$Url$Parser$s('dashboard')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Job,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('discover-jobs'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$JobIndex,
			$elm$url$Url$Parser$s('discover-jobs')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$MyJobs,
			$elm$url$Url$Parser$s('jobs')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Role,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('role'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AccountVerification,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('account'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ScheduleIndex,
			$elm$url$Url$Parser$s('schedules')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SchedulePage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('schedules'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$DayOfPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('schedule'),
				A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$CollaboratorsSignupPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('signup-collaborators'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$AgentsSignupPage,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('signup-agents'),
				$elm$url$Url$Parser$string))
		]));
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Route$fromUrl = function (url) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$PageNotFound,
		A2($elm$url$Url$Parser$parse, $author$project$Route$routeParser, url));
};
var $CurrySoftware$elm_datepicker$DatePicker$CurrentDate = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$DatePicker = $elm$core$Basics$identity;
var $elm$time$Time$May = 4;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$initDate = A3($justinmimbs$date$Date$fromCalendarDate, 1992, 4, 31);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.dm, posixMinutes) < 0) {
					return posixMinutes + era.id;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		g5: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		h$: month,
		jE: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).g5;
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).h$;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).jE;
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $justinmimbs$date$Date$today = A3($elm$core$Task$map2, $justinmimbs$date$Date$fromPosix, $elm$time$Time$here, $elm$time$Time$now);
var $CurrySoftware$elm_datepicker$DatePicker$init = _Utils_Tuple2(
	{
		ah: $elm$core$Maybe$Just($CurrySoftware$elm_datepicker$DatePicker$Date$initDate),
		aS: false,
		at: $elm$core$Maybe$Nothing,
		c9: false,
		bi: $CurrySoftware$elm_datepicker$DatePicker$Date$initDate
	},
	A2($elm$core$Task$perform, $CurrySoftware$elm_datepicker$DatePicker$CurrentDate, $justinmimbs$date$Date$today));
var $author$project$Utils$Closed = {$: 1};
var $author$project$Project$ClosedForm = 4;
var $author$project$Message$FetchingAllDataFromTwilio = 0;
var $author$project$SharedProjectRoleSchedules$Hidden = 0;
var $author$project$Utils$HiddenConf = {$: 5};
var $author$project$Project$HiddenForm = 1;
var $author$project$Model$Hiding = {$: 1};
var $author$project$SharedProjectRoleSchedules$Initial = 3;
var $author$project$User$Invalid = 5;
var $author$project$Message$LoadingMessages = {$: 0};
var $author$project$Model$LoggingIn = 1;
var $author$project$SharedProjectRoleSchedules$NoImageShowing = 0;
var $author$project$User$NoStage = 27;
var $author$project$Project$NotEditing = {$: 0};
var $author$project$MainMsg$NotFetched = {$: 1};
var $author$project$Schedule$PublishedModalClosed = 2;
var $author$project$SharedProjectRoleSchedules$ResumeWaiting = {$: 0};
var $author$project$Pipeline$StandardPipeline = {$: 0};
var $author$project$Pipeline$StandardView = 0;
var $author$project$Filter$TOff = 8;
var $author$project$SharedProjectRoleSchedules$Waiting = {$: 0};
var $author$project$User$emptyAddress = {bF: '', bG: '', dz: '', a0: '', e3: '', bf: '', cA: ''};
var $author$project$User$emptyAgency = {bF: '', bG: '', cF: '', gp: _List_Nil, a0: '', cL: '', bv: '', bx: '', aa: '', bP: '', eZ: '', bf: '', dv: ''};
var $author$project$User$emptySearchTalentProfile = {dA: 0, gj: $author$project$User$emptyAgency, gA: '', dT: false, a0: '', cK: '', gY: '', d4: 0, bv: '', eg: _List_Nil, hi: '', bx: '', hq: '', ck: '', cl: '', ht: 0, c$: '', l: _List_Nil, ez: false, bP: '', e0: '', ix: '', iH: $elm$core$Maybe$Nothing, iK: '', aX: '', iL: '', fA: _List_Nil, cz: false, i3: 27, bf: '', a_: _List_Nil, jA: 0, jC: 0};
var $author$project$Job$emptyApplicant = {aa: '', iJ: '', i3: 27, f_: $author$project$User$emptySearchTalentProfile, jt: ''};
var $author$project$Job$emptyApplication = {iJ: '', i3: 27, jt: ''};
var $author$project$Message$emptyChatFilterValues = {gu: false, iv: 'Project', iC: false, fr: 'Role', dh: _List_Nil, fF: ''};
var $author$project$User$Applied = 0;
var $author$project$User$Dateasc = 0;
var $author$project$Pipeline$emptyColumn = {g2: '', hm: 0, aa: '', hC: false, bS: '', io: 0, i2: 0, jx: _List_Nil};
var $author$project$User$emptyCompanyProfile = {gO: '', gP: '', gQ: '', gR: '', gS: ''};
var $author$project$SharedProjectRoleSchedules$emptyDashboardPage = {eR: _List_Nil, fh: _List_Nil, ft: _List_Nil, jb: _List_Nil, jl: _List_Nil};
var $author$project$Message$emptyConversation = {dI: false, cT: '', aa: '', hF: '', eE: '', hH: '', hL: '', hV: _List_Nil, iw: '', ix: '', iK: '', aX: '', iL: '', jc: '', jd: '', jf: '', bD: 0};
var $author$project$Message$emptyFromTwilioPayload = {n: _List_Nil, z: '', t: $author$project$Message$emptyConversation, hV: _List_Nil};
var $author$project$User$emptyImage = {aa: '', js: '/default_user.png'};
var $author$project$Job$Searching = 0;
var $author$project$Job$ViewingJobClosed = 1;
var $author$project$SharedProjectRoleSchedules$emptyBasicProjectData = {gk: '', dN: '', br: '', aa: '', hO: '', bS: '', e4: '', fc: '', ff: '', iy: '', ft: _List_Nil, i0: '', fJ: '', jb: $author$project$User$emptySearchTalentProfile, jg: '', jo: false};
var $author$project$Job$emptyJobPageData = {eR: _List_Nil, fh: _List_Nil, fE: 0, fF: '', fG: $author$project$SharedProjectRoleSchedules$emptyBasicProjectData, f3: 1};
var $author$project$Job$emptyNotification = {dP: '', gV: '', hK: '', aX: '', cA: ''};
var $author$project$User$AgentUser = 4;
var $author$project$User$PendingResponse = 2;
var $author$project$User$emptyAgent = {dw: false, dx: 2, cF: '', dJ: '', a0: '', bv: '', bx: '', aa: '', ey: '/default_user.png', hK: 4, bP: '', e0: '', fV: ''};
var $author$project$Profile$emptyProfilePageData = {cD: _List_Nil, b6: false, bL: $author$project$User$emptyAgent, d5: 0, de: false, bY: $author$project$MainMsg$NotFetched, fK: false, E: $author$project$MainMsg$NotFetched};
var $author$project$SharedProjectRoleSchedules$emptyDeadline = {bF: '', bG: '', a0: '', ee: '', hM: '', bS: '', fP: '', bf: '', dv: ''};
var $author$project$SharedProjectRoleSchedules$emptyProject = {
	gk: '',
	dI: false,
	cO: '',
	g6: _List_fromArray(
		[$author$project$SharedProjectRoleSchedules$emptyDeadline]),
	c$: '',
	hB: false,
	bS: '',
	A: _List_Nil,
	it: '',
	iy: '0',
	ft: _List_Nil,
	k: _List_Nil,
	jg: '',
	jo: false,
	jt: ''
};
var $author$project$User$emptyProxyImage = {aa: '', js: ''};
var $author$project$SharedProjectRoleSchedules$emptyRole = {gf: false, dI: false, g6: _List_Nil, eg: _List_Nil, hs: _List_Nil, c$: '', c2: 100, hP: 0, eM: 500, c4: 0, hW: 0, eQ: 0, bS: '', it: '', fe: '', iw: '', ix: '', iI: '', iM: ''};
var $author$project$Project$emptyRoleChangeInfo = {h4: '', aX: '', cA: ''};
var $author$project$User$Talent = 0;
var $author$project$User$emptyUserData = {cK: '', bv: '', bx: '', c$: '', bP: '', eU: '', eZ: '', e_: '', V: 0, iU: ''};
var $author$project$User$emptyUserPasswords = {cL: '', eU: '', eZ: ''};
var $author$project$User$emptyManualAgency = {cF: '', gl: '', gm: '', gn: '', go: ''};
var $author$project$User$emptyNotificationSettings = {gw: true, hV: true, is: true, aj: true, jb: true};
var $author$project$User$emptyUserProfile = {dA: 0, gj: $author$project$User$emptyAgency, cE: $author$project$User$emptyManualAgency, gp: _List_Nil, gA: '', a0: '', cK: '', bJ: $author$project$User$emptyCompanyProfile, g5: '', bv: '', eg: _List_Nil, hi: '', bx: '', hq: '', ht: 0, c$: '', l: _List_Nil, bP: '', c2: 0, c4: 0, h$: '', ic: $author$project$User$emptyNotificationSettings, bU: _List_Nil, e0: '', ct: _List_Nil, iH: $elm$core$Maybe$Nothing, V: 5, bf: '', C: '', f$: $author$project$User$emptyAddress, f0: $author$project$User$emptyAddress, jA: 0, jC: 0, jE: ''};
var $author$project$User$emptyVideo = {ef: false, aa: '', eI: '', bS: '', e$: false, fb: '0%', aX: '', fZ: '', js: '', ds: false};
var $author$project$InitData$initTalentFilterValues = {hj: _List_Nil, hr: _List_Nil, c2: '', hQ: '', eM: '', hR: '', c4: '', hX: '', eQ: '', hY: '', id: 0, iB: _List_Nil, iS: ''};
var $author$project$User$initialProfileValidations = {gA: false, eg: false, hi: false, hq: false, ht: false, l: false, jC: false};
var $author$project$Project$RoleMenuClosed = {$: 1};
var $author$project$Project$initialProjectMenuState = {ej: true, ek: true, el: true, di: $author$project$Project$RoleMenuClosed};
var $author$project$Views$DatePicker$initialRawDates = {gx: $elm$core$Maybe$Nothing, gy: $elm$core$Maybe$Nothing, gF: $elm$core$Maybe$Nothing, gG: $elm$core$Maybe$Nothing, ho: $elm$core$Maybe$Nothing, iu: $elm$core$Maybe$Nothing, iz: $elm$core$Maybe$Nothing, i0: $elm$core$Maybe$Nothing, i7: $elm$core$Maybe$Nothing};
var $author$project$SharedProjectRoleSchedules$DefaultSchedulePage = function (a) {
	return {$: 0, a: a};
};
var $author$project$SharedProjectRoleSchedules$NoScheduleForm = 0;
var $author$project$SharedProjectRoleSchedules$emptyCollaboratorForm = {gh: false, dX: _List_Nil, cK: '', bv: '', a4: false, cZ: false, bx: '', bP: '', c9: false, ik: '', cA: ''};
var $author$project$SharedProjectRoleSchedules$emptySchedule = {gB: '', gC: '', gH: 0, gW: '', hc: '', aa: '', bb: false, dh: _List_Nil, iN: '', ft: _List_Nil, fy: '', fB: '', i4: '', jk: 10, jl: _List_Nil};
var $author$project$SharedProjectRoleSchedules$emptyScheduleDeadline = {bF: '', bG: '', a0: '', ee: '', hM: '', bS: 'Audition', fP: '', bf: '', dv: ''};
var $author$project$SharedProjectRoleSchedules$emptyScheduleProject = {
	gk: '',
	dI: false,
	cO: '',
	g6: _List_fromArray(
		[$author$project$SharedProjectRoleSchedules$emptyScheduleDeadline]),
	c$: '',
	hB: false,
	bS: 'Select Project',
	A: _List_Nil,
	it: '',
	iy: '0',
	ft: _List_Nil,
	k: _List_Nil,
	jg: '',
	jo: false,
	jt: ''
};
var $author$project$User$emptyRoleInfo = {dZ: '', aa: '', bS: '', iw: ''};
var $author$project$User$emptyPipelineUser = {dA: 0, gj: $author$project$User$emptyAgency, dH: 27, gA: '', a0: '', cK: '', gY: '', bv: '', eg: _List_Nil, hi: '', bx: '', hq: '', ck: '', cl: '', ht: 0, c$: '', l: _List_Nil, bP: '', e0: '', ix: '', iH: $elm$core$Maybe$Nothing, V: $author$project$User$emptyRoleInfo, iK: '', aX: '', iL: '', fA: _List_Nil, cz: false, i3: 27, bf: '', a_: _List_Nil, jA: 0, jC: 0};
var $author$project$SharedProjectRoleSchedules$emptyUserSwapData = {Y: $author$project$User$emptyPipelineUser, a6: false, w: $author$project$User$emptyPipelineUser, iO: '', _: '', P: ''};
var $author$project$SharedProjectRoleSchedules$initialSchedulePageData = {
	gz: false,
	I: _List_Nil,
	bI: $author$project$SharedProjectRoleSchedules$emptyCollaboratorForm,
	dY: false,
	cb: '',
	a2: $author$project$SharedProjectRoleSchedules$emptySchedule,
	cf: $author$project$SharedProjectRoleSchedules$emptySchedule,
	ee: '',
	aj: $author$project$SharedProjectRoleSchedules$emptyScheduleProject,
	bb: false,
	fz: false,
	b_: 0,
	aK: $author$project$SharedProjectRoleSchedules$DefaultSchedulePage(''),
	fB: 'Audition',
	iP: _List_Nil,
	k: _List_Nil,
	iW: false,
	fL: false,
	fP: '',
	f2: $author$project$SharedProjectRoleSchedules$emptyUserSwapData
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$State$NoDropTarget = {$: 0};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$State = $elm$core$Basics$identity;
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState = {cg: $elm$core$Maybe$Nothing, bs: $arsduo$elm_dom_drag_drop$Dom$DragDrop$State$NoDropTarget};
var $author$project$Filter$initialTalentFilterExpands = {dB: true, eh: true, en: true, es: true, ev: true, eN: true, fM: true, gb: true};
var $author$project$User$MenuClosed = 1;
var $author$project$User$ModalClosed = {$: 0};
var $author$project$User$initialTalentMenuOptions = {g_: '', g0: '', h_: '', bR: $author$project$User$ModalClosed, aj: '', iD: '', fs: '', ft: _List_Nil, jb: $author$project$User$emptySearchTalentProfile, dr: 1};
var $author$project$Project$resetProjectValidation = {bS: false, it: false};
var $author$project$Role$resetRoleValidations = {eg: false, hq: false, c2: false, hP: false, eM: false, c4: false, hW: false, eQ: false, bS: false, fe: false, iI: false, iM: false};
var $author$project$Model$initialModel = function (key) {
	return function (url) {
		return function (flags) {
			return function (submissionDatePicker) {
				return function (audStartDatePicker) {
					return function (audEndDatePicker) {
						return function (projectStartDatePicker) {
							return function (callStartDatePicker) {
								return function (callEndDatePicker) {
									return function (projectEndDatePicker) {
										return function (fittingDatePicker) {
											return function (shootDatePicker) {
												return {
													aA: false,
													gj: $author$project$User$emptyAgency,
													f: $author$project$Model$Hiding,
													dD: _List_Nil,
													dE: _List_Nil,
													dF: _List_Nil,
													b7: $author$project$Message$LoadingMessages,
													F: _List_Nil,
													aB: _List_Nil,
													cG: _List_Nil,
													cH: $author$project$Job$emptyApplicant,
													dG: $author$project$Job$emptyApplication,
													cI: false,
													R: 1,
													aC: $author$project$User$emptyAddress,
													bo: '',
													ca: $author$project$Message$emptyChatFilterValues,
													dW: _List_Nil,
													gN: $author$project$Pipeline$emptyColumn,
													aR: '',
													bJ: $author$project$User$emptyCompanyProfile,
													q: false,
													ar: $author$project$Utils$HiddenConf,
													cP: _List_Nil,
													gY: '',
													bM: '',
													bq: $author$project$User$emptyImage,
													o: $author$project$Route$fromUrl(url),
													d6: '',
													g$: '',
													cd: 1,
													g1: '',
													ce: 27,
													cR: $author$project$User$emptyVideo,
													g3: $author$project$SharedProjectRoleSchedules$emptyDashboardPage,
													G: {dL: audEndDatePicker, dM: audStartDatePicker, dR: callEndDatePicker, dS: callStartDatePicker, eo: fittingDatePicker, fd: projectEndDatePicker, fg: projectStartDatePicker, fI: shootDatePicker, fS: submissionDatePicker},
													as: '',
													d8: '',
													a3: $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState,
													bt: false,
													cX: $author$project$Project$NotEditing,
													bv: '',
													eg: _List_Nil,
													hm: '',
													hn: '',
													aD: flags,
													c_: false,
													ap: 4,
													cj: 0,
													hs: _List_Nil,
													aE: $author$project$User$emptyProxyImage,
													ab: $author$project$SharedProjectRoleSchedules$Waiting,
													l: _List_Nil,
													S: $author$project$Job$emptyJobPageData,
													hI: '',
													eF: key,
													hN: false,
													eK: 0,
													eL: 0,
													a6: false,
													hV: _List_Nil,
													eO: 0,
													eP: 0,
													av: $author$project$Utils$Closed,
													eR: _List_Nil,
													L: {dP: ''},
													h3: _List_Nil,
													bT: $author$project$Job$emptyNotification,
													bU: _List_Nil,
													by: false,
													ii: $author$project$Pipeline$StandardPipeline,
													eZ: '',
													aH: $author$project$User$emptyAddress,
													A: _List_Nil,
													e5: _List_Nil,
													iq: '',
													e9: false,
													fa: '',
													h: $author$project$Profile$emptyProfilePageData,
													ay: $author$project$User$initialProfileValidations,
													aj: $author$project$SharedProjectRoleSchedules$emptyProject,
													aU: 1,
													df: '',
													bX: false,
													cu: false,
													aI: $author$project$Project$initialProjectMenuState,
													aV: '',
													aW: $author$project$Project$resetProjectValidation,
													cv: 2,
													aJ: 3,
													az: $author$project$Views$DatePicker$initialRawDates,
													cx: $author$project$SharedProjectRoleSchedules$ResumeWaiting,
													V: $author$project$SharedProjectRoleSchedules$emptyRole,
													bd: $author$project$Project$emptyRoleChangeInfo,
													am: 1,
													bZ: '',
													Z: $author$project$Role$resetRoleValidations,
													be: $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState,
													b$: $author$project$SharedProjectRoleSchedules$initialSchedulePageData,
													iR: '',
													iT: '',
													ac: '',
													bA: '',
													N: 0,
													B: _List_Nil,
													aL: false,
													ad: false,
													b0: '',
													aM: '',
													i2: 'asc',
													dq: false,
													K: 8,
													O: $author$project$Filter$initialTalentFilterExpands,
													r: $author$project$InitData$initTalentFilterValues,
													W: $author$project$User$initialTalentMenuOptions,
													fW: false,
													aN: false,
													bg: $author$project$MainMsg$NotFetched,
													x: 'Slayt',
													p: $author$project$Message$emptyFromTwilioPayload,
													aO: 0,
													aZ: $author$project$User$emptyUserData,
													jv: $author$project$User$emptyUserPasswords,
													E: $author$project$User$emptyUserProfile,
													X: $author$project$MainMsg$NotFetched,
													f1: 5,
													jw: 0,
													cB: $author$project$SharedProjectRoleSchedules$Waiting,
													m: $author$project$SharedProjectRoleSchedules$emptyProject,
													v: $author$project$User$emptySearchTalentProfile,
													b5: 0
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Main$getUserToken = _Platform_outgoingPort('getUserToken', $elm$json$Json$Encode$string);
var $author$project$Main$loadData = function (page) {
	return $author$project$Main$getUserToken('');
};
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$init = F3(
	function (key, url, flags) {
		var _v0 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var submissionDatePicker = _v0.a;
		var submissionDatePickerCmd = _v0.b;
		var _v1 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var shootDatePicker = _v1.a;
		var shootDatePickerCmd = _v1.b;
		var _v2 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var projectStartDatePicker = _v2.a;
		var projectStartDatePickerCmd = _v2.b;
		var _v3 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var projectEndDatePicker = _v3.a;
		var projectEndDatePickerCmd = _v3.b;
		var _v4 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var fittingDatePicker = _v4.a;
		var fittingDatePickerCmd = _v4.b;
		var _v5 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var callStartDatePicker = _v5.a;
		var callStartDatePickerCmd = _v5.b;
		var _v6 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var callEndDatePicker = _v6.a;
		var callEndDatePickerCmd = _v6.b;
		var _v7 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var audStartDatePicker = _v7.a;
		var audStartDatePickerCmd = _v7.b;
		var _v8 = $CurrySoftware$elm_datepicker$DatePicker$init;
		var audEndDatePicker = _v8.a;
		var audEndDatePickerCmd = _v8.b;
		var model = $author$project$Model$initialModel(key)(url)(flags)(submissionDatePicker)(audStartDatePicker)(audEndDatePicker)(projectStartDatePicker)(callStartDatePicker)(callEndDatePicker)(projectEndDatePicker)(fittingDatePicker)(shootDatePicker);
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Main$loadData(
						$author$project$Route$fromUrl(url)),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToSubDatePicker, submissionDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToAudStartDatePicker, audStartDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToAudEndDatePicker, audEndDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToProjectStartDatePicker, projectStartDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToCallStartDatePicker, callStartDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToCallEndDatePicker, callEndDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToProjectEndDatePicker, projectEndDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToFittingDatePicker, fittingDatePickerCmd),
						A2($elm$core$Platform$Cmd$map, $author$project$MainMsg$ToShootDatePicker, shootDatePickerCmd)
					])));
	});
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$MainMsg$DataReceivedFromTwilio = function (a) {
	return {$: 225, a: a};
};
var $author$project$MainMsg$ReceiveSignInTokens = function (a) {
	return {$: 76, a: a};
};
var $author$project$MainMsg$ReceiveSignUpTokens = function (a) {
	return {$: 77, a: a};
};
var $author$project$MainMsg$ReceiveToken = function (a) {
	return {$: 80, a: a};
};
var $author$project$MainMsg$RefreshProjectData = F2(
	function (a, b) {
		return {$: 281, a: a, b: b};
	});
var $author$project$MainMsg$RefreshViewingTalent = F2(
	function (a, b) {
		return {$: 292, a: a, b: b};
	});
var $author$project$MainMsg$SignInError = function (a) {
	return {$: 39, a: a};
};
var $author$project$MainMsg$SignUpError = function (a) {
	return {$: 79, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Main$dataFromTwilio = _Platform_incomingPort(
	'dataFromTwilio',
	A2(
		$elm$json$Json$Decode$andThen,
		function (messages) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (currentChannel) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (cmd) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (channels) {
									return $elm$json$Json$Decode$succeed(
										{n: channels, z: cmd, t: currentChannel, hV: messages});
								},
								A2(
									$elm$json$Json$Decode$field,
									'channels',
									$elm$json$Json$Decode$list(
										A2(
											$elm$json$Json$Decode$andThen,
											function (unreadMessages) {
												return A2(
													$elm$json$Json$Decode$andThen,
													function (talentName) {
														return A2(
															$elm$json$Json$Decode$andThen,
															function (talentId) {
																return A2(
																	$elm$json$Json$Decode$andThen,
																	function (talentAvatar) {
																		return A2(
																			$elm$json$Json$Decode$andThen,
																			function (roleName) {
																				return A2(
																					$elm$json$Json$Decode$andThen,
																					function (roleMemberId) {
																						return A2(
																							$elm$json$Json$Decode$andThen,
																							function (roleId) {
																								return A2(
																									$elm$json$Json$Decode$andThen,
																									function (projectName) {
																										return A2(
																											$elm$json$Json$Decode$andThen,
																											function (projectId) {
																												return A2(
																													$elm$json$Json$Decode$andThen,
																													function (messages) {
																														return A2(
																															$elm$json$Json$Decode$andThen,
																															function (lastMessage) {
																																return A2(
																																	$elm$json$Json$Decode$andThen,
																																	function (jobPosterName) {
																																		return A2(
																																			$elm$json$Json$Decode$andThen,
																																			function (jobPosterId) {
																																				return A2(
																																					$elm$json$Json$Decode$andThen,
																																					function (jobPosterAvatar) {
																																						return A2(
																																							$elm$json$Json$Decode$andThen,
																																							function (id) {
																																								return A2(
																																									$elm$json$Json$Decode$andThen,
																																									function (dateUpdated) {
																																										return A2(
																																											$elm$json$Json$Decode$andThen,
																																											function (archived) {
																																												return $elm$json$Json$Decode$succeed(
																																													{dI: archived, cT: dateUpdated, aa: id, hF: jobPosterAvatar, eE: jobPosterId, hH: jobPosterName, hL: lastMessage, hV: messages, iw: projectId, ix: projectName, iK: roleId, aX: roleMemberId, iL: roleName, jc: talentAvatar, jd: talentId, jf: talentName, bD: unreadMessages});
																																											},
																																											A2($elm$json$Json$Decode$field, 'archived', $elm$json$Json$Decode$bool));
																																									},
																																									A2($elm$json$Json$Decode$field, 'dateUpdated', $elm$json$Json$Decode$string));
																																							},
																																							A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
																																					},
																																					A2($elm$json$Json$Decode$field, 'jobPosterAvatar', $elm$json$Json$Decode$string));
																																			},
																																			A2($elm$json$Json$Decode$field, 'jobPosterId', $elm$json$Json$Decode$string));
																																	},
																																	A2($elm$json$Json$Decode$field, 'jobPosterName', $elm$json$Json$Decode$string));
																															},
																															A2($elm$json$Json$Decode$field, 'lastMessage', $elm$json$Json$Decode$string));
																													},
																													A2(
																														$elm$json$Json$Decode$field,
																														'messages',
																														$elm$json$Json$Decode$list(
																															A2(
																																$elm$json$Json$Decode$andThen,
																																function (timeStamp) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (size) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (name) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (messageType) {
																																							return A2(
																																								$elm$json$Json$Decode$andThen,
																																								function (id) {
																																									return A2(
																																										$elm$json$Json$Decode$andThen,
																																										function (fileName) {
																																											return A2(
																																												$elm$json$Json$Decode$andThen,
																																												function (downloadUrl) {
																																													return A2(
																																														$elm$json$Json$Decode$andThen,
																																														function (creatorId) {
																																															return A2(
																																																$elm$json$Json$Decode$andThen,
																																																function (conversationId) {
																																																	return A2(
																																																		$elm$json$Json$Decode$andThen,
																																																		function (contentType) {
																																																			return A2(
																																																				$elm$json$Json$Decode$andThen,
																																																				function (body) {
																																																					return $elm$json$Json$Decode$succeed(
																																																						{dP: body, cN: contentType, gV: conversationId, gW: creatorId, bN: downloadUrl, bw: fileName, aa: id, aF: messageType, bS: name, dl: size, bh: timeStamp});
																																																				},
																																																				A2($elm$json$Json$Decode$field, 'body', $elm$json$Json$Decode$string));
																																																		},
																																																		A2($elm$json$Json$Decode$field, 'contentType', $elm$json$Json$Decode$string));
																																																},
																																																A2($elm$json$Json$Decode$field, 'conversationId', $elm$json$Json$Decode$string));
																																														},
																																														A2($elm$json$Json$Decode$field, 'creatorId', $elm$json$Json$Decode$string));
																																												},
																																												A2($elm$json$Json$Decode$field, 'downloadUrl', $elm$json$Json$Decode$string));
																																										},
																																										A2($elm$json$Json$Decode$field, 'fileName', $elm$json$Json$Decode$string));
																																								},
																																								A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
																																						},
																																						A2($elm$json$Json$Decode$field, 'messageType', $elm$json$Json$Decode$string));
																																				},
																																				A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'size', $elm$json$Json$Decode$int));
																																},
																																A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$string)))));
																											},
																											A2($elm$json$Json$Decode$field, 'projectId', $elm$json$Json$Decode$string));
																									},
																									A2($elm$json$Json$Decode$field, 'projectName', $elm$json$Json$Decode$string));
																							},
																							A2($elm$json$Json$Decode$field, 'roleId', $elm$json$Json$Decode$string));
																					},
																					A2($elm$json$Json$Decode$field, 'roleMemberId', $elm$json$Json$Decode$string));
																			},
																			A2($elm$json$Json$Decode$field, 'roleName', $elm$json$Json$Decode$string));
																	},
																	A2($elm$json$Json$Decode$field, 'talentAvatar', $elm$json$Json$Decode$string));
															},
															A2($elm$json$Json$Decode$field, 'talentId', $elm$json$Json$Decode$string));
													},
													A2($elm$json$Json$Decode$field, 'talentName', $elm$json$Json$Decode$string));
											},
											A2($elm$json$Json$Decode$field, 'unreadMessages', $elm$json$Json$Decode$int)))));
						},
						A2($elm$json$Json$Decode$field, 'cmd', $elm$json$Json$Decode$string));
				},
				A2(
					$elm$json$Json$Decode$field,
					'currentChannel',
					A2(
						$elm$json$Json$Decode$andThen,
						function (unreadMessages) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (talentName) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (talentId) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (talentAvatar) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (roleName) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (roleMemberId) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (roleId) {
																			return A2(
																				$elm$json$Json$Decode$andThen,
																				function (projectName) {
																					return A2(
																						$elm$json$Json$Decode$andThen,
																						function (projectId) {
																							return A2(
																								$elm$json$Json$Decode$andThen,
																								function (messages) {
																									return A2(
																										$elm$json$Json$Decode$andThen,
																										function (lastMessage) {
																											return A2(
																												$elm$json$Json$Decode$andThen,
																												function (jobPosterName) {
																													return A2(
																														$elm$json$Json$Decode$andThen,
																														function (jobPosterId) {
																															return A2(
																																$elm$json$Json$Decode$andThen,
																																function (jobPosterAvatar) {
																																	return A2(
																																		$elm$json$Json$Decode$andThen,
																																		function (id) {
																																			return A2(
																																				$elm$json$Json$Decode$andThen,
																																				function (dateUpdated) {
																																					return A2(
																																						$elm$json$Json$Decode$andThen,
																																						function (archived) {
																																							return $elm$json$Json$Decode$succeed(
																																								{dI: archived, cT: dateUpdated, aa: id, hF: jobPosterAvatar, eE: jobPosterId, hH: jobPosterName, hL: lastMessage, hV: messages, iw: projectId, ix: projectName, iK: roleId, aX: roleMemberId, iL: roleName, jc: talentAvatar, jd: talentId, jf: talentName, bD: unreadMessages});
																																						},
																																						A2($elm$json$Json$Decode$field, 'archived', $elm$json$Json$Decode$bool));
																																				},
																																				A2($elm$json$Json$Decode$field, 'dateUpdated', $elm$json$Json$Decode$string));
																																		},
																																		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
																																},
																																A2($elm$json$Json$Decode$field, 'jobPosterAvatar', $elm$json$Json$Decode$string));
																														},
																														A2($elm$json$Json$Decode$field, 'jobPosterId', $elm$json$Json$Decode$string));
																												},
																												A2($elm$json$Json$Decode$field, 'jobPosterName', $elm$json$Json$Decode$string));
																										},
																										A2($elm$json$Json$Decode$field, 'lastMessage', $elm$json$Json$Decode$string));
																								},
																								A2(
																									$elm$json$Json$Decode$field,
																									'messages',
																									$elm$json$Json$Decode$list(
																										A2(
																											$elm$json$Json$Decode$andThen,
																											function (timeStamp) {
																												return A2(
																													$elm$json$Json$Decode$andThen,
																													function (size) {
																														return A2(
																															$elm$json$Json$Decode$andThen,
																															function (name) {
																																return A2(
																																	$elm$json$Json$Decode$andThen,
																																	function (messageType) {
																																		return A2(
																																			$elm$json$Json$Decode$andThen,
																																			function (id) {
																																				return A2(
																																					$elm$json$Json$Decode$andThen,
																																					function (fileName) {
																																						return A2(
																																							$elm$json$Json$Decode$andThen,
																																							function (downloadUrl) {
																																								return A2(
																																									$elm$json$Json$Decode$andThen,
																																									function (creatorId) {
																																										return A2(
																																											$elm$json$Json$Decode$andThen,
																																											function (conversationId) {
																																												return A2(
																																													$elm$json$Json$Decode$andThen,
																																													function (contentType) {
																																														return A2(
																																															$elm$json$Json$Decode$andThen,
																																															function (body) {
																																																return $elm$json$Json$Decode$succeed(
																																																	{dP: body, cN: contentType, gV: conversationId, gW: creatorId, bN: downloadUrl, bw: fileName, aa: id, aF: messageType, bS: name, dl: size, bh: timeStamp});
																																															},
																																															A2($elm$json$Json$Decode$field, 'body', $elm$json$Json$Decode$string));
																																													},
																																													A2($elm$json$Json$Decode$field, 'contentType', $elm$json$Json$Decode$string));
																																											},
																																											A2($elm$json$Json$Decode$field, 'conversationId', $elm$json$Json$Decode$string));
																																									},
																																									A2($elm$json$Json$Decode$field, 'creatorId', $elm$json$Json$Decode$string));
																																							},
																																							A2($elm$json$Json$Decode$field, 'downloadUrl', $elm$json$Json$Decode$string));
																																					},
																																					A2($elm$json$Json$Decode$field, 'fileName', $elm$json$Json$Decode$string));
																																			},
																																			A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
																																	},
																																	A2($elm$json$Json$Decode$field, 'messageType', $elm$json$Json$Decode$string));
																															},
																															A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
																													},
																													A2($elm$json$Json$Decode$field, 'size', $elm$json$Json$Decode$int));
																											},
																											A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$string)))));
																						},
																						A2($elm$json$Json$Decode$field, 'projectId', $elm$json$Json$Decode$string));
																				},
																				A2($elm$json$Json$Decode$field, 'projectName', $elm$json$Json$Decode$string));
																		},
																		A2($elm$json$Json$Decode$field, 'roleId', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'roleMemberId', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'roleName', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'talentAvatar', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'talentId', $elm$json$Json$Decode$string));
								},
								A2($elm$json$Json$Decode$field, 'talentName', $elm$json$Json$Decode$string));
						},
						A2($elm$json$Json$Decode$field, 'unreadMessages', $elm$json$Json$Decode$int))));
		},
		A2(
			$elm$json$Json$Decode$field,
			'messages',
			$elm$json$Json$Decode$list(
				A2(
					$elm$json$Json$Decode$andThen,
					function (timeStamp) {
						return A2(
							$elm$json$Json$Decode$andThen,
							function (size) {
								return A2(
									$elm$json$Json$Decode$andThen,
									function (name) {
										return A2(
											$elm$json$Json$Decode$andThen,
											function (messageType) {
												return A2(
													$elm$json$Json$Decode$andThen,
													function (id) {
														return A2(
															$elm$json$Json$Decode$andThen,
															function (fileName) {
																return A2(
																	$elm$json$Json$Decode$andThen,
																	function (downloadUrl) {
																		return A2(
																			$elm$json$Json$Decode$andThen,
																			function (creatorId) {
																				return A2(
																					$elm$json$Json$Decode$andThen,
																					function (conversationId) {
																						return A2(
																							$elm$json$Json$Decode$andThen,
																							function (contentType) {
																								return A2(
																									$elm$json$Json$Decode$andThen,
																									function (body) {
																										return $elm$json$Json$Decode$succeed(
																											{dP: body, cN: contentType, gV: conversationId, gW: creatorId, bN: downloadUrl, bw: fileName, aa: id, aF: messageType, bS: name, dl: size, bh: timeStamp});
																									},
																									A2($elm$json$Json$Decode$field, 'body', $elm$json$Json$Decode$string));
																							},
																							A2($elm$json$Json$Decode$field, 'contentType', $elm$json$Json$Decode$string));
																					},
																					A2($elm$json$Json$Decode$field, 'conversationId', $elm$json$Json$Decode$string));
																			},
																			A2($elm$json$Json$Decode$field, 'creatorId', $elm$json$Json$Decode$string));
																	},
																	A2($elm$json$Json$Decode$field, 'downloadUrl', $elm$json$Json$Decode$string));
															},
															A2($elm$json$Json$Decode$field, 'fileName', $elm$json$Json$Decode$string));
													},
													A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string));
											},
											A2($elm$json$Json$Decode$field, 'messageType', $elm$json$Json$Decode$string));
									},
									A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string));
							},
							A2($elm$json$Json$Decode$field, 'size', $elm$json$Json$Decode$int));
					},
					A2($elm$json$Json$Decode$field, 'timeStamp', $elm$json$Json$Decode$string))))));
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {e8: processes, fU: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.e8;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.fU);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Main$toElmSignIn = _Platform_incomingPort('toElmSignIn', $elm$json$Json$Decode$string);
var $author$project$Main$toElmSignInError = _Platform_incomingPort('toElmSignInError', $elm$json$Json$Decode$string);
var $author$project$Main$toElmSignUp = _Platform_incomingPort('toElmSignUp', $elm$json$Json$Decode$string);
var $author$project$Main$toElmSignUpError = _Platform_incomingPort('toElmSignUpError', $elm$json$Json$Decode$string);
var $author$project$Main$toElmToken = _Platform_incomingPort('toElmToken', $elm$json$Json$Decode$string);
var $author$project$Main$loginMessages = _List_fromArray(
	[
		$author$project$Main$toElmSignIn($author$project$MainMsg$ReceiveSignInTokens),
		$author$project$Main$toElmSignUp($author$project$MainMsg$ReceiveSignUpTokens),
		$author$project$Main$toElmToken($author$project$MainMsg$ReceiveToken),
		$author$project$Main$toElmSignUpError($author$project$MainMsg$SignUpError),
		$author$project$Main$toElmSignInError($author$project$MainMsg$SignInError)
	]);
var $author$project$MainMsg$FetchRefreshToken = function (a) {
	return {$: 148, a: a};
};
var $author$project$MainMsg$GetDataUpdates = function (a) {
	return {$: 75, a: a};
};
var $author$project$MainMsg$GetNotificationUpdates = function (a) {
	return {$: 239, a: a};
};
var $author$project$MainMsg$GotProgress = function (a) {
	return {$: 125, a: a};
};
var $author$project$MainMsg$GotVideoProgress = function (a) {
	return {$: 126, a: a};
};
var $author$project$MainMsg$PasswordEmailSent = function (a) {
	return {$: 309, a: a};
};
var $author$project$MainMsg$ReceivedCroppedUrl = function (a) {
	return {$: 255, a: a};
};
var $author$project$Main$croppedUrl = _Platform_incomingPort('croppedUrl', $elm$json$Json$Decode$string);
var $author$project$Main$passwordEmailSent = _Platform_incomingPort('passwordEmailSent', $elm$json$Json$Decode$string);
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {fm: reqs, fT: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.e;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.fm));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.fT)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					gq: r.gq,
					dP: r.dP,
					a: A2(_Http_mapExpect, func, r.a),
					b: r.b,
					c: r.c,
					d: r.d,
					e: r.e,
					js: r.js
				});
		}
	});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$track = F2(
	function (tracker, toMsg) {
		return $elm$http$Http$subscription(
			A2($elm$http$Http$MySub, tracker, toMsg));
	});
var $author$project$Main$subMessages = _List_fromArray(
	[
		A2($elm$time$Time$every, 300000000, $author$project$MainMsg$GetDataUpdates),
		A2($elm$time$Time$every, 330000000, $author$project$MainMsg$FetchRefreshToken),
		A2($elm$time$Time$every, 20000000, $author$project$MainMsg$GetNotificationUpdates),
		$author$project$Main$toElmSignIn($author$project$MainMsg$ReceiveSignInTokens),
		$author$project$Main$toElmSignUp($author$project$MainMsg$ReceiveSignUpTokens),
		$author$project$Main$toElmToken($author$project$MainMsg$ReceiveToken),
		$author$project$Main$toElmSignUpError($author$project$MainMsg$SignUpError),
		$author$project$Main$toElmSignInError($author$project$MainMsg$SignInError),
		A2($elm$http$Http$track, 'upload', $author$project$MainMsg$GotProgress),
		A2($elm$http$Http$track, 'uploadVideo', $author$project$MainMsg$GotVideoProgress),
		$author$project$Main$croppedUrl($author$project$MainMsg$ReceivedCroppedUrl),
		$author$project$Main$passwordEmailSent($author$project$MainMsg$PasswordEmailSent),
		$author$project$Main$dataFromTwilio($author$project$MainMsg$DataReceivedFromTwilio)
	]);
var $author$project$Main$subscriptions = function (model) {
	var _v0 = model.o;
	switch (_v0.$) {
		case 10:
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$author$project$Main$toElmSignIn($author$project$MainMsg$ReceiveSignInTokens),
						$author$project$Main$toElmSignUp($author$project$MainMsg$ReceiveSignUpTokens),
						$author$project$Main$toElmToken($author$project$MainMsg$ReceiveToken),
						$author$project$Main$toElmSignUpError($author$project$MainMsg$SignUpError),
						$author$project$Main$toElmSignInError($author$project$MainMsg$SignInError),
						$author$project$Main$dataFromTwilio($author$project$MainMsg$DataReceivedFromTwilio)
					]));
		case 25:
			var projectId = _v0.a;
			var scheduleId = _v0.b;
			return $elm$core$Platform$Sub$batch(
				_Utils_ap(
					$author$project$Main$subMessages,
					_List_fromArray(
						[
							A2(
							$elm$time$Time$every,
							10000000,
							function (time) {
								return A2($author$project$MainMsg$RefreshProjectData, time, projectId);
							}),
							A2(
							$elm$time$Time$every,
							10000,
							function (time) {
								return A2($author$project$MainMsg$RefreshViewingTalent, time, model.v.aX);
							})
						])));
		case 0:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 1:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 2:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 3:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 4:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 5:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 26:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		case 27:
			return $elm$core$Platform$Sub$batch($author$project$Main$loginMessages);
		default:
			return $elm$core$Platform$Sub$batch($author$project$Main$subMessages);
	}
};
var $author$project$User$AcceptedApplicationRequest = 3;
var $author$project$User$AcceptedAudition = 6;
var $author$project$User$AcceptedBooking = 18;
var $author$project$User$AcceptedCallBack = 12;
var $author$project$RoleForms$AddEthnicity = 2;
var $author$project$RoleForms$AddGender = 0;
var $author$project$User$AppliedToRole = 0;
var $author$project$Model$AudEnd = 2;
var $author$project$Model$AudStart = 1;
var $author$project$SharedProjectRoleSchedules$Body = $elm$core$Basics$identity;
var $author$project$Model$CallEnd = 5;
var $author$project$Model$CallStart = 4;
var $author$project$User$CanceledAudition = 10;
var $author$project$User$CanceledCallBack = 16;
var $author$project$MainMsg$ChatFileToString = function (a) {
	return {$: 228, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollaboratorAdded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Project$CreateRoleForm = 2;
var $author$project$MainMsg$CreateUser = {$: 78};
var $author$project$Utils$DeleteProject = {$: 3};
var $author$project$Project$Edit = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$Failed = function (a) {
	return {$: 0, a: a};
};
var $author$project$Model$Fitting = 7;
var $author$project$Utils$ForbiddenBookingColumn = {$: 7};
var $author$project$Utils$ForbiddenScheduleColumn = function (a) {
	return {$: 6, a: a};
};
var $author$project$SharedProjectRoleSchedules$FullScreen = 2;
var $author$project$MainMsg$GoToPage = function (a) {
	return {$: 295, a: a};
};
var $author$project$MainMsg$GotFile = F2(
	function (a, b) {
		return {$: 118, a: a, b: b};
	});
var $author$project$MainMsg$GotResume = F2(
	function (a, b) {
		return {$: 119, a: a, b: b};
	});
var $author$project$User$GotTalentInfo = function (a) {
	return {$: 2, a: a};
};
var $author$project$MainMsg$GotVideoFile = F2(
	function (a, b) {
		return {$: 121, a: a, b: b};
	});
var $author$project$SharedProjectRoleSchedules$JobSearchAction = 0;
var $author$project$Job$LandedOnPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$LoadMore = {$: 249};
var $author$project$SharedProjectRoleSchedules$LoadingScheduleData = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$MainMsg$Loadings = {$: 2};
var $author$project$Model$LoggedIn = 2;
var $author$project$MainMsg$Logout = {$: 32};
var $author$project$User$MenuOpen = 0;
var $author$project$User$MessageReceived = 20;
var $author$project$Message$Messages = function (a) {
	return {$: 1, a: a};
};
var $andrewMacmurray$elm_delay$Delay$Millisecond = 0;
var $author$project$MainMsg$NewMessageMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$MainMsg$NoOp = {$: 0};
var $author$project$Model$NotLoggedIn = 0;
var $author$project$Project$Pending = 0;
var $author$project$User$PendingApplicationRequest = 2;
var $author$project$User$PendingAudition = 5;
var $author$project$User$PendingBooking = 17;
var $author$project$User$PendingCallBack = 11;
var $author$project$SharedProjectRoleSchedules$PipelineUpdate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$ProfileInfo = 0;
var $author$project$Route$ProfileSubPage = function (a) {
	return {$: 18, a: a};
};
var $author$project$Model$ProjectEnd = 6;
var $author$project$Model$ProjectStart = 3;
var $author$project$MainMsg$PublishProject = {$: 156};
var $author$project$MainMsg$PublishRole = {$: 244};
var $author$project$Schedule$PublishScheduleUpdate = function (a) {
	return {$: 11, a: a};
};
var $author$project$SharedProjectRoleSchedules$QuickMessage = 1;
var $author$project$MainMsg$RedirectPage = function (a) {
	return {$: 136, a: a};
};
var $author$project$User$RejectedApplicationRequest = 4;
var $author$project$User$RejectedAudition = 7;
var $author$project$User$RejectedBooking = 19;
var $author$project$User$RejectedCallBack = 13;
var $author$project$RoleForms$RemoveEthnicity = 4;
var $author$project$RoleForms$RemoveGender = 1;
var $author$project$User$RescheduleAuditionRequest = 8;
var $author$project$User$RescheduleCallBackRequest = 14;
var $author$project$User$RescheduledAudition = 9;
var $author$project$User$RescheduledCallBack = 15;
var $author$project$Schedule$ResetSchedulePageData = {$: 6};
var $author$project$User$RoleCanceled = 21;
var $author$project$User$RoleChanged = 22;
var $author$project$Project$Saving = 2;
var $author$project$SharedProjectRoleSchedules$SavingSchedule = 3;
var $author$project$Schedule$ScheduleDataLoading = {$: 7};
var $author$project$Schedule$ScheduleDataUpdate = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$SharedProjectRoleSchedules$ScheduleDayOfPage = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Schedule$ScheduleFormViewUpdate = function (a) {
	return {$: 0, a: a};
};
var $author$project$Schedule$ScheduleListUpdate = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Schedule$SchedulePageViewUpdate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Schedule$ScheduleProjectUpdate = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$MainMsg$SearchJobs = {$: 304};
var $author$project$Job$SearchResults = function (a) {
	return {$: 5, a: a};
};
var $author$project$MainMsg$SearchUsers = {$: 140};
var $author$project$Job$SearchingJobs = {$: 2};
var $author$project$MainMsg$SetToLoggedIn = {$: 137};
var $author$project$Model$Shoot = 8;
var $author$project$Model$Showing = function (a) {
	return {$: 0, a: a};
};
var $author$project$SharedProjectRoleSchedules$ShowingMini = 1;
var $author$project$Model$Submission = 0;
var $author$project$MainMsg$Successs = function (a) {
	return {$: 3, a: a};
};
var $author$project$Schedule$SwitchViewingSchedules = function (a) {
	return {$: 4, a: a};
};
var $author$project$SharedProjectRoleSchedules$TalentSearchAction = 1;
var $author$project$MainMsg$Timeout = F2(
	function (a, b) {
		return {$: 259, a: a, b: b};
	});
var $author$project$MainMsg$ToggleColumnMenu = function (a) {
	return {$: 159, a: a};
};
var $author$project$MainMsg$ToggleFormOpen = function (a) {
	return {$: 24, a: a};
};
var $author$project$User$ToggleMenuModal = function (a) {
	return {$: 3, a: a};
};
var $author$project$Project$ToggleRoleMenu = function (a) {
	return {$: 3, a: a};
};
var $author$project$MainMsg$TypingEnded = function (a) {
	return {$: 263, a: a};
};
var $author$project$MainMsg$UpdateCollaboratorData = function (a) {
	return {$: 265, a: a};
};
var $author$project$SharedProjectRoleSchedules$UpdateCollaborators = function (a) {
	return {$: 7, a: a};
};
var $author$project$Schedule$UpdateCollaboratorsModal = {$: 13};
var $author$project$MainMsg$UpdateCurrentProjectId = function (a) {
	return {$: 93, a: a};
};
var $author$project$Schedule$UpdateMyComment = function (a) {
	return {$: 14, a: a};
};
var $author$project$MainMsg$UpdateProfileHeightValue = {$: 82};
var $author$project$Project$UpdateProjectForm = 1;
var $author$project$MainMsg$UpdateProjectMenuState = function (a) {
	return {$: 242, a: a};
};
var $author$project$MainMsg$UpdateSearchingRole = function (a) {
	return {$: 313, a: a};
};
var $author$project$Schedule$UpdateTimeSlot = function (a) {
	return {$: 5, a: a};
};
var $author$project$MainMsg$UpdateVotingComment = function (a) {
	return {$: 280, a: a};
};
var $author$project$SharedProjectRoleSchedules$Uploading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Project$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Schedule$User = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$RoleForms$UserAddEthnicity = 3;
var $author$project$User$UserEmail = function (a) {
	return {$: 2, a: a};
};
var $author$project$RoleForms$UserRemoveEthnicity = 5;
var $author$project$SharedProjectRoleSchedules$UserSwapData = F6(
	function (menuOpen, movingUser, droppedOnUser, timeSlotDroppedOn, timeSlotMovedFrom, scheduleId) {
		return {Y: droppedOnUser, a6: menuOpen, w: movingUser, iO: scheduleId, _: timeSlotDroppedOn, P: timeSlotMovedFrom};
	});
var $author$project$Schedule$UserSwapDataUpdate = function (a) {
	return {$: 9, a: a};
};
var $author$project$MainMsg$VerifyCollabForm = function (a) {
	return {$: 266, a: a};
};
var $author$project$SharedProjectRoleSchedules$VerifyForm = {$: 6};
var $author$project$SharedProjectRoleSchedules$VerifyInput = 2;
var $author$project$MainMsg$View = function (a) {
	return {$: 21, a: a};
};
var $author$project$MainMsg$ViewThenMarkAsRead = F2(
	function (a, b) {
		return {$: 238, a: a, b: b};
	});
var $author$project$SharedProjectRoleSchedules$Votes = 4;
var $author$project$SharedProjectRoleSchedules$VotesComments = 5;
var $author$project$MainMsg$AgentAdded = function (a) {
	return {$: 262, a: a};
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$Encoders$addAgentEncoder = F2(
	function (agentId, agencyId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'agent_id',
					$elm$json$Json$Encode$string(agentId)),
					_Utils_Tuple2(
					'agency_id',
					$elm$json$Json$Encode$string(agencyId))
				]));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Api$Request$authorizationHeader = function (token) {
	return A2($elm$http$Http$header, 'jwt', token);
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.i5));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{gq: false, dP: r.dP, a: r.a, b: r.b, c: r.c, d: r.d, e: r.e, js: r.js}));
};
var $author$project$Api$Request$talentSourceUrl = 'https://slayt-live-production.herokuapp.com/';
var $author$project$User$UserProfile = function (id_) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (eyeColor) {
						return function (birthDate) {
							return function (month) {
								return function (day) {
									return function (year) {
										return function (gender) {
											return function (ethnicities) {
												return function (height) {
													return function (weight) {
														return function (waistSize) {
															return function (city) {
																return function (state) {
																	return function (company) {
																		return function (role) {
																			return function (images) {
																				return function (minAge) {
																					return function (maxAge) {
																						return function (age) {
																							return function (companyProfile) {
																								return function (userBillingAddress) {
																									return function (userPhysicalAddress) {
																										return function (twilioToken) {
																											return function (notifications) {
																												return function (profilePages) {
																													return function (agency) {
																														return function (notificationSettings) {
																															return function (agents) {
																																return function (agencyForm) {
																																	return function (resume) {
																																		return {dA: age, gj: agency, cE: agencyForm, gp: agents, gA: birthDate, a0: city, cK: company, bJ: companyProfile, g5: day, bv: email, eg: ethnicities, hi: eyeColor, bx: firstName, hq: gender, ht: height, c$: id_, l: images, bP: lastName, c2: maxAge, c4: minAge, h$: month, ic: notificationSettings, bU: notifications, e0: phone, ct: profilePages, iH: resume, V: role, bf: state, C: twilioToken, f$: userBillingAddress, f0: userPhysicalAddress, jA: waistSize, jC: weight, jE: year};
																																	};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$Address = F7(
	function (address1, address2, city, state, postalCode, addressType, userId) {
		return {bF: address1, bG: address2, dz: addressType, a0: city, e3: postalCode, bf: state, cA: userId};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Api$Decoders$addressDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'user_id',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'kind',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'postal_code',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'state',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'city',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'address2',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'address1',
							$elm$json$Json$Decode$string,
							'',
							$elm$json$Json$Decode$succeed($author$project$User$Address))))))));
var $author$project$User$Agency = function (id) {
	return function (agencyName) {
		return function (firstName) {
			return function (lastName) {
				return function (agents) {
					return function (address1) {
						return function (address2) {
							return function (city) {
								return function (state) {
									return function (zip) {
										return function (email) {
											return function (password) {
												return function (confirmPassword) {
													return {bF: address1, bG: address2, cF: agencyName, gp: agents, a0: city, cL: confirmPassword, bv: email, bx: firstName, aa: id, bP: lastName, eZ: password, bf: state, dv: zip};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$Agent = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (imageUrl) {
						return function (city) {
							return function (talentCount) {
								return function (acceptedInvitation) {
									return function (agencyName) {
										return function (associationId) {
											return function (acceptedTalent) {
												return function (kind) {
													return {dw: acceptedInvitation, dx: acceptedTalent, cF: agencyName, dJ: associationId, a0: city, bv: email, bx: firstName, aa: id, ey: imageUrl, hK: kind, bP: lastName, e0: phone, fV: talentCount};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$AcceptedTalent = 0;
var $author$project$User$RejectedTalent = 1;
var $author$project$Api$Decoders$decodeAgentAcceptanceType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Accepted':
				return $elm$json$Json$Decode$succeed(0);
			case 'Rejected':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$succeed(2);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$User$AgencyUser = 3;
var $author$project$User$Collaborating = 2;
var $author$project$User$Director = 1;
var $author$project$Api$Decoders$decodeUserType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Talent':
				return $elm$json$Json$Decode$succeed(0);
			case 'Director':
				return $elm$json$Json$Decode$succeed(1);
			case 'Collaborator':
				return $elm$json$Json$Decode$succeed(2);
			case 'Agency':
				return $elm$json$Json$Decode$succeed(3);
			case 'Agent':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$agentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'kind',
	$author$project$Api$Decoders$decodeUserType,
	4,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'accepted_talent',
		$author$project$Api$Decoders$decodeAgentAcceptanceType,
		2,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'association_id',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'agency_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'accepted_invitation',
					$elm$json$Json$Decode$bool,
					false,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'talent_count',
						$elm$json$Json$Decode$string,
						'0',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'city',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'image_url',
								$elm$json$Json$Decode$string,
								'./default_user.png',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'phone',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'email',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'last_name',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'first_name',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'id',
													$elm$json$Json$Decode$string,
													'',
													$elm$json$Json$Decode$succeed($author$project$User$Agent))))))))))))));
var $author$project$Api$Decoders$agentsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$agentDecoder);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Api$Decoders$agencyDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'password_confirmation',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'password',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'zip',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'state',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'city',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'address_2',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'address_1',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'agents',
									$author$project$Api$Decoders$agentsDecoder,
									_List_Nil,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'last_name',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'first_name',
											$elm$json$Json$Decode$string,
											'',
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'agency_name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$string,
													$elm$json$Json$Decode$succeed($author$project$User$Agency))))))))))))));
var $author$project$User$ManualAgency = F5(
	function (agencyName, agentFirstName, agentLastName, agentEmail, agentPhone) {
		return {cF: agencyName, gl: agentEmail, gm: agentFirstName, gn: agentLastName, go: agentPhone};
	});
var $author$project$Api$Decoders$agencyFormDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'agent_phone',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'agent_email',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'agent_last_name',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'agent_first_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'agency_name',
					$elm$json$Json$Decode$string,
					'',
					$elm$json$Json$Decode$succeed($author$project$User$ManualAgency))))));
var $author$project$User$CompanyProfile = F5(
	function (companyName, companyType, companyWebAddress, companyPhone, companyId) {
		return {gO: companyId, gP: companyName, gQ: companyPhone, gR: companyType, gS: companyWebAddress};
	});
var $author$project$Api$Decoders$companyDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'id',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'phone',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'web_address',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'kind',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'name',
					$elm$json$Json$Decode$string,
					'',
					$elm$json$Json$Decode$succeed($author$project$User$CompanyProfile))))));
var $author$project$User$Option = F2(
	function (name, id) {
		return {aa: id, bS: name};
	});
var $author$project$Api$Decoders$optionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$User$Option)));
var $author$project$Api$Decoders$ethnicitiesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$optionDecoder);
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$User$Image = F2(
	function (id, url) {
		return {aa: id, js: url};
	});
var $author$project$Api$Decoders$imageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'image_url',
	$elm$json$Json$Decode$string,
	'./default_user.png',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'id',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$User$Image)));
var $author$project$Api$Decoders$imagesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$imageDecoder);
var $author$project$User$NotificationSettings = F5(
	function (project, talent, messages, audition, profileUpdate) {
		return {gw: audition, hV: messages, is: profileUpdate, aj: project, jb: talent};
	});
var $author$project$Api$Decoders$notificationSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'profile_update',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'audition',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'messages',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'talent',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'project',
					$elm$json$Json$Decode$bool,
					$elm$json$Json$Decode$succeed($author$project$User$NotificationSettings))))));
var $author$project$User$UserNotification = function (id) {
	return function (body) {
		return function (isRead) {
			return function (roleMemberId) {
				return function (jobPosterId) {
					return function (talentId) {
						return function (kind) {
							return function (updatedAt) {
								return function (count) {
									return function (projectId) {
										return function (conversationId) {
											return function (roleId) {
												return function (jobPosterAvatar) {
													return function (talentAvatar) {
														return function (talentName) {
															return function (jobPosterName) {
																return function (projectName) {
																	return function (roleName) {
																		return {dP: body, gV: conversationId, d0: count, aa: id, hE: isRead, hF: jobPosterAvatar, eE: jobPosterId, hH: jobPosterName, hK: kind, iw: projectId, ix: projectName, iK: roleId, aX: roleMemberId, iL: roleName, jc: talentAvatar, jd: talentId, jf: talentName, fY: updatedAt};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$AgentAddedToRole = 1;
var $author$project$User$AgentRemoved = 25;
var $author$project$User$DirectorRemoved = 24;
var $author$project$User$Scheduled = 26;
var $author$project$User$TalentRemoved = 23;
var $author$project$Api$Decoders$stageDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Applied':
				return $elm$json$Json$Decode$succeed(0);
			case 'Agent Added':
				return $elm$json$Json$Decode$succeed(1);
			case 'Requested to Apply':
				return $elm$json$Json$Decode$succeed(2);
			case 'Accepted Application':
				return $elm$json$Json$Decode$succeed(3);
			case 'Rejected Application':
				return $elm$json$Json$Decode$succeed(4);
			case 'Audition Requested':
				return $elm$json$Json$Decode$succeed(5);
			case 'Audition Accepted':
				return $elm$json$Json$Decode$succeed(6);
			case 'Audition Rejected':
				return $elm$json$Json$Decode$succeed(7);
			case 'Audition Reschedule Requested':
				return $elm$json$Json$Decode$succeed(8);
			case 'Audition Rescheduled':
				return $elm$json$Json$Decode$succeed(9);
			case 'Audition Canceled':
				return $elm$json$Json$Decode$succeed(10);
			case 'Callback Requested':
				return $elm$json$Json$Decode$succeed(11);
			case 'Callback Accepted':
				return $elm$json$Json$Decode$succeed(12);
			case 'Callback Rejected':
				return $elm$json$Json$Decode$succeed(13);
			case 'Callback Reschedule Requested':
				return $elm$json$Json$Decode$succeed(14);
			case 'Callback Rescheduled':
				return $elm$json$Json$Decode$succeed(15);
			case 'Callback Canceled':
				return $elm$json$Json$Decode$succeed(16);
			case 'Booking Request':
				return $elm$json$Json$Decode$succeed(17);
			case 'Booking Accepted':
				return $elm$json$Json$Decode$succeed(18);
			case 'Booking Rejected':
				return $elm$json$Json$Decode$succeed(19);
			case 'Role Canceled':
				return $elm$json$Json$Decode$succeed(21);
			case 'Role Changed':
				return $elm$json$Json$Decode$succeed(22);
			case 'message':
				return $elm$json$Json$Decode$succeed(20);
			case 'Scheduled':
				return $elm$json$Json$Decode$succeed(26);
			case 'Removed By Agent':
				return $elm$json$Json$Decode$succeed(25);
			case 'Removed By Talent':
				return $elm$json$Json$Decode$succeed(23);
			case 'Removed By Director':
				return $elm$json$Json$Decode$succeed(24);
			default:
				return $elm$json$Json$Decode$succeed(27);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$notificationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'role_name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'project_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'job_poster_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'talent_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'talent_avatar',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'job_poster_avatar',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'role_id',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'conversation_id',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'project_id',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'count',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'updated_at',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'kind',
												$author$project$Api$Decoders$stageDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'talent_id',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'job_poster_id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'role_member_id',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'is_read',
																$elm$json$Json$Decode$bool,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'body',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'id',
																		$elm$json$Json$Decode$string,
																		$elm$json$Json$Decode$succeed($author$project$User$UserNotification)))))))))))))))))));
var $author$project$Api$Decoders$notificationsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$notificationDecoder);
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$User$ProfilePage = F2(
	function (id, title) {
		return {aa: id, x: title};
	});
var $author$project$Api$Decoders$profilePageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'title',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$User$ProfilePage)));
var $author$project$Api$Decoders$profilePagesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$profilePageDecoder);
var $author$project$Api$Decoders$updateProfileDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resume',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'agencyForm',
		$author$project$Api$Decoders$agencyFormDecoder,
		$author$project$User$emptyManualAgency,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'agents',
			$author$project$Api$Decoders$agentsDecoder,
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'notification_settings',
				$author$project$Api$Decoders$notificationSettingsDecoder,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'agency',
					$author$project$Api$Decoders$agencyDecoder,
					$author$project$User$emptyAgency,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'profile_pages',
						$author$project$Api$Decoders$profilePagesDecoder,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'notifications',
							$author$project$Api$Decoders$notificationsDecoder,
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'twilio_token',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'physicalAddress',
									$author$project$Api$Decoders$addressDecoder,
									$author$project$User$emptyAddress,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'billingAddress',
										$author$project$Api$Decoders$addressDecoder,
										$author$project$User$emptyAddress,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'companyInfo',
											$author$project$Api$Decoders$companyDecoder,
											$author$project$User$emptyCompanyProfile,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'age',
												$elm$json$Json$Decode$int,
												0,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'max_age',
													$elm$json$Json$Decode$int,
													100,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'min_age',
														$elm$json$Json$Decode$int,
														0,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'images',
															$author$project$Api$Decoders$imagesDecoder,
															_List_Nil,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'kind',
																$author$project$Api$Decoders$decodeUserType,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'company',
																	$elm$json$Json$Decode$string,
																	'',
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'state',
																		$elm$json$Json$Decode$string,
																		'',
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'city',
																			$elm$json$Json$Decode$string,
																			'',
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'waist_size',
																				$elm$json$Json$Decode$oneOf(
																					_List_fromArray(
																						[
																							$elm$json$Json$Decode$float,
																							$elm$json$Json$Decode$null(0)
																						])),
																				0,
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'weight',
																					$elm$json$Json$Decode$int,
																					0,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'height',
																						$elm$json$Json$Decode$int,
																						0,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'ethnicities',
																							$author$project$Api$Decoders$ethnicitiesDecoder,
																							_List_Nil,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'gender',
																								$elm$json$Json$Decode$string,
																								'',
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'year',
																									$elm$json$Json$Decode$string,
																									'',
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'day',
																										$elm$json$Json$Decode$string,
																										'',
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'month',
																											$elm$json$Json$Decode$string,
																											'',
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'birth_date',
																												$elm$json$Json$Decode$string,
																												'',
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'eye_color',
																													$elm$json$Json$Decode$string,
																													'',
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'phone',
																														$elm$json$Json$Decode$string,
																														'',
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'email',
																															$elm$json$Json$Decode$string,
																															'',
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'last_name',
																																$elm$json$Json$Decode$string,
																																'',
																																A4(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																	'first_name',
																																	$elm$json$Json$Decode$string,
																																	'',
																																	A3(
																																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																		'id',
																																		$elm$json$Json$Decode$string,
																																		$elm$json$Json$Decode$succeed($author$project$User$UserProfile)))))))))))))))))))))))))))))))))));
var $author$project$Api$Request$addAgentToUser = F3(
	function (agentId, agencyId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$addAgentEncoder, agentId, agencyId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$AgentAdded, $author$project$Api$Decoders$updateProfileDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'users/add_agent'
			});
	});
var $author$project$MainMsg$AddedCollaborator = function (a) {
	return {$: 268, a: a};
};
var $author$project$Api$Encoders$collaboratorEncoder = F2(
	function (collaborator, projectId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'first_name',
					$elm$json$Json$Encode$string(collaborator.bx)),
					_Utils_Tuple2(
					'last_name',
					$elm$json$Json$Encode$string(collaborator.bP)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(collaborator.bv)),
					_Utils_Tuple2(
					'company',
					$elm$json$Json$Encode$string(collaborator.cK)),
					_Utils_Tuple2(
					'phone_number',
					$elm$json$Json$Encode$string(collaborator.ik)),
					_Utils_Tuple2(
					'user_id',
					$elm$json$Json$Encode$string(collaborator.cA)),
					_Utils_Tuple2(
					'project_id',
					$elm$json$Json$Encode$string(projectId))
				]));
	});
var $author$project$User$Collaborator = F8(
	function (id, email, firstName, lastName, phoneNumber, company, invitationId, accepted) {
		return {cC: accepted, cK: company, bv: email, bx: firstName, aa: id, eC: invitationId, bP: lastName, ik: phoneNumber};
	});
var $author$project$Api$Decoders$collaboratorDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accepted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'invitation_id',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'company',
			$elm$json$Json$Decode$string,
			'N/A',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'phone',
				$elm$json$Json$Decode$string,
				'N/A',
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'last_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'first_name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'email',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$User$Collaborator)))))))));
var $author$project$Api$Decoders$collaboratorsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$collaboratorDecoder);
var $author$project$Api$Request$addCollaborator = F3(
	function (collaboratorData, jwt, projectId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$collaboratorEncoder, collaboratorData, projectId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$AddedCollaborator, $author$project$Api$Decoders$collaboratorsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'collaborators/add'
			});
	});
var $author$project$Main$addMoreUsersToList = F2(
	function (newUsers, currentUsers) {
		var users = function () {
			if (currentUsers.$ === 3) {
				var u = currentUsers.a;
				return u;
			} else {
				return _List_Nil;
			}
		}();
		return A2($elm$core$List$append, users, newUsers);
	});
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $author$project$Main$addOrRemoveSelectedTalent = F2(
	function (talent, selectedTalent) {
		return A2(
			$elm$core$List$any,
			function (profile) {
				return _Utils_eq(profile.c$, talent.c$);
			},
			selectedTalent) ? A2(
			$elm$core$List$filter,
			function (profile) {
				return !_Utils_eq(profile.c$, talent.c$);
			},
			selectedTalent) : A2($elm$core$List$cons, talent, selectedTalent);
	});
var $author$project$Main$addPipelineToViewingProject = F2(
	function (project, columns) {
		return _Utils_update(
			project,
			{A: columns});
	});
var $author$project$Main$addSchedulesToViewingProject = F2(
	function (project, schedules) {
		return _Utils_update(
			project,
			{k: schedules});
	});
var $author$project$MainMsg$AddedUpdatedAgent = function (a) {
	return {$: 105, a: a};
};
var $author$project$Api$Encoders$agentEncoder = function (agent) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(agent.bx)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(agent.bP)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(agent.bv)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(agent.a0)),
				_Utils_Tuple2(
				'agent_id',
				$elm$json$Json$Encode$string(agent.aa))
			]));
};
var $author$project$Api$Request$addUpdateAgent = F3(
	function (agent, agencyId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$agentEncoder(agent)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$AddedUpdatedAgent, $author$project$Api$Decoders$agentsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('agencies/' + (agencyId + '/agents'))
			});
	});
var $author$project$MainMsg$TimeSlotUpdated = function (a) {
	return {$: 207, a: a};
};
var $author$project$SharedProjectRoleSchedules$TimeSlot = F8(
	function (id, eventTime, user, scheduleId, votes, comments, scheduleType, formattedTime) {
		return {d_: comments, hd: eventTime, eq: formattedTime, aa: id, iO: scheduleId, fB: scheduleType, f_: user, f6: votes};
	});
var $author$project$SharedProjectRoleSchedules$Comment = F6(
	function (id, body, creatorId, creatorName, creatorAvatar, updatedAt) {
		return {dP: body, d1: creatorAvatar, gW: creatorId, d2: creatorName, aa: id, fY: updatedAt};
	});
var $author$project$Api$Decoders$commentDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'updated_at',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'creator_avatar',
		$elm$json$Json$Decode$string,
		$author$project$User$emptyImage.js,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'creator_name',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'creator_id',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'body',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'id',
						$elm$json$Json$Decode$string,
						'',
						$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$Comment)))))));
var $author$project$Api$Decoders$commentsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$commentDecoder);
var $author$project$Api$Decoders$decodeTime = A2(
	$elm$json$Json$Decode$andThen,
	function (ms) {
		return $elm$json$Json$Decode$succeed(
			$elm$time$Time$millisToPosix(ms));
	},
	$elm$json$Json$Decode$int);
var $author$project$User$PipelineUser = function (id_) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (eyeColor) {
						return function (birthDate) {
							return function (gender) {
								return function (ethnicities) {
									return function (height) {
										return function (weight) {
											return function (waistSize) {
												return function (city) {
													return function (state) {
														return function (company) {
															return function (images) {
																return function (videos) {
																	return function (hairColor) {
																		return function (hairLength) {
																			return function (roleMemberId) {
																				return function (selected) {
																					return function (role) {
																						return function (currentColumn) {
																							return function (stage) {
																								return function (applicationStage) {
																									return function (age) {
																										return function (roleName) {
																											return function (projectName) {
																												return function (roleId) {
																													return function (scheduleMembers) {
																														return function (agency) {
																															return function (resume) {
																																return {dA: age, gj: agency, dH: applicationStage, gA: birthDate, a0: city, cK: company, gY: currentColumn, bv: email, eg: ethnicities, hi: eyeColor, bx: firstName, hq: gender, ck: hairColor, cl: hairLength, ht: height, c$: id_, l: images, bP: lastName, e0: phone, ix: projectName, iH: resume, V: role, iK: roleId, aX: roleMemberId, iL: roleName, fA: scheduleMembers, cz: selected, i3: stage, bf: state, a_: videos, jA: waistSize, jC: weight};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$User$RoleInfo = F4(
	function (name, id, projectId, columnId) {
		return {dZ: columnId, aa: id, bS: name, iw: projectId};
	});
var $author$project$Api$Decoders$roleInfoDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'column_id',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'project_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$User$RoleInfo)))));
var $author$project$User$ScheduleMember = F5(
	function (id, scheduleType, scheduleStatus, body, scheduledTime) {
		return {dP: body, aa: id, dj: scheduleStatus, fB: scheduleType, fD: scheduledTime};
	});
var $author$project$Api$Decoders$scheduleMemberDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'scheduled_time',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'body',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'schedule_status',
			$author$project$Api$Decoders$stageDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'schedule_type',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$User$ScheduleMember))))));
var $author$project$User$Video = function (id) {
	return function (name) {
		return function (url) {
			return function (length) {
				return function (visible) {
					return function (pending) {
						return function (error) {
							return function (roleMemberId) {
								return function (uploadId) {
									return function (progress) {
										return {ef: error, aa: id, eI: length, bS: name, e$: pending, fb: progress, aX: roleMemberId, fZ: uploadId, js: url, ds: visible};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$videoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'progress',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'upload_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'role_member_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'error',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pending',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'visible',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'length',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'url',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'id',
										$elm$json$Json$Decode$string,
										$elm$json$Json$Decode$succeed($author$project$User$Video)))))))))));
var $author$project$Api$Decoders$videosDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$videoDecoder);
var $author$project$Api$Decoders$pipelineUserDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resume',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'agency',
		$author$project$Api$Decoders$agencyDecoder,
		$author$project$User$emptyAgency,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'schedule_members',
			$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleMemberDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'role_id',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'project_name',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'role_name',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'age',
							$elm$json$Json$Decode$int,
							0,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'application_status',
								$author$project$Api$Decoders$stageDecoder,
								27,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'stage',
									$author$project$Api$Decoders$stageDecoder,
									27,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'current_column',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'role',
											$author$project$Api$Decoders$roleInfoDecoder,
											$author$project$User$emptyRoleInfo,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'selected',
												$elm$json$Json$Decode$bool,
												false,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'role_member_id',
													$elm$json$Json$Decode$string,
													'',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'hair_length',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'hair_color',
															$elm$json$Json$Decode$string,
															'',
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'videos',
																$author$project$Api$Decoders$videosDecoder,
																_List_Nil,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'images',
																	$author$project$Api$Decoders$imagesDecoder,
																	_List_Nil,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'company',
																		$elm$json$Json$Decode$string,
																		'',
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'state',
																			$elm$json$Json$Decode$string,
																			'',
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'city',
																				$elm$json$Json$Decode$string,
																				'',
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'waist_size',
																					$elm$json$Json$Decode$oneOf(
																						_List_fromArray(
																							[
																								$elm$json$Json$Decode$float,
																								$elm$json$Json$Decode$null(0)
																							])),
																					0,
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'weight',
																						$elm$json$Json$Decode$int,
																						0,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'height',
																							$elm$json$Json$Decode$int,
																							0,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'ethnicities',
																								$author$project$Api$Decoders$ethnicitiesDecoder,
																								_List_Nil,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'gender',
																									$elm$json$Json$Decode$string,
																									'',
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'birth_date',
																										$elm$json$Json$Decode$string,
																										'',
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'eye_color',
																											$elm$json$Json$Decode$string,
																											'',
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'phone',
																												$elm$json$Json$Decode$string,
																												'',
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'email',
																													$elm$json$Json$Decode$string,
																													'',
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'last_name',
																														$elm$json$Json$Decode$string,
																														'',
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'first_name',
																															$elm$json$Json$Decode$string,
																															'',
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'id',
																																$elm$json$Json$Decode$string,
																																'',
																																$elm$json$Json$Decode$succeed($author$project$User$PipelineUser)))))))))))))))))))))))))))))))));
var $author$project$SharedProjectRoleSchedules$Vote = F5(
	function (id, vote, roleMemberId, votingUserName, votingUserId) {
		return {aa: id, aX: roleMemberId, f5: vote, f7: votingUserId, f8: votingUserName};
	});
var $author$project$Api$Decoders$voteDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'voting_user_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'voting_user_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'role_member_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'vote',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$Vote))))));
var $author$project$Api$Decoders$votesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$voteDecoder);
var $author$project$Api$Decoders$timeSlotDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'formatted_time',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'schedule_type',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'comments',
			$author$project$Api$Decoders$commentsDecoder,
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'votes',
				$author$project$Api$Decoders$votesDecoder,
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'schedule_id',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'user',
						$author$project$Api$Decoders$pipelineUserDecoder,
						$author$project$User$emptyPipelineUser,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'event_time',
							$author$project$Api$Decoders$decodeTime,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'id',
								$elm$json$Json$Decode$string,
								'',
								$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$TimeSlot)))))))));
var $author$project$Api$Encoders$timeSlotUpdateEncoder = F4(
	function (roleMemberId, currentTimeSlot, newTimeSlotId, currentColumnId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'new_time_slot',
					$elm$json$Json$Encode$string(newTimeSlotId)),
					_Utils_Tuple2(
					'role_member_id',
					$elm$json$Json$Encode$string(roleMemberId)),
					_Utils_Tuple2(
					'current_column_id',
					$elm$json$Json$Encode$string(currentColumnId)),
					_Utils_Tuple2(
					'current_time_slot',
					$elm$json$Json$Encode$string(currentTimeSlot))
				]));
	});
var $author$project$Api$Request$addUserToSchedule = F5(
	function (roleMemberId, currentTimeSlotId, newTimeSlot, currentColumn, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A4($author$project$Api$Encoders$timeSlotUpdateEncoder, roleMemberId, currentTimeSlotId, newTimeSlot, currentColumn)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$TimeSlotUpdated, $author$project$Api$Decoders$timeSlotDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'PUT',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'schedules/update_time_slot'
			});
	});
var $author$project$Main$addUser = F5(
	function (user, newTimeSlotId, currentTimeSlotId, currentColumn, jwt) {
		return A5($author$project$Api$Request$addUserToSchedule, user.aX, newTimeSlotId, currentTimeSlotId, currentColumn, jwt);
	});
var $author$project$Utils$eq = F3(
	function (fn, opt, obj) {
		return _Utils_eq(
			fn(obj),
			opt);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$findColumnId = F2(
	function (pipeline, newColumnName) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pipeline$emptyColumn,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bS;
						},
						newColumnName),
					pipeline))).aa;
	});
var $author$project$Main$updateAvailiableTalent = F3(
	function (availableTalent, user, adding) {
		return adding ? A2(
			$elm$core$List$cons,
			_Utils_update(
				user,
				{fA: _List_Nil}),
			availableTalent) : A2(
			$elm$core$List$filter,
			function (talent) {
				return !_Utils_eq(talent.c$, user.c$);
			},
			availableTalent);
	});
var $author$project$MainMsg$StageUpdated = function (a) {
	return {$: 154, a: a};
};
var $author$project$User$NewStage = function (stage) {
	return {i3: stage};
};
var $author$project$Api$Decoders$getStageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stage',
	$author$project$Api$Decoders$stageDecoder,
	$elm$json$Json$Decode$succeed($author$project$User$NewStage));
var $author$project$Api$Encoders$stageEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(model.i3)),
				_Utils_Tuple2(
				'role_member_id',
				$elm$json$Json$Encode$string(model.aX)),
				_Utils_Tuple2(
				'body',
				$elm$json$Json$Encode$string(model.bT.dP)),
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$string(model.bT.cA)),
				_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string(model.bT.hK)),
				_Utils_Tuple2(
				'notifiable_type',
				$elm$json$Json$Encode$string('RoleMember')),
				_Utils_Tuple2(
				'notifiable_id',
				$elm$json$Json$Encode$string(model.bT.aX)),
				_Utils_Tuple2(
				'conversation_id',
				$elm$json$Json$Encode$string(model.bT.gV)),
				_Utils_Tuple2(
				'sending_user_id',
				$elm$json$Json$Encode$string(model.iX))
			]));
};
var $author$project$Api$Request$updateUsersRoleStage = F5(
	function (notification, jwt, roleMemberId, stage, sendingUserId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$stageEncoder(
						{bT: notification, aX: roleMemberId, iX: sendingUserId, i3: stage})),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$StageUpdated, $author$project$Api$Decoders$getStageDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'users/update_user_role_status'
			});
	});
var $author$project$Main$updateRoleMemberAndCreateNotification = F5(
	function (notification, jwt, roleMemberId, stage, sendingUserId) {
		return A5($author$project$Api$Request$updateUsersRoleStage, notification, jwt, roleMemberId, stage, sendingUserId);
	});
var $author$project$Main$updateSchedules = F4(
	function (schedules, user, newTimeSlot, currentTimeSlot) {
		return A2(
			$elm$core$List$map,
			function (schedule) {
				return _Utils_update(
					schedule,
					{
						jl: A2(
							$elm$core$List$map,
							function (timeSlot) {
								return _Utils_eq(timeSlot.aa, newTimeSlot) ? _Utils_update(
									timeSlot,
									{f_: user}) : (_Utils_eq(timeSlot.aa, currentTimeSlot) ? _Utils_update(
									timeSlot,
									{f_: $author$project$User$emptyPipelineUser}) : timeSlot);
							},
							schedule.jl)
					});
			},
			schedules);
	});
var $author$project$MainMsg$UsersMoved = function (a) {
	return {$: 160, a: a};
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Api$Request$updateUsersPipelinePositionFromSchedule = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: $elm$http$Http$expectWhatever($author$project$MainMsg$UsersMoved),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('users/' + (model.aX + ('/project/' + (model.iw + ('/pipeline/move_user/' + model.h2)))))
		});
};
var $author$project$Main$updateUsersPipelinePosition = F4(
	function (jwt, schedulePageData, user, newColumnName) {
		return $author$project$Api$Request$updateUsersPipelinePositionFromSchedule(
			{
				hI: jwt,
				h2: A2($author$project$Main$findColumnId, schedulePageData.aj.A, newColumnName),
				iw: schedulePageData.aj.c$,
				aX: user.aX,
				cA: user.c$
			});
	});
var $author$project$Main$addUserToPublishedScheduleAndUpdatePipeline = F7(
	function (model, user, notificationData, newTimeSlotId, currentTimeSlotId, currentColumn, movingToColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Main$addUser,
						user,
						'',
						newTimeSlotId,
						A2($author$project$Main$findColumnId, model.b$.aj.A, currentColumn),
						model.hI),
						A4($author$project$Main$updateUsersPipelinePosition, model.hI, model.b$, user, movingToColumn),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, notificationData, model.hI, notificationData.aX, notificationData.hK, notificationData.cA)
					])),
			A4($author$project$Main$updateSchedules, model.b$.k, user, newTimeSlotId, currentTimeSlotId),
			A3($author$project$Main$updateAvailiableTalent, model.b$.I, user, false));
	});
var $author$project$Main$addUserToScheduleAndUpdatePipeline = F6(
	function (model, user, newTimeSlotId, currentTimeSlotId, currentColumn, movingToColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A5(
						$author$project$Main$addUser,
						user,
						'',
						newTimeSlotId,
						A2($author$project$Main$findColumnId, model.b$.aj.A, currentColumn),
						model.hI),
						A4($author$project$Main$updateUsersPipelinePosition, model.hI, model.b$, user, movingToColumn)
					])),
			A4($author$project$Main$updateSchedules, model.b$.k, user, newTimeSlotId, currentTimeSlotId),
			A3($author$project$Main$updateAvailiableTalent, model.b$.I, user, false));
	});
var $andrewMacmurray$elm_delay$Delay$Duration = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$core$Process$sleep = _Process_sleep;
var $andrewMacmurray$elm_delay$Delay$after_ = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(time));
	});
var $andrewMacmurray$elm_delay$Delay$Minute = 2;
var $andrewMacmurray$elm_delay$Delay$Second = 1;
var $andrewMacmurray$elm_delay$Delay$toMillis = function (_v0) {
	var t = _v0.a;
	var u = _v0.b;
	switch (u) {
		case 0:
			return t;
		case 1:
			return 1000 * t;
		case 2:
			return $andrewMacmurray$elm_delay$Delay$toMillis(
				A2($andrewMacmurray$elm_delay$Delay$Duration, 60 * t, 1));
		default:
			return $andrewMacmurray$elm_delay$Delay$toMillis(
				A2($andrewMacmurray$elm_delay$Delay$Duration, 60 * t, 2));
	}
};
var $andrewMacmurray$elm_delay$Delay$after = F3(
	function (time, unit, msg) {
		return A2(
			$andrewMacmurray$elm_delay$Delay$after_,
			$andrewMacmurray$elm_delay$Delay$toMillis(
				A2($andrewMacmurray$elm_delay$Delay$Duration, time, unit)),
			msg);
	});
var $ccapndave$elm_update_extra$Update$Extra$andThen = F3(
	function (update, msg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var _v1 = A2(update, msg, model);
		var model_ = _v1.a;
		var cmd_ = _v1.b;
		return _Utils_Tuple2(
			model_,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, cmd_])));
	});
var $author$project$MainMsg$SendApplication = function (a) {
	return {$: 66, a: a};
};
var $author$project$Job$JobMessage = function (message) {
	return {hT: message};
};
var $author$project$Api$Decoders$jobAppDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Job$JobMessage));
var $author$project$Api$Request$applyToRole = F3(
	function (projectId, roleId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$SendApplication, $author$project$Api$Decoders$jobAppDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (projectId + ('/roles/' + (roleId + '/add_to_role'))))
			});
	});
var $author$project$MainMsg$GotBlankSchedules = function (a) {
	return {$: 196, a: a};
};
var $author$project$SharedProjectRoleSchedules$Schedule = function (id) {
	return function (scheduleDate) {
		return function (startTime) {
			return function (endTime) {
				return function (breakStart) {
					return function (breakEnd) {
						return function (timeIncrements) {
							return function (capacity) {
								return function (timeSlots) {
									return function (roles) {
										return function (roleList) {
											return function (roleSearchTerm) {
												return function (scheduleType) {
													return function (published) {
														return function (creatorId) {
															return {gB: breakEnd, gC: breakStart, gH: capacity, gW: creatorId, hc: endTime, aa: id, bb: published, dh: roleList, iN: roleSearchTerm, ft: roles, fy: scheduleDate, fB: scheduleType, i4: startTime, jk: timeIncrements, jl: timeSlots};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$scheduleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'creator_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'published',
		$elm$json$Json$Decode$bool,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'schedule_type',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'roleSearchTerm',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'roleList',
					$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'roles',
						$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'time_slots',
							$elm$json$Json$Decode$list($author$project$Api$Decoders$timeSlotDecoder),
							_List_Nil,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'capacity',
								$elm$json$Json$Decode$int,
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'time_increments',
									$elm$json$Json$Decode$int,
									0,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'break_end',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'break_start',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'end_time',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'start_time',
													$elm$json$Json$Decode$string,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'schedule_date',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'id',
															$elm$json$Json$Decode$string,
															'',
															$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$Schedule))))))))))))))));
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Api$Encoders$transformRoleNameToId = F2(
	function (roleNames, roles) {
		return A2(
			$elm$core$List$concatMap,
			function (role) {
				return A2(
					$elm$core$List$filter,
					function (roleData) {
						return _Utils_eq(roleData.bS, role);
					},
					roles);
			},
			roleNames);
	});
var $author$project$Api$Encoders$scheduleEncoder = function (scheduleData) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$string(scheduleData.fP)),
				_Utils_Tuple2(
				'end_date',
				$elm$json$Json$Encode$string(scheduleData.ee)),
				_Utils_Tuple2(
				'start_time',
				$elm$json$Json$Encode$string(scheduleData.a2.i4)),
				_Utils_Tuple2(
				'end_time',
				$elm$json$Json$Encode$string(scheduleData.a2.hc)),
				_Utils_Tuple2(
				'break_start',
				$elm$json$Json$Encode$string(scheduleData.a2.gC)),
				_Utils_Tuple2(
				'break_end',
				$elm$json$Json$Encode$string(scheduleData.a2.gB)),
				_Utils_Tuple2(
				'time_increments',
				$elm$json$Json$Encode$int(scheduleData.a2.jk)),
				_Utils_Tuple2(
				'capacity',
				$elm$json$Json$Encode$int(scheduleData.a2.gH)),
				_Utils_Tuple2(
				'auto_schedule',
				$elm$json$Json$Encode$bool(scheduleData.gz)),
				_Utils_Tuple2(
				'roles',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.c$;
						},
						A2($author$project$Api$Encoders$transformRoleNameToId, scheduleData.a2.ft, scheduleData.aj.ft)))),
				_Utils_Tuple2(
				'schedule_type',
				$elm$json$Json$Encode$string(scheduleData.fB))
			]));
};
var $author$project$Api$Request$autoSchedule = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$scheduleEncoder(model.b$)),
			a: A2(
				$elm$http$Http$expectJson,
				$author$project$MainMsg$GotBlankSchedules,
				$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder)),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.b$.aj.c$ + '/create_auto_schedule'))
		});
};
var $elm$http$Http$cancel = function (tracker) {
	return $elm$http$Http$command(
		$elm$http$Http$Cancel(tracker));
};
var $author$project$User$emptyProfilePage = {aa: '', x: ''};
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{M: nodeList, H: nodeListSize, J: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $author$project$Main$categoryFromIndex = F2(
	function (currentIndex, user) {
		var pagesArray = $elm$core$Array$fromList(user.ct);
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyProfilePage,
			A2($elm$core$Array$get, currentIndex, pagesArray));
	});
var $author$project$Api$Request$moveUserInSchedule = F4(
	function (userId, currentTimeSlotId, newTimeSlot, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A4($author$project$Api$Encoders$timeSlotUpdateEncoder, userId, currentTimeSlotId, newTimeSlot, '')),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$TimeSlotUpdated, $author$project$Api$Decoders$timeSlotDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'PUT',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'schedules/move_user'
			});
	});
var $author$project$Main$changeUsersTimeSlot = F4(
	function (user, currentTimeSlot, newTimeSlotId, jwt) {
		return A4($author$project$Api$Request$moveUserInSchedule, user.aX, currentTimeSlot, newTimeSlotId, jwt);
	});
var $author$project$Main$changeUsersTimeSlotInPublishedSchedule = F5(
	function (model, user, notificationData, currentTimeSlotId, newTimeSlotId) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$changeUsersTimeSlot, user, currentTimeSlotId, newTimeSlotId, model.hI),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, notificationData, model.hI, notificationData.aX, notificationData.hK, notificationData.cA)
					])),
			A4($author$project$Main$updateSchedules, model.b$.k, user, newTimeSlotId, currentTimeSlotId),
			model.b$.I);
	});
var $author$project$Main$changeUsersTimeSlotInSchedule = F4(
	function (model, user, currentTimeSlotId, newTimeSlotId) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$changeUsersTimeSlot, user, currentTimeSlotId, newTimeSlotId, model.hI)
					])),
			A4($author$project$Main$updateSchedules, model.b$.k, user, newTimeSlotId, currentTimeSlotId),
			model.b$.I);
	});
var $author$project$Main$changeWindowHeight = _Platform_outgoingPort('changeWindowHeight', $elm$json$Json$Encode$string);
var $author$project$Main$clearAgencyInfo = function (userProfile) {
	return _Utils_update(
		userProfile,
		{gj: $author$project$User$emptyAgency});
};
var $author$project$Main$closeAddAgentForm = function (profilePageData) {
	return _Utils_update(
		profilePageData,
		{b6: false});
};
var $author$project$Main$columnDefinitions = function (scheduleType) {
	switch (scheduleType) {
		case 'Audition':
			return _Utils_Tuple2('Selected Candidates', 'Scheduled Audition');
		case 'Callback':
			return _Utils_Tuple2('Selected Candidates', 'Scheduled Callbacks');
		default:
			return _Utils_Tuple2('', '');
	}
};
var $author$project$Message$emptyMessage = {dP: '', cN: '', gV: '', gW: '', bN: '', bw: '', aa: '', aF: '', bS: '', dl: 0, bh: ''};
var $author$project$Main$optimisticChannel = F2(
	function (model, message) {
		return _Utils_update(
			$author$project$Message$emptyConversation,
			{
				hF: A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyImage,
					$elm$core$List$head(model.E.l)).js,
				eE: model.E.c$,
				hL: model.L.dP,
				hV: _List_fromArray(
					[message]),
				iw: model.d6,
				ix: model.v.ix,
				iK: model.g$,
				aX: model.v.aX,
				iL: model.v.iL,
				jc: A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyImage,
					$elm$core$List$head(model.v.l)).js,
				jd: model.v.c$,
				jf: model.v.bx + (' ' + model.v.bP),
				bD: 0
			});
	});
var $author$project$Main$conversationTwilioPayload = function (model) {
	var message = _Utils_update(
		$author$project$Message$emptyMessage,
		{dP: model.L.dP, gW: model.E.c$, aF: 'text', bh: 'less than a minute ago'});
	return _Utils_update(
		$author$project$Message$emptyFromTwilioPayload,
		{
			z: 'creatingAConversation',
			t: A2($author$project$Main$optimisticChannel, model, message)
		});
};
var $author$project$MainMsg$AgencyCreated = function (a) {
	return {$: 307, a: a};
};
var $author$project$Api$Encoders$manualAgencyEncoder = function (agency) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(agency.gm)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(agency.gn)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(agency.gl)),
				_Utils_Tuple2(
				'agency_name',
				$elm$json$Json$Encode$string(agency.cF)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(agency.go))
			]));
};
var $author$project$Api$Request$createAgency = F2(
	function (agency, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$manualAgencyEncoder(agency)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$AgencyCreated, $author$project$Api$Decoders$updateProfileDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'agencies'
			});
	});
var $author$project$Api$Request$createBlankSchedule = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$scheduleEncoder(model.b$)),
			a: A2(
				$elm$http$Http$expectJson,
				$author$project$MainMsg$GotBlankSchedules,
				$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder)),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.b$.aj.c$ + '/schedules'))
		});
};
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {g5: d, h$: m, jE: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		da: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		jE: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.jE, 0, date.da);
};
var $justinmimbs$date$Date$day = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.g5;
	});
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.h$;
	});
var $justinmimbs$date$Date$monthNumber = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToNumber);
var $justinmimbs$date$Date$ordinalDay = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toOrdinalDate,
	function ($) {
		return $.da;
	});
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $justinmimbs$date$Date$padSignedInt = F2(
	function (length, _int) {
		return _Utils_ap(
			(_int < 0) ? '-' : '',
			A3(
				$elm$core$String$padLeft,
				length,
				'0',
				$elm$core$String$fromInt(
					$elm$core$Basics$abs(_int))));
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$daysBeforeWeekYear = function (y) {
	var jan4 = $justinmimbs$date$Date$daysBeforeYear(y) + 4;
	return jan4 - $justinmimbs$date$Date$weekdayNumber(jan4);
};
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $justinmimbs$date$Date$numberToWeekday = function (wdn) {
	var _v0 = A2($elm$core$Basics$max, 1, wdn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		default:
			return 6;
	}
};
var $justinmimbs$date$Date$toWeekDate = function (_v0) {
	var rd = _v0;
	var wdn = $justinmimbs$date$Date$weekdayNumber(rd);
	var wy = $justinmimbs$date$Date$year(rd + (4 - wdn));
	var week1Day1 = $justinmimbs$date$Date$daysBeforeWeekYear(wy) + 1;
	return {
		f9: 1 + (((rd - week1Day1) / 7) | 0),
		ga: wy,
		jB: $justinmimbs$date$Date$numberToWeekday(wdn)
	};
};
var $justinmimbs$date$Date$weekNumber = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.f9;
	});
var $justinmimbs$date$Date$weekYear = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toWeekDate,
	function ($) {
		return $.ga;
	});
var $justinmimbs$date$Date$weekday = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$weekdayNumber, $justinmimbs$date$Date$numberToWeekday);
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $justinmimbs$date$Date$ordinalSuffix = function (n) {
	var nn = A2($elm$core$Basics$modBy, 100, n);
	var _v0 = A2(
		$elm$core$Basics$min,
		(nn < 20) ? nn : A2($elm$core$Basics$modBy, 10, nn),
		4);
	switch (_v0) {
		case 1:
			return 'st';
		case 2:
			return 'nd';
		case 3:
			return 'rd';
		default:
			return 'th';
	}
};
var $justinmimbs$date$Date$withOrdinalSuffix = function (n) {
	return _Utils_ap(
		$elm$core$String$fromInt(n),
		$justinmimbs$date$Date$ordinalSuffix(n));
};
var $justinmimbs$date$Date$formatField = F4(
	function (language, _char, length, date) {
		switch (_char) {
			case 'y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$year(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$year(date));
				}
			case 'Y':
				if (length === 2) {
					return A2(
						$elm$core$String$right,
						2,
						A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekYear(date))));
				} else {
					return A2(
						$justinmimbs$date$Date$padSignedInt,
						length,
						$justinmimbs$date$Date$weekYear(date));
				}
			case 'Q':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 3:
						return 'Q' + $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					case 4:
						return $justinmimbs$date$Date$withOrdinalSuffix(
							$justinmimbs$date$Date$quarter(date));
					case 5:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$quarter(date));
					default:
						return '';
				}
			case 'M':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$monthNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$monthNumber(date)));
					case 3:
						return language.cn(
							$justinmimbs$date$Date$month(date));
					case 4:
						return language.c6(
							$justinmimbs$date$Date$month(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.cn(
								$justinmimbs$date$Date$month(date)));
					default:
						return '';
				}
			case 'w':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekNumber(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$weekNumber(date)));
					default:
						return '';
				}
			case 'd':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$day(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$day(date)));
					case 3:
						return language.cV(
							$justinmimbs$date$Date$day(date));
					default:
						return '';
				}
			case 'D':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$ordinalDay(date));
					case 2:
						return A3(
							$elm$core$String$padLeft,
							2,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					case 3:
						return A3(
							$elm$core$String$padLeft,
							3,
							'0',
							$elm$core$String$fromInt(
								$justinmimbs$date$Date$ordinalDay(date)));
					default:
						return '';
				}
			case 'E':
				switch (length) {
					case 1:
						return language.bm(
							$justinmimbs$date$Date$weekday(date));
					case 2:
						return language.bm(
							$justinmimbs$date$Date$weekday(date));
					case 3:
						return language.bm(
							$justinmimbs$date$Date$weekday(date));
					case 4:
						return language.dt(
							$justinmimbs$date$Date$weekday(date));
					case 5:
						return A2(
							$elm$core$String$left,
							1,
							language.bm(
								$justinmimbs$date$Date$weekday(date)));
					case 6:
						return A2(
							$elm$core$String$left,
							2,
							language.bm(
								$justinmimbs$date$Date$weekday(date)));
					default:
						return '';
				}
			case 'e':
				switch (length) {
					case 1:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					case 2:
						return $elm$core$String$fromInt(
							$justinmimbs$date$Date$weekdayNumber(date));
					default:
						return A4($justinmimbs$date$Date$formatField, language, 'E', length, date);
				}
			default:
				return '';
		}
	});
var $justinmimbs$date$Date$formatWithTokens = F3(
	function (language, tokens, date) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (token, formatted) {
					if (!token.$) {
						var _char = token.a;
						var length = token.b;
						return _Utils_ap(
							A4($justinmimbs$date$Date$formatField, language, _char, length, date),
							formatted);
					} else {
						var str = token.a;
						return _Utils_ap(str, formatted);
					}
				}),
			'',
			tokens);
	});
var $justinmimbs$date$Pattern$Literal = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {dV: col, gU: contextStack, e6: problem, fu: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.fu, s.dV, x, s.s));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.id, s.fu, s.dV, s.i);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{dV: newCol, s: s.s, y: s.y, id: newOffset, fu: newRow, i: s.i});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $justinmimbs$date$Pattern$escapedQuote = A2(
	$elm$parser$Parser$ignorer,
	$elm$parser$Parser$succeed(
		$justinmimbs$date$Pattern$Literal('\'')),
	$elm$parser$Parser$token('\'\''));
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.id, s.i);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dV: 1, s: s.s, y: s.y, id: s.id + 1, fu: s.fu + 1, i: s.i}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{dV: s.dV + 1, s: s.s, y: s.y, id: newOffset, fu: s.fu, i: s.i}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $justinmimbs$date$Pattern$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.i);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.id, offset) < 0,
					0,
					{dV: col, s: s0.s, y: s0.y, id: offset, fu: row, i: s0.i});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.id, s.fu, s.dV, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.id, s);
};
var $elm$parser$Parser$getOffset = $elm$parser$Parser$Advanced$getOffset;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $justinmimbs$date$Pattern$fieldRepeats = function (str) {
	var _v0 = $elm$core$String$toList(str);
	if (_v0.b && (!_v0.b.b)) {
		var _char = _v0.a;
		return A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F2(
						function (x, y) {
							return A2($justinmimbs$date$Pattern$Field, _char, 1 + (y - x));
						})),
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$getOffset,
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq(_char)))),
			$elm$parser$Parser$getOffset);
	} else {
		return $elm$parser$Parser$problem('expected exactly one char');
	}
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.id, s1.id, s0.i),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $justinmimbs$date$Pattern$field = A2(
	$elm$parser$Parser$andThen,
	$justinmimbs$date$Pattern$fieldRepeats,
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompIf($elm$core$Char$isAlpha)));
var $justinmimbs$date$Pattern$finalize = A2(
	$elm$core$List$foldl,
	F2(
		function (token, tokens) {
			var _v0 = _Utils_Tuple2(token, tokens);
			if (((_v0.a.$ === 1) && _v0.b.b) && (_v0.b.a.$ === 1)) {
				var x = _v0.a.a;
				var _v1 = _v0.b;
				var y = _v1.a.a;
				var rest = _v1.b;
				return A2(
					$elm$core$List$cons,
					$justinmimbs$date$Pattern$Literal(
						_Utils_ap(x, y)),
					rest);
			} else {
				return A2($elm$core$List$cons, token, tokens);
			}
		}),
	_List_Nil);
var $elm$parser$Parser$Advanced$lazy = function (thunk) {
	return function (s) {
		var _v0 = thunk(0);
		var parse = _v0;
		return parse(s);
	};
};
var $elm$parser$Parser$lazy = $elm$parser$Parser$Advanced$lazy;
var $justinmimbs$date$Pattern$isLiteralChar = function (_char) {
	return (_char !== '\'') && (!$elm$core$Char$isAlpha(_char));
};
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $justinmimbs$date$Pattern$literal = A2(
	$elm$parser$Parser$map,
	$justinmimbs$date$Pattern$Literal,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($justinmimbs$date$Pattern$isLiteralChar)),
			$elm$parser$Parser$chompWhile($justinmimbs$date$Pattern$isLiteralChar))));
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.i),
			s.id) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $justinmimbs$date$Pattern$quotedHelp = function (result) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (str) {
					return $justinmimbs$date$Pattern$quotedHelp(
						_Utils_ap(result, str));
				},
				$elm$parser$Parser$getChompedString(
					A2(
						$elm$parser$Parser$ignorer,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed(0),
							$elm$parser$Parser$chompIf(
								$elm$core$Basics$neq('\''))),
						$elm$parser$Parser$chompWhile(
							$elm$core$Basics$neq('\''))))),
				A2(
				$elm$parser$Parser$andThen,
				function (_v0) {
					return $justinmimbs$date$Pattern$quotedHelp(result + '\'');
				},
				$elm$parser$Parser$token('\'\'')),
				$elm$parser$Parser$succeed(result)
			]));
};
var $justinmimbs$date$Pattern$quoted = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($justinmimbs$date$Pattern$Literal),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('\''))),
	A2(
		$elm$parser$Parser$ignorer,
		$justinmimbs$date$Pattern$quotedHelp(''),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('\'')),
					$elm$parser$Parser$end
				]))));
var $justinmimbs$date$Pattern$patternHelp = function (tokens) {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$andThen,
				function (token) {
					return $justinmimbs$date$Pattern$patternHelp(
						A2($elm$core$List$cons, token, tokens));
				},
				$elm$parser$Parser$oneOf(
					_List_fromArray(
						[$justinmimbs$date$Pattern$field, $justinmimbs$date$Pattern$literal, $justinmimbs$date$Pattern$escapedQuote, $justinmimbs$date$Pattern$quoted]))),
				$elm$parser$Parser$lazy(
				function (_v0) {
					return $elm$parser$Parser$succeed(
						$justinmimbs$date$Pattern$finalize(tokens));
				})
			]));
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {dV: col, e6: problem, fu: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.fu, p.dV, p.e6);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{dV: 1, s: _List_Nil, y: 1, id: 0, fu: 1, i: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $justinmimbs$date$Pattern$fromString = function (str) {
	return A2(
		$elm$core$Result$withDefault,
		_List_fromArray(
			[
				$justinmimbs$date$Pattern$Literal(str)
			]),
		A2(
			$elm$parser$Parser$run,
			$justinmimbs$date$Pattern$patternHelp(_List_Nil),
			str));
};
var $justinmimbs$date$Date$formatWithLanguage = F2(
	function (language, pattern) {
		var tokens = $elm$core$List$reverse(
			$justinmimbs$date$Pattern$fromString(pattern));
		return A2($justinmimbs$date$Date$formatWithTokens, language, tokens);
	});
var $justinmimbs$date$Date$monthToName = function (m) {
	switch (m) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$weekdayToName = function (wd) {
	switch (wd) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $justinmimbs$date$Date$language_en = {
	cV: $justinmimbs$date$Date$withOrdinalSuffix,
	c6: $justinmimbs$date$Date$monthToName,
	cn: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$monthToName,
		$elm$core$String$left(3)),
	dt: $justinmimbs$date$Date$weekdayToName,
	bm: A2(
		$elm$core$Basics$composeR,
		$justinmimbs$date$Date$weekdayToName,
		$elm$core$String$left(3))
};
var $justinmimbs$date$Date$format = function (pattern) {
	return A2($justinmimbs$date$Date$formatWithLanguage, $justinmimbs$date$Date$language_en, pattern);
};
var $author$project$Main$createDates = function (dateEvent) {
	if (dateEvent.$ === 2) {
		var changedDate = dateEvent.a;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(changedDate),
			A2($justinmimbs$date$Date$format, 'y-MM-dd', changedDate));
	} else {
		return _Utils_Tuple2($elm$core$Maybe$Nothing, '');
	}
};
var $author$project$Message$emptyToTwilioPayload = {dI: false, dP: '', gJ: '', gK: _List_Nil, gW: '', hp: '', hF: '', eE: '', hG: '', hH: '', iw: '', ix: '', iK: '', aX: '', iL: '', jc: '', je: '', jf: '', jp: ''};
var $author$project$Main$twilio = _Platform_outgoingPort(
	'twilio',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'cmd',
					$elm$json$Json$Encode$string($.z)),
					_Utils_Tuple2(
					'payload',
					$elm$core$Basics$identity($.ai)),
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string($.ao))
				]));
	});
var $author$project$Api$Encoders$twilioPayloadEncoder = function (payload) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'friendlyName',
				$elm$json$Json$Encode$string(payload.hp)),
				_Utils_Tuple2(
				'uniqueName',
				$elm$json$Json$Encode$string(payload.jp)),
				_Utils_Tuple2(
				'jobPosterAvatar',
				$elm$json$Json$Encode$string(payload.hF)),
				_Utils_Tuple2(
				'jobPosterName',
				$elm$json$Json$Encode$string(payload.hH)),
				_Utils_Tuple2(
				'talentAvatar',
				$elm$json$Json$Encode$string(payload.jc)),
				_Utils_Tuple2(
				'talentName',
				$elm$json$Json$Encode$string(payload.jf)),
				_Utils_Tuple2(
				'jobPosterIdentity',
				$elm$json$Json$Encode$string(payload.hG)),
				_Utils_Tuple2(
				'talentIdentity',
				$elm$json$Json$Encode$string(payload.je)),
				_Utils_Tuple2(
				'roleName',
				$elm$json$Json$Encode$string(payload.iL)),
				_Utils_Tuple2(
				'projectName',
				$elm$json$Json$Encode$string(payload.ix)),
				_Utils_Tuple2(
				'body',
				$elm$json$Json$Encode$string(payload.dP)),
				_Utils_Tuple2(
				'channelId',
				$elm$json$Json$Encode$string(payload.gJ)),
				_Utils_Tuple2(
				'creatorId',
				$elm$json$Json$Encode$string(payload.gW)),
				_Utils_Tuple2(
				'roleMemberId',
				$elm$json$Json$Encode$string(payload.aX)),
				_Utils_Tuple2(
				'projectId',
				$elm$json$Json$Encode$string(payload.iw)),
				_Utils_Tuple2(
				'roleId',
				$elm$json$Json$Encode$string(payload.iK)),
				_Utils_Tuple2(
				'channelIds',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, payload.gK)),
				_Utils_Tuple2(
				'jobPosterId',
				$elm$json$Json$Encode$string(payload.eE))
			]));
};
var $author$project$Main$createMessage = F4(
	function (channelId, body, token, creatorId) {
		var twilioPayload = _Utils_update(
			$author$project$Message$emptyToTwilioPayload,
			{dP: body, gJ: channelId, gW: creatorId});
		return $author$project$Main$twilio(
			{
				z: 'sendMessage',
				ai: $author$project$Api$Encoders$twilioPayloadEncoder(twilioPayload),
				ao: token
			});
	});
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Main$addIfNotPresent = F2(
	function (item, items) {
		return (A2($elm$core$List$member, item, items) || (item.bS === '-')) ? items : A2($elm$core$List$cons, item, items);
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$core$String$toFloat = _String_toFloat;
var $author$project$Main$createRole = F2(
	function (msg, model) {
		var role = model.V;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{bS: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{iM: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{iI: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									c4: A2(
										$elm$core$Maybe$withDefault,
										17,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									c2: A2(
										$elm$core$Maybe$withDefault,
										75,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									hs: A2(
										$author$project$Main$addIfNotPresent,
										A2(
											$elm$core$Maybe$withDefault,
											{aa: '', bS: ''},
											$elm$core$List$head(
												A2(
													$elm$core$List$filter,
													A2(
														$author$project$Utils$eq,
														function ($) {
															return $.aa;
														},
														value),
													model.hs))),
										model.V.hs)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									eg: A2(
										$author$project$Main$addIfNotPresent,
										A2(
											$elm$core$Maybe$withDefault,
											{aa: '', bS: ''},
											$elm$core$List$head(
												A2(
													$elm$core$List$filter,
													A2(
														$author$project$Utils$eq,
														function ($) {
															return $.aa;
														},
														value),
													model.eg))),
										model.V.eg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									hW: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									hP: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									eQ: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									eM: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$createSingleNotificationKind = F2(
	function (model, userInSchedule) {
		return (userInSchedule && (model.b$.fB === 'Audition')) ? 'Audition Rescheduled' : (((!userInSchedule) && (model.b$.fB === 'Audition')) ? 'Audition Requested' : ((userInSchedule && (model.b$.fB === 'Callback')) ? 'Callback Rescheduled' : (((!userInSchedule) && (model.b$.fB === 'Callback')) ? 'Callback Requested' : '')));
	});
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $CurrySoftware$elm_datepicker$DatePicker$formatCell = function (day) {
	return $elm$html$Html$text(day);
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay = function (day) {
	switch (day) {
		case 0:
			return 'Mo';
		case 1:
			return 'Tu';
		case 2:
			return 'We';
		case 3:
			return 'Th';
		case 4:
			return 'Fr';
		case 5:
			return 'Sa';
		default:
			return 'Su';
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $justinmimbs$date$Date$deadEndToString = function (_v0) {
	var problem = _v0.e6;
	if (problem.$ === 12) {
		var message = problem.a;
		return message;
	} else {
		return 'Expected a date in ISO 8601 format';
	}
};
var $justinmimbs$date$Date$MonthAndDay = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $justinmimbs$date$Date$OrdinalDay = function (a) {
	return {$: 2, a: a};
};
var $justinmimbs$date$Date$WeekAndWeekday = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$Advanced$commit = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, true, a, s);
	};
};
var $elm$parser$Parser$commit = $elm$parser$Parser$Advanced$commit;
var $elm$parser$Parser$mapChompedString = $elm$parser$Parser$Advanced$mapChompedString;
var $justinmimbs$date$Date$int1 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$elm$parser$Parser$chompIf($elm$core$Char$isDigit));
var $justinmimbs$date$Date$int2 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed(0),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$int3 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $justinmimbs$date$Date$dayOfYear = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed($elm$core$Basics$identity),
				$elm$parser$Parser$token('-')),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$backtrackable(
						A2(
							$elm$parser$Parser$andThen,
							$elm$parser$Parser$commit,
							A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int2),
									$elm$parser$Parser$succeed(1)
								]))),
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$ignorer,
								$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
								$elm$parser$Parser$token('W')),
							$justinmimbs$date$Date$int2),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$token('-')),
									$justinmimbs$date$Date$int1),
									$elm$parser$Parser$succeed(1)
								])))
					]))),
			$elm$parser$Parser$backtrackable(
			A2(
				$elm$parser$Parser$andThen,
				$elm$parser$Parser$commit,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($justinmimbs$date$Date$MonthAndDay),
						$justinmimbs$date$Date$int2),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$justinmimbs$date$Date$int2,
								$elm$parser$Parser$succeed(1)
							]))))),
			A2($elm$parser$Parser$map, $justinmimbs$date$Date$OrdinalDay, $justinmimbs$date$Date$int3),
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($justinmimbs$date$Date$WeekAndWeekday),
					$elm$parser$Parser$token('W')),
				$justinmimbs$date$Date$int2),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$justinmimbs$date$Date$int1,
						$elm$parser$Parser$succeed(1)
					]))),
			$elm$parser$Parser$succeed(
			$justinmimbs$date$Date$OrdinalDay(1))
		]));
var $justinmimbs$date$Date$isBetweenInt = F3(
	function (a, b, x) {
		return (_Utils_cmp(a, x) < 1) && (_Utils_cmp(x, b) < 1);
	});
var $justinmimbs$date$Date$fromCalendarParts = F3(
	function (y, mn, d) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 12, mn) && A3(
			$justinmimbs$date$Date$isBetweenInt,
			1,
			A2(
				$justinmimbs$date$Date$daysInMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn)),
			d)) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeYear(y) + A2(
				$justinmimbs$date$Date$daysBeforeMonth,
				y,
				$justinmimbs$date$Date$numberToMonth(mn))) + d) : $elm$core$Result$Err(
			'Invalid calendar date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(mn) + (', ' + ($elm$core$String$fromInt(d) + ')'))))));
	});
var $justinmimbs$date$Date$fromOrdinalParts = F2(
	function (y, od) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 365, od) || ((od === 366) && $justinmimbs$date$Date$isLeapYear(y))) ? $elm$core$Result$Ok(
			$justinmimbs$date$Date$daysBeforeYear(y) + od) : $elm$core$Result$Err(
			'Invalid ordinal date (' + ($elm$core$String$fromInt(y) + (', ' + ($elm$core$String$fromInt(od) + ')'))));
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$is53WeekYear = function (y) {
	var wdnJan1 = $justinmimbs$date$Date$weekdayNumber(
		$justinmimbs$date$Date$firstOfYear(y));
	return (wdnJan1 === 4) || ((wdnJan1 === 3) && $justinmimbs$date$Date$isLeapYear(y));
};
var $justinmimbs$date$Date$fromWeekParts = F3(
	function (wy, wn, wdn) {
		return (A3($justinmimbs$date$Date$isBetweenInt, 1, 7, wdn) && (A3($justinmimbs$date$Date$isBetweenInt, 1, 52, wn) || ((wn === 53) && $justinmimbs$date$Date$is53WeekYear(wy)))) ? $elm$core$Result$Ok(
			($justinmimbs$date$Date$daysBeforeWeekYear(wy) + ((wn - 1) * 7)) + wdn) : $elm$core$Result$Err(
			'Invalid week date (' + ($elm$core$String$fromInt(wy) + (', ' + ($elm$core$String$fromInt(wn) + (', ' + ($elm$core$String$fromInt(wdn) + ')'))))));
	});
var $justinmimbs$date$Date$fromYearAndDayOfYear = function (_v0) {
	var y = _v0.a;
	var doy = _v0.b;
	switch (doy.$) {
		case 0:
			var mn = doy.a;
			var d = doy.b;
			return A3($justinmimbs$date$Date$fromCalendarParts, y, mn, d);
		case 1:
			var wn = doy.a;
			var wdn = doy.b;
			return A3($justinmimbs$date$Date$fromWeekParts, y, wn, wdn);
		default:
			var od = doy.a;
			return A2($justinmimbs$date$Date$fromOrdinalParts, y, od);
	}
};
var $justinmimbs$date$Date$int4 = A2(
	$elm$parser$Parser$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed(0),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									$elm$parser$Parser$chompIf(
									function (c) {
										return c === '-';
									}),
									$elm$parser$Parser$succeed(0)
								]))),
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
				$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
			$elm$parser$Parser$chompIf($elm$core$Char$isDigit)),
		$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $justinmimbs$date$Date$resultToParser = function (result) {
	if (!result.$) {
		var x = result.a;
		return $elm$parser$Parser$succeed(x);
	} else {
		var message = result.a;
		return $elm$parser$Parser$problem(message);
	}
};
var $justinmimbs$date$Date$parser = A2(
	$elm$parser$Parser$andThen,
	A2($elm$core$Basics$composeR, $justinmimbs$date$Date$fromYearAndDayOfYear, $justinmimbs$date$Date$resultToParser),
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Tuple$pair),
			$justinmimbs$date$Date$int4),
		$justinmimbs$date$Date$dayOfYear));
var $justinmimbs$date$Date$fromIsoString = A2(
	$elm$core$Basics$composeR,
	$elm$parser$Parser$run(
		A2(
			$elm$parser$Parser$keeper,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			A2(
				$elm$parser$Parser$ignorer,
				$justinmimbs$date$Date$parser,
				A2(
					$elm$parser$Parser$andThen,
					$justinmimbs$date$Date$resultToParser,
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2($elm$parser$Parser$map, $elm$core$Result$Ok, $elm$parser$Parser$end),
								A2(
								$elm$parser$Parser$map,
								$elm$core$Basics$always(
									$elm$core$Result$Err('Expected a date only, not a date and time')),
								$elm$parser$Parser$chompIf(
									$elm$core$Basics$eq('T'))),
								$elm$parser$Parser$succeed(
								$elm$core$Result$Err('Expected a date only'))
							])))))),
	$elm$core$Result$mapError(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map($justinmimbs$date$Date$deadEndToString),
			$elm$core$String$join('; '))));
var $CurrySoftware$elm_datepicker$DatePicker$Date$Off = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$off = $CurrySoftware$elm_datepicker$DatePicker$Date$Off;
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$required = $elm$html$Html$Attributes$boolProperty('required');
var $CurrySoftware$elm_datepicker$DatePicker$defaultSettings = {
	cJ: $CurrySoftware$elm_datepicker$DatePicker$formatCell,
	b9: $CurrySoftware$elm_datepicker$DatePicker$off,
	bp: 'elm-datepicker--',
	cM: _List_Nil,
	cS: $justinmimbs$date$Date$format('yyyy/MM/dd'),
	cU: $CurrySoftware$elm_datepicker$DatePicker$Date$formatDay,
	ci: 6,
	c0: _List_fromArray(
		[
			$elm$html$Html$Attributes$required(false)
		]),
	hy: _List_Nil,
	hz: $elm$core$Maybe$Nothing,
	c1: $elm$core$Maybe$Nothing,
	bO: $elm$core$Basics$always(false),
	c5: $CurrySoftware$elm_datepicker$DatePicker$Date$formatMonth,
	db: $justinmimbs$date$Date$fromIsoString,
	dc: 'Please pick a date...',
	du: $elm$core$String$fromInt
};
var $author$project$Views$DatePicker$dateSettings = _Utils_update(
	$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
	{
		hy: _List_fromArray(
			[
				_Utils_Tuple2('form-control', true)
			]),
		hz: $elm$core$Maybe$Just('datepicker'),
		dc: ''
	});
var $author$project$Api$Request$deleteAgent = F3(
	function (agentId, agencyId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$AddedUpdatedAgent, $author$project$Api$Decoders$agentsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'DELETE',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('agencies/' + (agencyId + ('/agents/' + agentId)))
			});
	});
var $author$project$MainMsg$DeletedImage = function (a) {
	return {$: 133, a: a};
};
var $author$project$Api$Request$deleteImage = F3(
	function (imageId, jwt, userId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$DeletedImage),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'DELETE',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (userId + ('/images/' + imageId)))
			});
	});
var $author$project$MainMsg$DeletedResume = function (a) {
	return {$: 129, a: a};
};
var $author$project$Api$Request$deleteResume = F2(
	function (jwt, userId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$DeletedResume),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'DELETE',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Just('upload'),
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (userId + '/resume'))
			});
	});
var $author$project$MainMsg$RemovedAgentFromTalent = function (a) {
	return {$: 33, a: a};
};
var $author$project$Api$Encoders$deleteTalentAgentEncoder = F2(
	function (associationId, agentId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'association_id',
					$elm$json$Json$Encode$string(associationId)),
					_Utils_Tuple2(
					'agent_id',
					$elm$json$Json$Encode$string(agentId))
				]));
	});
var $author$project$Api$Request$deleteTalentAgent = F3(
	function (associationId, agentId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$deleteTalentAgentEncoder, associationId, agentId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$RemovedAgentFromTalent, $author$project$Api$Decoders$updateProfileDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'DELETE',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'agencies/talent/remove_agent'
			});
	});
var $author$project$MainMsg$VideoDeleted = function (a) {
	return {$: 287, a: a};
};
var $author$project$Api$Request$deleteVideo = F2(
	function (videoId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$VideoDeleted, $author$project$Api$Decoders$videoDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'DELETE',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('video/' + videoId)
			});
	});
var $author$project$SharedProjectRoleSchedules$ProjectSchedule = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Main$determineSchedulePageView = F3(
	function (schedules, scheduleType, project) {
		return ($elm$core$List$length(
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.fB;
					},
					scheduleType),
				schedules)) > 0) ? A2($author$project$SharedProjectRoleSchedules$ProjectSchedule, project, scheduleType) : $author$project$SharedProjectRoleSchedules$DefaultSchedulePage(scheduleType);
	});
var $author$project$MainMsg$DismissAlert = {$: 81};
var $author$project$Utils$delay = F2(
	function (time, msg) {
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Task$andThen,
				$elm$core$Basics$always(
					$elm$core$Task$succeed(msg)),
				$elm$core$Process$sleep(time)));
	});
var $author$project$Main$dismissAlert = A2($author$project$Utils$delay, 5000, $author$project$MainMsg$DismissAlert);
var $author$project$Main$droppedOnBookingColumn = F2(
	function (columnId, columns) {
		var column = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pipeline$emptyColumn,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.aa;
						},
						columnId),
					columns)));
		return column.bS === 'Holding/Booked';
	});
var $author$project$Main$droppedOnSchedulingColumn = F2(
	function (columnId, columns) {
		var column = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Pipeline$emptyColumn,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.aa;
						},
						columnId),
					columns)));
		return _Utils_Tuple2(
			A2(
				$elm$core$List$member,
				column.bS,
				_List_fromArray(
					['Scheduled Audition', 'Scheduled Callbacks'])),
			A2(
				$elm$core$Maybe$withDefault,
				'',
				$elm$core$List$head(
					$elm$core$List$reverse(
						A2($elm$core$String$split, ' ', column.bS)))));
	});
var $author$project$User$emptyUserConvoInfo = {ir: $author$project$User$emptyImage, iw: '', ix: '', iK: '', aX: '', iL: '', ju: ''};
var $author$project$User$emptyUserNotification = {dP: '', gV: '', d0: 1, aa: '', hE: false, hF: '', eE: '', hH: '', hK: 27, iw: '', ix: '', iK: '', aX: '', iL: '', jc: '', jd: '', jf: '', fY: ''};
var $author$project$Main$evaluateAuthStatus = function (token) {
	return (token === '') ? 0 : 1;
};
var $author$project$User$emptyScheduleMember = {dP: '', aa: '', dj: 27, fB: '', fD: ''};
var $author$project$Main$getFirstOrLatestScheduleStatus = function (scheduleMembers) {
	return ($elm$core$List$length(scheduleMembers) > 1) ? A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyScheduleMember,
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (scheduleMember) {
					return A2(
						$elm$core$List$member,
						scheduleMember.dj,
						_List_fromArray(
							[6]));
				},
				scheduleMembers))).dj : A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyScheduleMember,
		$elm$core$List$head(scheduleMembers)).dj;
};
var $author$project$Main$extractStage = function (pipelineUser) {
	var _v0 = pipelineUser.i3;
	if (_v0 === 26) {
		return $author$project$Main$getFirstOrLatestScheduleStatus(pipelineUser.fA);
	} else {
		return pipelineUser.i3;
	}
};
var $author$project$MainMsg$AllProjects = function (a) {
	return {$: 45, a: a};
};
var $author$project$SharedProjectRoleSchedules$ProjectData = function (id_) {
	return function (name) {
		return function (agencyNotes) {
			return function (talentNotes) {
				return function (projectRate) {
					return function (union) {
						return function (deadlines) {
							return function (projectDescription) {
								return function (userID) {
									return function (archived) {
										return function (isActive) {
											return function (schedules) {
												return function (roles) {
													return function (pipeline) {
														return function (createdAt) {
															return {gk: agencyNotes, dI: archived, cO: createdAt, g6: deadlines, c$: id_, hB: isActive, bS: name, A: pipeline, it: projectDescription, iy: projectRate, ft: roles, k: schedules, jg: talentNotes, jo: union, jt: userID};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Pipeline$Column = F8(
	function (id, position, name, customName, isHidden, users, sort, filter) {
		return {g2: customName, hm: filter, aa: id, hC: isHidden, bS: name, io: position, i2: sort, jx: users};
	});
var $author$project$User$NoFilter = 3;
var $author$project$User$AcceptedInvite = 2;
var $author$project$User$Invited = 1;
var $author$project$Api$Decoders$decodeFilterType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Applied':
				return $elm$json$Json$Decode$succeed(0);
			case 'Requested to Apply':
				return $elm$json$Json$Decode$succeed(1);
			case 'Accepted Application':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$succeed(3);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$User$Datedesc = 1;
var $author$project$User$RoleType = 2;
var $author$project$User$StatusType = 3;
var $author$project$Api$Decoders$decodeSortType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'asc':
				return $elm$json$Json$Decode$succeed(0);
			case 'desc':
				return $elm$json$Json$Decode$succeed(1);
			case 'role':
				return $elm$json$Json$Decode$succeed(2);
			case 'status':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$succeed(0);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$usersInPipelineDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$pipelineUserDecoder);
var $author$project$Api$Decoders$columnDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'filter',
	$author$project$Api$Decoders$decodeFilterType,
	3,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'sort',
		$author$project$Api$Decoders$decodeSortType,
		0,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'users',
			$author$project$Api$Decoders$usersInPipelineDecoder,
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_hidden',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'custom_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'position',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'id',
								$elm$json$Json$Decode$string,
								$elm$json$Json$Decode$succeed($author$project$Pipeline$Column)))))))));
var $author$project$SharedProjectRoleSchedules$Deadline = F9(
	function (name, startDate, endDate, location, address1, address2, city, state, zip) {
		return {bF: address1, bG: address2, a0: city, ee: endDate, hM: location, bS: name, fP: startDate, bf: state, dv: zip};
	});
var $author$project$Api$Decoders$deadlineDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'zip_code',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'state',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'city',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'address_2',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'address_1',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'location',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'due_at',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'starts_at',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$Deadline))))))))));
var $author$project$SharedProjectRoleSchedules$ProjectRoleData = F4(
	function (id_, name, roleDescription, active) {
		return {gf: active, c$: id_, bS: name, iI: roleDescription};
	});
var $author$project$Api$Decoders$projectRoleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'active',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'description',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$ProjectRoleData)))));
var $author$project$Api$Decoders$projectDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'created_at',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'pipeline',
		$elm$json$Json$Decode$list($author$project$Api$Decoders$columnDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'roles',
			$elm$json$Json$Decode$list($author$project$Api$Decoders$projectRoleDecoder),
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'schedules',
				$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder),
				_List_Nil,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_active',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'archived',
						$elm$json$Json$Decode$bool,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'user_id',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'notes',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'deadlines',
									$elm$json$Json$Decode$list($author$project$Api$Decoders$deadlineDecoder),
									_List_Nil,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'union',
										$elm$json$Json$Decode$bool,
										false,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'rate',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'talent_notes',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'agency_notes',
													$elm$json$Json$Decode$string,
													'',
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'name',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$string,
															$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$ProjectData))))))))))))))));
var $author$project$Api$Request$getProjects = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2(
				$elm$http$Http$expectJson,
				$author$project$MainMsg$AllProjects,
				$elm$json$Json$Decode$list($author$project$Api$Decoders$projectDecoder)),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'projects'
		});
};
var $author$project$Main$fetchAllProjects = function (token) {
	return $author$project$Api$Request$getProjects(token);
};
var $author$project$MainMsg$AllApplicants = function (a) {
	return {$: 141, a: a};
};
var $author$project$Job$ApplicantData = F5(
	function (roleID, userID, id, stage, user) {
		return {aa: id, iJ: roleID, i3: stage, f_: user, jt: userID};
	});
var $author$project$User$SearchResultTalentProfile = function (id_) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phone) {
					return function (eyeColor) {
						return function (birthDate) {
							return function (gender) {
								return function (ethnicities) {
									return function (height) {
										return function (weight) {
											return function (waistSize) {
												return function (city) {
													return function (state) {
														return function (company) {
															return function (images) {
																return function (videos) {
																	return function (hairColor) {
																		return function (hairLength) {
																			return function (roleMemberId) {
																				return function (selected) {
																					return function (currentColumn) {
																						return function (stage) {
																							return function (age) {
																								return function (roleName) {
																									return function (projectName) {
																										return function (roleId) {
																											return function (canLoadMore) {
																												return function (currentOffset) {
																													return function (agency) {
																														return function (inRole) {
																															return function (scheduleMembers) {
																																return function (resume) {
																																	return {dA: age, gj: agency, gA: birthDate, dT: canLoadMore, a0: city, cK: company, gY: currentColumn, d4: currentOffset, bv: email, eg: ethnicities, hi: eyeColor, bx: firstName, hq: gender, ck: hairColor, cl: hairLength, ht: height, c$: id_, l: images, ez: inRole, bP: lastName, e0: phone, ix: projectName, iH: resume, iK: roleId, aX: roleMemberId, iL: roleName, fA: scheduleMembers, cz: selected, i3: stage, bf: state, a_: videos, jA: waistSize, jC: weight};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$searchResultTalentProfileDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'resume',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'schedule_members',
		$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleMemberDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'in_role',
			$elm$json$Json$Decode$bool,
			false,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'agency',
				$author$project$Api$Decoders$agencyDecoder,
				$author$project$User$emptyAgency,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'current_offset',
					$elm$json$Json$Decode$int,
					0,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'can_load_more',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'role_id',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'project_name',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'role_name',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'age',
										$elm$json$Json$Decode$int,
										0,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'stage',
											$author$project$Api$Decoders$stageDecoder,
											27,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'current_column',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'selected',
													$elm$json$Json$Decode$bool,
													false,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'role_member_id',
														$elm$json$Json$Decode$string,
														'',
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'hair_length',
															$elm$json$Json$Decode$string,
															'',
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'hair_color',
																$elm$json$Json$Decode$string,
																'',
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'videos',
																	$author$project$Api$Decoders$videosDecoder,
																	_List_Nil,
																	A4(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																		'images',
																		$author$project$Api$Decoders$imagesDecoder,
																		_List_Nil,
																		A4(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																			'company',
																			$elm$json$Json$Decode$string,
																			'',
																			A4(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																				'state',
																				$elm$json$Json$Decode$string,
																				'',
																				A4(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																					'city',
																					$elm$json$Json$Decode$string,
																					'',
																					A4(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																						'waist_size',
																						$elm$json$Json$Decode$oneOf(
																							_List_fromArray(
																								[
																									$elm$json$Json$Decode$float,
																									$elm$json$Json$Decode$null(0)
																								])),
																						0,
																						A4(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																							'weight',
																							$elm$json$Json$Decode$int,
																							0,
																							A4(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																								'height',
																								$elm$json$Json$Decode$int,
																								0,
																								A4(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																									'ethnicities',
																									$author$project$Api$Decoders$ethnicitiesDecoder,
																									_List_Nil,
																									A4(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																										'gender',
																										$elm$json$Json$Decode$string,
																										'',
																										A4(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																											'birth_date',
																											$elm$json$Json$Decode$string,
																											'',
																											A4(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																												'eye_color',
																												$elm$json$Json$Decode$string,
																												'',
																												A4(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																													'phone',
																													$elm$json$Json$Decode$string,
																													'',
																													A4(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																														'email',
																														$elm$json$Json$Decode$string,
																														'',
																														A4(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																															'last_name',
																															$elm$json$Json$Decode$string,
																															'',
																															A4(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																																'first_name',
																																$elm$json$Json$Decode$string,
																																'',
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'id',
																																	$elm$json$Json$Decode$string,
																																	$elm$json$Json$Decode$succeed($author$project$User$SearchResultTalentProfile))))))))))))))))))))))))))))))))));
var $author$project$Api$Decoders$applicantDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'user',
	$author$project$Api$Decoders$searchResultTalentProfileDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'stage',
		$author$project$Api$Decoders$stageDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'userID',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'roleID',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Job$ApplicantData))))));
var $author$project$Api$Decoders$applicantListDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$applicantDecoder);
var $author$project$Api$Request$getRoleApplicants = F2(
	function (roleID, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$AllApplicants, $author$project$Api$Decoders$applicantListDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('role/member?roleId=' + roleID)
			});
	});
var $author$project$Main$fetchApplicantData = F2(
	function (roleId, token) {
		return A2($author$project$Api$Request$getRoleApplicants, roleId, token);
	});
var $author$project$MainMsg$GotCollaboratorProjects = function (a) {
	return {$: 270, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollaboratingProject = F4(
	function (id, name, schedule_id, accepted) {
		return {cC: accepted, aa: id, bS: name, fC: schedule_id};
	});
var $author$project$Api$Decoders$collaboratingProjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accepted',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'schedule_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$CollaboratingProject)))));
var $author$project$Api$Decoders$collaboratingProjectsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$collaboratingProjectDecoder);
var $author$project$Api$Request$getCollaboratingProjects = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotCollaboratorProjects, $author$project$Api$Decoders$collaboratingProjectsDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'collaborator/projects'
		});
};
var $author$project$Main$fetchCollaboratingProjects = function (jwt) {
	return $author$project$Api$Request$getCollaboratingProjects(jwt);
};
var $author$project$Main$fetchConversations = F2(
	function (twilioToken, twilioData) {
		return $author$project$Main$twilio(
			{
				z: 'getChannels',
				ai: $author$project$Api$Encoders$twilioPayloadEncoder($author$project$Message$emptyToTwilioPayload),
				ao: twilioToken
			});
	});
var $author$project$MainMsg$GotPipeline = function (a) {
	return {$: 157, a: a};
};
var $author$project$Api$Decoders$pipelineDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$columnDecoder);
var $author$project$Api$Request$getPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotPipeline, $author$project$Api$Decoders$pipelineDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + '/pipeline'))
		});
};
var $author$project$Main$fetchPipeline = function (model) {
	return $author$project$Api$Request$getPipeline(model);
};
var $author$project$MainMsg$AllRoles = function (a) {
	return {$: 52, a: a};
};
var $author$project$SharedProjectRoleSchedules$RoleData = function (id_) {
	return function (name) {
		return function (projectID) {
			return function (roleDescription) {
				return function (genders) {
					return function (minAge) {
						return function (maxAge) {
							return function (roleRate) {
								return function (ethnicities) {
									return function (minHeight) {
										return function (maxHeight) {
											return function (minWeight) {
												return function (maxWeight) {
													return function (archived) {
														return function (projectId) {
															return function (projectName) {
																return function (projectDescription) {
																	return function (deadlines) {
																		return function (active) {
																			return {gf: active, dI: archived, g6: deadlines, eg: ethnicities, hs: genders, c$: id_, c2: maxAge, hP: maxHeight, eM: maxWeight, c4: minAge, hW: minHeight, eQ: minWeight, bS: name, it: projectDescription, fe: projectID, iw: projectId, ix: projectName, iI: roleDescription, iM: roleRate};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$roleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'active',
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'deadlines',
		$elm$json$Json$Decode$list($author$project$Api$Decoders$deadlineDecoder),
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'project_description',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'project_name',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'project_id',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'archived',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'max_weight',
							$elm$json$Json$Decode$oneOf(
								_List_fromArray(
									[
										$elm$json$Json$Decode$float,
										$elm$json$Json$Decode$null(0)
									])),
							0,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'min_weight',
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											$elm$json$Json$Decode$float,
											$elm$json$Json$Decode$null(0)
										])),
								0,
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'max_height',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$null(0)
											])),
									0,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'min_height',
										$elm$json$Json$Decode$oneOf(
											_List_fromArray(
												[
													$elm$json$Json$Decode$int,
													$elm$json$Json$Decode$null(0)
												])),
										0,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'ethnicities',
											$author$project$Api$Decoders$ethnicitiesDecoder,
											_List_Nil,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'rate',
												$elm$json$Json$Decode$string,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'max_age',
													$elm$json$Json$Decode$int,
													100,
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'min_age',
														$elm$json$Json$Decode$int,
														0,
														A4(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
															'genders',
															$author$project$Api$Decoders$ethnicitiesDecoder,
															_List_Nil,
															A4(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																'description',
																$elm$json$Json$Decode$string,
																'',
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'project_id',
																	$elm$json$Json$Decode$string,
																	'',
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'name',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$string,
																			$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$RoleData))))))))))))))))))));
var $author$project$Api$Request$getRoles = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2(
				$elm$http$Http$expectJson,
				$author$project$MainMsg$AllRoles,
				$elm$json$Json$Decode$list($author$project$Api$Decoders$roleDecoder)),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'roles'
		});
};
var $author$project$Main$fetchRoleData = function (token) {
	return $author$project$Api$Request$getRoles(token);
};
var $author$project$MainMsg$GotTalent = function (a) {
	return {$: 315, a: a};
};
var $author$project$SharedProjectRoleSchedules$TalentUser = F6(
	function (id, name, accepted, currentJobs, membershipId, profileImage) {
		return {cC: accepted, gZ: currentJobs, aa: id, hS: membershipId, bS: name, ir: profileImage};
	});
var $author$project$SharedProjectRoleSchedules$UserJob = F6(
	function (role, state, applicationStatus, timeSlots, roleMemberId, scheduleMembers) {
		return {gt: applicationStatus, V: role, aX: roleMemberId, fA: scheduleMembers, bf: state, jl: timeSlots};
	});
var $author$project$SharedProjectRoleSchedules$BasicSchedulingInfo = F2(
	function (eventTime, scheduleType) {
		return {hd: eventTime, fB: scheduleType};
	});
var $author$project$Api$Decoders$basicSchedulingInfoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'schedule_type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'event_time',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$BasicSchedulingInfo)));
var $author$project$Api$Decoders$jobDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'schedule_members',
	$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleMemberDecoder),
	_List_Nil,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'roleMemberId',
		$elm$json$Json$Decode$string,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'time_slots',
			$elm$json$Json$Decode$list($author$project$Api$Decoders$basicSchedulingInfoDecoder),
			_List_Nil,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'application_status',
				$author$project$Api$Decoders$stageDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$author$project$Api$Decoders$stageDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'role',
						$author$project$Api$Decoders$roleDecoder,
						$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$UserJob)))))));
var $author$project$Api$Decoders$jobsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$jobDecoder);
var $author$project$SharedProjectRoleSchedules$MembershipAccepted = 0;
var $author$project$SharedProjectRoleSchedules$MembershipPending = 2;
var $author$project$SharedProjectRoleSchedules$MembershipRejected = 1;
var $author$project$Api$Decoders$talentMembershipDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'Accepted':
				return $elm$json$Json$Decode$succeed(0);
			case 'Rejected':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$succeed(2);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$talentUserDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'profile_image',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'membership_id',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'current_jobs',
			$author$project$Api$Decoders$jobsDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'accepted',
				$author$project$Api$Decoders$talentMembershipDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$TalentUser)))))));
var $author$project$Api$Decoders$talentUsersDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$talentUserDecoder);
var $author$project$Api$Request$getAgentTalent = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotTalent, $author$project$Api$Decoders$talentUsersDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'agency/talent'
		});
};
var $author$project$Main$fetchTalent = function (token) {
	return $author$project$Api$Request$getAgentTalent(token);
};
var $author$project$MainMsg$GotJobs = function (a) {
	return {$: 174, a: a};
};
var $author$project$Api$Request$getUserJobs = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotJobs, $author$project$Api$Decoders$jobsDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('users/' + ('user_id' + '/jobs'))
		});
};
var $author$project$Main$fetchUsersJobs = function (jwt) {
	return $author$project$Api$Request$getUserJobs(jwt);
};
var $author$project$MainMsg$GotCollaboratorsOnProject = function (a) {
	return {$: 277, a: a};
};
var $author$project$Api$Request$getCollaboratorsOnProject = F2(
	function (projectId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotCollaboratorsOnProject, $author$project$Api$Decoders$collaboratorsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('project/' + (projectId + '/collaborators'))
			});
	});
var $author$project$MainMsg$GotOptions = function (a) {
	return {$: 172, a: a};
};
var $author$project$User$Options = F2(
	function (ethnicities, genders) {
		return {eg: ethnicities, hs: genders};
	});
var $author$project$Api$Decoders$optionsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'genders',
	$author$project$Api$Decoders$ethnicitiesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ethnicities',
		$author$project$Api$Decoders$ethnicitiesDecoder,
		$elm$json$Json$Decode$succeed($author$project$User$Options)));
var $author$project$Api$Request$getOptions = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotOptions, $author$project$Api$Decoders$optionsDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'ethnicities'
		});
};
var $author$project$MainMsg$GotProject = function (a) {
	return {$: 206, a: a};
};
var $author$project$Api$Request$getProjectData = F2(
	function (jwt, projectId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotProject, $author$project$Api$Decoders$projectDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('projects/' + projectId)
			});
	});
var $author$project$MainMsg$GotSchedule = function (a) {
	return {$: 290, a: a};
};
var $author$project$Api$Request$getSchedule = F3(
	function (jwt, projectId, scheduleId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotSchedule, $author$project$Api$Decoders$scheduleDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (projectId + ('/schedules/' + scheduleId)))
			});
	});
var $author$project$MainMsg$GotProjectSchedules = function (a) {
	return {$: 191, a: a};
};
var $author$project$Api$Request$getSchedules = F2(
	function (projectId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2(
					$elm$http$Http$expectJson,
					$author$project$MainMsg$GotProjectSchedules,
					$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder)),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (projectId + '/schedules'))
			});
	});
var $author$project$MainMsg$AccountVerified = function (a) {
	return {$: 139, a: a};
};
var $author$project$Api$Request$verification = F3(
	function (jwt, id, code) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$AccountVerified),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('account/' + (id + ('/verify/' + code)))
			});
	});
var $author$project$Main$verifyAccount = F3(
	function (jwt, id, code) {
		return A3($author$project$Api$Request$verification, jwt, id, code);
	});
var $author$project$Main$fetchAppropriateData = F8(
	function (page, id, jwt, sort, filter, twilioToken, twilioData, user) {
		switch (page.$) {
			case 10:
				return _List_fromArray(
					[
						A2($author$project$Main$fetchConversations, twilioToken, twilioData),
						$author$project$Main$fetchAllProjects(jwt)
					]);
			case 13:
				switch (user) {
					case 0:
						return _List_fromArray(
							[
								A2($author$project$Main$fetchConversations, twilioToken, twilioData),
								$author$project$Main$fetchUsersJobs(jwt)
							]);
					case 1:
						return _List_fromArray(
							[
								$author$project$Main$fetchAllProjects(jwt),
								$author$project$Main$fetchRoleData(jwt),
								A2($author$project$Main$fetchConversations, twilioToken, twilioData),
								$author$project$Main$fetchCollaboratingProjects(jwt)
							]);
					case 3:
						return _List_fromArray(
							[
								$author$project$Main$fetchAllProjects(jwt),
								$author$project$Main$fetchTalent(jwt),
								$author$project$Main$fetchRoleData(jwt),
								A2($author$project$Main$fetchConversations, twilioToken, twilioData),
								$author$project$Main$fetchCollaboratingProjects(jwt)
							]);
					case 2:
						return _List_fromArray(
							[
								$author$project$Main$fetchCollaboratingProjects(jwt)
							]);
					default:
						return _List_Nil;
				}
			case 21:
				var i = page.a;
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(jwt),
						$author$project$Main$fetchPipeline(
						{d6: i, hI: jwt, i2: sort}),
						A2($author$project$Api$Request$getSchedules, i, jwt),
						$author$project$Main$fetchRoleData(jwt),
						A2($author$project$Api$Request$getProjectData, jwt, i),
						$author$project$Main$fetchCollaboratingProjects(jwt)
					]);
			case 12:
				var i = page.a;
				return _List_fromArray(
					[
						$author$project$Main$fetchRoleData(jwt),
						A2($author$project$Main$fetchApplicantData, i, jwt)
					]);
			case 22:
				var i = page.a;
				var code = page.b;
				return _List_fromArray(
					[
						A3($author$project$Main$verifyAccount, jwt, i, code)
					]);
			case 8:
				return _List_Nil;
			case 7:
				return _List_Nil;
			case 9:
				return _List_fromArray(
					[
						$author$project$Main$fetchRoleData(jwt),
						$author$project$Main$fetchUsersJobs(jwt),
						A2($author$project$Main$fetchConversations, twilioToken, twilioData)
					]);
			case 23:
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(jwt),
						$author$project$Main$fetchRoleData(jwt)
					]);
			case 24:
				var i = page.a;
				var scheduleType = page.b;
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(jwt),
						$author$project$Main$fetchRoleData(jwt),
						A2($author$project$Api$Request$getProjectData, jwt, i)
					]);
			case 25:
				var projectId = page.a;
				var scheduleId = page.b;
				return _List_fromArray(
					[
						A3($author$project$Api$Request$getSchedule, jwt, projectId, scheduleId),
						A2($author$project$Api$Request$getSchedules, projectId, jwt),
						A2($author$project$Api$Request$getCollaboratorsOnProject, projectId, jwt)
					]);
			default:
				return _List_fromArray(
					[
						$author$project$Api$Request$getOptions(jwt)
					]);
		}
	});
var $author$project$MainMsg$GotDashboardPageData = function (a) {
	return {$: 40, a: a};
};
var $author$project$SharedProjectRoleSchedules$DashboardPage = F5(
	function (projects, roles, myJobs, talent, timeSlots) {
		return {eR: myJobs, fh: projects, ft: roles, jb: talent, jl: timeSlots};
	});
var $author$project$SharedProjectRoleSchedules$BasicProjectData = function (id) {
	return function (name) {
		return function (agencyNotes) {
			return function (talentNotes) {
				return function (projectRate) {
					return function (union) {
						return function (postedDate) {
							return function (description) {
								return function (shootDate) {
									return function (projectLocation) {
										return function (auditionLocation) {
											return function (shootLocation) {
												return function (roles) {
													return function (matchingCandidatesColumn) {
														return function (projectDates) {
															return function (talent) {
																return {gk: agencyNotes, dN: auditionLocation, br: description, aa: id, hO: matchingCandidatesColumn, bS: name, e4: postedDate, fc: projectDates, ff: projectLocation, iy: projectRate, ft: roles, i0: shootDate, fJ: shootLocation, jb: talent, jg: talentNotes, jo: union};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$SharedProjectRoleSchedules$BasicRoleData = F8(
	function (id, name, description, genders, ethnicities, ageRange, projectId, projectName) {
		return {dC: ageRange, br: description, eg: ethnicities, hs: genders, aa: id, bS: name, iw: projectId, ix: projectName};
	});
var $author$project$Api$Decoders$basicRoleDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'project_name',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'project_id',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'age_range',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'ethnicities',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'genders',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'description',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'name',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'id',
								$elm$json$Json$Decode$string,
								'',
								$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$BasicRoleData)))))))));
var $author$project$Api$Decoders$basicRolesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$basicRoleDecoder);
var $author$project$Api$Decoders$basicProjectDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'talent',
	$author$project$Api$Decoders$searchResultTalentProfileDecoder,
	$author$project$User$emptySearchTalentProfile,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'project_dates',
		$elm$json$Json$Decode$string,
		'',
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'matching_candidates_column',
			$elm$json$Json$Decode$string,
			'',
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'roles',
				$author$project$Api$Decoders$basicRolesDecoder,
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'shoot_location',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'audition_location',
						$elm$json$Json$Decode$string,
						'',
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'project_location',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'shoot_date',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'description',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'posted_date',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'union',
											$elm$json$Json$Decode$bool,
											false,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'project_rate',
												$elm$json$Json$Decode$string,
												'',
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'talent_notes',
													$elm$json$Json$Decode$string,
													'',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'agency_notes',
														$elm$json$Json$Decode$string,
														'',
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'name',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'id',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$BasicProjectData)))))))))))))))));
var $author$project$Api$Decoders$basicProjectsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$basicProjectDecoder);
var $author$project$Api$Decoders$dashboardPageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'time_slots',
	$elm$json$Json$Decode$list($author$project$Api$Decoders$timeSlotDecoder),
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'talent',
		$author$project$Api$Decoders$talentUsersDecoder,
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'myJobs',
			$author$project$Api$Decoders$jobsDecoder,
			_List_Nil,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'roles',
				$author$project$Api$Decoders$basicRolesDecoder,
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'projects',
					$author$project$Api$Decoders$basicProjectsDecoder,
					_List_Nil,
					$elm$json$Json$Decode$succeed($author$project$SharedProjectRoleSchedules$DashboardPage))))));
var $author$project$Api$Request$getDashboardData = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotDashboardPageData, $author$project$Api$Decoders$dashboardPageDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'dashboard'
		});
};
var $author$project$MainMsg$GotJobPageData = function (a) {
	return {$: 319, a: a};
};
var $author$project$Job$JobPageData = F6(
	function (projects, myJobs, searchTerm, searchStatus, viewingJob, selectedProject) {
		return {eR: myJobs, fh: projects, fE: searchStatus, fF: searchTerm, fG: selectedProject, f3: viewingJob};
	});
var $author$project$Job$Results = 1;
var $author$project$Api$Decoders$searchStatusDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return $elm$json$Json$Decode$succeed(1);
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$viewingJobDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return $elm$json$Json$Decode$succeed(1);
	},
	$elm$json$Json$Decode$string);
var $author$project$Api$Decoders$jobPageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'selected_project',
	$author$project$Api$Decoders$basicProjectDecoder,
	$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'viewing_job',
		$author$project$Api$Decoders$viewingJobDecoder,
		1,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'search_status',
			$author$project$Api$Decoders$searchStatusDecoder,
			1,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'search_term',
				$elm$json$Json$Decode$string,
				'',
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'my_jobs',
					$author$project$Api$Decoders$jobsDecoder,
					_List_Nil,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'projects',
						$author$project$Api$Decoders$basicProjectsDecoder,
						$elm$json$Json$Decode$succeed($author$project$Job$JobPageData)))))));
var $author$project$Api$Request$getJobPageData = F2(
	function (jwt, projectId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotJobPageData, $author$project$Api$Decoders$jobPageDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('job_page_data/' + projectId)
			});
	});
var $author$project$Main$fetchDataForPage = F2(
	function (page, model) {
		switch (page.$) {
			case 13:
				return _List_fromArray(
					[
						$author$project$Api$Request$getDashboardData(model.hI),
						A2($author$project$Main$fetchConversations, model.E.C, model.p),
						$author$project$Main$fetchCollaboratingProjects(model.hI)
					]);
			case 21:
				var projectId = page.a;
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(model.hI),
						$author$project$Main$fetchPipeline(
						{d6: projectId, hI: model.hI, i2: model.i2}),
						A2($author$project$Api$Request$getSchedules, projectId, model.hI),
						$author$project$Main$fetchRoleData(model.hI),
						A2($author$project$Api$Request$getProjectData, model.hI, projectId),
						$author$project$Main$fetchCollaboratingProjects(model.hI)
					]);
			case 23:
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(model.hI)
					]);
			case 8:
				return _List_fromArray(
					[
						$author$project$Main$fetchAllProjects(model.hI),
						$author$project$Main$fetchRoleData(model.hI),
						$author$project$Main$fetchUsersJobs(model.hI)
					]);
			case 7:
				var projectId = page.a;
				return _List_fromArray(
					[
						A2($author$project$Api$Request$getJobPageData, model.hI, projectId)
					]);
			default:
				return _List_Nil;
		}
	});
var $author$project$MainMsg$GotMessages = function (a) {
	return {$: 99, a: a};
};
var $author$project$Message$MessageData = function (id) {
	return function (creatorId) {
		return function (name) {
			return function (timeStamp) {
				return function (body) {
					return function (conversationId) {
						return function (downloadUrl) {
							return function (fileName) {
								return function (size) {
									return function (messageType) {
										return function (contentType) {
											return {dP: body, cN: contentType, gV: conversationId, gW: creatorId, bN: downloadUrl, bw: fileName, aa: id, aF: messageType, bS: name, dl: size, bh: timeStamp};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Api$Decoders$messageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'contentType',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'messageType',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'size',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'fileName',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'downloadUrl',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'conversationId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'body',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'timeStamp',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'creatorId',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$Message$MessageData))))))))))));
var $author$project$Api$Decoders$messagesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$messageDecoder);
var $author$project$Api$Request$getMessages = F3(
	function (creatorId, conversationId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotMessages, $author$project$Api$Decoders$messagesDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (creatorId + ('/conversations/' + (conversationId + '/messages'))))
			});
	});
var $author$project$Main$fetchMessages = F3(
	function (conversationId, token, userId) {
		return (conversationId !== '') ? A3($author$project$Api$Request$getMessages, userId, conversationId, token) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Main$fetchNewToken = _Platform_outgoingPort('fetchNewToken', $elm$json$Json$Encode$string);
var $author$project$MainMsg$GotUnreadMessages = function (a) {
	return {$: 134, a: a};
};
var $author$project$Api$Request$getUnreadMessages = F2(
	function (userId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotUnreadMessages, $author$project$Api$Decoders$messagesDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (userId + '/messages/unread'))
			});
	});
var $author$project$Main$fetchUnreadMessages = F2(
	function (userId, token) {
		return A2($author$project$Api$Request$getUnreadMessages, userId, token);
	});
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$Main$fileUploadPayload = F3(
	function (file, channelId, roleMemberId) {
		return _Utils_update(
			$author$project$Message$emptyToTwilioPayload,
			{dP: file, gJ: channelId, aX: roleMemberId});
	});
var $author$project$Main$filterImages = F2(
	function (id, images) {
		return A2(
			$elm$core$List$filter,
			function (image) {
				return !_Utils_eq(image.aa, id);
			},
			images);
	});
var $author$project$Main$updatePipelineUsers = F2(
	function (pipeline, column) {
		return A2(
			$elm$core$List$map,
			function (c) {
				return _Utils_eq(c.aa, column.aa) ? column : c;
			},
			pipeline);
	});
var $author$project$Main$filterOrSortViewingProjectPipeline = F2(
	function (viewingProject, column) {
		return _Utils_update(
			viewingProject,
			{
				A: A2($author$project$Main$updatePipelineUsers, viewingProject.A, column)
			});
	});
var $author$project$MainMsg$FilteredColumn = function (a) {
	return {$: 182, a: a};
};
var $author$project$Api$Encoders$filterEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'filter',
				$elm$json$Json$Encode$string(model.hm)),
				_Utils_Tuple2(
				'column_id',
				$elm$json$Json$Encode$string(model.aa))
			]));
};
var $author$project$Api$Request$filterPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$filterEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$FilteredColumn, $author$project$Api$Decoders$pipelineDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + '/pipeline'))
		});
};
var $author$project$Main$filterPipelineUsers = function (model) {
	return $author$project$Api$Request$filterPipeline(model);
};
var $author$project$Main$filterProject = F2(
	function (id, projects) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.c$;
					},
					id),
				projects));
	});
var $author$project$Main$filterRole = F2(
	function (id, roles) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.c$;
					},
					id),
				roles));
	});
var $author$project$Main$filteringMap = function (filter) {
	switch (filter) {
		case 0:
			return 'Applied';
		case 1:
			return 'Requested to Apply';
		case 2:
			return 'Accepted Application';
		default:
			return 'no_filter';
	}
};
var $author$project$Utils$findProject = F2(
	function (projects, projectId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyProject,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.c$;
						},
						projectId),
					projects)));
	});
var $author$project$Views$Messages$findRole = F2(
	function (roles, roleId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyRole,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.c$;
						},
						roleId),
					roles)));
	});
var $author$project$Main$fireBaseLogin = _Platform_outgoingPort(
	'fireBaseLogin',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Main$fireBaseSignUp = _Platform_outgoingPort(
	'fireBaseSignUp',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Views$Project$firstProject = function (allProjects) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptyProject,
		$elm$core$List$head(allProjects));
};
var $elm$http$Http$fractionSent = function (p) {
	return (!p.dl) ? 1 : A3($elm$core$Basics$clamp, 0, 1, p.i_ / p.dl);
};
var $author$project$MainMsg$GotAgencies = function (a) {
	return {$: 301, a: a};
};
var $author$project$Api$Decoders$agenciesDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$agencyDecoder);
var $author$project$Api$Request$getAgencies = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotAgencies, $author$project$Api$Decoders$agenciesDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'agencies'
		});
};
var $author$project$MainMsg$GotAgent = function (a) {
	return {$: 108, a: a};
};
var $author$project$User$Invitation = F2(
	function (user, create_account) {
		return {cc: create_account, f_: user};
	});
var $author$project$Api$Decoders$invitationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'create_account',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'user',
		$author$project$Api$Decoders$collaboratorDecoder,
		$elm$json$Json$Decode$succeed($author$project$User$Invitation)));
var $author$project$Api$Request$getAgentInfo = F2(
	function (jwt, secretKey) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotAgent, $author$project$Api$Decoders$invitationDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('agencies/invite/' + secretKey)
			});
	});
var $author$project$MainMsg$GotCollaborator = function (a) {
	return {$: 269, a: a};
};
var $author$project$Api$Request$getCollaboratorInfo = F2(
	function (jwt, secretKey) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotCollaborator, $author$project$Api$Decoders$invitationDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('collaborator/invite/' + secretKey)
			});
	});
var $author$project$MainMsg$GotCollaborators = function (a) {
	return {$: 267, a: a};
};
var $author$project$Api$Request$getCollaborators = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotCollaborators, $author$project$Api$Decoders$collaboratorsDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + '/collaborators'
		});
};
var $author$project$MainMsg$UserSignIn = function (a) {
	return {$: 18, a: a};
};
var $author$project$Api$Request$getCurrentUser = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UserSignIn, $author$project$Api$Decoders$updateProfileDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'users/user_id'
		});
};
var $author$project$MainMsg$GotDetailedTalentInfo = function (a) {
	return {$: 260, a: a};
};
var $author$project$Api$Request$getDetailedTalentInfo = F3(
	function (jwt, projectId, userId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotDetailedTalentInfo, $author$project$Api$Decoders$searchResultTalentProfileDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (userId + ('/' + (projectId + '/detailed'))))
			});
	});
var $author$project$MainMsg$NotificationsRefreshed = function (a) {
	return {$: 240, a: a};
};
var $author$project$Api$Request$getNotifications = F2(
	function (jwt, notificationCount) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$NotificationsRefreshed, $author$project$Api$Decoders$notificationsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (jwt + ('/get_notifications/' + notificationCount)))
			});
	});
var $author$project$MainMsg$GotProxiedImage = function (a) {
	return {$: 258, a: a};
};
var $author$project$Api$Encoders$imageProxyEncoder = F2(
	function (url, id) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'url',
					$elm$json$Json$Encode$string(url)),
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(id))
				]));
	});
var $author$project$User$ProxyImage = F2(
	function (id, url) {
		return {aa: id, js: url};
	});
var $author$project$Api$Decoders$proxyImageDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'image_url',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'id',
		$elm$json$Json$Decode$string,
		'',
		$elm$json$Json$Decode$succeed($author$project$User$ProxyImage)));
var $author$project$Api$Request$getProxiedImage = F2(
	function (image, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$imageProxyEncoder, image.js, image.aa)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotProxiedImage, $author$project$Api$Decoders$proxyImageDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'images/proxy'
			});
	});
var $author$project$MainMsg$GotTempfile = function (a) {
	return {$: 294, a: a};
};
var $author$project$Api$Request$getTempfile = F2(
	function (jwt, roleMemberId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotTempfile, $author$project$Api$Decoders$videoDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (roleMemberId + '/tempfile'))
			});
	});
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Main$toPath = function (page) {
	switch (page.$) {
		case 0:
			return '/login';
		case 1:
			return '/talent-signup';
		case 5:
			return '/agency-signup';
		case 2:
			var email = page.a;
			return '/talent-signup/' + email;
		case 4:
			return '/casting-signup';
		case 3:
			var email = page.a;
			return '/casting-signup/' + email;
		case 9:
			return '/jobs';
		case 10:
			return '/inbox';
		case 13:
			return '/dashboard';
		case 14:
			return '/talent-profile';
		case 15:
			return '/agency-profile';
		case 16:
			return '/agent-profile';
		case 6:
			return '/account/profile';
		case 18:
			var p = page.a;
			return '/account/profile';
		case 20:
			return '/talent-search';
		case 21:
			var i = page.a;
			return '/projects/' + i;
		case 19:
			var s = page.a;
			return '/account';
		case 11:
			return '/roles';
		case 12:
			var i = page.a;
			return '/role/' + i;
		case 22:
			var id = page.a;
			var code = page.b;
			return '/account/' + (id + ('/' + code));
		case 8:
			return '/discover-jobs';
		case 7:
			var i = page.a;
			return '/discover-jobs/' + i;
		case 23:
			return '/schedules';
		case 24:
			var i = page.a;
			var scheduleType = page.b;
			return '/schedules/' + (i + ('/' + scheduleType));
		case 25:
			var projectId = page.a;
			var scheduleId = page.b;
			return '/schedule/' + (projectId + ('/' + scheduleId));
		case 26:
			var secretKey = page.a;
			return '/signup-collaborators/' + secretKey;
		case 27:
			var secretKey = page.a;
			return '/signup-agents/' + secretKey;
		default:
			return '/404';
	}
};
var $author$project$Main$goTo = F2(
	function (_v0, page) {
		var key = _v0.eF;
		return A2(
			$elm$browser$Browser$Navigation$pushUrl,
			key,
			$author$project$Main$toPath(page));
	});
var $author$project$SharedProjectRoleSchedules$Done = {$: 2};
var $author$project$Main$imageUploadStatus = function (images) {
	return (images >= 5) ? $author$project$SharedProjectRoleSchedules$Done : $author$project$SharedProjectRoleSchedules$Waiting;
};
var $author$project$Main$kickOffResizing = _Platform_outgoingPort('kickOffResizing', $elm$json$Json$Encode$string);
var $author$project$MainMsg$UsersAdded = function (a) {
	return {$: 173, a: a};
};
var $author$project$Pipeline$PipelineMessage = function (message) {
	return {hT: message};
};
var $author$project$Api$Decoders$pipelineMessageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'message',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$Pipeline$PipelineMessage));
var $author$project$Api$Encoders$roleMemberEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'users',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, model.jx)),
				_Utils_Tuple2(
				'column',
				$elm$json$Json$Encode$string(model.gN)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(model.bf))
			]));
};
var $author$project$Api$Request$addUsersToRole = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$roleMemberEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UsersAdded, $author$project$Api$Decoders$pipelineMessageDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.iw + ('/roles/' + (model.iK + '/add_users'))))
		});
};
var $author$project$Utils$determineApplicationState = function (userProfile) {
	var _v0 = userProfile.V;
	switch (_v0) {
		case 1:
			return 'Requested to Apply';
		case 3:
			return 'Agent Added';
		case 4:
			return 'Agent Added';
		default:
			return '';
	}
};
var $author$project$Main$linkToRole = F6(
	function (project, role, users, jwt, column, userProfile) {
		return ((project !== '') && (role !== '')) ? $author$project$Api$Request$addUsersToRole(
			{
				gN: column,
				hI: jwt,
				iw: project,
				iK: role,
				bf: $author$project$Utils$determineApplicationState(userProfile),
				jx: users
			}) : $elm$core$Platform$Cmd$none;
	});
var $author$project$MainMsg$MoreUsersLoaded = function (a) {
	return {$: 250, a: a};
};
var $author$project$Api$Encoders$searchAllIfEmpty = function (selectedValue) {
	return (selectedValue === 'ANY') ? '' : selectedValue;
};
var $author$project$Api$Encoders$searchEncoder = F2(
	function (talentFilterValues, projectId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'gender',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, talentFilterValues.hr)),
					_Utils_Tuple2(
					'eyeColor',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, talentFilterValues.hj)),
					_Utils_Tuple2(
					'heightLow',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.hY))),
					_Utils_Tuple2(
					'heightHigh',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.hR))),
					_Utils_Tuple2(
					'weightLow',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.eQ))),
					_Utils_Tuple2(
					'weightHigh',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.eM))),
					_Utils_Tuple2(
					'race',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, talentFilterValues.iB)),
					_Utils_Tuple2(
					'ageLow',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.c4))),
					_Utils_Tuple2(
					'ageHigh',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.c2))),
					_Utils_Tuple2(
					'waistSizeLow',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.hX))),
					_Utils_Tuple2(
					'waistSizeHigh',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$searchAllIfEmpty(talentFilterValues.hQ))),
					_Utils_Tuple2(
					'name',
					$elm$json$Json$Encode$string(talentFilterValues.iS)),
					_Utils_Tuple2(
					'offset',
					$elm$json$Json$Encode$int(talentFilterValues.id)),
					_Utils_Tuple2(
					'project_id',
					$elm$json$Json$Encode$string(projectId))
				]));
	});
var $author$project$Api$Decoders$userSearchResultsDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$searchResultTalentProfileDecoder);
var $author$project$Api$Request$loadMoreUsers = F3(
	function (jwt, talentFilterValues, roleId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$searchEncoder, talentFilterValues, roleId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$MoreUsersLoaded, $author$project$Api$Decoders$userSearchResultsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'users/search'
			});
	});
var $author$project$MainMsg$PipelineLoaded = function (a) {
	return {$: 158, a: a};
};
var $author$project$Api$Request$loadPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$PipelineLoaded, $author$project$Api$Decoders$pipelineDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + '/pipeline'))
		});
};
var $author$project$Main$loadPipelineForProject = function (model) {
	return $author$project$Api$Request$loadPipeline(model);
};
var $author$project$MainMsg$MarkedConversationAsRead = function (a) {
	return {$: 153, a: a};
};
var $author$project$Api$Encoders$userIdEncoder = function (userId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'userID',
				$elm$json$Json$Encode$string(userId))
			]));
};
var $author$project$Api$Request$markConversationAsRead = F3(
	function (userId, jwt, conversationId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$userIdEncoder(userId)),
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$MarkedConversationAsRead),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (userId + ('/conversations/' + (conversationId + '/mark_as_read'))))
			});
	});
var $author$project$MainMsg$DoNothing = function (a) {
	return {$: 236, a: a};
};
var $author$project$Api$Encoders$notificationIdsEncoder = function (notificationIds) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'notification_ids',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, notificationIds))
			]));
};
var $author$project$Api$Request$markNotificationsAsRead = F2(
	function (jwt, notificationIds) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$notificationIdsEncoder(notificationIds)),
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$DoNothing),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'users/mark_notifications_as_read'
			});
	});
var $author$project$Api$Encoders$userEncoder = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role_member_id',
				$elm$json$Json$Encode$string(user.aX)),
				_Utils_Tuple2(
				'new_column_id',
				$elm$json$Json$Encode$string(user.h2))
			]));
};
var $author$project$Api$Encoders$moveUsersEncoder = function (users) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'targets',
				A2($elm$json$Json$Encode$list, $author$project$Api$Encoders$userEncoder, users))
			]));
};
var $author$project$Api$Request$moveUsersInPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$moveUsersEncoder(model.jy)),
			a: $elm$http$Http$expectWhatever($author$project$MainMsg$UsersMoved),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + '/pipeline/move_users'))
		});
};
var $elm$file$File$name = _File_name;
var $author$project$Main$addMessageToChannelIndex = F4(
	function (channels, message, currentConversation, userProfile) {
		return A2(
			$elm$core$List$map,
			function (channel) {
				return _Utils_eq(channel.aa, message.gV) ? _Utils_update(
					channel,
					{
						cT: 'less than a minute ago',
						hL: message.dP,
						hV: _Utils_ap(
							channel.hV,
							_List_fromArray(
								[message])),
						bD: _Utils_eq(message.gW, userProfile.c$) ? 0 : (channel.bD + 1)
					}) : channel;
			},
			channels);
	});
var $author$project$Main$updateChannelMessages = F2(
	function (currentChannel, message) {
		return _Utils_update(
			currentChannel,
			{
				hL: message.dP,
				hV: _Utils_ap(
					currentChannel.hV,
					_List_fromArray(
						[message]))
			});
	});
var $author$project$Main$optimisticMessages = F3(
	function (body, creator, model) {
		var twilioData = model.p;
		var message = (body === '') ? _Utils_update(
			$author$project$Message$emptyMessage,
			{dP: model.bo + ' Uploading file...', gV: twilioData.t.aa, gW: creator, aF: 'media', bh: 'less than a minute ago'}) : _Utils_update(
			$author$project$Message$emptyMessage,
			{dP: body, gV: twilioData.t.aa, gW: creator, aF: 'text', bh: 'less than a minute ago'});
		return _Utils_update(
			twilioData,
			{
				n: A4($author$project$Main$addMessageToChannelIndex, twilioData.n, message, twilioData.t, model.E),
				t: A2($author$project$Main$updateChannelMessages, twilioData.t, message)
			});
	});
var $author$project$MainMsg$NewUser = function (a) {
	return {$: 34, a: a};
};
var $author$project$User$userTypeConvertToString = function (role) {
	switch (role) {
		case 0:
			return 'Talent';
		case 1:
			return 'Director';
		case 2:
			return 'Collaborator';
		case 3:
			return 'Agency';
		case 4:
			return 'Agent';
		default:
			return 'Invalid';
	}
};
var $author$project$Api$Encoders$newAgencyEncoder = F3(
	function (agency, userData, firebaseId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$string(firebaseId)),
					_Utils_Tuple2(
					'agency_name',
					$elm$json$Json$Encode$string(agency.cF)),
					_Utils_Tuple2(
					'agency_email',
					$elm$json$Json$Encode$string(agency.bv)),
					_Utils_Tuple2(
					'first_name',
					$elm$json$Json$Encode$string(agency.bx)),
					_Utils_Tuple2(
					'last_name',
					$elm$json$Json$Encode$string(agency.bP)),
					_Utils_Tuple2(
					'agency_address1',
					$elm$json$Json$Encode$string(agency.bF)),
					_Utils_Tuple2(
					'agency_address2',
					$elm$json$Json$Encode$string(agency.bG)),
					_Utils_Tuple2(
					'agency_city',
					$elm$json$Json$Encode$string(agency.a0)),
					_Utils_Tuple2(
					'agency_state',
					$elm$json$Json$Encode$string(agency.bf)),
					_Utils_Tuple2(
					'agency_zip',
					$elm$json$Json$Encode$string(agency.dv)),
					_Utils_Tuple2(
					'type',
					$elm$json$Json$Encode$string(
						$author$project$User$userTypeConvertToString(userData.V)))
				]));
	});
var $author$project$Api$Request$postNewAgency = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				A3($author$project$Api$Encoders$newAgencyEncoder, model.gj, model.aZ, model.hn)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewUser, $author$project$Api$Decoders$updateProfileDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'user/login'
		});
};
var $author$project$MainMsg$NewCompany = function (a) {
	return {$: 35, a: a};
};
var $author$project$Api$Encoders$createCompanyEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.aZ.cK))
			]));
};
var $author$project$Api$Request$postNewCompany = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$createCompanyEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewCompany, $author$project$Api$Decoders$companyDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'companies/'
		});
};
var $author$project$MainMsg$NewRole = function (a) {
	return {$: 58, a: a};
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $author$project$Api$Encoders$roleEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.V.bS)),
				_Utils_Tuple2(
				'project_id',
				$elm$json$Json$Encode$string(model.d6)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(model.V.iI)),
				_Utils_Tuple2(
				'genders',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$List$map,
						function (option) {
							return option.aa;
						},
						model.V.hs))),
				_Utils_Tuple2(
				'min_age',
				$elm$json$Json$Encode$int(model.V.c4)),
				_Utils_Tuple2(
				'max_age',
				$elm$json$Json$Encode$int(model.V.c2)),
				_Utils_Tuple2(
				'rate',
				$elm$json$Json$Encode$string(model.V.iM)),
				_Utils_Tuple2(
				'ethnicities',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$List$map,
						function (option) {
							return option.aa;
						},
						model.V.eg))),
				_Utils_Tuple2(
				'min_height',
				$elm$json$Json$Encode$int(model.V.hW)),
				_Utils_Tuple2(
				'max_height',
				$elm$json$Json$Encode$int(model.V.hP)),
				_Utils_Tuple2(
				'min_weight',
				$elm$json$Json$Encode$float(model.V.eQ)),
				_Utils_Tuple2(
				'max_weight',
				$elm$json$Json$Encode$float(model.V.eM)),
				_Utils_Tuple2(
				'archived',
				$elm$json$Json$Encode$bool(model.V.dI)),
				_Utils_Tuple2(
				'creator_id',
				$elm$json$Json$Encode$string(model.hI)),
				_Utils_Tuple2(
				'active',
				$elm$json$Json$Encode$bool(model.V.gf))
			]));
};
var $author$project$Api$Request$postNewRole = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$roleEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewRole, $author$project$Api$Decoders$roleDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + '/roles'))
		});
};
var $author$project$Api$Encoders$newUserEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(model.hn)),
				_Utils_Tuple2(
				'firstName',
				$elm$json$Json$Encode$string(model.aZ.bx)),
				_Utils_Tuple2(
				'lastName',
				$elm$json$Json$Encode$string(model.aZ.bP)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.aZ.bv)),
				_Utils_Tuple2(
				'type',
				$elm$json$Json$Encode$string(
					$author$project$User$userTypeConvertToString(model.aZ.V))),
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(model.aZ.eZ)),
				_Utils_Tuple2(
				'company_id',
				$elm$json$Json$Encode$string(model.bJ.gO)),
				_Utils_Tuple2(
				'original_id',
				$elm$json$Json$Encode$string(model.aZ.c$)),
				_Utils_Tuple2(
				'secret_key',
				$elm$json$Json$Encode$string(model.aZ.iU))
			]));
};
var $author$project$Api$Request$postNewUser = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$newUserEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewUser, $author$project$Api$Decoders$updateProfileDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'user/login'
		});
};
var $author$project$Api$Encoders$applicationEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$string(model.dG.jt)),
				_Utils_Tuple2(
				'role_id',
				$elm$json$Json$Encode$string(model.dG.iJ)),
				_Utils_Tuple2(
				'stage',
				$elm$json$Json$Encode$string('applied')),
				_Utils_Tuple2(
				'project_id',
				$elm$json$Json$Encode$string(model.d6))
			]));
};
var $author$project$Api$Request$postRoleApplication = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$applicationEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$SendApplication, $author$project$Api$Decoders$jobAppDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + ('/roles/' + (model.dG.iJ + '/add_to_role'))))
		});
};
var $author$project$MainMsg$NewRoleResetForm = function (a) {
	return {$: 59, a: a};
};
var $author$project$Api$Request$postRoleResetForm = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$roleEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewRoleResetForm, $author$project$Api$Decoders$roleDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + '/roles'))
		});
};
var $author$project$MainMsg$SchedulePublished = function (a) {
	return {$: 205, a: a};
};
var $author$project$Api$Encoders$convertStage = function (stage) {
	switch (stage) {
		case 5:
			return 'Audition Requested';
		case 11:
			return 'Callback Requested';
		default:
			return '';
	}
};
var $author$project$Api$Encoders$scheduledTalentEncoder = function (scheduledTalent) {
	return $elm$json$Json$Encode$string(scheduledTalent.aX);
};
var $author$project$Api$Encoders$updateScheduleEncoder = F2(
	function (scheduleData, stage) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'schedule_type',
					$elm$json$Json$Encode$string(scheduleData.fB)),
					_Utils_Tuple2(
					'project_id',
					$elm$json$Json$Encode$string(scheduleData.aj.c$)),
					_Utils_Tuple2(
					'published',
					$elm$json$Json$Encode$bool(true)),
					_Utils_Tuple2(
					'scheduled_talent',
					A2($elm$json$Json$Encode$list, $author$project$Api$Encoders$scheduledTalentEncoder, scheduleData.iP)),
					_Utils_Tuple2(
					'state',
					$elm$json$Json$Encode$string(
						$author$project$Api$Encoders$convertStage(stage)))
				]));
	});
var $author$project$Api$Request$publishSchedule = F2(
	function (model, stage) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$updateScheduleEncoder, model.b$, stage)),
				a: A2(
					$elm$http$Http$expectJson,
					$author$project$MainMsg$SchedulePublished,
					$elm$json$Json$Decode$list($author$project$Api$Decoders$scheduleDecoder)),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(model.hI)
					]),
				c: 'PUT',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'publish_schedule'
			});
	});
var $author$project$Schedule$MovePublishedUser = 0;
var $author$project$Schedule$RemovePublishedUser = 1;
var $author$project$Views$Schedule$schedulePublished = function (schedules) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptySchedule,
		$elm$core$List$head(schedules)).bb;
};
var $author$project$Main$publishedModalState = F2(
	function (model, dropTarget) {
		if ($author$project$Views$Schedule$schedulePublished(model.b$.k)) {
			switch (dropTarget.$) {
				case 2:
					var timeSlotId = dropTarget.a;
					var droppedOnUser = dropTarget.b;
					var schedId = dropTarget.c;
					return 0;
				case 3:
					var timeSlotId = dropTarget.a;
					var droppedOnUser = dropTarget.b;
					var schedId = dropTarget.c;
					return 1;
				default:
					return 2;
			}
		} else {
			return 2;
		}
	});
var $author$project$Main$redirectAway = F3(
	function (role, model, page) {
		switch (role) {
			case 2:
				return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
			case 0:
				return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
			case 3:
				switch (page.$) {
					case 21:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 24:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 25:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 23:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 10:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 4:
				switch (page.$) {
					case 21:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 24:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 25:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 23:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					case 10:
						return A2($author$project$Main$goTo, model, $author$project$Route$Dashboard);
					default:
						return $elm$core$Platform$Cmd$none;
				}
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$MainMsg$SignInRefreshed = function (a) {
	return {$: 132, a: a};
};
var $author$project$Api$Request$refreshUser = function (jwt) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$emptyBody,
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$SignInRefreshed, $author$project$Api$Decoders$updateProfileDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(jwt)
				]),
			c: 'GET',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'users/user_id'
		});
};
var $author$project$Main$redirectToLoginOrRefresh = F2(
	function (jwt, model) {
		var _v0 = model.o;
		switch (_v0.$) {
			case 22:
				var id = _v0.a;
				var code = _v0.b;
				return _List_fromArray(
					[
						A3($author$project$Main$verifyAccount, jwt, id, code)
					]);
			case 3:
				var email = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Main$goTo,
						model,
						$author$project$Route$MarketingDirectorRegistration(email))
					]);
			case 2:
				var email = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Main$goTo,
						model,
						$author$project$Route$MarketingTalentRegistration(email))
					]);
			case 26:
				var secretKey = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Main$goTo,
						model,
						$author$project$Route$CollaboratorsSignupPage(secretKey))
					]);
			case 27:
				var secretKey = _v0.a;
				return _List_fromArray(
					[
						A2(
						$author$project$Main$goTo,
						model,
						$author$project$Route$AgentsSignupPage(secretKey))
					]);
			default:
				if (jwt === '') {
					return _List_fromArray(
						[
							A2($author$project$Main$goTo, model, $author$project$Route$Login)
						]);
				} else {
					var loginRefresh = $author$project$Api$Request$refreshUser(jwt);
					var _v1 = model.o;
					switch (_v1.$) {
						case 0:
							return _List_fromArray(
								[
									A2($author$project$Main$goTo, model, $author$project$Route$Dashboard),
									loginRefresh
								]);
						case 13:
							return _List_fromArray(
								[loginRefresh]);
						case 22:
							var id = _v1.a;
							var code = _v1.b;
							return _List_fromArray(
								[
									A3($author$project$Main$verifyAccount, model.hI, id, code)
								]);
						default:
							return _List_fromArray(
								[loginRefresh]);
					}
				}
		}
	});
var $author$project$MainMsg$RefreshedTalentProfile = function (a) {
	return {$: 293, a: a};
};
var $author$project$Api$Request$refreshTalentData = F2(
	function (roleMemberId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$RefreshedTalentProfile, $author$project$Api$Decoders$searchResultTalentProfileDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (roleMemberId + '/refresh_user'))
			});
	});
var $author$project$MainMsg$RemovedCollaborator = function (a) {
	return {$: 279, a: a};
};
var $author$project$Api$Request$removeCollaborator = F2(
	function (invitationId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$RemovedCollaborator, $author$project$Api$Decoders$collaboratorsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'DELETE',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('collaborators/' + (invitationId + '/remove'))
			});
	});
var $author$project$Api$Encoders$updatingRemovedUserSpot = function (movingUserId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'moving_user_id',
				$elm$json$Json$Encode$string(movingUserId))
			]));
};
var $author$project$Api$Request$removeUserFromSchedule = F4(
	function (userId, timeSlotId, movingUserId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$updatingRemovedUserSpot(movingUserId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$TimeSlotUpdated, $author$project$Api$Decoders$timeSlotDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'PUT',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('schedules/time_slots/' + (timeSlotId + ('/users/' + (userId + '/remove_user'))))
			});
	});
var $author$project$Main$removeUser = F4(
	function (user, currentTimeSlotId, movingRoleMemberId, jwt) {
		return A4($author$project$Api$Request$removeUserFromSchedule, user.c$, currentTimeSlotId, movingRoleMemberId, jwt);
	});
var $author$project$Main$removeCurrentPublishedUserAndAddMovingUser = F9(
	function (data, jwt, schedulePageData, notificationData, swapNotificationData, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$removeUser, data.Y, data._, data.w.aX, jwt),
						A4($author$project$Main$removeUser, data.w, data.P, '', jwt),
						A4($author$project$Main$updateUsersPipelinePosition, jwt, schedulePageData, data.Y, pendingColumn),
						A4($author$project$Main$updateUsersPipelinePosition, jwt, schedulePageData, data.w, scheduledColumn),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, notificationData, jwt, data.w.aX, notificationData.hK, notificationData.cA),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, swapNotificationData, jwt, data.Y.aX, swapNotificationData.hK, notificationData.cA)
					])),
			firstScheduleUpdate,
			A3($author$project$Main$updateAvailiableTalent, firstTalentUpdate, data.Y, true));
	});
var $author$project$Main$removeCurrentUserAndAddMovingUser = F7(
	function (data, jwt, schedulePageData, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$removeUser, data.Y, data._, data.w.aX, jwt),
						A4($author$project$Main$removeUser, data.w, data.P, '', jwt),
						A4($author$project$Main$updateUsersPipelinePosition, jwt, schedulePageData, data.Y, pendingColumn),
						A4($author$project$Main$updateUsersPipelinePosition, jwt, schedulePageData, data.w, scheduledColumn)
					])),
			firstScheduleUpdate,
			A3($author$project$Main$updateAvailiableTalent, firstTalentUpdate, data.Y, true));
	});
var $author$project$Main$removeMultiItems = F2(
	function (msg, model) {
		var role = model.V;
		var userProfile = model.E;
		switch (msg) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{hs: _List_Nil})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{eg: _List_Nil})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{eg: _List_Nil})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$removeNotificationKind = F2(
	function (model, movedFromOutsideSchedule) {
		return ((!movedFromOutsideSchedule) && (model.b$.fB === 'Audition')) ? _Utils_Tuple2('Audition Rescheduled', 'Audition Canceled') : ((movedFromOutsideSchedule && (model.b$.fB === 'Audition')) ? _Utils_Tuple2('Audition Requested', 'Audition Canceled') : (((!movedFromOutsideSchedule) && (model.b$.fB === 'Callback')) ? _Utils_Tuple2('Callback Rescheduled', 'Callback Canceled') : ((movedFromOutsideSchedule && (model.b$.fB === 'Callback')) ? _Utils_Tuple2('Callback Requested', 'Callback Canceled') : _Utils_Tuple2('', ''))));
	});
var $author$project$Main$originalImage = F2(
	function (images, image) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyImage,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.aa;
						},
						image.aa),
					images))).aa;
	});
var $author$project$MainMsg$Uploaded = function (a) {
	return {$: 127, a: a};
};
var $author$project$Api$Encoders$croppedImageEncoder = function (imageUrl) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'image_url',
				$elm$json$Json$Encode$string(imageUrl))
			]));
};
var $author$project$Api$Request$uploadCroppedImage = F3(
	function (image, jwt, userId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$croppedImageEncoder(image)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$Uploaded, $author$project$Api$Decoders$imageDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Just('upload'),
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (userId + '/upload_cropped_image'))
			});
	});
var $author$project$Main$removeOriginalImage = F5(
	function (jwt, currentUserId, newUrl, image, images) {
		return (newUrl === '') ? _Utils_Tuple3(images, $elm$core$Platform$Cmd$none, $elm$core$Platform$Cmd$none) : _Utils_Tuple3(
			A2($author$project$Main$filterImages, image.aa, images),
			A3(
				$author$project$Api$Request$deleteImage,
				A2($author$project$Main$originalImage, images, image),
				jwt,
				currentUserId),
			A3($author$project$Api$Request$uploadCroppedImage, newUrl, jwt, currentUserId));
	});
var $author$project$MainMsg$TalentRemovedFromRole = function (a) {
	return {$: 323, a: a};
};
var $author$project$Api$Encoders$removeTalentEncoder = function (reason) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'reason',
				$elm$json$Json$Encode$string(reason))
			]));
};
var $author$project$Api$Request$removeTalent = F2(
	function (talentMenu, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$removeTalentEncoder(talentMenu.iD)),
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$TalentRemovedFromRole),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'DELETE',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('role_members/' + talentMenu.jb.aX)
			});
	});
var $author$project$Main$removeUserFromScheduleAndUpdatePipeline = F5(
	function (model, user, newTimeSlotId, currentTimeSlotId, movingToColumn) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$removeUser, user, currentTimeSlotId, '', model.hI),
						A4($author$project$Main$updateUsersPipelinePosition, model.hI, model.b$, user, movingToColumn)
					])),
			A4($author$project$Main$updateSchedules, model.b$.k, user, newTimeSlotId, currentTimeSlotId),
			A3($author$project$Main$updateAvailiableTalent, model.b$.I, user, true));
	});
var $author$project$Main$removeUserToken = _Platform_outgoingPort('removeUserToken', $elm$json$Json$Encode$string);
var $author$project$Main$removeVideoFromTalent = F2(
	function (profile, deletedVideoId) {
		return _Utils_update(
			profile,
			{
				a_: A2(
					$elm$core$List$filter,
					function (video) {
						return !_Utils_eq(video.aa, deletedVideoId);
					},
					profile.a_)
			});
	});
var $author$project$Main$replacingData = F2(
	function (fileAction, model) {
		switch (fileAction) {
			case 0:
				return _Utils_Tuple3(
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$User$emptyImage,
						$elm$core$List$head(model.l)).aa,
					_List_Nil,
					A3(
						$author$project$Api$Request$deleteImage,
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$User$emptyImage,
							$elm$core$List$head(model.l)).aa,
						model.hI,
						model.g1));
			case 1:
				return _Utils_Tuple3('', model.l, $elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple3('', model.l, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$MainMsg$ResetErrorMessage = {$: 310};
var $author$project$Main$resetErrorMessage = A2($author$project$Utils$delay, 2000, $author$project$MainMsg$ResetErrorMessage);
var $author$project$Main$resetModel = function (model) {
	return _Utils_update(
		model,
		{f: $author$project$Model$Hiding, dE: _List_Nil, b7: $author$project$Message$LoadingMessages, F: _List_Nil, aB: _List_Nil, R: 0, bM: '', d6: '', g$: '', g1: '', as: '', d8: '', bt: false, hn: '', ap: 4, l: _List_Nil, hI: '', a6: !model.a6, aj: $author$project$SharedProjectRoleSchedules$emptyProject, V: $author$project$SharedProjectRoleSchedules$emptyRole, b0: '', aM: '', dq: false, p: $author$project$Message$emptyFromTwilioPayload});
};
var $author$project$MainMsg$GotSearchedJobs = function (a) {
	return {$: 305, a: a};
};
var $author$project$Api$Request$searchJobs = F2(
	function (jwt, searchTerm) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotSearchedJobs, $author$project$Api$Decoders$basicProjectsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('jobs/' + searchTerm)
			});
	});
var $author$project$MainMsg$ReceivedSearchResults = function (a) {
	return {$: 138, a: a};
};
var $author$project$Api$Request$searchUsers = F3(
	function (jwt, talentFilterValues, roleId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$searchEncoder, talentFilterValues, roleId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$ReceivedSearchResults, $author$project$Api$Decoders$userSearchResultsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'users/search'
			});
	});
var $author$project$Main$sendPasswordResetEmail = _Platform_outgoingPort('sendPasswordResetEmail', $elm$json$Json$Encode$string);
var $author$project$Main$setUserDataToAgency = function (userData) {
	return _Utils_update(
		userData,
		{V: 3});
};
var $author$project$Main$setUserRegistrationType = function (model) {
	return A2(
		$elm$core$List$member,
		model.o,
		_List_fromArray(
			[
				$author$project$Route$DirectorRegistration,
				$author$project$Route$MarketingDirectorRegistration(model.aZ.bv)
			])) ? 1 : (A2(
		$elm$core$List$member,
		model.o,
		_List_fromArray(
			[
				$author$project$Route$TalentRegistration,
				$author$project$Route$MarketingTalentRegistration(model.aZ.bv)
			])) ? 0 : (A2(
		$elm$core$List$member,
		model.o,
		_List_fromArray(
			[
				$author$project$Route$CollaboratorsSignupPage(model.aZ.iU)
			])) ? 2 : (A2(
		$elm$core$List$member,
		model.o,
		_List_fromArray(
			[
				$author$project$Route$AgentsSignupPage(model.aZ.iU)
			])) ? 4 : (_Utils_eq(model.o, $author$project$Route$AgencyRegistration) ? 3 : 5))));
};
var $author$project$Main$setUserType = F2(
	function (model, role) {
		var userData = model.aZ;
		return _Utils_update(
			userData,
			{V: role});
	});
var $author$project$MainMsg$SortedColumn = function (a) {
	return {$: 181, a: a};
};
var $author$project$Api$Encoders$sortEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sort',
				$elm$json$Json$Encode$string(model.i2)),
				_Utils_Tuple2(
				'column_id',
				$elm$json$Json$Encode$string(model.aa))
			]));
};
var $author$project$Api$Request$sortPipeline = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$sortEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$SortedColumn, $author$project$Api$Decoders$pipelineDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + '/pipeline'))
		});
};
var $author$project$Main$sortPipelineUsers = function (model) {
	return $author$project$Api$Request$sortPipeline(model);
};
var $author$project$Main$sortingMap = function (sort) {
	switch (sort) {
		case 0:
			return 'asc';
		case 1:
			return 'desc';
		case 2:
			return 'role';
		default:
			return 'status';
	}
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$startDragging = F2(
	function (_v0, id) {
		var stateData = _v0;
		var updatedStateData = _Utils_update(
			stateData,
			{
				cg: $elm$core$Maybe$Just(id)
			});
		return updatedStateData;
	});
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$stopDragging = function (_v0) {
	var stateData = _v0;
	return $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState;
};
var $author$project$MainMsg$VoteRecorded = function (a) {
	return {$: 272, a: a};
};
var $author$project$Api$Encoders$voteEncoder = F4(
	function (vote, comment, roleMemberId, timeSlotId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'vote',
					$elm$json$Json$Encode$string(vote)),
					_Utils_Tuple2(
					'role_member_id',
					$elm$json$Json$Encode$string(roleMemberId)),
					_Utils_Tuple2(
					'time_slot_id',
					$elm$json$Json$Encode$string(timeSlotId))
				]));
	});
var $author$project$Api$Request$submitVote = F5(
	function (roleMemberId, vote, comment, jwt, timeSlotId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A4($author$project$Api$Encoders$voteEncoder, vote, comment, roleMemberId, timeSlotId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$VoteRecorded, $author$project$Api$Decoders$timeSlotDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'vote/'
			});
	});
var $author$project$MainMsg$CommentSubmitted = function (a) {
	return {$: 283, a: a};
};
var $author$project$Api$Encoders$commentEncoder = F2(
	function (body, timeSlotId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'body',
					$elm$json$Json$Encode$string(body)),
					_Utils_Tuple2(
					'time_slot_id',
					$elm$json$Json$Encode$string(timeSlotId))
				]));
	});
var $author$project$Api$Request$submitVotingComment = F3(
	function (comment, jwt, timeSlotId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$commentEncoder, comment, timeSlotId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$CommentSubmitted, $author$project$Api$Decoders$timeSlotDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'timeslot/comment'
			});
	});
var $author$project$Main$swapNotificationKind = F2(
	function (model, movedFromOutsideSchedule) {
		return ((!movedFromOutsideSchedule) && (model.b$.fB === 'Audition')) ? _Utils_Tuple2('Audition Rescheduled', 'Audition Rescheduled') : ((movedFromOutsideSchedule && (model.b$.fB === 'Audition')) ? _Utils_Tuple2('Audition Requested', 'Audition Canceled') : (((!movedFromOutsideSchedule) && (model.b$.fB === 'Callback')) ? _Utils_Tuple2('Callback Rescheduled', 'Callback Rescheduled') : ((movedFromOutsideSchedule && (model.b$.fB === 'Callback')) ? _Utils_Tuple2('Callback Requested', 'Callback Canceled') : _Utils_Tuple2('', ''))));
	});
var $elm$file$File$toString = _File_toString;
var $author$project$Main$toggleAgencyFields = function (profilePage) {
	return _Utils_update(
		profilePage,
		{fK: !profilePage.fK});
};
var $author$project$Main$toggleAgentForm = F3(
	function (profilePageData, agentId, userProfile) {
		return (agentId === '') ? _Utils_update(
			profilePageData,
			{b6: false, bL: $author$project$User$emptyAgent}) : _Utils_update(
			profilePageData,
			{
				b6: true,
				bL: A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyAgent,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.aa;
								},
								agentId),
							userProfile.gj.gp)))
			});
	});
var $author$project$Filter$TAge = 4;
var $author$project$Filter$TEye = 5;
var $author$project$Filter$TGender = 0;
var $author$project$Filter$THeight = 1;
var $author$project$Filter$TMenu = 7;
var $author$project$Filter$TRace = 6;
var $author$project$Filter$TSizes = 3;
var $author$project$Filter$TWeight = 2;
var $author$project$Main$toggleFilter = F2(
	function (current, toggle) {
		return _Utils_eq(current, toggle) ? 8 : toggle;
	});
var $author$project$Main$toggleFilters = F2(
	function (toggle, model) {
		var talentFilter = model.K;
		switch (toggle) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2($author$project$Main$toggleFilter, model.K, 0)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2($author$project$Main$toggleFilter, model.K, 4)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2($author$project$Main$toggleFilter, model.K, 1)
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2($author$project$Main$toggleFilter, model.K, 2)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2($author$project$Main$toggleFilter, model.K, 5)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2($author$project$Main$toggleFilter, model.K, 6)
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2($author$project$Main$toggleFilter, model.K, 7)
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							K: A2($author$project$Main$toggleFilter, model.K, 3)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{K: 8}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Utils$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$toggleMultiModal = F2(
	function (id, multiModalStatus) {
		if (!multiModalStatus.$) {
			var str = multiModalStatus.a;
			return _Utils_eq(id, str) ? $author$project$Utils$Closed : $author$project$Utils$Open(id);
		} else {
			return $author$project$Utils$Open(id);
		}
	});
var $author$project$Main$toggleProfilePageNav = function (profilePageData) {
	return _Utils_update(
		profilePageData,
		{de: !profilePageData.de});
};
var $author$project$Main$togglePublishProject = function (project) {
	return _Utils_update(
		project,
		{hB: !project.hB});
};
var $author$project$Main$togglePublishRole = function (role) {
	return _Utils_update(
		role,
		{gf: !role.gf});
};
var $author$project$Views$Schedule$findSchedule = function (schedules) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptySchedule,
		$elm$core$List$head(schedules));
};
var $author$project$Views$Schedule$resetScheduleForm = function (model) {
	return _Utils_update(
		model,
		{gz: false, a2: $author$project$SharedProjectRoleSchedules$emptySchedule, ee: '', b_: 0, fB: '', fP: ''});
};
var $author$project$Views$Schedule$scheduleDates = F2(
	function (project, scheduleType) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyDeadline,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bS;
						},
						scheduleType),
					project.g6)));
	});
var $author$project$Views$Schedule$showCorrectSchedule = F4(
	function (model, schedule, deadlineValue, scheduleView) {
		return _Utils_update(
			model,
			{gz: false, a2: schedule, ee: deadlineValue.ee, b_: scheduleView, fB: deadlineValue.bS, fP: deadlineValue.fP});
	});
var $author$project$Views$Schedule$toggleScheduleForm = F2(
	function (model, scheduleView) {
		var schedule = $author$project$Views$Schedule$findSchedule(model.k);
		var deadlineValue = function () {
			var _v1 = model.aK;
			switch (_v1.$) {
				case 3:
					var project = _v1.a;
					var sType = _v1.b;
					return A2($author$project$Views$Schedule$scheduleDates, project, sType);
				case 0:
					var sType = _v1.a;
					return A2($author$project$Views$Schedule$scheduleDates, model.aj, sType);
				default:
					return $author$project$SharedProjectRoleSchedules$emptyDeadline;
			}
		}();
		if (scheduleView === 1) {
			return A4($author$project$Views$Schedule$showCorrectSchedule, model, schedule, deadlineValue, scheduleView);
		} else {
			return $author$project$Views$Schedule$resetScheduleForm(model);
		}
	});
var $author$project$Main$toggleSelectedTalent = F2(
	function (users, id) {
		if (users.$ === 3) {
			var profiles = users.a;
			return A2(
				$elm$core$List$map,
				function (result) {
					return _Utils_eq(result.c$, id) ? _Utils_update(
						result,
						{cz: !result.cz}) : result;
				},
				profiles);
		} else {
			return _List_Nil;
		}
	});
var $author$project$MainMsg$VideoUpdated = function (a) {
	return {$: 286, a: a};
};
var $author$project$Api$Encoders$videoEncoder = function (videoId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(videoId))
			]));
};
var $author$project$Api$Request$toggleVideoVisibility = F2(
	function (videoId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$videoEncoder(videoId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$VideoUpdated, $author$project$Api$Decoders$videoDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'PUT',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'video/toggle_visibility'
			});
	});
var $author$project$Views$Form$transformIdToOption = F2(
	function (id, options) {
		return A2(
			$elm$core$Maybe$withDefault,
			{aa: '', bS: ''},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.aa;
						},
						id),
					options)));
	});
var $author$project$Views$Form$transformNameToOption = F2(
	function (name, options) {
		return A2(
			$elm$core$Maybe$withDefault,
			{aa: '', bS: ''},
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bS;
						},
						name),
					options)));
	});
var $author$project$Utils$transformToSearchResultTalentProfile = function (user) {
	return {dA: user.dA, gj: user.gj, gA: user.gA, dT: false, a0: user.a0, cK: user.cK, gY: user.gY, d4: 0, bv: user.bv, eg: user.eg, hi: user.hi, bx: user.bx, hq: user.hq, ck: user.ck, cl: user.cl, ht: user.ht, c$: user.c$, l: user.l, ez: true, bP: user.bP, e0: user.e0, ix: user.ix, iH: user.iH, iK: user.iK, aX: user.aX, iL: user.iL, fA: user.fA, cz: user.cz, i3: user.i3, bf: user.bf, a_: user.a_, jA: user.jA, jC: user.jC};
};
var $CurrySoftware$elm_datepicker$DatePicker$Disabled = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$FailedInput = function (a) {
	return {$: 1, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$Invalid = function (a) {
	return {$: 0, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$None = {$: 0};
var $CurrySoftware$elm_datepicker$DatePicker$Picked = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$update = F3(
	function (settings, msg, _v0) {
		var model = _v0;
		var forceOpen = model.aS;
		var focused = model.ah;
		switch (msg.$) {
			case 0:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: $elm$core$Maybe$Just(date),
							bi: date
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 1:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ah: $elm$core$Maybe$Just(date)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 2:
				var date = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{ah: $elm$core$Maybe$Nothing, at: $elm$core$Maybe$Nothing, c9: false}),
					$CurrySoftware$elm_datepicker$DatePicker$Picked(date));
			case 3:
				var text = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							at: $elm$core$Maybe$Just(text)
						}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 4:
				if (forceOpen) {
					return _Utils_Tuple2(model, $CurrySoftware$elm_datepicker$DatePicker$None);
				} else {
					var dateEvent = function () {
						var _v5 = settings.db(
							A2($elm$core$Maybe$withDefault, '', model.at));
						if (!_v5.$) {
							var date = _v5.a;
							return settings.bO(date) ? $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
								$CurrySoftware$elm_datepicker$DatePicker$Disabled(date)) : $CurrySoftware$elm_datepicker$DatePicker$Picked(date);
						} else {
							var e = _v5.a;
							return $CurrySoftware$elm_datepicker$DatePicker$FailedInput(
								$CurrySoftware$elm_datepicker$DatePicker$Invalid(e));
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ah: function () {
									if (dateEvent.$ === 2) {
										var date = dateEvent.a;
										return $elm$core$Maybe$Just(date);
									} else {
										return model.ah;
									}
								}(),
								at: function () {
									if (dateEvent.$ === 2) {
										return $elm$core$Maybe$Nothing;
									} else {
										return model.at;
									}
								}()
							}),
						dateEvent);
				}
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aS: false, c9: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c9: forceOpen}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aS: true}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aS: false}),
					$CurrySoftware$elm_datepicker$DatePicker$None);
		}
	});
var $author$project$Main$updateAgeInUserProfile = F2(
	function (age, _v0) {
		var userProfile = _v0.E;
		return _Utils_update(
			userProfile,
			{dA: age});
	});
var $author$project$Main$updateAgencies = F2(
	function (agencies, profilePageData) {
		return _Utils_update(
			profilePageData,
			{cD: agencies});
	});
var $author$project$Main$updateAgency = F2(
	function (agency, aMsg) {
		switch (aMsg.$) {
			case 0:
				var name = aMsg.a;
				return _Utils_update(
					agency,
					{cF: name});
			case 4:
				var email = aMsg.a;
				return _Utils_update(
					agency,
					{bv: email});
			case 1:
				var name = aMsg.a;
				return _Utils_update(
					agency,
					{bx: name});
			case 2:
				var name = aMsg.a;
				return _Utils_update(
					agency,
					{bP: name});
			case 5:
				var address = aMsg.a;
				return _Utils_update(
					agency,
					{bF: address});
			case 6:
				var address = aMsg.a;
				return _Utils_update(
					agency,
					{bG: address});
			case 7:
				var city = aMsg.a;
				return _Utils_update(
					agency,
					{a0: city});
			case 8:
				var state = aMsg.a;
				return _Utils_update(
					agency,
					{bf: state});
			case 9:
				var zip = aMsg.a;
				return _Utils_update(
					agency,
					{dv: zip});
			case 10:
				var password = aMsg.a;
				return _Utils_update(
					agency,
					{eZ: password});
			case 11:
				var passwordConfirmation = aMsg.a;
				return _Utils_update(
					agency,
					{cL: passwordConfirmation});
			default:
				return agency;
		}
	});
var $author$project$Main$updateCurrentAgent = F2(
	function (agent, agentMsg) {
		switch (agentMsg.$) {
			case 0:
				var value = agentMsg.a;
				return _Utils_update(
					agent,
					{bx: value});
			case 1:
				var value = agentMsg.a;
				return _Utils_update(
					agent,
					{bP: value});
			case 2:
				var value = agentMsg.a;
				return _Utils_update(
					agent,
					{a0: value});
			default:
				var value = agentMsg.a;
				return _Utils_update(
					agent,
					{bv: value});
		}
	});
var $author$project$Main$updateAgentInfo = F2(
	function (profilePageData, agentMsg) {
		return _Utils_update(
			profilePageData,
			{
				bL: A2($author$project$Main$updateCurrentAgent, profilePageData.bL, agentMsg)
			});
	});
var $author$project$Main$updateAgents = F2(
	function (agency, agents) {
		return _Utils_update(
			agency,
			{gp: agents});
	});
var $author$project$Main$updateAgentsList = F2(
	function (userProfile, agents) {
		return _Utils_update(
			userProfile,
			{
				gj: A2($author$project$Main$updateAgents, userProfile.gj, agents)
			});
	});
var $author$project$Main$updateAllProjects = F2(
	function (allProjects, updatedProject) {
		return A2(
			$elm$core$List$map,
			function (project) {
				return _Utils_eq(project.c$, updatedProject.c$) ? updatedProject : project;
			},
			allProjects);
	});
var $author$project$Main$updateAllRoles = F2(
	function (updatedRole, roleList) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return _Utils_eq(role.c$, updatedRole.c$) ? updatedRole : role;
			},
			roleList);
	});
var $author$project$Main$updateBillingAddress = F2(
	function (msg, model) {
		var billingAddress = model.aC;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								billingAddress,
								{bF: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								billingAddress,
								{bG: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								billingAddress,
								{a0: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								billingAddress,
								{bf: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								billingAddress,
								{e3: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aC: _Utils_update(
								billingAddress,
								{dz: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateBothUsersPositionsInPublishedSchedule = F5(
	function (data, jwt, schedulePageData, notificationData, swapNotificationData) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$changeUsersTimeSlot, data.w, data.P, data._, jwt),
						A4($author$project$Main$changeUsersTimeSlot, data.Y, data._, data.P, jwt),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, notificationData, jwt, data.w.aX, notificationData.hK, notificationData.cA),
						A5($author$project$Main$updateRoleMemberAndCreateNotification, swapNotificationData, jwt, data.Y.aX, swapNotificationData.hK, notificationData.cA)
					])),
			A4($author$project$Main$updateSchedules, schedulePageData.k, data.w, data._, data.P),
			schedulePageData.I);
	});
var $author$project$Main$updateBothUsersPositionsInSchedule = F3(
	function (data, jwt, schedulePageData) {
		return _Utils_Tuple3(
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A4($author$project$Main$changeUsersTimeSlot, data.w, data.P, data._, jwt),
						A4($author$project$Main$changeUsersTimeSlot, data.Y, data._, data.P, jwt)
					])),
			A4($author$project$Main$updateSchedules, schedulePageData.k, data.w, data._, data.P),
			schedulePageData.I);
	});
var $author$project$Main$chatFilterRoleList = F2(
	function (projects, project) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyProject,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bS;
						},
						project),
					projects))).ft;
	});
var $author$project$Main$updateChatFilterValues = F2(
	function (filterType, model) {
		var chatFilterValues = model.ca;
		switch (filterType.$) {
			case 0:
				var project = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{
						iv: project,
						fr: 'Role',
						dh: A2($author$project$Main$chatFilterRoleList, model.F, project)
					});
			case 1:
				var role = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{fr: role});
			case 2:
				var read = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{iC: read});
			case 3:
				var archived = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{gu: archived});
			default:
				var term = filterType.a;
				return _Utils_update(
					chatFilterValues,
					{fF: term});
		}
	});
var $author$project$Main$verifyCompleteCollabForm = function (data) {
	return (data.bv !== '') && ((data.bx !== '') && (data.bP !== ''));
};
var $author$project$Main$updateCollaboratorData = F2(
	function (collaboratorData, collabMsg) {
		switch (collabMsg.$) {
			case 0:
				return collaboratorData.c9 ? $author$project$SharedProjectRoleSchedules$emptyCollaboratorForm : _Utils_update(
					collaboratorData,
					{c9: true});
			case 1:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{bv: val, a4: true, cA: ''});
			case 4:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{a4: false, bx: val});
			case 5:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{a4: false, bP: val});
			case 2:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{cK: val, a4: false});
			case 3:
				var val = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{a4: false, ik: val});
			case 6:
				return _Utils_update(
					collaboratorData,
					{
						cZ: $author$project$Main$verifyCompleteCollabForm(collaboratorData)
					});
			case 7:
				var collaborators = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{dX: collaborators});
			case 8:
				var collaborator = collabMsg.a;
				return _Utils_update(
					collaboratorData,
					{cK: collaborator.cK, bv: collaborator.bv, a4: false, bx: collaborator.bx, bP: collaborator.bP, ik: collaborator.ik, cA: collaborator.aa});
			case 9:
				return _Utils_update(
					collaboratorData,
					{a4: false});
			case 10:
				return _Utils_update(
					collaboratorData,
					{gh: collaboratorData.cZ});
			default:
				var collaborators = collabMsg.a;
				return _Utils_update(
					$author$project$SharedProjectRoleSchedules$emptyCollaboratorForm,
					{dX: collaborators});
		}
	});
var $author$project$Main$updateCollaborator = F2(
	function (schedulePageData, amsg) {
		return _Utils_update(
			schedulePageData,
			{
				bI: A2($author$project$Main$updateCollaboratorData, schedulePageData.bI, amsg)
			});
	});
var $author$project$Main$updateCollaboratorProfile = F2(
	function (profile, collaborator) {
		return _Utils_update(
			profile,
			{cK: collaborator.cK, bv: collaborator.bv, bx: collaborator.bx, c$: collaborator.aa, bP: collaborator.bP});
	});
var $author$project$Main$updateColumn = F2(
	function (msg, model) {
		var column = model.gN;
		if (!msg.$) {
			var value = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						gN: _Utils_update(
							column,
							{g2: value})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$MainMsg$ColumnUpdated = function (a) {
	return {$: 171, a: a};
};
var $author$project$Api$Encoders$columnEncoder = function (column) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'position',
				$elm$json$Json$Encode$int(column.io)),
				_Utils_Tuple2(
				'custom_name',
				$elm$json$Json$Encode$string(column.g2)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(column.aa)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(column.bS)),
				_Utils_Tuple2(
				'is_hidden',
				$elm$json$Json$Encode$bool(column.hC))
			]));
};
var $author$project$Api$Request$updateColumnData = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$columnEncoder(model.gN)),
			a: $elm$http$Http$expectWhatever($author$project$MainMsg$ColumnUpdated),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'PUT',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + ('/columns/' + model.gN.aa)))
		});
};
var $author$project$MainMsg$UpdateUserProfile = function (a) {
	return {$: 38, a: a};
};
var $author$project$Api$Encoders$updateCompanyEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.bJ.gP)),
				_Utils_Tuple2(
				'kind',
				$elm$json$Json$Encode$string(model.bJ.gR)),
				_Utils_Tuple2(
				'web_address',
				$elm$json$Json$Encode$string(model.bJ.gS)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(model.bJ.gQ))
			]));
};
var $author$project$Api$Request$updateCompany = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$updateCompanyEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdateUserProfile, $author$project$Api$Decoders$updateProfileDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'PUT',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('companies/' + model.bJ.gO)
		});
};
var $author$project$Main$updateCompanyProfile = F2(
	function (msg, model) {
		var companyProfile = model.bJ;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bJ: _Utils_update(
								companyProfile,
								{gP: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bJ: _Utils_update(
								companyProfile,
								{gR: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bJ: _Utils_update(
								companyProfile,
								{gQ: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bJ: _Utils_update(
								companyProfile,
								{gS: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateCurrentProfilePage = F2(
	function (profilePageData, pageIndex) {
		var _v0 = profilePageData.E;
		if (_v0.$ === 3) {
			var userProfile = _v0.a;
			return ((_Utils_cmp(
				pageIndex + 1,
				$elm$core$List$length(userProfile.ct)) > 0) || (pageIndex < 0)) ? profilePageData : _Utils_update(
				profilePageData,
				{b6: false, d5: pageIndex, de: false, bY: $author$project$MainMsg$Loadings});
		} else {
			return profilePageData;
		}
	});
var $author$project$Project$AuditionEndDate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Project$AuditionStartDate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Project$CallbackEndDate = function (a) {
	return {$: 13, a: a};
};
var $author$project$Project$CallbackStartDate = function (a) {
	return {$: 12, a: a};
};
var $author$project$Project$FittingDate = function (a) {
	return {$: 22, a: a};
};
var $author$project$Project$ProjectEndDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Project$ProjectStartDate = function (a) {
	return {$: 4, a: a};
};
var $author$project$Project$ShootDate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Project$SubmissionDueDate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$updateDeadlines = F3(
	function (deadlines, name, action) {
		var existingDeadline = A2(
			$elm$core$List$filter,
			A2(
				$author$project$Utils$eq,
				function ($) {
					return $.bS;
				},
				name),
			deadlines);
		var deadlineList = ($elm$core$List$length(existingDeadline) > 0) ? deadlines : A2(
			$elm$core$List$cons,
			_Utils_update(
				$author$project$SharedProjectRoleSchedules$emptyDeadline,
				{bS: name}),
			deadlines);
		return A2(
			$elm$core$List$map,
			function (dl) {
				if (_Utils_eq(dl.bS, name)) {
					switch (action.$) {
						case 1:
							var value = action.a;
							return _Utils_update(
								dl,
								{ee: value, fP: value});
						case 2:
							var value = action.a;
							return _Utils_update(
								dl,
								{fP: value});
						case 3:
							var value = action.a;
							return _Utils_update(
								dl,
								{ee: value});
						case 11:
							var value = action.a;
							return _Utils_update(
								dl,
								{hM: value});
						case 12:
							var value = action.a;
							return _Utils_update(
								dl,
								{fP: value});
						case 13:
							var value = action.a;
							return _Utils_update(
								dl,
								{ee: value});
						case 14:
							var value = action.a;
							return _Utils_update(
								dl,
								{hM: value});
						case 4:
							var value = action.a;
							return _Utils_update(
								dl,
								{fP: value});
						case 5:
							var value = action.a;
							return _Utils_update(
								dl,
								{ee: value});
						case 6:
							var value = action.a;
							return _Utils_update(
								dl,
								{bF: value});
						case 7:
							var value = action.a;
							return _Utils_update(
								dl,
								{bG: value});
						case 8:
							var value = action.a;
							return _Utils_update(
								dl,
								{a0: value});
						case 9:
							var value = action.a;
							return _Utils_update(
								dl,
								{bf: value});
						case 10:
							var value = action.a;
							return _Utils_update(
								dl,
								{dv: value});
						case 15:
							var value = action.a;
							return _Utils_update(
								dl,
								{ee: value, fP: value});
						case 22:
							var value = action.a;
							return _Utils_update(
								dl,
								{ee: value, fP: value});
						default:
							return dl;
					}
				} else {
					return dl;
				}
			},
			deadlineList);
	});
var $author$project$Main$updateDatesInModel = F5(
	function (model, date, newDate, dateString, newDatePicker) {
		var rawDates = model.az;
		var project = model.aj;
		var datePickers = model.G;
		var projectValidations = model.aW;
		var userProfile = model.E;
		switch (date) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{fS: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Submission',
										$author$project$Project$SubmissionDueDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{i7: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{dM: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Audition',
										$author$project$Project$AuditionStartDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{gy: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{dL: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Audition',
										$author$project$Project$AuditionEndDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{gx: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{fg: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Project',
										$author$project$Project$ProjectStartDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{iz: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{dS: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Callback',
										$author$project$Project$CallbackStartDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{gG: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{dR: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Callback',
										$author$project$Project$CallbackEndDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{gF: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{fd: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Project',
										$author$project$Project$ProjectEndDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{iu: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{eo: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Fitting',
										$author$project$Project$FittingDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{ho: newDate})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							G: _Utils_update(
								datePickers,
								{fI: newDatePicker}),
							aj: _Utils_update(
								project,
								{
									g6: A3(
										$author$project$Main$updateDeadlines,
										project.g6,
										'Shoot',
										$author$project$Project$ShootDate(dateString))
								}),
							az: _Utils_update(
								rawDates,
								{i0: newDate})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$State$SpecificDropTarget = function (a) {
	return {$: 1, a: a};
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$updateDropTarget = F2(
	function (_v0, id) {
		var stateData = _v0;
		var updatedStateData = _Utils_update(
			stateData,
			{
				bs: $arsduo$elm_dom_drag_drop$Dom$DragDrop$State$SpecificDropTarget(id)
			});
		return updatedStateData;
	});
var $author$project$MainMsg$UpdateExistingProject = function (a) {
	return {$: 48, a: a};
};
var $author$project$Api$Encoders$deadlineEncoder = function (deadline) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(deadline.bS)),
				_Utils_Tuple2(
				'starts_at',
				$elm$json$Json$Encode$string(deadline.fP)),
				_Utils_Tuple2(
				'due_at',
				$elm$json$Json$Encode$string(deadline.ee)),
				_Utils_Tuple2(
				'location',
				$elm$json$Json$Encode$string(deadline.hM)),
				_Utils_Tuple2(
				'address_1',
				$elm$json$Json$Encode$string(deadline.bF)),
				_Utils_Tuple2(
				'address_2',
				$elm$json$Json$Encode$string(deadline.bG)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(deadline.a0)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(deadline.bf)),
				_Utils_Tuple2(
				'zip_code',
				$elm$json$Json$Encode$string(deadline.dv))
			]));
};
var $author$project$Api$Encoders$projectEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(model.aj.bS)),
				_Utils_Tuple2(
				'userID',
				$elm$json$Json$Encode$string(model.g1)),
				_Utils_Tuple2(
				'notes',
				$elm$json$Json$Encode$string(model.aj.it)),
				_Utils_Tuple2(
				'rate',
				$elm$json$Json$Encode$string(model.aj.iy)),
				_Utils_Tuple2(
				'union',
				$elm$json$Json$Encode$bool(model.aj.jo)),
				_Utils_Tuple2(
				'deadlines',
				A2($elm$json$Json$Encode$list, $author$project$Api$Encoders$deadlineEncoder, model.aj.g6)),
				_Utils_Tuple2(
				'talent_notes',
				$elm$json$Json$Encode$string(model.aj.jg)),
				_Utils_Tuple2(
				'agency_notes',
				$elm$json$Json$Encode$string(model.aj.gk)),
				_Utils_Tuple2(
				'archived',
				$elm$json$Json$Encode$bool(model.aj.dI)),
				_Utils_Tuple2(
				'is_active',
				$elm$json$Json$Encode$bool(model.aj.hB))
			]));
};
var $author$project$Api$Request$updateExistingProject = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$projectEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdateExistingProject, $author$project$Api$Decoders$projectDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'PUT',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + model.d6)
		});
};
var $author$project$MainMsg$UpdateExistingRole = function (a) {
	return {$: 61, a: a};
};
var $author$project$Api$Request$updateExistingRole = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$roleEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdateExistingRole, $author$project$Api$Decoders$roleDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'PUT',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (model.d6 + ('/roles/' + model.g$)))
		});
};
var $author$project$Main$updateFilterValues = F2(
	function (val, filterValues) {
		return A2($elm$core$List$member, val, filterValues) ? A2(
			$elm$core$List$filter,
			function (value) {
				return !_Utils_eq(val, value);
			},
			filterValues) : A2($elm$core$List$cons, val, filterValues);
	});
var $elm$core$String$fromFloat = _String_fromNumber;
var $author$project$Main$updateFiltersBasedOnRole = F2(
	function (role, talentFilterValues) {
		return _Utils_update(
			talentFilterValues,
			{
				hr: A2(
					$elm$core$List$map,
					function (gender) {
						return gender.bS;
					},
					role.hs),
				c2: $elm$core$String$fromInt(role.c2),
				eM: $elm$core$String$fromFloat(role.eM),
				hR: $elm$core$String$fromInt(role.hP),
				c4: $elm$core$String$fromInt(role.c4),
				eQ: $elm$core$String$fromFloat(role.eQ),
				hY: $elm$core$String$fromInt(role.hW),
				iB: A2(
					$elm$core$List$map,
					function (ethnicity) {
						return ethnicity.bS;
					},
					role.eg)
			});
	});
var $author$project$MainMsg$UpdatedInvitation = function (a) {
	return {$: 275, a: a};
};
var $author$project$Api$Encoders$invitationEncoder = F2(
	function (response, invitationId) {
		var res = function () {
			if (!response) {
				return 'accept';
			} else {
				return 'reject';
			}
		}();
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'response',
					$elm$json$Json$Encode$string(res)),
					_Utils_Tuple2(
					'project_id',
					$elm$json$Json$Encode$string(invitationId))
				]));
	});
var $author$project$Api$Request$updateInvitation = F3(
	function (response, invitationId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A2($author$project$Api$Encoders$invitationEncoder, response, invitationId)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdatedInvitation, $author$project$Api$Decoders$collaboratingProjectsDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'invitation/update'
			});
	});
var $author$project$Job$ViewingJobOpen = 0;
var $author$project$Main$updateJobPageData = F2(
	function (jMsg, jobPageData) {
		switch (jMsg.$) {
			case 0:
				var data = jMsg.a;
				return _Utils_update(
					data,
					{f3: 0});
			case 4:
				var state = function () {
					var _v1 = jobPageData.f3;
					if (_v1 === 1) {
						return 0;
					} else {
						return 1;
					}
				}();
				return _Utils_update(
					jobPageData,
					{fG: $author$project$SharedProjectRoleSchedules$emptyBasicProjectData, f3: state});
			case 2:
				return _Utils_update(
					jobPageData,
					{fE: 0});
			case 1:
				var searchTerm = jMsg.a;
				return _Utils_update(
					jobPageData,
					{fF: searchTerm});
			case 5:
				var projects = jMsg.a;
				return _Utils_update(
					jobPageData,
					{
						fh: projects,
						fE: 1,
						fG: A2(
							$elm$core$Maybe$withDefault,
							$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
							$elm$core$List$head(projects))
					});
			default:
				var projectId = jMsg.a;
				return _Utils_update(
					jobPageData,
					{
						fG: A2(
							$elm$core$Maybe$withDefault,
							$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
							$elm$core$List$head(
								A2(
									$elm$core$List$filter,
									A2(
										$author$project$Utils$eq,
										function ($) {
											return $.aa;
										},
										projectId),
									jobPageData.fh))),
						f3: 0
					});
		}
	});
var $author$project$Main$updateMessage = F2(
	function (msg, model) {
		var newMessageData = model.L;
		var value = msg;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					L: _Utils_update(
						newMessageData,
						{dP: value})
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Main$updateNotification = F2(
	function (msg, model) {
		var notificationData = model.bT;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bT: _Utils_update(
								notificationData,
								{dP: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bT: _Utils_update(
								notificationData,
								{cA: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bT: _Utils_update(
								notificationData,
								{hK: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bT: _Utils_update(
								notificationData,
								{aX: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateNotificationSetting = F2(
	function (nMsg, notificationSettings) {
		switch (nMsg.$) {
			case 0:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{aj: value});
			case 1:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{jb: value});
			case 3:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{is: value});
			case 2:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{gw: value});
			default:
				var value = nMsg.a;
				return _Utils_update(
					notificationSettings,
					{hV: value});
		}
	});
var $author$project$Main$updateNotificationSettings = F2(
	function (nMsg, userProfile) {
		return _Utils_update(
			userProfile,
			{
				ic: A2($author$project$Main$updateNotificationSetting, nMsg, userProfile.ic)
			});
	});
var $author$project$Main$updateNotifications = F2(
	function (userProfile, notificationIds) {
		var filteredNotifications = A2(
			$elm$core$List$map,
			function (notification) {
				return A2($elm$core$List$member, notification.aa, notificationIds) ? _Utils_update(
					notification,
					{hE: true}) : notification;
			},
			userProfile.bU);
		return _Utils_update(
			userProfile,
			{bU: filteredNotifications});
	});
var $author$project$Main$updateNotificationsForUser = F2(
	function (currentUser, notifications) {
		return _Utils_update(
			currentUser,
			{bU: notifications});
	});
var $author$project$Main$updatePassword = F2(
	function (msg, model) {
		var userPasswords = model.jv;
		switch (msg.$) {
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jv: _Utils_update(
								userPasswords,
								{eU: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jv: _Utils_update(
								userPasswords,
								{eZ: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							jv: _Utils_update(
								userPasswords,
								{cL: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updatePhysicalAddress = F2(
	function (msg, model) {
		var physicalAddress = model.aH;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: _Utils_update(
								physicalAddress,
								{bF: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: _Utils_update(
								physicalAddress,
								{bG: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: _Utils_update(
								physicalAddress,
								{a0: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: _Utils_update(
								physicalAddress,
								{bf: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: _Utils_update(
								physicalAddress,
								{e3: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aH: _Utils_update(
								physicalAddress,
								{dz: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateAgencyInfo = F2(
	function (agency, aMsg) {
		switch (aMsg.$) {
			case 0:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{cF: value});
			case 1:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{gm: value});
			case 2:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{gn: value});
			case 4:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{gl: value});
			case 3:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{go: value});
			default:
				return agency;
		}
	});
var $author$project$Main$updateAgentData = F2(
	function (agency, agent) {
		return _Utils_update(
			agency,
			{
				gp: _List_fromArray(
					[agent])
			});
	});
var $author$project$Main$updateProfileAgencyInfo = F2(
	function (agency, aMsg) {
		switch (aMsg.$) {
			case 0:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{cF: value});
			case 1:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bx: value});
			case 2:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bP: value});
			case 5:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bF: value});
			case 6:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bG: value});
			case 8:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{bf: value});
			case 7:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{a0: value});
			case 9:
				var value = aMsg.a;
				return _Utils_update(
					agency,
					{dv: value});
			default:
				return agency;
		}
	});
var $author$project$Main$updateProfile = F2(
	function (msg, model) {
		var userProfile = model.E;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{bx: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{bP: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{bv: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{a0: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{bf: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{e0: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{hi: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var part = msg.a;
				switch (part.$) {
					case 0:
						var val = part.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									E: _Utils_update(
										userProfile,
										{h$: val})
								}),
							$elm$core$Platform$Cmd$none);
					case 1:
						var val = part.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									E: _Utils_update(
										userProfile,
										{g5: val})
								}),
							$elm$core$Platform$Cmd$none);
					default:
						var val = part.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									E: _Utils_update(
										userProfile,
										{jE: val})
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{hq: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eO: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(value))
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							eP: A2(
								$elm$core$Maybe$withDefault,
								0,
								$elm$core$String$toInt(value))
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									jA: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toFloat(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									jC: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									c4: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									c2: A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(value))
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var aMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									cE: A2($author$project$Main$updateAgencyInfo, model.E.cE, aMsg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var aMsg = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									gj: A2($author$project$Main$updateProfileAgencyInfo, model.E.gj, aMsg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var id = msg.a;
				var agency = A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyAgency,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.aa;
								},
								id),
							model.h.cD)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{gj: agency})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var id = msg.a;
				var agency = A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyAgency,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.aa;
								},
								model.E.gj.aa),
							model.h.cD)));
				var agent = A2(
					$elm$core$Maybe$withDefault,
					$author$project$User$emptyAgent,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.aa;
								},
								id),
							agency.gp)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									gj: A2($author$project$Main$updateAgentData, model.E.gj, agent)
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateProfileHeightValue = function (model) {
	var userProfile = model.E;
	return _Utils_update(
		userProfile,
		{ht: (model.eO * 12) + model.eP});
};
var $author$project$Main$updateProject = F2(
	function (msg, model) {
		var project = model.aj;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{bS: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Submission', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Audition', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Audition', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Audition', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Callback', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Callback', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Project', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Callback', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Fitting', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 15:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{
									g6: A3($author$project$Main$updateDeadlines, project.g6, 'Shoot', msg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{jg: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{gk: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{it: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 19:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{iy: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 20:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{jo: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 21:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{jo: false})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aj: _Utils_update(
								project,
								{hB: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Project$RoleMenuOpen = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$updateProjectMenuState = F2(
	function (model, msg) {
		var projectMenuState = model.aI;
		var role = model.V;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aI: _Utils_update(
								projectMenuState,
								{ek: !model.aI.ek})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aI: _Utils_update(
								projectMenuState,
								{ej: !model.aI.ej})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aI: _Utils_update(
								projectMenuState,
								{el: !model.aI.el, di: $author$project$Project$RoleMenuClosed})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var projectRoleData = msg.a;
				var _v1 = function () {
					if (!projectRoleData.$) {
						var roleData = projectRoleData.a;
						return _Utils_eq(model.aI.di, $author$project$Project$RoleMenuClosed) ? _Utils_Tuple2(
							$author$project$Project$RoleMenuOpen(roleData),
							roleData.c$) : _Utils_Tuple2($author$project$Project$RoleMenuClosed, '');
					} else {
						return _Utils_Tuple2($author$project$Project$RoleMenuClosed, '');
					}
				}();
				var state = _v1.a;
				var roleId = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							g$: roleId,
							aI: _Utils_update(
								projectMenuState,
								{di: state}),
							V: A2($author$project$Views$Messages$findRole, model.aB, roleId)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateProjectValidation = F2(
	function (msg, model) {
		var projectValidations = model.aW;
		if (!msg) {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aW: _Utils_update(
							projectValidations,
							{bS: true})
					}),
				$elm$core$Platform$Cmd$none);
		} else {
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aW: _Utils_update(
							projectValidations,
							{it: true})
					}),
				$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateQuestions = F2(
	function (profilePage, questions) {
		return _Utils_update(
			profilePage,
			{
				bY: $author$project$MainMsg$Successs(questions)
			});
	});
var $author$project$Main$updateAnswer = F3(
	function (answer, value, questionId) {
		return _Utils_update(
			answer,
			{iA: questionId, iG: value});
	});
var $author$project$Main$updateQuestionsForm = F3(
	function (value, questionId, profilePageData) {
		var updatedQuestions = function () {
			var _v0 = profilePageData.bY;
			if (_v0.$ === 3) {
				var questions = _v0.a;
				return A2(
					$elm$core$List$map,
					function (question) {
						return _Utils_eq(question.aa, questionId) ? _Utils_update(
							question,
							{
								gs: A3($author$project$Main$updateAnswer, question.gs, value, questionId)
							}) : question;
					},
					questions);
			} else {
				return _List_Nil;
			}
		}();
		return _Utils_update(
			profilePageData,
			{
				bY: $author$project$MainMsg$Successs(updatedQuestions)
			});
	});
var $author$project$Main$updateResume = F2(
	function (userProfile, maybeResume) {
		return _Utils_update(
			userProfile,
			{iH: maybeResume});
	});
var $author$project$Main$updateRoleChangeInfo = F4(
	function (roleInfo, roleMemberId, newRoleId, userId) {
		return _Utils_update(
			roleInfo,
			{h4: newRoleId, aX: roleMemberId, cA: userId});
	});
var $author$project$Main$updateRoleEthnicities = F2(
	function (role, options) {
		return _Utils_update(
			role,
			{eg: options});
	});
var $author$project$Main$updateRoleGenders = F2(
	function (role, options) {
		return _Utils_update(
			role,
			{hs: options});
	});
var $author$project$Main$updateRoleMulti = F3(
	function (msg, model, item) {
		var role = model.V;
		var userProfile = model.E;
		switch (msg) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									hs: A2($author$project$Main$addIfNotPresent, item, model.V.hs)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									hs: A2(
										$elm$core$List$filter,
										function (gender) {
											return !_Utils_eq(item, gender);
										},
										model.V.hs)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									eg: A2($author$project$Main$addIfNotPresent, item, model.V.eg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									eg: A2($author$project$Main$addIfNotPresent, item, model.E.eg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							V: _Utils_update(
								role,
								{
									eg: A2(
										$elm$core$List$filter,
										function (ethnicity) {
											return !_Utils_eq(item, ethnicity);
										},
										model.V.eg)
								})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							E: _Utils_update(
								userProfile,
								{
									eg: A2(
										$elm$core$List$filter,
										function (ethnicity) {
											return !_Utils_eq(item, ethnicity);
										},
										model.E.eg)
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateRoleValidation = F2(
	function (msg, model) {
		var roleValidations = model.Z;
		switch (msg) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{bS: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{iM: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{iI: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{hq: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{c4: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{c2: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{eg: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{hW: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{hP: true})
						}),
					$elm$core$Platform$Cmd$none);
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{eQ: true})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							Z: _Utils_update(
								roleValidations,
								{eM: true})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$userPresent = F2(
	function (user, schedules) {
		return A2(
			$elm$core$List$member,
			user.c$,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.c$;
				},
				A2(
					$elm$core$List$map,
					function ($) {
						return $.f_;
					},
					A2(
						$elm$core$List$concatMap,
						function ($) {
							return $.jl;
						},
						schedules))));
	});
var $author$project$Main$availableList = F3(
	function (pipeline, columnNames, schedules) {
		return A2(
			$elm$core$List$filter,
			function (user) {
				return !A2($author$project$Main$userPresent, user, schedules);
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.jx;
				},
				A2(
					$elm$core$List$filter,
					function (column) {
						return A2($elm$core$List$member, column.bS, columnNames);
					},
					pipeline)));
	});
var $author$project$Main$columnsToPullScheduledUsersFrom = function (scheduleType) {
	switch (scheduleType) {
		case 'Audition':
			return _List_fromArray(
				['Scheduled Audition']);
		case 'Callback':
			return _List_fromArray(
				['Scheduled Callbacks']);
		default:
			return _List_Nil;
	}
};
var $author$project$Main$columnsToPullUsersFrom = function (scheduleType) {
	switch (scheduleType) {
		case 'Audition':
			return _List_fromArray(
				['Selected Candidates']);
		case 'Callback':
			return _List_fromArray(
				['Scheduled Audition', 'Selected Candidates']);
		default:
			return _List_Nil;
	}
};
var $author$project$Main$findSchedule = F2(
	function (scheduleId, schedules) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptySchedule,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.aa;
						},
						scheduleId),
					schedules)));
	});
var $author$project$Main$publishedStatus = function (schedules) {
	var _v0 = $elm$core$List$head(schedules);
	if (_v0.$ === 1) {
		return false;
	} else {
		var val = _v0.a;
		return val.bb;
	}
};
var $author$project$Main$pullTalentFromSchedules = function (schedules) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.f_;
		},
		A2(
			$elm$core$List$concatMap,
			function (schedule) {
				return A2(
					$elm$core$List$filter,
					function (timeSlot) {
						return !_Utils_eq(timeSlot.f_, $author$project$User$emptyPipelineUser);
					},
					schedule.jl);
			},
			schedules));
};
var $author$project$Main$scheduleList = F2(
	function (schedules, scheduleType) {
		return A2(
			$elm$core$List$filter,
			function (schedule) {
				return _Utils_eq(schedule.fB, scheduleType);
			},
			schedules);
	});
var $author$project$Main$scheduledList = F3(
	function (pipeline, columnNames, schedules) {
		return A2(
			$elm$core$List$filter,
			function (user) {
				return A2($author$project$Main$userPresent, user, schedules);
			},
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.jx;
				},
				A2(
					$elm$core$List$filter,
					function (column) {
						return A2($elm$core$List$member, column.bS, columnNames);
					},
					pipeline)));
	});
var $author$project$Main$addOrRemoveRole = F2(
	function (item, items) {
		return A2($elm$core$List$member, item, items) ? A2(
			$elm$core$List$filter,
			function (role) {
				return !_Utils_eq(role, item);
			},
			items) : A2($elm$core$List$cons, item, items);
	});
var $elm$core$String$toUpper = _String_toUpper;
var $author$project$Main$filterRoleList = F2(
	function (searchString, roles) {
		return A2(
			$elm$core$List$filter,
			function (role) {
				return A2(
					$elm$core$String$contains,
					$elm$core$String$toUpper(searchString),
					$elm$core$String$toUpper(role));
			},
			roles);
	});
var $author$project$Views$Schedule$roleNames = function (roles) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.bS;
		},
		roles);
};
var $author$project$Main$updateScheduleForm = F3(
	function (model, schedulePageData, scheduleFormMsg) {
		var currentSchedule = schedulePageData.a2;
		switch (scheduleFormMsg.$) {
			case 0:
				var value = scheduleFormMsg.a;
				var deadlineValue = A2(
					$elm$core$Maybe$withDefault,
					$author$project$SharedProjectRoleSchedules$emptyDeadline,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$author$project$Utils$eq,
								function ($) {
									return $.bS;
								},
								value),
							schedulePageData.aj.g6)));
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{fB: value}),
						ee: deadlineValue.ee,
						fP: deadlineValue.fP
					});
			case 1:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{i4: value})
					});
			case 2:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{hc: value})
					});
			case 4:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{gC: value})
					});
			case 5:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{gB: value})
					});
			case 6:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{
								gH: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(value))
							})
					});
			case 7:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{
								ft: A2($author$project$Main$addOrRemoveRole, value, currentSchedule.ft)
							})
					});
			case 8:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{
								dh: A2(
									$author$project$Main$filterRoleList,
									value,
									$author$project$Views$Schedule$roleNames(schedulePageData.aj.ft)),
								iN: value
							})
					});
			case 9:
				var open = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{iW: open});
			case 14:
				return _Utils_update(
					schedulePageData,
					{fL: !model.b$.fL});
			case 10:
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{ft: _List_Nil})
					});
			case 11:
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{
								ft: $author$project$Views$Schedule$roleNames(schedulePageData.aj.ft)
							})
					});
			case 3:
				var value = scheduleFormMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						a2: _Utils_update(
							currentSchedule,
							{
								jk: A2(
									$elm$core$Maybe$withDefault,
									0,
									$elm$core$String$toInt(value))
							})
					});
			case 12:
				return _Utils_update(
					schedulePageData,
					{
						gz: true,
						a2: _Utils_update(
							currentSchedule,
							{
								dh: $author$project$Views$Schedule$roleNames(schedulePageData.aj.ft)
							})
					});
			default:
				return _Utils_update(
					schedulePageData,
					{gz: false});
		}
	});
var $author$project$Main$updateTimeSlotInDayOfPage = F2(
	function (schedule, updatedTimeSlot) {
		return _Utils_update(
			schedule,
			{
				jl: A2(
					$elm$core$List$map,
					function (time_slot) {
						return _Utils_eq(time_slot.aa, updatedTimeSlot.aa) ? updatedTimeSlot : time_slot;
					},
					schedule.jl)
			});
	});
var $author$project$Main$updateTimeSlotInSchedule = F2(
	function (schedules, updatedTimeSlot) {
		return A2(
			$elm$core$List$map,
			function (schedule) {
				return _Utils_eq(schedule.aa, updatedTimeSlot.iO) ? _Utils_update(
					schedule,
					{
						jl: A2(
							$elm$core$List$map,
							function (timeSlot) {
								return _Utils_eq(timeSlot.aa, updatedTimeSlot.aa) ? updatedTimeSlot : timeSlot;
							},
							schedule.jl)
					}) : schedule;
			},
			schedules);
	});
var $author$project$Main$validScheduleForm = function (schedule) {
	return (schedule.i4 === '') || ((schedule.hc === '') || ((!schedule.gH) || (!schedule.jk)));
};
var $author$project$Main$updateSchedulePageData = F2(
	function (model, sMsg) {
		var schedulePageData = model.b$;
		var viewingProject = model.m;
		switch (sMsg.$) {
			case 0:
				var scheduleForm = sMsg.a;
				switch (scheduleForm) {
					case 0:
						return _Utils_update(
							schedulePageData,
							{a2: $author$project$SharedProjectRoleSchedules$emptySchedule, b_: scheduleForm});
					case 2:
						return (!$author$project$Main$validScheduleForm(schedulePageData.a2)) ? _Utils_update(
							schedulePageData,
							{fz: false, b_: scheduleForm}) : _Utils_update(
							schedulePageData,
							{fz: true});
					default:
						return _Utils_update(
							schedulePageData,
							{b_: scheduleForm});
				}
			case 14:
				var comment = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{cb: comment});
			case 1:
				var schedulePage = sMsg.a;
				switch (schedulePage.$) {
					case 1:
						var scheduleType = schedulePage.a;
						return _Utils_update(
							schedulePageData,
							{fB: scheduleType});
					case 3:
						var project = schedulePage.a;
						var scheduleType = schedulePage.b;
						return _Utils_update(
							schedulePageData,
							{
								I: A3(
									$author$project$Main$availableList,
									project.A,
									$author$project$Main$columnsToPullUsersFrom(model.b$.fB),
									A2($author$project$Main$scheduleList, project.k, model.b$.fB)),
								aj: project,
								bb: $author$project$Main$publishedStatus(schedulePageData.k),
								aK: schedulePage,
								fB: scheduleType,
								iP: A3(
									$author$project$Main$scheduledList,
									project.A,
									$author$project$Main$columnsToPullScheduledUsersFrom(model.b$.fB),
									A2($author$project$Main$scheduleList, project.k, model.b$.fB)),
								k: A2($author$project$Main$scheduleList, project.k, scheduleType)
							});
					case 4:
						var updatedPipeline = schedulePage.a;
						return _Utils_update(
							schedulePageData,
							{
								I: A3(
									$author$project$Main$availableList,
									updatedPipeline,
									$author$project$Main$columnsToPullUsersFrom(model.b$.fB),
									A2($author$project$Main$scheduleList, model.b$.k, model.b$.fB)),
								iP: A3(
									$author$project$Main$scheduledList,
									updatedPipeline,
									$author$project$Main$columnsToPullScheduledUsersFrom(model.b$.fB),
									A2($author$project$Main$scheduleList, model.b$.k, model.b$.fB))
							});
					case 2:
						var projectId = schedulePage.a;
						var scheduleType = schedulePage.b;
						return _Utils_update(
							schedulePageData,
							{
								a2: $author$project$SharedProjectRoleSchedules$emptySchedule,
								aj: A2(
									$elm$core$Maybe$withDefault,
									$author$project$SharedProjectRoleSchedules$emptyProject,
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											A2(
												$author$project$Utils$eq,
												function ($) {
													return $.c$;
												},
												projectId),
											model.F))),
								aK: schedulePage,
								fB: scheduleType,
								k: _List_Nil
							});
					default:
						return _Utils_update(
							schedulePageData,
							{aK: schedulePage});
				}
			case 2:
				var scheduleFormMsg = sMsg.a;
				return A3($author$project$Main$updateScheduleForm, model, schedulePageData, scheduleFormMsg);
			case 3:
				var schedules = sMsg.a;
				var formView = sMsg.b;
				return _Utils_update(
					schedulePageData,
					{
						I: A3(
							$author$project$Main$availableList,
							model.m.A,
							$author$project$Main$columnsToPullUsersFrom(model.b$.fB),
							A2($author$project$Main$scheduleList, schedules, model.b$.fB)),
						bb: false,
						b_: formView,
						aK: A3($author$project$Main$determineSchedulePageView, schedules, model.b$.fB, model.b$.aj),
						iP: A3(
							$author$project$Main$scheduledList,
							model.m.A,
							$author$project$Main$columnsToPullScheduledUsersFrom(model.b$.fB),
							A2($author$project$Main$scheduleList, schedules, model.b$.fB)),
						k: A2($author$project$Main$scheduleList, schedules, model.b$.fB)
					});
			case 8:
				var schedules = sMsg.a;
				var scheduleView = sMsg.b;
				var _v3 = function () {
					switch (scheduleView.$) {
						case 0:
							var scheduleType = scheduleView.a;
							return _Utils_Tuple2(scheduleType, '');
						case 3:
							var scheduleType = scheduleView.b;
							return _Utils_Tuple2(scheduleType, '');
						case 5:
							var projectId = scheduleView.a;
							var scheduleId = scheduleView.b;
							return _Utils_Tuple2(
								A2($author$project$Main$findSchedule, scheduleId, schedules).fB,
								scheduleId);
						default:
							return _Utils_Tuple2('', '');
					}
				}();
				var sType = _v3.a;
				var sId = _v3.b;
				return _Utils_update(
					schedulePageData,
					{
						I: A3(
							$author$project$Main$availableList,
							viewingProject.A,
							$author$project$Main$columnsToPullUsersFrom(sType),
							A2($author$project$Main$scheduleList, schedules, sType)),
						cf: A2($author$project$Main$findSchedule, sId, schedules),
						aj: A2($author$project$Main$addSchedulesToViewingProject, model.m, schedules),
						bb: $author$project$Main$publishedStatus(schedules),
						aK: scheduleView,
						iP: A3(
							$author$project$Main$scheduledList,
							viewingProject.A,
							$author$project$Main$columnsToPullScheduledUsersFrom(sType),
							A2($author$project$Main$scheduleList, schedules, sType)),
						k: A2($author$project$Main$scheduleList, schedules, sType)
					});
			case 10:
				var schedules = sMsg.a;
				var talent = sMsg.b;
				var userSwapData = sMsg.c;
				return _Utils_update(
					schedulePageData,
					{
						I: talent,
						bb: $author$project$Main$publishedStatus(schedules),
						b_: 0,
						iP: $author$project$Main$pullTalentFromSchedules(schedules),
						k: schedules,
						f2: userSwapData
					});
			case 4:
				var scheduleType = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						I: A3(
							$author$project$Main$availableList,
							viewingProject.A,
							$author$project$Main$columnsToPullUsersFrom(scheduleType),
							A2($author$project$Main$scheduleList, schedulePageData.aj.k, scheduleType)),
						bb: $author$project$Main$publishedStatus(schedulePageData.k),
						fB: scheduleType,
						iP: A3(
							$author$project$Main$scheduledList,
							viewingProject.A,
							$author$project$Main$columnsToPullScheduledUsersFrom(scheduleType),
							A2($author$project$Main$scheduleList, schedulePageData.aj.k, scheduleType)),
						k: A2($author$project$Main$scheduleList, schedulePageData.aj.k, scheduleType)
					});
			case 5:
				var updatedTimeSlot = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						cb: '',
						cf: A2($author$project$Main$updateTimeSlotInDayOfPage, schedulePageData.cf, updatedTimeSlot),
						k: A2($author$project$Main$updateTimeSlotInSchedule, schedulePageData.k, updatedTimeSlot)
					});
			case 6:
				return $author$project$SharedProjectRoleSchedules$initialSchedulePageData;
			case 7:
				return $author$project$SharedProjectRoleSchedules$initialSchedulePageData;
			case 9:
				var data = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{f2: data});
			case 11:
				var schedules = sMsg.a;
				return _Utils_update(
					schedulePageData,
					{
						bb: $author$project$Main$publishedStatus(schedules),
						aK: A2($author$project$SharedProjectRoleSchedules$ProjectSchedule, schedulePageData.aj, schedulePageData.fB),
						k: schedules
					});
			case 12:
				var project = sMsg.a;
				var schedule = sMsg.b;
				return _Utils_update(
					schedulePageData,
					{
						cf: schedule,
						aK: A2($author$project$SharedProjectRoleSchedules$ScheduleDayOfPage, project.c$, schedule.aa)
					});
			default:
				return _Utils_update(
					schedulePageData,
					{dY: !schedulePageData.dY});
		}
	});
var $author$project$Main$updateSearchResultAge = F2(
	function (age, _v0) {
		var viewingTalentResult = _v0.v;
		return _Utils_update(
			viewingTalentResult,
			{dA: age});
	});
var $author$project$Main$updateSecretString = F2(
	function (profile, secretString) {
		return _Utils_update(
			profile,
			{iU: secretString});
	});
var $author$project$Main$updateTalentFilterExpand = F2(
	function (model, talentFilter) {
		var talentFilterExpands = model.O;
		switch (talentFilter) {
			case 0:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: _Utils_update(
								talentFilterExpands,
								{es: !model.O.es})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: _Utils_update(
								talentFilterExpands,
								{dB: !model.O.dB})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: _Utils_update(
								talentFilterExpands,
								{eh: !model.O.eh})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: _Utils_update(
								talentFilterExpands,
								{en: !model.O.en})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: _Utils_update(
								talentFilterExpands,
								{ev: !model.O.ev})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: _Utils_update(
								talentFilterExpands,
								{gb: !model.O.gb})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: _Utils_update(
								talentFilterExpands,
								{fM: !model.O.fM})
						}),
					$elm$core$Platform$Cmd$none);
			case 7:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							O: _Utils_update(
								talentFilterExpands,
								{eN: !model.O.eN})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateTalentFilterOffset = F2(
	function (talentFilterValues, offset) {
		return _Utils_update(
			talentFilterValues,
			{id: offset + 48});
	});
var $author$project$MainMsg$UpdatedMembership = function (a) {
	return {$: 316, a: a};
};
var $author$project$Api$Request$updateTalentMembership = F3(
	function (status, membershipId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdatedMembership, $author$project$Api$Decoders$talentUserDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('agencies/talent/' + (membershipId + ('/' + status)))
			});
	});
var $author$project$User$LoadingTalentDetails = {$: 2};
var $author$project$User$OptionsModal = {$: 3};
var $author$project$Main$filterRoleOptions = F2(
	function (roles, projectId) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return {aa: role.c$, bS: role.bS};
			},
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.iw;
					},
					projectId),
				roles));
	});
var $author$project$Utils$reasonActionText = function (reason) {
	switch (reason) {
		case 0:
			return 'Removing from role. Please provide a reason.';
		case 1:
			return 'Requesting to be rescheduled. Please provide a reason.';
		case 2:
			return 'Declining audition schedule request. Please provide a reason.';
		case 4:
			return 'Requesting to be rescheduled. Please provide a reason.';
		case 5:
			return 'Declining callback schedule request. Please provide a reason.';
		case 3:
			return 'Declining application request. Please provide a reason.';
		case 6:
			return 'Declining booking request. Please provide a reason.';
		default:
			return '';
	}
};
var $author$project$Main$updateTalentMenuOptions = F5(
	function (tMsg, talentOptionsMenu, projectId, roleId, roles) {
		switch (tMsg.$) {
			case 0:
				var reason = tMsg.a;
				return _Utils_update(
					talentOptionsMenu,
					{iD: reason});
			case 2:
				var talent = tMsg.a;
				return _Utils_update(
					talentOptionsMenu,
					{bR: $author$project$User$OptionsModal, jb: talent});
			case 1:
				var modalView = tMsg.a;
				switch (modalView.$) {
					case 1:
						var reasonAction = modalView.a;
						return _Utils_update(
							talentOptionsMenu,
							{
								h_: $author$project$Utils$reasonActionText(reasonAction),
								bR: modalView
							});
					case 4:
						return _Utils_update(
							talentOptionsMenu,
							{
								bR: modalView,
								ft: A2($author$project$Main$filterRoleOptions, roles, projectId)
							});
					default:
						return _Utils_update(
							talentOptionsMenu,
							{bR: modalView});
				}
			case 3:
				var talentProfile = tMsg.a;
				return (!talentOptionsMenu.dr) ? $author$project$User$initialTalentMenuOptions : _Utils_update(
					talentOptionsMenu,
					{g_: projectId, g0: roleId, bR: $author$project$User$LoadingTalentDetails, jb: talentProfile, dr: 0});
			default:
				var newRole = tMsg.a;
				return _Utils_update(
					talentOptionsMenu,
					{fs: newRole});
		}
	});
var $author$project$Main$updateTalentVideo = F2(
	function (profile, updatedVideo) {
		return _Utils_update(
			profile,
			{
				a_: A2(
					$elm$core$List$map,
					function (video) {
						return _Utils_eq(video.aa, updatedVideo.aa) ? updatedVideo : video;
					},
					profile.a_)
			});
	});
var $author$project$Message$TwilioDataReceived = 2;
var $author$project$Message$TwilioMessageSent = 3;
var $author$project$Main$archiveChannelIndex = F2(
	function (conversations, id) {
		return A2(
			$elm$core$List$map,
			function (conversation) {
				return _Utils_eq(conversation.aa, id) ? _Utils_update(
					conversation,
					{dI: !conversation.dI}) : conversation;
			},
			conversations);
	});
var $author$project$Api$Encoders$newMessageEncoder = function (conversation) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role_member_id',
				$elm$json$Json$Encode$string(conversation.aX)),
				_Utils_Tuple2(
				'message',
				$elm$json$Json$Encode$string(
					A3($elm$core$String$slice, 0, 99, conversation.hL) + '...'))
			]));
};
var $author$project$Api$Request$channelCreated = F2(
	function (conversation, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$newMessageEncoder(conversation)),
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$DoNothing),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'users/created_channel'
			});
	});
var $author$project$Main$checkIfChannelsAreDifferent = F2(
	function (receivedConversations, frontendConversations) {
		return (_Utils_cmp(
			$elm$core$List$length(receivedConversations),
			$elm$core$List$length(frontendConversations)) < 0) ? frontendConversations : receivedConversations;
	});
var $author$project$Main$createConversation = F5(
	function (creator, user, message, projectId, roleId) {
		var twilioPayload = _Utils_update(
			$author$project$Message$emptyToTwilioPayload,
			{
				dP: message,
				gW: creator.c$,
				hp: user.bx + (' ' + user.bP),
				hF: A2(
					$elm$core$Maybe$withDefault,
					{aa: '', js: ''},
					$elm$core$List$head(creator.l)).js,
				eE: creator.c$,
				hG: creator.c$,
				hH: creator.bx + (' ' + creator.bP),
				iw: projectId,
				ix: user.ix,
				iK: roleId,
				aX: user.aX,
				iL: user.iL,
				jc: A2(
					$elm$core$Maybe$withDefault,
					{aa: '', js: ''},
					$elm$core$List$head(user.l)).js,
				je: user.c$,
				jf: user.bx + (' ' + user.bP),
				jp: ''
			});
		return $author$project$Main$twilio(
			{
				z: 'createChannel',
				ai: $author$project$Api$Encoders$twilioPayloadEncoder(twilioPayload),
				ao: creator.C
			});
	});
var $author$project$Api$Encoders$notificationEncoder = F4(
	function (sendingUser, body, notificationType, conversation) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'sending_user_id',
					$elm$json$Json$Encode$string(sendingUser)),
					_Utils_Tuple2(
					'role_member_id',
					$elm$json$Json$Encode$string(conversation.aX)),
					_Utils_Tuple2(
					'body',
					$elm$json$Json$Encode$string(body)),
					_Utils_Tuple2(
					'notification_type',
					$elm$json$Json$Encode$string(notificationType)),
					_Utils_Tuple2(
					'conversation_id',
					$elm$json$Json$Encode$string(conversation.aa)),
					_Utils_Tuple2(
					'job_poster_id',
					$elm$json$Json$Encode$string(conversation.eE)),
					_Utils_Tuple2(
					'talent_id',
					$elm$json$Json$Encode$string(conversation.jd))
				]));
	});
var $author$project$Api$Request$createNotification = F5(
	function (jwt, sendingUser, body, notificationType, conversation) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					A4($author$project$Api$Encoders$notificationEncoder, sendingUser, body, notificationType, conversation)),
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$DoNothing),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'users/create_notification'
			});
	});
var $author$project$MainMsg$ProjectDeleted = function (a) {
	return {$: 50, a: a};
};
var $author$project$Api$Encoders$deleteEncoder = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'archived',
			$elm$json$Json$Encode$bool(true))
		]));
var $elm$http$Http$expectString = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$elm$http$Http$resolve($elm$core$Result$Ok));
};
var $author$project$Api$Request$deleteProject = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody($author$project$Api$Encoders$deleteEncoder),
			a: $elm$http$Http$expectString($author$project$MainMsg$ProjectDeleted),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'PUT',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('projects/' + model.d6)
		});
};
var $author$project$MainMsg$RoleDeleted = function (a) {
	return {$: 63, a: a};
};
var $author$project$Api$Request$deleteRole = F3(
	function (projectId, roleId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody($author$project$Api$Encoders$deleteEncoder),
				a: $elm$http$Http$expectString($author$project$MainMsg$RoleDeleted),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'PUT',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('projects/' + (projectId + ('/roles/' + roleId)))
			});
	});
var $author$project$Main$findChannel = F2(
	function (conversations, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Message$emptyConversation,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.aa;
						},
						id),
					conversations)));
	});
var $author$project$Main$findChannelIdsByProject = F2(
	function (projectId, conversations) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.aa;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.iw;
					},
					projectId),
				conversations));
	});
var $author$project$Main$findChannelIdsByRole = F2(
	function (roleId, conversations) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.aa;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.iK;
					},
					roleId),
				conversations));
	});
var $author$project$MainMsg$GotUserConvoInfo = function (a) {
	return {$: 237, a: a};
};
var $author$project$Api$Encoders$roleMemberIdEncoder = function (roleMemberIds) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role_member_ids',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, roleMemberIds))
			]));
};
var $author$project$User$UserConvoInfo = F7(
	function (projectName, roleName, userName, projectId, roleId, profileImage, roleMemberId) {
		return {ir: profileImage, iw: projectId, ix: projectName, iK: roleId, aX: roleMemberId, iL: roleName, ju: userName};
	});
var $author$project$Api$Decoders$userConvoDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'role_member_id',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'profile_image',
		$author$project$Api$Decoders$imageDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'role_id',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'project_id',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'user_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'role_name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'project_name',
							$elm$json$Json$Decode$string,
							$elm$json$Json$Decode$succeed($author$project$User$UserConvoInfo))))))));
var $author$project$Api$Decoders$userConvosDecoder = $elm$json$Json$Decode$list($author$project$Api$Decoders$userConvoDecoder);
var $author$project$Api$Request$getChannelInfo = F2(
	function (jwt, roleMemberIds) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$roleMemberIdEncoder(roleMemberIds)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotUserConvoInfo, $author$project$Api$Decoders$userConvosDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'users/user_info_for_convos'
			});
	});
var $author$project$MainMsg$GotUserJobStageInfo = function (a) {
	return {$: 227, a: a};
};
var $author$project$Api$Request$getUserJobStageInfo = F2(
	function (roleMemberId, jwt) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$emptyBody,
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotUserJobStageInfo, $author$project$Api$Decoders$pipelineUserDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (roleMemberId + '/job_stage_info'))
			});
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Main$removeLastMessage = function (conversation) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$drop,
			1,
			$elm$core$List$reverse(conversation.hV)));
};
var $author$project$Main$myMessageMedia = F2(
	function (currentConversation, receivedMessage) {
		var messages = $author$project$Main$removeLastMessage(currentConversation);
		return _Utils_update(
			currentConversation,
			{
				hV: _Utils_ap(
					messages,
					_List_fromArray(
						[receivedMessage]))
			});
	});
var $author$project$Main$otherUsersMessage = F2(
	function (currentConversation, receivedMessage) {
		return _Utils_update(
			currentConversation,
			{
				hV: _Utils_ap(
					currentConversation.hV,
					_List_fromArray(
						[receivedMessage]))
			});
	});
var $author$project$Main$checkIfViewingChannel = F3(
	function (currentConversation, receivedMessage, userProfile) {
		var viewingChannel = _Utils_eq(receivedMessage.gV, currentConversation.aa);
		var myMessage = _Utils_eq(receivedMessage.gW, userProfile.c$);
		return (viewingChannel && myMessage) ? A2($author$project$Main$myMessageMedia, currentConversation, receivedMessage) : ((viewingChannel && (!myMessage)) ? A2($author$project$Main$otherUsersMessage, currentConversation, receivedMessage) : currentConversation);
	});
var $author$project$Main$pullOutMessage = function (messages) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Message$emptyMessage,
		$elm$core$List$head(messages));
};
var $author$project$Main$replacePendingUploadMessageInChannelIndex = F2(
	function (conversations, receivedMessage) {
		return A2(
			$elm$core$List$map,
			function (conversation) {
				if (_Utils_eq(conversation.aa, receivedMessage.gV)) {
					var updatedMessages = $author$project$Main$removeLastMessage(conversation);
					return _Utils_update(
						conversation,
						{
							hL: 'Media Message',
							hV: _Utils_ap(
								updatedMessages,
								_List_fromArray(
									[receivedMessage]))
						});
				} else {
					return conversation;
				}
			},
			conversations);
	});
var $author$project$Main$handleNewMessagePayload = F2(
	function (payload, model) {
		var twilioData = model.p;
		var receivedMessage = $author$project$Main$pullOutMessage(payload.hV);
		if (_Utils_eq(receivedMessage.gW, model.E.c$)) {
			var _v0 = receivedMessage.aF;
			if (_v0 === 'media') {
				return _Utils_update(
					twilioData,
					{
						n: A2($author$project$Main$replacePendingUploadMessageInChannelIndex, twilioData.n, receivedMessage),
						t: A3($author$project$Main$checkIfViewingChannel, twilioData.t, receivedMessage, model.E)
					});
			} else {
				return twilioData;
			}
		} else {
			return _Utils_update(
				twilioData,
				{
					n: A4($author$project$Main$addMessageToChannelIndex, twilioData.n, receivedMessage, twilioData.t, model.E),
					t: A3($author$project$Main$checkIfViewingChannel, twilioData.t, receivedMessage, model.E)
				});
		}
	});
var $author$project$Main$markMessagesAsRead = F2(
	function (allChannels, channel) {
		return A2(
			$elm$core$List$map,
			function (chan) {
				return _Utils_eq(chan.aa, channel.aa) ? _Utils_update(
					chan,
					{bD: 0}) : chan;
			},
			allChannels);
	});
var $author$project$MainMsg$GotNewTwilioToken = function (a) {
	return {$: 224, a: a};
};
var $author$project$Api$Encoders$twilioTokenEncoder = function (token) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'old-twilio_token',
				$elm$json$Json$Encode$string(token))
			]));
};
var $author$project$Api$Request$refreshTwilioToken = F3(
	function (token, jwt, uid) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$twilioTokenEncoder(token)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotNewTwilioToken, $author$project$Api$Decoders$updateProfileDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'GET',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (uid + '/refresh_twilio'))
			});
	});
var $author$project$Main$resetButtonTimeout = A2(
	$author$project$Utils$delay,
	200,
	$author$project$MainMsg$DataReceivedFromTwilio(
		_Utils_update(
			$author$project$Message$emptyFromTwilioPayload,
			{z: 'reset-send-button'})));
var $author$project$Main$roleMemberIdsFromChannels = function (conversations) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.aX;
		},
		conversations);
};
var $author$project$Main$roleMembersMatch = F2(
	function (channel, user) {
		return _Utils_eq(channel.aX, user.aX);
	});
var $author$project$Main$findUserConvoInfo = F2(
	function (userInfoList, roleMemberId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyUserConvoInfo,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.aX;
						},
						roleMemberId),
					userInfoList)));
	});
var $author$project$Main$updateChannelInfo = F2(
	function (conversations, userInfoList) {
		return A2(
			$elm$core$List$map,
			function (conversation) {
				var roleMemberIds = A2(
					$elm$core$List$map,
					function ($) {
						return $.aX;
					},
					userInfoList);
				if (A2($elm$core$List$member, conversation.aX, roleMemberIds)) {
					var userInfo = A2($author$project$Main$findUserConvoInfo, userInfoList, conversation.aX);
					return _Utils_update(
						conversation,
						{iw: userInfo.iw, ix: userInfo.ix, iK: userInfo.iK, iL: userInfo.iL, jc: userInfo.ir.js, jf: userInfo.ju});
				} else {
					return conversation;
				}
			},
			conversations);
	});
var $author$project$Main$updateTwilioData = F4(
	function (data, model, id, userConvosInfo) {
		var twilioData = model.p;
		var newMessageData = model.L;
		var _v0 = data.z;
		switch (_v0) {
			case 'refreshTwilioToken':
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Api$Request$refreshTwilioToken, model.E.C, model.hI, model.E.c$),
								$author$project$Main$changeWindowHeight('')
							])));
			case 'gotChannels':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							p: _Utils_update(
								twilioData,
								{
									n: A2($author$project$Main$checkIfChannelsAreDifferent, data.n, twilioData.n)
								}),
							aO: 2
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$changeWindowHeight(''),
								A2(
								$author$project$Api$Request$getChannelInfo,
								model.hI,
								$author$project$Main$roleMemberIdsFromChannels(data.n))
							])));
			case 'gotUserConvoInfo':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							p: _Utils_update(
								twilioData,
								{
									n: A2($author$project$Main$updateChannelInfo, twilioData.n, userConvosInfo)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 'switchChannel':
				var channelSwitchedTo = A2($author$project$Main$findChannel, twilioData.n, id);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							a6: false,
							by: false,
							dq: true,
							p: _Utils_update(
								twilioData,
								{
									n: A2($author$project$Main$markMessagesAsRead, twilioData.n, channelSwitchedTo),
									t: channelSwitchedTo
								})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$changeWindowHeight(''),
								A2($author$project$Api$Request$getUserJobStageInfo, channelSwitchedTo.aX, model.hI),
								$author$project$Main$twilio(
								{
									z: 'markConversationAsRead',
									ai: $author$project$Api$Encoders$twilioPayloadEncoder(
										_Utils_update(
											$author$project$Message$emptyToTwilioPayload,
											{gJ: id})),
									ao: model.E.C
								})
							])));
			case 'archiveConversationsByProject':
				var channelIds = A2($author$project$Main$findChannelIdsByProject, id, twilioData.n);
				var archivedChannels = A2(
					$elm$core$List$map,
					function (channel) {
						return A2($elm$core$List$member, channel.aa, channelIds) ? _Utils_update(
							channel,
							{dI: !channel.dI}) : channel;
					},
					twilioData.n);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ad: false,
							p: _Utils_update(
								twilioData,
								{n: archivedChannels})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Api$Request$deleteProject(model),
								$author$project$Main$twilio(
								{
									z: 'archiveAllConversations',
									ai: $author$project$Api$Encoders$twilioPayloadEncoder(
										_Utils_update(
											$author$project$Message$emptyToTwilioPayload,
											{gK: channelIds})),
									ao: model.E.C
								})
							])));
			case 'archiveConversationsByRole':
				var channelIds = A2($author$project$Main$findChannelIdsByRole, id, twilioData.n);
				var archivedChannels = A2(
					$elm$core$List$map,
					function (channel) {
						return A2($elm$core$List$member, channel.aa, channelIds) ? _Utils_update(
							channel,
							{dI: !channel.dI}) : channel;
					},
					twilioData.n);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ad: false,
							p: _Utils_update(
								twilioData,
								{n: archivedChannels})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3($author$project$Api$Request$deleteRole, model.d6, id, model.hI),
								$author$project$Main$twilio(
								{
									z: 'archiveAllConversations',
									ai: $author$project$Api$Encoders$twilioPayloadEncoder(
										_Utils_update(
											$author$project$Message$emptyToTwilioPayload,
											{gK: channelIds})),
									ao: model.E.C
								})
							])));
			case 'archiveConversation':
				var channel = A2($author$project$Main$findChannel, twilioData.n, id);
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							p: _Utils_update(
								twilioData,
								{
									n: A2($author$project$Main$archiveChannelIndex, twilioData.n, id)
								})
						}),
					$author$project$Main$twilio(
						{
							z: 'archiveChannel',
							ai: $author$project$Api$Encoders$twilioPayloadEncoder(
								_Utils_update(
									$author$project$Message$emptyToTwilioPayload,
									{gJ: id})),
							ao: model.E.C
						}));
			case 'newMessage':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							p: A2($author$project$Main$handleNewMessagePayload, data, model)
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Main$changeWindowHeight('')
							])));
			case 'sentMessage':
				var message = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Message$emptyMessage,
					$elm$core$List$head(
						$elm$core$List$reverse(data.t.hV)));
				var _v1 = message.aF;
				if (_v1 === 'media') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								p: _Utils_update(
									twilioData,
									{
										hV: _Utils_ap(twilioData.hV, data.hV)
									}),
								aO: 3
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$changeWindowHeight(''),
									A5($author$project$Api$Request$createNotification, model.hI, model.E.c$, 'Media Message', 'message', data.t),
									$author$project$Main$resetButtonTimeout
								])));
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aO: 3}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A5($author$project$Api$Request$createNotification, model.hI, model.E.c$, message.dP, 'message', data.t),
									$author$project$Main$resetButtonTimeout
								])));
				}
			case 'reset-send-button':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aO: 2}),
					$elm$core$Platform$Cmd$none);
			case 'closeTalentConversationContainer':
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dq: false,
							p: _Utils_update(
								twilioData,
								{t: $author$project$Message$emptyConversation})
						}),
					$elm$core$Platform$Cmd$none);
			case 'createdChannel':
				var receivedConvoId = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Message$emptyConversation,
					$elm$core$List$head(data.n)).aa;
				var updatedChannels = A2(
					$elm$core$List$map,
					function (convo) {
						return (convo.aa === '') ? _Utils_update(
							convo,
							{aa: receivedConvoId}) : convo;
					},
					twilioData.n);
				var message = A2(
					$elm$core$Maybe$withDefault,
					$author$project$Message$emptyMessage,
					$elm$core$List$head(
						$elm$core$List$reverse(data.t.hV)));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							p: _Utils_update(
								twilioData,
								{n: updatedChannels, t: data.t}),
							aO: 2
						}),
					A5($author$project$Api$Request$createNotification, model.hI, model.E.c$, message.dP, 'message', data.t));
			case 'creatingAConversation':
				var conversation = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (channel) {
							return A2($author$project$Main$roleMembersMatch, channel, model.v);
						},
						model.p.n));
				var _v2 = function () {
					if (!conversation.$) {
						var convo = conversation.a;
						var message = A2(
							$elm$core$Maybe$withDefault,
							$author$project$Message$emptyMessage,
							$elm$core$List$head(data.t.hV));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									L: _Utils_update(
										newMessageData,
										{dP: ''}),
									p: _Utils_update(
										twilioData,
										{
											n: twilioData.n,
											t: A2($author$project$Main$updateChannelMessages, convo, message)
										}),
									aO: 0
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A4($author$project$Main$createMessage, convo.aa, model.L.dP, model.E.C, model.E.c$)
									])));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									L: _Utils_update(
										newMessageData,
										{dP: ''}),
									p: _Utils_update(
										twilioData,
										{
											n: A2($elm$core$List$cons, data.t, twilioData.n),
											t: data.t,
											hV: data.hV
										}),
									aO: 0
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A5($author$project$Main$createConversation, model.E, model.v, model.L.dP, model.d6, model.g$),
										A2(
										$author$project$Api$Request$channelCreated,
										_Utils_update(
											$author$project$Message$emptyConversation,
											{hL: model.L.dP, aX: model.v.aX}),
										model.hI)
									])));
					}
				}();
				var optiModel = _v2.a;
				var action = _v2.b;
				return _Utils_Tuple2(optiModel, action);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Main$updateUser = F2(
	function (msg, model) {
		var userData = model.aZ;
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: _Utils_update(
								userData,
								{bx: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: _Utils_update(
								userData,
								{bP: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: _Utils_update(
								userData,
								{eZ: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: _Utils_update(
								userData,
								{e_: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: _Utils_update(
								userData,
								{eU: value})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: _Utils_update(
								userData,
								{bv: value})
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: _Utils_update(
								userData,
								{cK: value})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$MainMsg$UpdatePasswords = function (a) {
	return {$: 43, a: a};
};
var $author$project$User$UserPasswords = F3(
	function (password, oldPassword, confirmPassword) {
		return {cL: confirmPassword, eU: oldPassword, eZ: password};
	});
var $author$project$Api$Decoders$updatePasswordDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'oldPassword',
	$elm$json$Json$Decode$string,
	'',
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'confirmPassword',
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'password',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$User$UserPasswords))));
var $author$project$Api$Encoders$updatePasswordEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'password',
				$elm$json$Json$Encode$string(model.jv.eZ))
			]));
};
var $author$project$Api$Request$updateUserPassword = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$updatePasswordEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdatePasswords, $author$project$Api$Decoders$updatePasswordDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'PUT',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('user/' + model.hn)
		});
};
var $author$project$Api$Encoders$agencyEncoder = function (agency) {
	var agent = A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyAgent,
		$elm$core$List$head(agency.gp));
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(agency.aa)),
				_Utils_Tuple2(
				'agency_name',
				$elm$json$Json$Encode$string(agency.cF)),
				_Utils_Tuple2(
				'agent_id',
				$elm$json$Json$Encode$string(agent.aa)),
				_Utils_Tuple2(
				'agent_name',
				$elm$json$Json$Encode$string(agent.bx)),
				_Utils_Tuple2(
				'agent_email',
				$elm$json$Json$Encode$string(agent.bv)),
				_Utils_Tuple2(
				'agent_phone',
				$elm$json$Json$Encode$string(agent.e0)),
				_Utils_Tuple2(
				'agent_address1',
				$elm$json$Json$Encode$string(agency.bF)),
				_Utils_Tuple2(
				'agent_address2',
				$elm$json$Json$Encode$string(agency.bG)),
				_Utils_Tuple2(
				'agent_city',
				$elm$json$Json$Encode$string(agency.a0)),
				_Utils_Tuple2(
				'agent_state',
				$elm$json$Json$Encode$string(agency.bf)),
				_Utils_Tuple2(
				'agent_zip',
				$elm$json$Json$Encode$string(agency.dv))
			]));
};
var $author$project$Utils$createDobFromValues = F3(
	function (month, day, year) {
		return year + ('/' + (month + ('/' + day)));
	});
var $author$project$Api$Encoders$notificationSettingsEncoder = function (settings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'project',
				$elm$json$Json$Encode$bool(settings.aj)),
				_Utils_Tuple2(
				'talent',
				$elm$json$Json$Encode$bool(settings.jb)),
				_Utils_Tuple2(
				'audition',
				$elm$json$Json$Encode$bool(settings.gw)),
				_Utils_Tuple2(
				'messages',
				$elm$json$Json$Encode$bool(settings.hV)),
				_Utils_Tuple2(
				'profile_update',
				$elm$json$Json$Encode$bool(settings.is))
			]));
};
var $author$project$Api$Encoders$updateProfileEncoder = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(model.E.bx)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(model.E.bP)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(model.E.bv)),
				_Utils_Tuple2(
				'phone',
				$elm$json$Json$Encode$string(model.E.e0)),
				_Utils_Tuple2(
				'eye_color',
				$elm$json$Json$Encode$string(model.E.hi)),
				_Utils_Tuple2(
				'city',
				$elm$json$Json$Encode$string(model.E.a0)),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(model.E.bf)),
				_Utils_Tuple2(
				'birth_date',
				$elm$json$Json$Encode$string(
					A3($author$project$Utils$createDobFromValues, model.E.h$, model.E.g5, model.E.jE))),
				_Utils_Tuple2(
				'gender',
				$elm$json$Json$Encode$string(model.E.hq)),
				_Utils_Tuple2(
				'ethnic_appearance',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$string,
					A2(
						$elm$core$List$map,
						function (option) {
							return option.aa;
						},
						model.E.eg))),
				_Utils_Tuple2(
				'height',
				$elm$json$Json$Encode$int(model.E.ht)),
				_Utils_Tuple2(
				'weight',
				$elm$json$Json$Encode$int(model.E.jC)),
				_Utils_Tuple2(
				'waist_size',
				$elm$json$Json$Encode$float(model.E.jA)),
				_Utils_Tuple2(
				'company',
				$elm$json$Json$Encode$string(model.E.cK)),
				_Utils_Tuple2(
				'min_age',
				$elm$json$Json$Encode$int(model.E.c4)),
				_Utils_Tuple2(
				'max_age',
				$elm$json$Json$Encode$int(model.E.c2)),
				_Utils_Tuple2(
				'agency',
				$author$project$Api$Encoders$agencyEncoder(model.E.gj)),
				_Utils_Tuple2(
				'notification_settings',
				$author$project$Api$Encoders$notificationSettingsEncoder(model.E.ic))
			]));
};
var $author$project$Api$Request$updateUserProfile = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$updateProfileEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UpdateUserProfile, $author$project$Api$Decoders$updateProfileDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'PUT',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('users/' + model.E.c$)
		});
};
var $author$project$MainMsg$PageChangedProfileUpdated = function (a) {
	return {$: 311, a: a};
};
var $author$project$Api$Request$updateUserProfilePageChange = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$updateProfileEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$PageChangedProfileUpdated, $author$project$Api$Decoders$updateProfileDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'PUT',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + ('users/' + model.E.c$)
		});
};
var $author$project$Main$updateUserProfileStatus = F3(
	function (profileData, status, questionsStatus) {
		return _Utils_update(
			profileData,
			{bY: questionsStatus, E: status});
	});
var $author$project$MainMsg$UpdatedUsersRole = function (a) {
	return {$: 219, a: a};
};
var $author$project$Api$Encoders$roleChangeInfoEncoder = function (roleChangeInfo) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'role_member_id',
				$elm$json$Json$Encode$string(roleChangeInfo.aX)),
				_Utils_Tuple2(
				'new_role_id',
				$elm$json$Json$Encode$string(roleChangeInfo.h4)),
				_Utils_Tuple2(
				'user_id',
				$elm$json$Json$Encode$string(roleChangeInfo.cA))
			]));
};
var $author$project$Api$Request$updateUsersRoleInfo = F2(
	function (jwt, roleChangeInfo) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$roleChangeInfoEncoder(roleChangeInfo)),
				a: $elm$http$Http$expectWhatever($author$project$MainMsg$UpdatedUsersRole),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'PUT',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + 'update_users_role'
			});
	});
var $author$project$Api$Encoders$videoNameEncoder = function (filename) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'filename',
				$elm$json$Json$Encode$string(filename))
			]));
};
var $author$project$Api$Request$updateVideoInfo = F3(
	function (jwt, filename, tempId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$jsonBody(
					$author$project$Api$Encoders$videoNameEncoder(filename)),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$GotTempfile, $author$project$Api$Decoders$videoDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'PUT',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Nothing,
				js: $author$project$Api$Request$talentSourceUrl + ('videos/' + (tempId + '/update'))
			});
	});
var $author$project$Main$optimisticPipeline = F3(
	function (roleMemberIds, newColumnId, pipeline) {
		var pipelineWithUsersRemoved = A2(
			$elm$core$List$map,
			function (column) {
				return _Utils_update(
					column,
					{
						jx: A2(
							$elm$core$List$filter,
							function (user) {
								return !A2($elm$core$List$member, user.aX, roleMemberIds);
							},
							column.jx)
					});
			},
			pipeline);
		var affectedUsers = A2(
			$elm$core$List$concatMap,
			function (column) {
				return A2(
					$elm$core$List$filter,
					function (user) {
						return A2($elm$core$List$member, user.aX, roleMemberIds);
					},
					column.jx);
			},
			pipeline);
		return A2(
			$elm$core$List$map,
			function (column) {
				return _Utils_eq(column.aa, newColumnId) ? (($elm$core$List$length(affectedUsers) > 1) ? _Utils_update(
					column,
					{
						jx: $elm$core$List$reverse(
							A2($elm$core$List$append, affectedUsers, column.jx))
					}) : _Utils_update(
					column,
					{
						jx: A2($elm$core$List$append, affectedUsers, column.jx)
					})) : column;
			},
			pipelineWithUsersRemoved);
	});
var $author$project$Main$updateViewingProjectPipeline = F3(
	function (viewingProject, roleMemberIds, newColumnId) {
		return _Utils_update(
			viewingProject,
			{
				A: A3($author$project$Main$optimisticPipeline, roleMemberIds, newColumnId, viewingProject.A)
			});
	});
var $author$project$Main$updateViewingProjectRoles = F2(
	function (updatedRole, project) {
		return _Utils_update(
			project,
			{
				ft: A2(
					$elm$core$List$map,
					function (role) {
						return _Utils_eq(role.c$, updatedRole.c$) ? {gf: updatedRole.gf, c$: updatedRole.c$, bS: updatedRole.bS, iI: updatedRole.iI} : role;
					},
					project.ft)
			});
	});
var $elm$http$Http$filePart = _Http_pair;
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $author$project$Api$Request$uploadImage = F3(
	function (image, jwt, userId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'image', image)
						])),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$Uploaded, $author$project$Api$Decoders$imageDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Just('upload'),
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (userId + '/upload_image'))
			});
	});
var $author$project$MainMsg$UploadedResume = function (a) {
	return {$: 128, a: a};
};
var $author$project$User$ResumeResponse = function (url) {
	return {js: url};
};
var $author$project$Api$Decoders$resumeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	$elm$json$Json$Decode$succeed($author$project$User$ResumeResponse));
var $author$project$Api$Request$uploadResume = F3(
	function (resume, jwt, userId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'resume', resume)
						])),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UploadedResume, $author$project$Api$Decoders$resumeDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Just('upload'),
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (userId + '/resume'))
			});
	});
var $author$project$MainMsg$UploadedVideo = function (a) {
	return {$: 122, a: a};
};
var $author$project$Api$Request$uploadVideo = F4(
	function (video, tempId, jwt, roleMemberId) {
		return $elm$http$Http$request(
			{
				dP: $elm$http$Http$multipartBody(
					_List_fromArray(
						[
							A2($elm$http$Http$filePart, 'video', video)
						])),
				a: A2($elm$http$Http$expectJson, $author$project$MainMsg$UploadedVideo, $author$project$Api$Decoders$videoDecoder),
				b: _List_fromArray(
					[
						$author$project$Api$Request$authorizationHeader(jwt)
					]),
				c: 'POST',
				d: $elm$core$Maybe$Nothing,
				e: $elm$core$Maybe$Just('uploadVideo'),
				js: $author$project$Api$Request$talentSourceUrl + ('users/' + (roleMemberId + ('/upload_video/' + tempId)))
			});
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $author$project$Main$userNotScheduled = F3(
	function (schedules, roleMemberId, scheduleType) {
		var correctSchedules = A2(
			$elm$core$List$filter,
			A2(
				$author$project$Utils$eq,
				function ($) {
					return $.fB;
				},
				scheduleType),
			schedules);
		var allTimeSlots = A2(
			$elm$core$List$concatMap,
			function (schedule) {
				return schedule.jl;
			},
			correctSchedules);
		var foundUser = A2(
			$elm_community$list_extra$List$Extra$find,
			function (timeSlot) {
				return _Utils_eq(timeSlot.f_.aX, roleMemberId);
			},
			allTimeSlots);
		if (!foundUser.$) {
			var user = foundUser.a;
			return false;
		} else {
			return true;
		}
	});
var $author$project$Pipeline$UserPositions = F2(
	function (roleMemberId, newColumnId) {
		return {h2: newColumnId, aX: roleMemberId};
	});
var $author$project$Main$usersToMoveList = F2(
	function (selectedTalent, columnToMoveToId) {
		return A2(
			$elm$core$List$map,
			function (talent) {
				return A2($author$project$Pipeline$UserPositions, talent.aX, columnToMoveToId);
			},
			selectedTalent);
	});
var $author$project$Views$FormValidation$invalidFields = function (project) {
	return (project.bS === '') || (project.it === '');
};
var $author$project$Main$touchAllProjectFields = function (model) {
	var projectValidations = model.aW;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				df: 'Please Complete the items marked in red',
				aW: _Utils_update(
					projectValidations,
					{bS: true, it: true})
			}),
		$elm$core$Platform$Cmd$none);
};
var $author$project$MainMsg$NewProject = function (a) {
	return {$: 46, a: a};
};
var $author$project$Api$Request$postNewProject = function (model) {
	return $elm$http$Http$request(
		{
			dP: $elm$http$Http$jsonBody(
				$author$project$Api$Encoders$projectEncoder(model)),
			a: A2($elm$http$Http$expectJson, $author$project$MainMsg$NewProject, $author$project$Api$Decoders$projectDecoder),
			b: _List_fromArray(
				[
					$author$project$Api$Request$authorizationHeader(model.hI)
				]),
			c: 'POST',
			d: $elm$core$Maybe$Nothing,
			e: $elm$core$Maybe$Nothing,
			js: $author$project$Api$Request$talentSourceUrl + 'projects'
		});
};
var $author$project$Main$updateOrCreateAction = F2(
	function (form, model) {
		switch (form) {
			case 0:
				return $author$project$Api$Request$postNewProject(model);
			case 1:
				return $author$project$Api$Request$updateExistingProject(model);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Main$validateFormAndSubmitProject = function (model) {
	return $author$project$Views$FormValidation$invalidFields(model.aj) ? $author$project$Main$touchAllProjectFields(model) : _Utils_Tuple2(
		_Utils_update(
			model,
			{A: _List_Nil, aU: 2, df: '', aW: $author$project$Project$resetProjectValidation}),
		A2($author$project$Main$updateOrCreateAction, model.ap, model));
};
var $author$project$Main$validateWeight = function (model) {
	return ((100 < model.E.jC) && (model.E.jC < 500)) ? true : false;
};
var $author$project$Main$handleError = function (model) {
	return A3(
		$ccapndave$elm_update_extra$Update$Extra$andThen,
		$author$project$Main$update,
		$author$project$MainMsg$Logout,
		_Utils_Tuple2(
			_Utils_update(
				model,
				{
					f: $author$project$Model$Showing('Your Session has ended, Please login again!')
				}),
			$author$project$Main$dismissAlert));
};
var $author$project$Main$update = F2(
	function (msg, model) {
		update:
		while (true) {
			switch (msg.$) {
				case 15:
					var url = msg.a;
					var _v3 = $author$project$Route$fromUrl(url);
					switch (_v3.$) {
						case 13:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										x: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									A2($author$project$Main$fetchDataForPage, $author$project$Route$Dashboard, model)));
						case 10:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										N: 0,
										B: _List_Nil,
										x: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3(
											$author$project$Main$redirectAway,
											model.E.V,
											model,
											$author$project$Route$fromUrl(url)),
											A2($author$project$Main$fetchConversations, model.E.C, model.p)
										])));
						case 2:
							var email = _v3.a;
							return A2(
								$author$project$Main$updateUser,
								$author$project$User$UserEmail(email),
								model);
						case 3:
							var email = _v3.a;
							return A2(
								$author$project$Main$updateUser,
								$author$project$User$UserEmail(email),
								model);
						case 21:
							var i = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										d6: i,
										aj: A2($author$project$Utils$findProject, model.F, i),
										ac: i,
										N: 0,
										B: _List_Nil,
										x: 'Slayt',
										m: A2($author$project$Utils$findProject, model.F, i)
									}),
								$elm$core$Platform$Cmd$batch(
									_Utils_ap(
										_List_fromArray(
											[
												A3(
												$author$project$Main$redirectAway,
												model.E.V,
												model,
												$author$project$Route$fromUrl(url))
											]),
										A2(
											$author$project$Main$fetchDataForPage,
											$author$project$Route$Project(i),
											model))));
						case 7:
							var projectId = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										d6: projectId,
										aj: A2($author$project$Utils$findProject, model.F, projectId),
										ac: projectId,
										N: 0,
										B: _List_Nil,
										x: 'Slayt',
										m: A2($author$project$Utils$findProject, model.F, projectId)
									}),
								$elm$core$Platform$Cmd$batch(
									A2(
										$author$project$Main$fetchDataForPage,
										$author$project$Route$Job(projectId),
										model)));
						case 8:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										N: 0,
										B: _List_Nil,
										x: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									A2($author$project$Main$fetchDataForPage, $author$project$Route$JobIndex, model)));
						case 20:
							return A3(
								$ccapndave$elm_update_extra$Update$Extra$andThen,
								$author$project$Main$update,
								$author$project$MainMsg$UpdateSearchingRole(model.bA),
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											o: $author$project$Route$fromUrl(url),
											N: 0,
											B: _List_Nil,
											r: $author$project$InitData$initTalentFilterValues,
											x: 'Slayt'
										}),
									$elm$core$Platform$Cmd$batch(
										_List_fromArray(
											[
												A3(
												$author$project$Main$redirectAway,
												model.E.V,
												model,
												$author$project$Route$fromUrl(url)),
												$author$project$Main$fetchAllProjects(model.hI),
												$author$project$Main$fetchRoleData(model.hI),
												A2($author$project$Api$Request$getJobPageData, model.hI, '')
											]))));
						case 23:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{d6: '', b$: $author$project$SharedProjectRoleSchedules$initialSchedulePageData, N: 0, B: _List_Nil}),
								$elm$core$Platform$Cmd$batch(
									_Utils_ap(
										_List_fromArray(
											[
												A3(
												$author$project$Main$redirectAway,
												model.E.V,
												model,
												$author$project$Route$fromUrl(url))
											]),
										A2($author$project$Main$fetchDataForPage, $author$project$Route$ScheduleIndex, model))));
						case 24:
							var projectId = _v3.a;
							var scheduleType = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										b$: A2(
											$author$project$Main$updateSchedulePageData,
											model,
											$author$project$Schedule$SchedulePageViewUpdate(
												A2($author$project$SharedProjectRoleSchedules$LoadingScheduleData, projectId, scheduleType)))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A3(
											$author$project$Main$redirectAway,
											model.E.V,
											model,
											$author$project$Route$fromUrl(url)),
											A2($author$project$Api$Request$getProjectData, model.hI, projectId),
											A2($author$project$Api$Request$getSchedules, projectId, model.hI)
										])));
						case 25:
							var projectId = _v3.a;
							var scheduleId = _v3.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										d6: projectId,
										b$: A2(
											$author$project$Main$updateSchedulePageData,
											model,
											$author$project$Schedule$SchedulePageViewUpdate(
												A2($author$project$SharedProjectRoleSchedules$ScheduleDayOfPage, projectId, scheduleId)))
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Api$Request$getProjectData, model.hI, projectId),
											A2($author$project$Api$Request$getSchedules, projectId, model.hI),
											A2($author$project$Api$Request$getCollaboratorsOnProject, projectId, model.hI)
										])));
						case 9:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										x: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchRoleData(model.hI),
											$author$project$Main$fetchUsersJobs(model.hI),
											A2($author$project$Main$fetchConversations, model.E.C, model.p)
										])));
						case 26:
							var secretKey = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										x: 'Slayt',
										aZ: A2($author$project$Main$updateSecretString, model.aZ, secretKey)
									}),
								A2($author$project$Api$Request$getCollaboratorInfo, model.hI, secretKey));
						case 27:
							var secretKey = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										x: 'Slayt',
										aZ: A2($author$project$Main$updateSecretString, model.aZ, secretKey)
									}),
								A2($author$project$Api$Request$getAgentInfo, model.hI, secretKey));
						case 19:
							var s = _v3.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										ay: $author$project$User$initialProfileValidations,
										N: 0,
										B: _List_Nil,
										x: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Api$Request$getAgencies(model.hI),
											$author$project$Api$Request$getOptions(model.hI)
										])));
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										o: $author$project$Route$fromUrl(url),
										ay: $author$project$User$initialProfileValidations,
										N: 0,
										B: _List_Nil,
										x: 'Slayt'
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Main$fetchConversations, model.E.C, model.p)
										])));
					}
				case 16:
					var urlRequest = msg.a;
					if (!urlRequest.$) {
						var url = urlRequest.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o: $author$project$Route$fromUrl(url),
									N: 0,
									B: _List_Nil,
									x: 'Slayt'
								}),
							A2($elm$browser$Browser$Navigation$pushUrl, model.eF, url.ij));
					} else {
						var href = urlRequest.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{x: href}),
							$elm$core$Platform$Cmd$none);
					}
				case 21:
					var page = msg.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$RedirectPage(page),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{o: page, a6: false, aL: false, W: $author$project$User$initialTalentMenuOptions}),
							$elm$core$Platform$Cmd$none));
				case 22:
					var page = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								o: $author$project$Route$ProfileSubPage(page),
								e9: false
							}),
						A2(
							$author$project$Main$goTo,
							model,
							$author$project$Route$ProfileSubPage(page)));
				case 23:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a6: !model.a6}),
						$elm$core$Platform$Cmd$none);
				case 24:
					var form = msg.a;
					var _v5 = function () {
						switch (form) {
							case 0:
								return _Utils_Tuple2(0, 1);
							case 1:
								return _Utils_Tuple2(0, 1);
							case 2:
								return _Utils_Tuple2(1, 0);
							case 3:
								return _Utils_Tuple2(1, 0);
							default:
								return _Utils_Tuple2(1, 1);
						}
					}();
					var projectFormStatus = _v5.a;
					var roleFormStatus = _v5.b;
					var _v7 = function () {
						switch (form) {
							case 2:
								var _v9 = model.eg;
								if (!_v9.b) {
									return _Utils_Tuple2(
										$author$project$Api$Request$getOptions(model.hI),
										$author$project$MainMsg$NoOp);
								} else {
									return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$MainMsg$NoOp);
								}
							case 3:
								var _v10 = model.eg;
								if (!_v10.b) {
									return _Utils_Tuple2(
										$author$project$Api$Request$getOptions(model.hI),
										$author$project$MainMsg$NoOp);
								} else {
									return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$MainMsg$NoOp);
								}
							case 4:
								return _Utils_Tuple2(
									$elm$core$Platform$Cmd$none,
									$author$project$MainMsg$UpdateCurrentProjectId(model.m.c$));
							default:
								return _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$MainMsg$NoOp);
						}
					}();
					var action = _v7.a;
					var closedModalAction = _v7.b;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						closedModalAction,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{ap: form, aj: $author$project$SharedProjectRoleSchedules$emptyProject, aU: projectFormStatus, df: '', aW: $author$project$Project$resetProjectValidation, V: $author$project$SharedProjectRoleSchedules$emptyRole, am: roleFormStatus, Z: $author$project$Role$resetRoleValidations}),
							action));
				case 25:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{fW: !model.fW}),
						$elm$core$Platform$Cmd$none);
				case 26:
					var user = msg.a;
					var applicant = msg.b;
					var columnId = msg.c;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$UpdateVotingComment(''),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									cH: applicant,
									cI: false,
									bq: A2(
										$elm$core$Maybe$withDefault,
										$author$project$User$emptyImage,
										$elm$core$List$head(user.l)),
									cR: A2(
										$elm$core$Maybe$withDefault,
										$author$project$User$emptyVideo,
										$elm$core$List$head(
											A2(
												$elm$core$List$filter,
												function (video) {
													return video.ds;
												},
												user.a_))),
									cj: 0,
									iq: columnId,
									aJ: 3,
									aN: !model.aN,
									v: user
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Main$fetchConversations, model.E.C, model.p)
									]))));
				case 284:
					var action = function () {
						var _v11 = model.aJ;
						switch (_v11) {
							case 4:
								return 5;
							case 5:
								return 4;
							default:
								return 3;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aJ: action}),
						$elm$core$Platform$Cmd$none);
				case 239:
					var time = msg.a;
					var _v12 = model.R;
					if (_v12 === 2) {
						return _Utils_Tuple2(
							model,
							A2(
								$author$project$Api$Request$getNotifications,
								model.hI,
								$elm$core$String$fromInt(
									$elm$core$List$length(model.E.bU))));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 4:
					var aMsg = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 240:
					var res = msg.a;
					if (!res.$) {
						var notifications = res.a;
						var latestNotification = A2(
							$elm$core$Maybe$withDefault,
							$author$project$User$emptyUserNotification,
							$elm$core$List$head(notifications));
						var newNotification = !_Utils_eq(
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$User$emptyUserNotification,
								$elm$core$List$head(model.E.bU)).aa,
							latestNotification.aa);
						var action = (A2(
							$elm$core$List$member,
							latestNotification.hK,
							_List_fromArray(
								[0, 3, 4, 18, 19, 6, 7, 12, 13, 14, 8])) && newNotification) ? A2($author$project$Api$Request$getProjectData, model.hI, latestNotification.iw) : ((A2(
							$elm$core$List$member,
							latestNotification.hK,
							_List_fromArray(
								[2, 22, 15, 9, 11, 5, 16, 21, 10, 17])) && newNotification) ? $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$fetchUsersJobs(model.hI),
									$author$project$Main$fetchRoleData(model.hI)
								])) : ((A2(
							$elm$core$List$member,
							latestNotification.hK,
							_List_fromArray(
								[20])) && newNotification) ? $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$fetchUsersJobs(model.hI),
									A2($author$project$Main$fetchConversations, model.E.C, model.p)
								])) : $elm$core$Platform$Cmd$none));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									E: A2($author$project$Main$updateNotificationsForUser, model.E, notifications)
								}),
							action);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 220:
					var img = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bq: img}),
						$elm$core$Platform$Cmd$none);
				case 83:
					var deleteID = msg.a;
					var name = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ar: $author$project$Utils$DeleteProject, as: deleteID, d8: name, ad: !model.ad}),
						$elm$core$Platform$Cmd$none);
				case 97:
					var projectId = msg.a;
					var confirmation = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ar: confirmation,
								bt: false,
								aj: A2(
									$elm$core$Maybe$withDefault,
									$author$project$SharedProjectRoleSchedules$emptyProject,
									A2($author$project$Main$filterProject, projectId, model.F)),
								V: A2($author$project$Views$Messages$findRole, model.aB, projectId),
								aL: !model.aL
							}),
						$elm$core$Platform$Cmd$none);
				case 29:
					var id = msg.a;
					var talent = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								N: ($elm$core$List$length(
									A2($author$project$Main$addOrRemoveSelectedTalent, talent, model.B)) >= 1) ? 1 : 0,
								B: A2($author$project$Main$addOrRemoveSelectedTalent, talent, model.B),
								aN: false,
								bg: $author$project$MainMsg$Successs(
									A2($author$project$Main$toggleSelectedTalent, model.bg, id))
							}),
						$elm$core$Platform$Cmd$none);
				case 27:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dG: {iJ: model.g$, i3: 0, jt: model.g1},
								q: !model.q
							}),
						$elm$core$Platform$Cmd$none);
				case 28:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{q: !model.q}),
						$elm$core$Platform$Cmd$none);
				case 221:
					var userJob = msg.a;
					var state = msg.b;
					var conversationId = msg.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								q: !model.q,
								c_: false,
								bT: {
									dP: '',
									gV: conversationId,
									hK: state,
									aX: userJob.aX,
									cA: A2($author$project$Utils$findProject, model.F, userJob.V.iw).jt
								}
							}),
						$elm$core$Platform$Cmd$none);
				case 222:
					var roleMemberId = msg.a;
					var userId = msg.b;
					var state = msg.c;
					var conversationId = msg.d;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								q: !model.q,
								c_: false,
								bT: {dP: '', gV: conversationId, hK: state, aX: roleMemberId, cA: userId}
							}),
						$elm$core$Platform$Cmd$none);
				case 81:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{f: $author$project$Model$Hiding}),
						$elm$core$Platform$Cmd$none);
				case 2:
					var rMsg = msg.a;
					return A2($author$project$Main$updateUser, rMsg, model);
				case 6:
					var rMsg = msg.a;
					return A2($author$project$Main$updateCompanyProfile, rMsg, model);
				case 7:
					var rMsg = msg.a;
					return A2($author$project$Main$updateBillingAddress, rMsg, model);
				case 8:
					var rMsg = msg.a;
					return A2($author$project$Main$updatePhysicalAddress, rMsg, model);
				case 1:
					var pMsg = msg.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$UpdateProfileHeightValue,
						A2($author$project$Main$updateProfile, pMsg, model));
				case 223:
					var nMsg = msg.a;
					return A2($author$project$Main$updateNotification, nMsg, model);
				case 82:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								E: $author$project$Main$updateProfileHeightValue(model)
							}),
						$elm$core$Platform$Cmd$none);
				case 9:
					var pMsg = msg.a;
					return A2($author$project$Main$updatePassword, pMsg, model);
				case 10:
					var pMsg = msg.a;
					return A2($author$project$Main$updateMessage, pMsg, model);
				case 11:
					var pMsg = msg.a;
					return A2($author$project$Main$updateProject, pMsg, model);
				case 12:
					var pMsg = msg.a;
					return A2($author$project$Main$updateProjectValidation, pMsg, model);
				case 292:
					var time = msg.a;
					var roleMemberId = msg.b;
					return (roleMemberId !== '') ? _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$refreshTalentData, roleMemberId, model.hI)) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 13:
					var rMsg = msg.a;
					return A2($author$project$Main$createRole, rMsg, model);
				case 14:
					var rMsg = msg.a;
					return A2($author$project$Main$updateRoleValidation, rMsg, model);
				case 30:
					var email = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bv: email}),
						$elm$core$Platform$Cmd$none);
				case 31:
					var password = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{eZ: password}),
						$elm$core$Platform$Cmd$none);
				case 17:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: A3($author$project$Main$updateUserProfileStatus, model.h, $author$project$MainMsg$Loadings, $author$project$MainMsg$Loadings),
								X: $author$project$MainMsg$Loadings
							}),
						$author$project$Main$fireBaseLogin(
							_Utils_Tuple2(model.bv, model.eZ)));
				case 79:
					var err = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: $author$project$Model$Showing(err),
								R: 0
							}),
						$author$project$Main$dismissAlert);
				case 39:
					var err = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: $author$project$Model$Showing(err),
								R: 0
							}),
						$author$project$Main$dismissAlert);
				case 291:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cI: !model.cI}),
						$elm$core$Platform$Cmd$none);
				case 98:
					var result = msg.a;
					if (!result.$) {
						var conversations = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dE: conversations}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 76:
					var jwt = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{R: 1, hn: jwt, hI: jwt}),
						$author$project$Api$Request$getCurrentUser(jwt));
				case 136:
					var page = msg.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Main$goTo, model, page));
				case 18:
					if (!msg.a.$) {
						var user = msg.a.a;
						var page = function () {
							var _v15 = user.V;
							switch (_v15) {
								case 1:
									return $author$project$Route$Dashboard;
								case 0:
									return $author$project$Route$Dashboard;
								case 2:
									return $author$project$Route$Dashboard;
								case 3:
									return $author$project$Route$Dashboard;
								case 4:
									return $author$project$Route$Dashboard;
								default:
									return $author$project$Route$Login;
							}
						}();
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectPage(page),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										R: 2,
										aC: user.f$,
										bJ: user.bJ,
										g1: user.c$,
										ab: $author$project$Main$imageUploadStatus(
											$elm$core$List$length(user.l)),
										l: user.l,
										aH: user.f0,
										h: A3(
											$author$project$Main$updateUserProfileStatus,
											model.h,
											$author$project$MainMsg$Successs(user),
											$author$project$MainMsg$Loadings),
										aZ: A2($author$project$Main$setUserType, model, 0),
										E: user,
										X: $author$project$MainMsg$Successs(user),
										f1: user.V
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchAllProjects(model.hI),
											A2($author$project$Main$fetchConversations, model.E.C, model.p),
											$author$project$Main$fetchRoleData(model.hI),
											$author$project$Main$twilio(
											{
												z: '',
												ai: $author$project$Api$Encoders$twilioPayloadEncoder($author$project$Message$emptyToTwilioPayload),
												ao: user.C
											})
										]))));
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									R: 0,
									hN: true,
									h: A3(
										$author$project$Main$updateUserProfileStatus,
										model.h,
										$author$project$MainMsg$Failed(err),
										$author$project$MainMsg$Loadings),
									X: $author$project$MainMsg$Failed(err)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 132:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						var category = A2($author$project$Main$categoryFromIndex, model.h.d5, user);
						var _v17 = function () {
							var _v18 = model.o;
							switch (_v18.$) {
								case 13:
									return _Utils_Tuple2($author$project$Route$Dashboard, model.g1);
								case 12:
									var string = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$Role(string),
										string);
								case 21:
									var string = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$Project(string),
										string);
								case 10:
									return _Utils_Tuple2($author$project$Route$Inbox, model.g1);
								case 22:
									var i = _v18.a;
									var code = _v18.b;
									return _Utils_Tuple2(
										A2($author$project$Route$AccountVerification, i, code),
										'');
								case 9:
									return _Utils_Tuple2($author$project$Route$MyJobs, model.g1);
								case 23:
									return _Utils_Tuple2($author$project$Route$ScheduleIndex, model.g1);
								case 24:
									var i = _v18.a;
									var scheduleType = _v18.b;
									return _Utils_Tuple2(
										A2($author$project$Route$SchedulePage, i, scheduleType),
										i);
								case 25:
									var projectId = _v18.a;
									var scheduleId = _v18.b;
									return _Utils_Tuple2(
										A2($author$project$Route$DayOfPage, projectId, scheduleId),
										scheduleId);
								case 26:
									var secretKey = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$CollaboratorsSignupPage(secretKey),
										'');
								case 27:
									var secretKey = _v18.a;
									return _Utils_Tuple2(
										$author$project$Route$AgentsSignupPage(secretKey),
										'');
								case 6:
									return _Utils_Tuple2($author$project$Route$Account, category.aa);
								default:
									return _Utils_Tuple2($author$project$Route$Dashboard, '');
							}
						}();
						var page = _v17.a;
						var id = _v17.b;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SetToLoggedIn,
							A3(
								$ccapndave$elm_update_extra$Update$Extra$andThen,
								$author$project$Main$update,
								$author$project$MainMsg$RedirectPage(page),
								_Utils_Tuple2(
									_Utils_update(
										model,
										{
											R: 1,
											aC: user.f$,
											bJ: user.bJ,
											d6: id,
											g$: id,
											g1: user.c$,
											ab: $author$project$Main$imageUploadStatus(
												$elm$core$List$length(user.l)),
											l: user.l,
											aH: user.f0,
											h: A3(
												$author$project$Main$updateUserProfileStatus,
												model.h,
												$author$project$MainMsg$Successs(user),
												$author$project$MainMsg$Loadings),
											b$: $author$project$SharedProjectRoleSchedules$initialSchedulePageData,
											aZ: A2($author$project$Main$setUserType, model, 0),
											E: user,
											X: $author$project$MainMsg$Successs(user),
											f1: user.V
										}),
									$author$project$Main$twilio(
										{
											z: '',
											ai: $author$project$Api$Encoders$twilioPayloadEncoder($author$project$Message$emptyToTwilioPayload),
											ao: user.C
										}))));
					} else {
						var err = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$Logout,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('User Authentication Failed!')
									}),
								$elm$core$Platform$Cmd$none));
					}
				case 137:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{R: 2}),
						$elm$core$Platform$Cmd$none);
				case 264:
					var agentId = msg.a;
					var agencyId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$addAgentToUser, agentId, agencyId, model.hI));
				case 262:
					var res = msg.a;
					if (!res.$) {
						var userProfile = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Successfully sent verification email to agent!'),
									E: userProfile
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 19:
					return (!_Utils_eq(model.aZ.eZ, model.aZ.e_)) ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: $author$project$Model$Showing('Passwords do not match!')
							}),
						$author$project$Main$dismissAlert) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: A3($author$project$Main$updateUserProfileStatus, model.h, $author$project$MainMsg$Loadings, $author$project$MainMsg$Loadings),
								aZ: A2(
									$author$project$Main$setUserType,
									model,
									$author$project$Main$setUserRegistrationType(model)),
								X: $author$project$MainMsg$Loadings
							}),
						$author$project$Main$fireBaseSignUp(
							_Utils_Tuple2(model.aZ.bv, model.aZ.eZ)));
				case 106:
					var nMsg = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								E: A2($author$project$Main$updateNotificationSettings, nMsg, model.E)
							}),
						$elm$core$Platform$Cmd$none);
				case 77:
					var jwt = msg.a;
					var command = function () {
						var _v20 = model.aZ.V;
						switch (_v20) {
							case 1:
								return $author$project$Api$Request$postNewCompany;
							case 3:
								return $author$project$Api$Request$postNewAgency;
							default:
								return $author$project$Api$Request$postNewUser;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{R: 1, hn: jwt, hI: jwt, aM: ''}),
						command(
							_Utils_update(
								model,
								{hI: jwt})));
				case 78:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$postNewUser(model));
				case 80:
					var jwt = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								R: $author$project$Main$evaluateAuthStatus(jwt),
								hn: jwt,
								hI: jwt,
								h: A3($author$project$Main$updateUserProfileStatus, model.h, $author$project$MainMsg$Loadings, $author$project$MainMsg$Loadings),
								X: $author$project$MainMsg$Loadings
							}),
						$elm$core$Platform$Cmd$batch(
							A2($author$project$Main$redirectToLoginOrRefresh, jwt, model)));
				case 32:
					return _Utils_Tuple2(
						$author$project$Main$resetModel(model),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$removeUserToken(''),
									A2($author$project$Main$goTo, model, $author$project$Route$Login)
								])));
				case 35:
					var result = msg.a;
					if (!result.$) {
						var company = result.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$CreateUser,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{bJ: company}),
								$elm$core$Platform$Cmd$none));
					} else {
						var err = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 36:
					var result = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 34:
					if (!msg.a.$) {
						var user = msg.a.a;
						var modalStatus = function () {
							var _v24 = $author$project$Main$setUserRegistrationType(model);
							if (_v24 === 1) {
								return true;
							} else {
								return false;
							}
						}();
						var currentPage = function () {
							var _v23 = $author$project$Main$setUserRegistrationType(model);
							switch (_v23) {
								case 1:
									return $author$project$Route$DirectorRegistration;
								case 2:
									return $author$project$Route$Dashboard;
								case 3:
									return $author$project$Route$AgencyProfile;
								case 4:
									return $author$project$Route$Dashboard;
								default:
									return $author$project$Route$TalentProfile;
							}
						}();
						var cmd = function () {
							var _v22 = $author$project$Main$setUserRegistrationType(model);
							switch (_v22) {
								case 1:
									return _List_fromArray(
										[
											A2($author$project$Main$goTo, model, $author$project$Route$Dashboard)
										]);
								case 2:
									return _List_fromArray(
										[
											A2($author$project$Main$goTo, model, $author$project$Route$Dashboard)
										]);
								case 3:
									return _List_fromArray(
										[
											A2($author$project$Main$goTo, model, $author$project$Route$AgencyProfile)
										]);
								case 4:
									return _List_fromArray(
										[
											A2($author$project$Main$goTo, model, $author$project$Route$Dashboard)
										]);
								default:
									return _List_fromArray(
										[
											A2(
											$author$project$Main$goTo,
											model,
											$author$project$Route$ProfileSubPage(0))
										]);
							}
						}();
						var categoryId = A2(
							$elm$core$Maybe$withDefault,
							$author$project$User$emptyProfilePage,
							$elm$core$List$head(user.ct));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									R: 2,
									q: modalStatus,
									o: currentPage,
									g1: user.c$,
									h: A3(
										$author$project$Main$updateUserProfileStatus,
										model.h,
										$author$project$MainMsg$Successs(user),
										$author$project$MainMsg$Loadings),
									E: user,
									X: $author$project$MainMsg$Successs(user)
								}),
							$elm$core$Platform$Cmd$batch(cmd));
					} else {
						var err = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									h: A3(
										$author$project$Main$updateUserProfileStatus,
										model.h,
										$author$project$MainMsg$Failed(err),
										$author$project$MainMsg$Loadings),
									X: $author$project$MainMsg$Failed(err)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 20:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{q: false, o: $author$project$Route$Login}),
						A2($author$project$Main$goTo, model, $author$project$Route$Login));
				case 37:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									h: A3(
										$author$project$Main$updateUserProfileStatus,
										model.h,
										$author$project$MainMsg$Successs(user),
										$author$project$MainMsg$Loadings),
									E: user,
									X: $author$project$MainMsg$Successs(user)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									h: A3(
										$author$project$Main$updateUserProfileStatus,
										model.h,
										$author$project$MainMsg$Failed(err),
										$author$project$MainMsg$Loadings),
									X: $author$project$MainMsg$Failed(err)
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 41:
					var _v26 = (!model.E.V) ? A2($author$project$Main$validateProfileFields, model.E, model) : _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Api$Request$updateUserProfile(model),
									$author$project$Api$Request$updateCompany(model)
								])));
					var updatedModel = _v26.a;
					var action = _v26.b;
					return _Utils_Tuple2(updatedModel, action);
				case 38:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Your profile was updated successfully!'),
									e9: !$author$project$Main$validateWeight(model),
									h: A3(
										$author$project$Main$updateUserProfileStatus,
										model.h,
										$author$project$MainMsg$Successs(user),
										$author$project$MainMsg$Loadings),
									E: user,
									X: $author$project$MainMsg$Successs(user)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Main$goTo, model, $author$project$Route$Dashboard),
										$author$project$Main$fetchRoleData(model.hI),
										$author$project$Main$dismissAlert
									])));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error updating your profile')
								}),
							$author$project$Main$dismissAlert);
					}
				case 44:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$updateUserPassword(model));
				case 43:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('The password was updated successfully')
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Main$goTo, model, $author$project$Route$Dashboard),
										$author$project$Main$dismissAlert
									])));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error updating the password')
								}),
							$author$project$Main$dismissAlert);
					}
				case 45:
					var res = msg.a;
					if (!res.$) {
						var projects = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{F: projects}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = res.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 47:
					return $author$project$Main$validateFormAndSubmitProject(model);
				case 46:
					var res = msg.a;
					if (!res.$) {
						var project = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing(project.bS + ' was successfully created'),
									d6: project.c$,
									ap: 2,
									aU: 1,
									am: 0,
									m: project
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Api$Request$getOptions(model.hI),
										$author$project$Main$dismissAlert
									])));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error creating the project'),
									aU: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 49:
					return $author$project$Main$validateFormAndSubmitProject(model);
				case 156:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$updateExistingProject(model));
				case 96:
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$PublishProject,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									bt: false,
									aj: $author$project$Main$togglePublishProject(model.aj),
									cu: true,
									aL: false
								}),
							$elm$core$Platform$Cmd$none));
				case 243:
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$PublishRole,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									cu: true,
									V: $author$project$Main$togglePublishRole(model.V),
									aL: false
								}),
							$elm$core$Platform$Cmd$none));
				case 244:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$updateExistingRole(model));
				case 48:
					var res = msg.a;
					if (!res.$) {
						var project = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectPage(
								$author$project$Route$Project(project.c$)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing(project.bS + ' was successfully updated!'),
										ap: 4,
										aU: 1,
										cu: false
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchAllProjects(model.hI),
											$author$project$Main$dismissAlert
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error updating the project'),
									aU: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 51:
					var project = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{z: 'archiveConversationsByProject'}),
						model,
						project,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 50:
					var res = msg.a;
					if (!res.$) {
						var project = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectPage(
								$author$project$Route$Project(
									$author$project$Views$Project$firstProject(model.F).c$)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Project was successfully deleted')
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchAllProjects(model.hI),
											$author$project$Main$dismissAlert
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error deleting the project')
								}),
							$author$project$Main$dismissAlert);
					}
				case 293:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_eq(model.v.c$, user.c$) ? _Utils_Tuple2(
							_Utils_update(
								model,
								{v: user}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 53:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d6: projectId}),
						$elm$core$Platform$Cmd$none);
				case 54:
					var roleId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g$: roleId}),
						A2(
							$author$project$Main$goTo,
							model,
							$author$project$Route$Role(roleId)));
				case 55:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{g$: projectId, ac: projectId}),
						A2(
							$author$project$Main$goTo,
							model,
							$author$project$Route$Job(projectId)));
				case 57:
					var roleId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								q: false,
								g$: roleId,
								av: A2($author$project$Main$toggleMultiModal, roleId, model.av),
								bX: !model.bX
							}),
						$elm$core$Platform$Cmd$none);
				case 56:
					var roleId = msg.a;
					var projectId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								dG: {iJ: roleId, i3: 0, jt: model.g1},
								q: !model.q,
								d6: projectId,
								ac: projectId
							}),
						$elm$core$Platform$Cmd$none);
				case 52:
					var res = msg.a;
					if (!res.$) {
						var roles = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aB: roles}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = res.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 60:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{am: 2}),
						$author$project$Api$Request$postNewRole(model));
				case 152:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ap: 4, V: $author$project$SharedProjectRoleSchedules$emptyRole, am: 2, Z: $author$project$Role$resetRoleValidations}),
						$author$project$Api$Request$postRoleResetForm(model));
				case 58:
					var res = msg.a;
					if (!res.$) {
						var role = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$ToggleFormOpen(4),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing(role.bS + ' was created successfully'),
										q: false,
										g$: role.c$,
										ap: 4,
										am: 1
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchRoleData(model.hI),
											A2($author$project$Api$Request$getProjectData, model.hI, model.m.c$),
											$author$project$Main$dismissAlert
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error creating the role'),
									am: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 59:
					var res = msg.a;
					if (!res.$) {
						var role = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing(role.bS + ' was created successfully'),
									ap: 2,
									am: 0
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Main$fetchRoleData(model.hI),
										$author$project$Main$dismissAlert
									])));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error creating the role'),
									aU: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 62:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{am: 2}),
						$author$project$Api$Request$updateExistingRole(model));
				case 61:
					var res = msg.a;
					if (!res.$) {
						var role = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$UpdateProjectMenuState(
								$author$project$Project$ToggleRoleMenu($elm$core$Maybe$Nothing)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Successfully updated ' + (role.bS + ' role')),
										aB: A2($author$project$Main$updateAllRoles, role, model.aB),
										ar: $author$project$Utils$HiddenConf,
										ap: 4,
										cu: false,
										am: 1,
										m: A2($author$project$Main$updateViewingProjectRoles, role, model.m)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$dismissAlert,
											$author$project$Main$fetchAllProjects(model.hI)
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error updating the role'),
									am: 0
								}),
							$author$project$Main$dismissAlert);
					}
				case 64:
					var role = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{z: 'archiveConversationsByRole'}),
						model,
						role,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 63:
					var res = msg.a;
					if (!res.$) {
						var role = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectPage(
								$author$project$Route$Project(model.d6)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Role Deleted!'),
										ar: $author$project$Utils$HiddenConf
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchRoleData(model.hI),
											$author$project$Main$dismissAlert
										]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Error Deleting Role')
								}),
							$author$project$Main$dismissAlert);
					}
				case 68:
					var val = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iR: val}),
						$elm$core$Platform$Cmd$none);
				case 69:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								d6: projectId,
								bt: false,
								ap: 1,
								aj: A2($author$project$Utils$findProject, model.F, projectId),
								aU: 0,
								am: 1,
								m: A2($author$project$Utils$findProject, model.F, projectId)
							}),
						$elm$core$Platform$Cmd$none);
				case 70:
					var roleId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								g$: roleId,
								ap: 2,
								V: A2(
									$elm$core$Maybe$withDefault,
									$author$project$SharedProjectRoleSchedules$emptyRole,
									A2($author$project$Main$filterRole, roleId, model.aB)),
								am: 0
							}),
						$author$project$Api$Request$getOptions(model.hI));
				case 71:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cd: model.cd + 1}),
						$elm$core$Platform$Cmd$none);
				case 72:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cd: model.cd - 1}),
						$elm$core$Platform$Cmd$none);
				case 75:
					var time = msg.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							A2($author$project$Main$fetchDataForPage, model.o, model)));
				case 74:
					var tMsg = msg.a;
					return A2($author$project$Main$toggleFilters, tMsg, model);
				case 73:
					var fMsg = msg.a;
					return A2($author$project$Main$updateTalentFilterValues, fMsg, model);
				case 84:
					var subMsg = msg.a;
					var _v39 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.fS);
					var newDatePicker = _v39.a;
					var dateEvent = _v39.b;
					var _v40 = $author$project$Main$createDates(dateEvent);
					var newDate = _v40.a;
					var formattedDate = _v40.b;
					return A5($author$project$Main$updateDatesInModel, model, 0, newDate, formattedDate, newDatePicker);
				case 85:
					var subMsg = msg.a;
					var _v41 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.dM);
					var newDatePicker = _v41.a;
					var dateEvent = _v41.b;
					var _v42 = $author$project$Main$createDates(dateEvent);
					var newDate = _v42.a;
					var formattedDate = _v42.b;
					return A5($author$project$Main$updateDatesInModel, model, 1, newDate, formattedDate, newDatePicker);
				case 86:
					var subMsg = msg.a;
					var _v43 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.dL);
					var newDatePicker = _v43.a;
					var dateEvent = _v43.b;
					var _v44 = $author$project$Main$createDates(dateEvent);
					var newDate = _v44.a;
					var formattedDate = _v44.b;
					return A5($author$project$Main$updateDatesInModel, model, 2, newDate, formattedDate, newDatePicker);
				case 87:
					var subMsg = msg.a;
					var _v45 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.fg);
					var newDatePicker = _v45.a;
					var dateEvent = _v45.b;
					var _v46 = $author$project$Main$createDates(dateEvent);
					var newDate = _v46.a;
					var formattedDate = _v46.b;
					return A5($author$project$Main$updateDatesInModel, model, 3, newDate, formattedDate, newDatePicker);
				case 88:
					var subMsg = msg.a;
					var _v47 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.dS);
					var newDatePicker = _v47.a;
					var dateEvent = _v47.b;
					var _v48 = $author$project$Main$createDates(dateEvent);
					var newDate = _v48.a;
					var formattedDate = _v48.b;
					return A5($author$project$Main$updateDatesInModel, model, 4, newDate, formattedDate, newDatePicker);
				case 89:
					var subMsg = msg.a;
					var _v49 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.dR);
					var newDatePicker = _v49.a;
					var dateEvent = _v49.b;
					var _v50 = $author$project$Main$createDates(dateEvent);
					var newDate = _v50.a;
					var formattedDate = _v50.b;
					return A5($author$project$Main$updateDatesInModel, model, 5, newDate, formattedDate, newDatePicker);
				case 90:
					var subMsg = msg.a;
					var _v51 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.fd);
					var newDatePicker = _v51.a;
					var dateEvent = _v51.b;
					var _v52 = $author$project$Main$createDates(dateEvent);
					var newDate = _v52.a;
					var formattedDate = _v52.b;
					return A5($author$project$Main$updateDatesInModel, model, 6, newDate, formattedDate, newDatePicker);
				case 91:
					var subMsg = msg.a;
					var _v53 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.eo);
					var newDatePicker = _v53.a;
					var dateEvent = _v53.b;
					var _v54 = $author$project$Main$createDates(dateEvent);
					var newDate = _v54.a;
					var formattedDate = _v54.b;
					return A5($author$project$Main$updateDatesInModel, model, 7, newDate, formattedDate, newDatePicker);
				case 92:
					var subMsg = msg.a;
					var _v55 = A3($CurrySoftware$elm_datepicker$DatePicker$update, $author$project$Views$DatePicker$dateSettings, subMsg, model.G.fI);
					var newDatePicker = _v55.a;
					var dateEvent = _v55.b;
					var _v56 = $author$project$Main$createDates(dateEvent);
					var newDate = _v56.a;
					var formattedDate = _v56.b;
					return A5($author$project$Main$updateDatesInModel, model, 8, newDate, formattedDate, newDatePicker);
				case 93:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d6: projectId}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$author$project$Main$goTo,
									model,
									$author$project$Route$Project(projectId))
								])));
				case 94:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bX: !model.bX}),
						$elm$core$Platform$Cmd$none);
				case 95:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bt: !model.bt}),
						$elm$core$Platform$Cmd$none);
				case 100:
					var conversationId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b7: $author$project$Message$LoadingMessages, bM: conversationId}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Main$fetchMessages, conversationId, model.hI, model.g1),
									A3($author$project$Api$Request$markConversationAsRead, model.g1, model.hI, conversationId)
								])));
				case 107:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b7: $author$project$Message$LoadingMessages, bM: ''}),
						$elm$core$Platform$Cmd$none);
				case 101:
					var time = msg.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Main$fetchMessages, model.bM, model.hI, model.g1),
									A2($author$project$Main$fetchUnreadMessages, model.g1, model.hI)
								])));
				case 99:
					var result = msg.a;
					if (!result.$) {
						var receivedMessages = result.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectPage($author$project$Route$Inbox),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										b7: $author$project$Message$Messages(
											$elm$core$List$reverse(receivedMessages))
									}),
								$author$project$Main$changeWindowHeight('')));
					} else {
						var err = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 102:
					return ((model.L.dP !== '') || (model.bo !== '')) ? A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$NewMessageMsg(''),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									bo: '',
									p: A3($author$project$Main$optimisticMessages, model.L.dP, model.E.c$, model)
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Main$changeWindowHeight(''),
										A4($author$project$Main$createMessage, model.p.t.aa, model.L.dP, model.E.C, model.E.c$)
									])))) : _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 111:
					var id = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						$author$project$Main$conversationTwilioPayload(model),
						model,
						id,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 112:
					var result = msg.a;
					if (!result.$) {
						var conversation = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{bM: conversation.aa}),
							A4($author$project$Main$createMessage, conversation.aa, model.L.dP, model.E.C, model.E.c$));
					} else {
						var err = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 113:
					if (msg.a === 2) {
						var _v59 = msg.a;
						return _Utils_Tuple2(
							model,
							A2($author$project$Api$Request$deleteResume, model.hI, model.g1));
					} else {
						var fileAction = msg.a;
						var mime_types = _List_fromArray(
							['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'text/plain', 'application/pdf']);
						return _Utils_Tuple2(
							model,
							A2(
								$elm$file$File$Select$file,
								mime_types,
								function (file) {
									return A2($author$project$MainMsg$GotResume, file, fileAction);
								}));
					}
				case 114:
					var fileAction = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$file$File$Select$file,
							_List_fromArray(
								['image/*']),
							function (file) {
								return A2($author$project$MainMsg$GotFile, file, fileAction);
							}));
				case 115:
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$getTempfile, model.hI, model.v.aX));
				case 294:
					var res = msg.a;
					if (!res.$) {
						var video = res.a;
						return _Utils_Tuple2(
							model,
							A2(
								$elm$file$File$Select$file,
								_List_fromArray(
									['video/*']),
								function (file) {
									return A2($author$project$MainMsg$GotVideoFile, file, video.aa);
								}));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 116:
					var file = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bo: A2($elm$core$String$dropLeft, 12, file)
							}),
						$elm$core$Platform$Cmd$none);
				case 117:
					var file = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$perform,
							$author$project$MainMsg$ChatFileToString,
							$elm$file$File$toString(file)));
				case 228:
					var stringFile = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Main$twilio(
							{
								z: 'sendFile',
								ai: $author$project$Api$Encoders$twilioPayloadEncoder(
									A3($author$project$Main$fileUploadPayload, stringFile, model.p.t.aa, model.v.aX)),
								ao: model.E.C
							}));
				case 118:
					var file = msg.a;
					var fileAction = msg.b;
					var _v61 = A2($author$project$Main$replacingData, fileAction, model);
					var deletingId = _v61.a;
					var images = _v61.b;
					var replaceImageMessage = _v61.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								as: deletingId,
								ab: $author$project$SharedProjectRoleSchedules$Uploading(0),
								l: images
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$Api$Request$uploadImage, file, model.hI, model.g1),
									replaceImageMessage
								])));
				case 124:
					var file = msg.a;
					var files = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$uploadImage, file, model.hI, model.g1));
				case 119:
					var file = msg.a;
					var fileAction = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$uploadResume, file, model.hI, model.g1));
				case 120:
					var file = msg.a;
					var files = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$uploadResume, file, model.hI, model.g1));
				case 125:
					var progress = msg.a;
					if (!progress.$) {
						var p = progress.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ab: $author$project$SharedProjectRoleSchedules$Uploading(
										$elm$http$Http$fractionSent(p))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 129:
					var result = msg.a;
					if (!result.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cx: $author$project$SharedProjectRoleSchedules$ResumeWaiting,
									E: A2($author$project$Main$updateResume, model.E, $elm$core$Maybe$Nothing)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 128:
					var result = msg.a;
					if (!result.$) {
						var resume = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cx: $author$project$SharedProjectRoleSchedules$ResumeWaiting,
									E: A2(
										$author$project$Main$updateResume,
										model.E,
										$elm$core$Maybe$Just(resume.js))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 127:
					var result = msg.a;
					if (!result.$) {
						var image = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ab: $author$project$Main$imageUploadStatus(
										$elm$core$List$length(model.l) + 1),
									l: A2($elm$core$List$cons, image, model.l)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 130:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ab: $author$project$SharedProjectRoleSchedules$Waiting}),
						$elm$http$Http$cancel('upload'));
				case 121:
					var file = msg.a;
					var tempId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: $author$project$Model$Showing('Received file successfully!'),
								cB: $author$project$SharedProjectRoleSchedules$Waiting
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Main$dismissAlert,
									A3(
									$author$project$Api$Request$updateVideoInfo,
									model.hI,
									$elm$file$File$name(file),
									tempId),
									A4($author$project$Api$Request$uploadVideo, file, tempId, model.hI, model.v.aX)
								])));
				case 126:
					var progress = msg.a;
					if (!progress.$) {
						var p = progress.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cB: $author$project$SharedProjectRoleSchedules$Waiting}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 122:
					var result = msg.a;
					if (!result.$) {
						var video = result.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Error uploading video'),
									cB: $author$project$SharedProjectRoleSchedules$Waiting
								}),
							$author$project$Main$dismissAlert);
					}
				case 288:
					var videoId = msg.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$toggleVideoVisibility, videoId, model.hI));
				case 289:
					var videoId = msg.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$deleteVideo, videoId, model.hI));
				case 286:
					var result = msg.a;
					if (!result.$) {
						var video = result.a;
						var message = video.ds ? 'Video is now visible to collaborators' : 'Video is now hidden from collaborators';
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing(message),
									v: A2($author$project$Main$updateTalentVideo, model.v, video)
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 287:
					var result = msg.a;
					if (!result.$) {
						var video = result.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Successfully Deleted Video'),
									v: A2($author$project$Main$removeVideoFromTalent, model.v, video.aa)
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 123:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cB: $author$project$SharedProjectRoleSchedules$Waiting}),
						$elm$http$Http$cancel('uploadVideo'));
				case 131:
					var url = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								e5: A2($elm$core$List$cons, url, model.e5)
							}),
						$elm$core$Platform$Cmd$none);
				case 133:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ab: $author$project$Main$imageUploadStatus(
										$elm$core$List$length(model.l) - 1),
									l: A2($author$project$Main$filterImages, model.as, model.l)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 134:
					var res = msg.a;
					if (!res.$) {
						var result = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{h3: result}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 135:
					var id = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ad: false}),
						A3($author$project$Api$Request$deleteImage, id, model.hI, model.g1));
				case 65:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{q: !model.q}),
						$author$project$Api$Request$postRoleApplication(model));
				case 261:
					var projectId = msg.a;
					var roleId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$applyToRole, projectId, roleId, model.hI));
				case 66:
					var res = msg.a;
					if (!res.$) {
						var mes = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SearchJobs,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing(mes.hT),
										W: A5(
											$author$project$Main$updateTalentMenuOptions,
											$author$project$User$ToggleMenuModal($author$project$User$emptySearchTalentProfile),
											model.W,
											'',
											'',
											_List_Nil)
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$fetchUsersJobs(model.hI),
											$author$project$Main$dismissAlert
										]))));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error applying for this job.')
								}),
							$author$project$Main$dismissAlert);
					}
				case 67:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 141:
					var res = msg.a;
					if (!res.$) {
						var applicants = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dD: applicants}),
							A2(
								$author$project$Main$goTo,
								model,
								$author$project$Route$Role(model.g$)));
					} else {
						var err = res.a;
						return $author$project$Main$handleError(model);
					}
				case 142:
					var res = msg.a;
					if (!res.$) {
						var applicants = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dD: applicants}),
							$elm$core$Platform$Cmd$none);
					} else {
						var err = res.a;
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 138:
					var res = msg.a;
					if (!res.$) {
						var results = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bg: $author$project$MainMsg$Successs(results)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 250:
					var res = msg.a;
					if (!res.$) {
						var results = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									bg: $author$project$MainMsg$Successs(
										A2($author$project$Main$addMoreUsersToList, results, model.bg))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 140:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{B: _List_Nil, bg: $author$project$MainMsg$Loadings}),
						A3($author$project$Api$Request$searchUsers, model.hI, model.r, model.ac));
				case 249:
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$loadMoreUsers, model.hI, model.r, model.bA));
				case 248:
					var offset = msg.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$LoadMore,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									r: A2($author$project$Main$updateTalentFilterOffset, model.r, offset)
								}),
							$elm$core$Platform$Cmd$none));
				case 139:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							model,
							A2($author$project$Main$goTo, model, $author$project$Route$Dashboard));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 143:
					var item = msg.a;
					return A3(
						$author$project$Main$updateRoleMulti,
						0,
						model,
						A2($author$project$Views$Form$transformIdToOption, item, model.hs));
				case 285:
					var video = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cR: video}),
						$elm$core$Platform$Cmd$none);
				case 151:
					var item = msg.a;
					return A2($author$project$Main$removeMultiItems, item, model);
				case 144:
					var item = msg.a;
					return A3(
						$author$project$Main$updateRoleMulti,
						2,
						model,
						A2($author$project$Views$Form$transformIdToOption, item, model.eg));
				case 145:
					var item = msg.a;
					return A3(
						$author$project$Main$updateRoleMulti,
						3,
						model,
						A2($author$project$Views$Form$transformIdToOption, item, model.eg));
				case 146:
					var multiMsg = msg.a;
					var item = msg.b;
					switch (multiMsg) {
						case 0:
							return A3(
								$author$project$Main$updateRoleMulti,
								1,
								model,
								A2($author$project$Views$Form$transformNameToOption, item, model.hs));
						case 2:
							return A3(
								$author$project$Main$updateRoleMulti,
								4,
								model,
								A2($author$project$Views$Form$transformNameToOption, item, model.eg));
						case 3:
							return A3(
								$author$project$Main$updateRoleMulti,
								5,
								model,
								A2($author$project$Views$Form$transformNameToOption, item, model.eg));
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 147:
					var token = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hI: token}),
						$elm$core$Platform$Cmd$none);
				case 148:
					return _Utils_Tuple2(
						model,
						$author$project$Main$fetchNewToken(''));
				case 149:
					var action = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aJ: action}),
						$elm$core$Platform$Cmd$none);
				case 150:
					var size = msg.a;
					switch (size) {
						case 2:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{N: 2}),
								$elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{N: 1}),
								$elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{N: 0}),
								$elm$core$Platform$Cmd$none);
					}
				case 153:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							model,
							A2($author$project$Main$fetchUnreadMessages, model.g1, model.hI));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 154:
					var res = msg.a;
					var page = function () {
						var _v85 = model.E.V;
						if (_v85 === 1) {
							return A2($author$project$Api$Request$getProjectData, model.hI, model.m.c$);
						} else {
							return $author$project$Main$fetchUsersJobs(model.hI);
						}
					}();
					var message = function () {
						var _v84 = model.E.V;
						switch (_v84) {
							case 1:
								return 'Successfully sent to user!';
							case 3:
								return 'Successfully updated user!';
							case 4:
								return 'Successfully updated user!';
							default:
								return 'Your response has been sent!';
						}
					}();
					var action = function () {
						var _v83 = model.E.V;
						if (!_v83) {
							return $author$project$MainMsg$SearchJobs;
						} else {
							return $author$project$MainMsg$SearchUsers;
						}
					}();
					if (!res.$) {
						var newStage = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							action,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing(message),
										q: false,
										ce: newStage.i3,
										aL: false,
										W: $author$project$User$initialTalentMenuOptions,
										aN: false
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[page, $author$project$Main$dismissAlert]))));
					} else {
						var err = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error with your request.')
								}),
							$author$project$Main$dismissAlert);
					}
				case 155:
					var notification = msg.a;
					var roleMemberId = msg.b;
					var stage = msg.c;
					var sendingUser = msg.d;
					return _Utils_Tuple2(
						model,
						A5($author$project$Api$Request$updateUsersRoleStage, notification, model.hI, roleMemberId, stage, model.E.c$));
				case 157:
					var res = msg.a;
					if (!res.$) {
						var pipeline = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									A: pipeline,
									b$: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$SchedulePageViewUpdate(
											$author$project$SharedProjectRoleSchedules$PipelineUpdate(pipeline))),
									aN: false,
									m: A2($author$project$Main$addPipelineToViewingProject, model.m, pipeline)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 158:
					var res = msg.a;
					if (!res.$) {
						var pipeline = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{A: pipeline}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 159:
					var id = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								av: A2($author$project$Main$toggleMultiModal, id, model.av)
							}),
						$elm$core$Platform$Cmd$none);
				case 160:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('User successfully Moved!'),
									aR: '',
									aV: '',
									aJ: 3,
									bZ: ''
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[$author$project$Main$dismissAlert])));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 161:
					var columnId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aR: columnId}),
						$elm$core$Platform$Cmd$none);
				case 164:
					var users = msg.a;
					var projectId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{d6: projectId}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A6(
									$author$project$Main$linkToRole,
									model.aV,
									model.bZ,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.c$;
										},
										users),
									model.hI,
									model.aR,
									model.E)
								])));
				case 162:
					var roleMemberId = msg.a;
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$moveUsersInPipeline(
							{
								d6: model.d6,
								hI: model.hI,
								jy: _List_fromArray(
									[
										{h2: model.aR, aX: roleMemberId}
									])
							}));
				case 163:
					var updatedProject = A3(
						$author$project$Main$updateViewingProjectPipeline,
						model.m,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.aX;
							},
							model.B),
						model.aR);
					var currentColumnId = A2(
						$elm$core$Maybe$withDefault,
						$author$project$User$emptySearchTalentProfile,
						$elm$core$List$head(model.B)).gY;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								F: A2($author$project$Main$updateAllProjects, model.F, updatedProject),
								N: 0,
								B: _List_Nil,
								m: updatedProject
							}),
						$author$project$Api$Request$moveUsersInPipeline(
							{
								d6: model.d6,
								hI: model.hI,
								jy: A2($author$project$Main$usersToMoveList, model.B, model.aR)
							}));
				case 165:
					var projectId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aV: projectId}),
						$elm$core$Platform$Cmd$none);
				case 166:
					var roleId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{bZ: roleId}),
						$author$project$Main$loadPipelineForProject(
							{d6: model.aV, hI: model.hI}));
				case 167:
					var notification = msg.a;
					var roleMemberId = msg.b;
					return _Utils_Tuple2(
						model,
						A5($author$project$Api$Request$updateUsersRoleStage, notification, model.hI, roleMemberId, 'accepted', model.E.c$));
				case 168:
					var column = msg.a;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$ToggleColumnMenu(''),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									gN: column,
									cX: _Utils_eq(model.cX, $author$project$Project$NotEditing) ? $author$project$Project$Edit(column.aa) : $author$project$Project$NotEditing
								}),
							$elm$core$Platform$Cmd$none));
				case 169:
					var columnForm = msg.a;
					return A2($author$project$Main$updateColumn, columnForm, model);
				case 170:
					return _Utils_Tuple2(
						model,
						$author$project$Api$Request$updateColumnData(
							{gN: model.gN, d6: model.d6, hI: model.hI}));
				case 171:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cX: $author$project$Project$NotEditing}),
							$elm$core$Platform$Cmd$batch(
								A8(
									$author$project$Main$fetchAppropriateData,
									$author$project$Route$Project(model.d6),
									'',
									model.hI,
									model.i2,
									model.hm,
									model.E.C,
									model.p,
									model.E.V)));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 172:
					var res = msg.a;
					if (!res.$) {
						var options = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{eg: options.eg, hs: options.hs}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 173:
					var res = msg.a;
					if (!res.$) {
						var response = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SearchUsers,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing(response.hT),
										N: 0,
										B: _List_Nil
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											A2($author$project$Api$Request$getProjectData, model.hI, model.m.c$),
											$author$project$Main$dismissAlert
										]))));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 174:
					var res = msg.a;
					if (!res.$) {
						var jobs = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{eR: jobs}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 175:
					var user = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bq: A2(
									$elm$core$Maybe$withDefault,
									$author$project$User$emptyImage,
									$elm$core$List$head(user.l)),
								aJ: 1,
								aN: true,
								v: user
							}),
						A2($author$project$Main$fetchConversations, model.E.C, model.p));
				case 176:
					var user = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bq: A2(
									$elm$core$Maybe$withDefault,
									$author$project$User$emptyImage,
									$elm$core$List$head(user.l)),
								cR: A2(
									$elm$core$Maybe$withDefault,
									$author$project$User$emptyVideo,
									$elm$core$List$head(
										A2(
											$elm$core$List$filter,
											function (video) {
												return video.ds;
											},
											user.a_))),
								aJ: 4,
								aN: true,
								v: user
							}),
						A2($author$project$Main$fetchConversations, model.E.C, model.p));
				case 177:
					var users = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{av: $author$project$Utils$Closed, N: 1, B: users}),
						$elm$core$Platform$Cmd$none);
				case 178:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{N: 0, B: _List_Nil}),
						$elm$core$Platform$Cmd$none);
				case 179:
					var sort = msg.a;
					var id = msg.b;
					var sortingOption = $author$project$Main$sortingMap(sort);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{av: $author$project$Utils$Closed, i2: sortingOption}),
						$author$project$Main$sortPipelineUsers(
							{d6: model.d6, aa: id, hI: model.hI, i2: sortingOption}));
				case 181:
					var res = msg.a;
					if (!res.$) {
						var column = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									m: A2(
										$author$project$Main$filterOrSortViewingProjectPipeline,
										model.m,
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Pipeline$emptyColumn,
											$elm$core$List$head(column)))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 182:
					var res = msg.a;
					if (!res.$) {
						var column = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									m: A2(
										$author$project$Main$filterOrSortViewingProjectPipeline,
										model.m,
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Pipeline$emptyColumn,
											$elm$core$List$head(column)))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 180:
					var filter = msg.a;
					var id = msg.b;
					var filteringOption = $author$project$Main$filteringMap(filter);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{hm: filteringOption, av: $author$project$Utils$Closed}),
						$author$project$Main$filterPipelineUsers(
							{d6: model.d6, hm: filteringOption, aa: id, hI: model.hI}));
				case 183:
					var age = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								E: A2($author$project$Main$updateAgeInUserProfile, age, model),
								v: A2($author$project$Main$updateSearchResultAge, age, model)
							}),
						$elm$core$Platform$Cmd$none);
				case 184:
					var user = msg.a;
					var _v95 = function () {
						var id = user.a;
						var pcolumn = user.b;
						return _Utils_Tuple2(id, pcolumn);
					}();
					var userId = _v95.a;
					var previousColumn = _v95.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a3: A2(
									$arsduo$elm_dom_drag_drop$Dom$DragDrop$startDragging,
									model.a3,
									A2($author$project$Project$User, userId, previousColumn))
							}),
						$elm$core$Platform$Cmd$none);
				case 185:
					var dropTargetId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a3: A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$updateDropTarget, model.a3, dropTargetId)
							}),
						$elm$core$Platform$Cmd$none);
				case 186:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								a3: $arsduo$elm_dom_drag_drop$Dom$DragDrop$stopDragging(model.a3)
							}),
						$elm$core$Platform$Cmd$none);
				case 187:
					var draggedUser = msg.a;
					var dropTarget = msg.b;
					var _v97 = function () {
						var roleMId = draggedUser.a;
						var pcol = draggedUser.b;
						return _Utils_Tuple2(roleMId, pcol);
					}();
					var roleMemberId = _v97.a;
					var previousColumnId = _v97.b;
					var moveData = function () {
						if (!dropTarget.$) {
							var dropTargetId = dropTarget.a;
							var _v100 = A2($author$project$Main$droppedOnSchedulingColumn, dropTargetId, model.m.A);
							var droppedOnSchedule = _v100.a;
							var scheduleType = _v100.b;
							return (droppedOnSchedule && A3($author$project$Main$userNotScheduled, model.m.k, roleMemberId, scheduleType)) ? {
								bK: true,
								ar: $author$project$Utils$ForbiddenScheduleColumn(scheduleType),
								bT: $author$project$Job$emptyNotification,
								bC: previousColumnId
							} : (A2($author$project$Main$droppedOnBookingColumn, dropTargetId, model.m.A) ? {
								bK: true,
								ar: $author$project$Utils$ForbiddenBookingColumn,
								bT: {dP: '', gV: '', hK: 'Booking Request', aX: roleMemberId, cA: model.E.c$},
								bC: previousColumnId
							} : {bK: false, ar: $author$project$Utils$HiddenConf, bT: $author$project$Job$emptyNotification, bC: dropTargetId});
						} else {
							return {bK: false, ar: $author$project$Utils$HiddenConf, bT: $author$project$Job$emptyNotification, bC: previousColumnId};
						}
					}();
					var updatedProject = A3(
						$author$project$Main$updateViewingProjectPipeline,
						model.m,
						_List_fromArray(
							[roleMemberId]),
						moveData.bC);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								F: A2($author$project$Main$updateAllProjects, model.F, updatedProject),
								ar: moveData.ar,
								a3: $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState,
								bT: moveData.bT,
								aL: moveData.bK,
								m: updatedProject
							}),
						$author$project$Api$Request$moveUsersInPipeline(
							{
								d6: model.d6,
								hI: model.hI,
								jy: _List_fromArray(
									[
										{h2: moveData.bC, aX: roleMemberId}
									])
							}));
				case 188:
					var userView = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{av: $author$project$Utils$Closed, jw: userView}),
						$elm$core$Platform$Cmd$none);
				case 189:
					var pageView = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{av: $author$project$Utils$Closed, ii: pageView, bX: false}),
						$elm$core$Platform$Cmd$none);
				case 190:
					var searchQuery = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{iT: searchQuery}),
						$elm$core$Platform$Cmd$none);
				case 191:
					var res = msg.a;
					if (!res.$) {
						var schedules = res.a;
						var page = function () {
							var _v102 = model.b$.aK;
							if (_v102.$ === 5) {
								var projectId = _v102.a;
								var scheduleId = _v102.b;
								return A2($author$project$SharedProjectRoleSchedules$ScheduleDayOfPage, projectId, scheduleId);
							} else {
								return A3($author$project$Main$determineSchedulePageView, schedules, model.b$.fB, model.m);
							}
						}();
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									b$: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										A2($author$project$Schedule$ScheduleProjectUpdate, schedules, page)),
									m: A2($author$project$Main$addSchedulesToViewingProject, model.m, schedules)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 192:
					var projectId = msg.a;
					var _v103 = (projectId === '') ? _Utils_Tuple2($elm$core$Platform$Cmd$none, $author$project$Schedule$ResetSchedulePageData) : _Utils_Tuple2(
						A2($author$project$Api$Request$getProjectData, model.hI, projectId),
						$author$project$Schedule$ScheduleDataLoading);
					var request = _v103.a;
					var pMsg = _v103.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								d6: projectId,
								b$: A2($author$project$Main$updateSchedulePageData, model, pMsg)
							}),
						request);
				case 311:
					var res = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 193:
					var scheduleFormView = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2($author$project$Views$Schedule$toggleScheduleForm, model.b$, scheduleFormView)
							}),
						$elm$core$Platform$Cmd$none);
				case 194:
					var schedulingAction = model.b$.gz ? $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Api$Request$autoSchedule(model)
							])) : $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Api$Request$createBlankSchedule(model)
							]));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$ScheduleFormViewUpdate(3))
							}),
						schedulingAction);
				case 195:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$ScheduleFormViewUpdate(2))
							}),
						$elm$core$Platform$Cmd$none);
				case 196:
					var res = msg.a;
					if (!res.$) {
						var schedules = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									b$: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										A2($author$project$Schedule$ScheduleListUpdate, schedules, 0))
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2($author$project$Api$Request$getProjectData, model.hI, model.m.c$),
										A2($author$project$Api$Request$getProjectData, model.hI, model.b$.aj.c$)
									])));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 197:
					var sMsg = msg.a;
					var action = $elm$core$Platform$Cmd$none;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2($author$project$Main$updateSchedulePageData, model, sMsg)
							}),
						action);
				case 198:
					var dragType = msg.a;
					var _v107 = function () {
						var id = dragType.a;
						var columnId = dragType.b;
						return _Utils_Tuple2(id, columnId);
					}();
					var userId = _v107.a;
					var previousColumn = _v107.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								be: A2(
									$arsduo$elm_dom_drag_drop$Dom$DragDrop$startDragging,
									model.be,
									A2($author$project$Schedule$User, userId, previousColumn))
							}),
						$elm$core$Platform$Cmd$none);
				case 199:
					var dropTargetId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								be: A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$updateDropTarget, model.be, dropTargetId)
							}),
						$elm$core$Platform$Cmd$none);
				case 200:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								be: $arsduo$elm_dom_drag_drop$Dom$DragDrop$stopDragging(model.be)
							}),
						$elm$core$Platform$Cmd$none);
				case 202:
					var draggedUser = msg.a;
					var dropTarget = msg.b;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 201:
					var draggedUser = msg.a;
					var dropTarget = msg.b;
					var _v109 = $author$project$Main$columnDefinitions(model.b$.fB);
					var pendingColumn = _v109.a;
					var scheduledColumn = _v109.b;
					var _v110 = function () {
						var userData = draggedUser.a;
						var cTimeSlot = draggedUser.b;
						return _Utils_Tuple2(userData, cTimeSlot);
					}();
					var user = _v110.a;
					var currentTimeSlotId = _v110.b;
					var _v112 = function () {
						if ($author$project$Views$Schedule$schedulePublished(model.b$.k)) {
							switch (dropTarget.$) {
								case 0:
									var id = dropTarget.a;
									var schedId = dropTarget.b;
									return _Utils_Tuple3(id, schedId, $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								case 1:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_eq(droppedOnUser.c$, user.c$) ? _Utils_Tuple3(timeSlotId, schedId, $author$project$SharedProjectRoleSchedules$emptyUserSwapData) : _Utils_Tuple3(
										timeSlotId,
										schedId,
										A6($author$project$SharedProjectRoleSchedules$UserSwapData, true, user, droppedOnUser, timeSlotId, currentTimeSlotId, schedId));
								case 4:
									return _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								case 2:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_Tuple3(
										timeSlotId,
										schedId,
										A6($author$project$SharedProjectRoleSchedules$UserSwapData, false, user, droppedOnUser, timeSlotId, currentTimeSlotId, schedId));
								default:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_Tuple3(
										'',
										'',
										A6($author$project$SharedProjectRoleSchedules$UserSwapData, false, user, droppedOnUser, '', currentTimeSlotId, schedId));
							}
						} else {
							switch (dropTarget.$) {
								case 0:
									var id = dropTarget.a;
									var schedId = dropTarget.b;
									return _Utils_Tuple3(id, schedId, $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								case 1:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_eq(droppedOnUser.c$, user.c$) ? _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData) : _Utils_Tuple3(
										timeSlotId,
										schedId,
										A6($author$project$SharedProjectRoleSchedules$UserSwapData, true, user, droppedOnUser, timeSlotId, currentTimeSlotId, schedId));
								case 4:
									return _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								case 2:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
								default:
									var timeSlotId = dropTarget.a;
									var droppedOnUser = dropTarget.b;
									var schedId = dropTarget.c;
									return _Utils_Tuple3('', '', $author$project$SharedProjectRoleSchedules$emptyUserSwapData);
							}
						}
					}();
					var newTimeSlotId = _v112.a;
					var scheduleId = _v112.b;
					var userSwapData = _v112.c;
					var removingUserFromSchedule = (newTimeSlotId === '') && (scheduleId === '');
					var droppedOnATakenSlot = userSwapData.Y.c$ !== '';
					var droppedOnMyself = _Utils_eq(userSwapData.w.aX, userSwapData.Y.aX);
					var userInSchedule = A2($author$project$Main$userPresent, user, model.b$.k);
					var addingUnscheduledUserToEmpySlot = (!userInSchedule) && ((!removingUserFromSchedule) && ((!droppedOnATakenSlot) && (!$author$project$Views$Schedule$schedulePublished(model.b$.k))));
					var removeScheduledUserFromSchedule = userInSchedule && removingUserFromSchedule;
					var usersInScheduleNotRemovingOrSwapping = userInSchedule && ((!removingUserFromSchedule) && ((!droppedOnATakenSlot) && (!$author$project$Views$Schedule$schedulePublished(model.b$.k))));
					var _v115 = usersInScheduleNotRemovingOrSwapping ? A4($author$project$Main$changeUsersTimeSlotInSchedule, model, user, currentTimeSlotId, newTimeSlotId) : (removeScheduledUserFromSchedule ? A5($author$project$Main$removeUserFromScheduleAndUpdatePipeline, model, user, newTimeSlotId, currentTimeSlotId, pendingColumn) : (addingUnscheduledUserToEmpySlot ? A6($author$project$Main$addUserToScheduleAndUpdatePipeline, model, user, newTimeSlotId, currentTimeSlotId, pendingColumn, scheduledColumn) : _Utils_Tuple3($elm$core$Platform$Cmd$none, model.b$.k, model.b$.I)));
					var backendChanges = _v115.a;
					var scheduleData = _v115.b;
					var talentData = _v115.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cv: A2($author$project$Main$publishedModalState, model, dropTarget),
								be: $arsduo$elm_dom_drag_drop$Dom$DragDrop$initialState,
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, userSwapData))
							}),
						backendChanges);
				case 203:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{q: !model.q}),
						$elm$core$Platform$Cmd$none);
				case 204:
					var stageType = (model.b$.fB === 'Audition') ? 5 : 11;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								q: false,
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$SchedulePageViewUpdate(
										A2($author$project$SharedProjectRoleSchedules$LoadingScheduleData, model.b$.aj.c$, model.b$.fB)))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Request$publishSchedule, model, stageType),
									$author$project$Main$dismissAlert
								])));
				case 205:
					var res = msg.a;
					if (!res.$) {
						var schedules = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Your Schedule has been Published! Talent will be notified.'),
									b$: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$PublishScheduleUpdate(schedules))
								}),
							A2($author$project$Api$Request$getProjectData, model.hI, model.d6));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 206:
					var res = msg.a;
					if (!res.$) {
						var project = res.a;
						var oldScheduleData = model.b$;
						var updatedScheduleData = _Utils_update(
							oldScheduleData,
							{aj: project});
						var updatedModel = (_Utils_eq(model.m.c$, project.c$) || (_Utils_eq(model.d6, project.c$) || _Utils_eq(model.b$.aj.c$, project.c$))) ? _Utils_update(
							model,
							{d6: project.c$, b$: updatedScheduleData, m: project}) : model;
						return _Utils_Tuple2(updatedModel, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 207:
					var res = msg.a;
					if (!res.$) {
						var timeSlot = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									b$: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$UpdateTimeSlot(timeSlot))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 208:
					var project = msg.a;
					var scheduleType = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$SchedulePageViewUpdate(
										A2($author$project$SharedProjectRoleSchedules$LoadingScheduleData, project.c$, scheduleType)))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Request$getProjectData, model.hI, project.c$),
									A2(
									$author$project$Main$goTo,
									model,
									A2($author$project$Route$SchedulePage, project.c$, scheduleType))
								])));
				case 209:
					var data = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$UserSwapDataUpdate(data))
							}),
						$elm$core$Platform$Cmd$none);
				case 212:
					var data = msg.a;
					var movedFromOutsideSchedule = data.P === '';
					var _v119 = $author$project$Main$columnDefinitions(model.b$.fB);
					var pendingColumn = _v119.a;
					var scheduledColumn = _v119.b;
					var _v120 = A2($author$project$Main$swapNotificationKind, model, movedFromOutsideSchedule);
					var notification1 = _v120.a;
					var notification2 = _v120.b;
					var notificationData = {dP: '', gV: '', hK: notification1, aX: data.w.aX, cA: model.g1};
					var swapNotificationData = {dP: '', gV: '', hK: notification2, aX: data.Y.aX, cA: model.g1};
					var _v121 = function () {
						if (movedFromOutsideSchedule) {
							var _v122 = _Utils_Tuple2(
								A4($author$project$Main$updateSchedules, model.b$.k, data.w, data._, data.P),
								A3($author$project$Main$updateAvailiableTalent, model.b$.I, data.w, false));
							var firstScheduleUpdate = _v122.a;
							var firstTalentUpdate = _v122.b;
							return A9($author$project$Main$removeCurrentPublishedUserAndAddMovingUser, data, model.hI, model.b$, notificationData, swapNotificationData, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn);
						} else {
							return A5($author$project$Main$updateBothUsersPositionsInPublishedSchedule, data, model.hI, model.b$, notificationData, swapNotificationData);
						}
					}();
					var backendChanges = _v121.a;
					var scheduleData = _v121.b;
					var talentData = _v121.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cv: 2,
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 213:
					var data = msg.a;
					var movedFromOutsideSchedule = data.P === '';
					var _v123 = $author$project$Main$columnDefinitions(model.b$.fB);
					var pendingColumn = _v123.a;
					var scheduledColumn = _v123.b;
					var _v124 = A2($author$project$Main$removeNotificationKind, model, movedFromOutsideSchedule);
					var notification1 = _v124.a;
					var notification2 = _v124.b;
					var notificationData = {dP: '', gV: '', hK: notification1, aX: data.w.aX, cA: model.g1};
					var swapNotificationData = {dP: '', gV: '', hK: notification2, aX: data.Y.aX, cA: model.g1};
					var _v125 = function () {
						var _v126 = _Utils_Tuple2(
							A4($author$project$Main$updateSchedules, model.b$.k, data.w, data._, data.P),
							A3($author$project$Main$updateAvailiableTalent, model.b$.I, data.w, false));
						var firstScheduleUpdate = _v126.a;
						var firstTalentUpdate = _v126.b;
						return A9($author$project$Main$removeCurrentPublishedUserAndAddMovingUser, data, model.hI, model.b$, notificationData, swapNotificationData, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn);
					}();
					var backendChanges = _v125.a;
					var scheduleData = _v125.b;
					var talentData = _v125.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 214:
					var data = msg.a;
					var userInSchedule = A2($author$project$Main$userPresent, data.w, model.b$.k);
					var notificationData = {
						dP: '',
						gV: '',
						hK: A2($author$project$Main$createSingleNotificationKind, model, userInSchedule),
						aX: data.w.aX,
						cA: model.g1
					};
					var _v127 = $author$project$Main$columnDefinitions(model.b$.fB);
					var pendingColumn = _v127.a;
					var scheduledColumn = _v127.b;
					var _v128 = userInSchedule ? A5($author$project$Main$changeUsersTimeSlotInPublishedSchedule, model, data.w, notificationData, data.P, data._) : A7($author$project$Main$addUserToPublishedScheduleAndUpdatePipeline, model, data.w, notificationData, data._, data.P, pendingColumn, scheduledColumn);
					var backendChanges = _v128.a;
					var scheduleData = _v128.b;
					var talentData = _v128.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								cv: 2,
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 210:
					var data = msg.a;
					var movedFromOutsideSchedule = data.P === '';
					var _v129 = $author$project$Main$columnDefinitions(model.b$.fB);
					var pendingColumn = _v129.a;
					var scheduledColumn = _v129.b;
					var _v130 = function () {
						if (movedFromOutsideSchedule) {
							var _v131 = _Utils_Tuple2(
								A4($author$project$Main$updateSchedules, model.b$.k, data.w, data._, data.P),
								A3($author$project$Main$updateAvailiableTalent, model.b$.I, data.w, false));
							var firstScheduleUpdate = _v131.a;
							var firstTalentUpdate = _v131.b;
							return A7($author$project$Main$removeCurrentUserAndAddMovingUser, data, model.hI, model.b$, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn);
						} else {
							return A3($author$project$Main$updateBothUsersPositionsInSchedule, data, model.hI, model.b$);
						}
					}();
					var backendChanges = _v130.a;
					var scheduleData = _v130.b;
					var talentData = _v130.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 211:
					var data = msg.a;
					var _v132 = $author$project$Main$columnDefinitions(model.b$.fB);
					var pendingColumn = _v132.a;
					var scheduledColumn = _v132.b;
					var _v133 = function () {
						var _v134 = _Utils_Tuple2(
							A4($author$project$Main$updateSchedules, model.b$.k, data.w, data._, data.P),
							A3($author$project$Main$updateAvailiableTalent, model.b$.I, data.w, false));
						var firstScheduleUpdate = _v134.a;
						var firstTalentUpdate = _v134.b;
						return A7($author$project$Main$removeCurrentUserAndAddMovingUser, data, model.hI, model.b$, firstScheduleUpdate, firstTalentUpdate, pendingColumn, scheduledColumn);
					}();
					var backendChanges = _v133.a;
					var scheduleData = _v133.b;
					var talentData = _v133.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									A3($author$project$Schedule$ScheduleDataUpdate, scheduleData, talentData, $author$project$SharedProjectRoleSchedules$emptyUserSwapData))
							}),
						backendChanges);
				case 215:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cv: 2}),
						$elm$core$Platform$Cmd$none);
				case 216:
					var scheduleType = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$SwitchViewingSchedules(scheduleType))
							}),
						A2(
							$author$project$Main$goTo,
							model,
							A2($author$project$Route$SchedulePage, model.b$.aj.c$, scheduleType)));
				case 217:
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$updateUsersRoleInfo, model.hI, model.bd));
				case 321:
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Api$Request$updateUsersRoleInfo,
							model.hI,
							{h4: model.W.fs, aX: model.W.jb.aX, cA: model.W.jb.c$}));
				case 218:
					var roleMemberId = msg.a;
					var newRoleId = msg.b;
					var userId = msg.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								bd: A4($author$project$Main$updateRoleChangeInfo, model.bd, roleMemberId, newRoleId, userId)
							}),
						$elm$core$Platform$Cmd$none);
				case 219:
					var res = msg.a;
					if (!res.$) {
						var action = function () {
							var _v136 = model.E.V;
							if (!_v136) {
								return $author$project$MainMsg$SearchJobs;
							} else {
								return $author$project$MainMsg$SearchUsers;
							}
						}();
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							action,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Users Role Successfully Updated'),
										bd: A4($author$project$Main$updateRoleChangeInfo, model.bd, '', '', ''),
										W: $author$project$User$initialTalentMenuOptions
									}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Main$dismissAlert,
											A2($author$project$Api$Request$getProjectData, model.hI, model.m.c$)
										]))));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('There was an error updating users role.')
								}),
							$author$project$Main$dismissAlert);
					}
				case 224:
					var res = msg.a;
					if (!res.$) {
						var user = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{E: user}),
							$author$project$Main$twilio(
								{
									z: 'refreshTwilioToken',
									ai: $author$project$Api$Encoders$twilioPayloadEncoder($author$project$Message$emptyToTwilioPayload),
									ao: user.C
								}));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 225:
					var data = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						data,
						model,
						'',
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 226:
					var id = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{z: 'switchChannel'}),
						model,
						id,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 227:
					var res = msg.a;
					if (!res.$) {
						var pipelineUser = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									ce: $author$project$Main$extractStage(pipelineUser),
									v: $author$project$Utils$transformToSearchResultTalentProfile(pipelineUser)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 229:
					var filterType = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								ca: A2($author$project$Main$updateChatFilterValues, filterType, model)
							}),
						$elm$core$Platform$Cmd$none);
				case 230:
					var convoId = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{z: 'switchChannel'}),
						model,
						convoId,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 231:
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{z: 'closeTalentConversationContainer'}),
						model,
						'',
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 232:
					var convoId = msg.a;
					return A4(
						$author$project$Main$updateTwilioData,
						_Utils_update(
							$author$project$Message$emptyFromTwilioPayload,
							{z: 'archiveConversation'}),
						model,
						convoId,
						_List_fromArray(
							[$author$project$User$emptyUserConvoInfo]));
				case 233:
					var convoId = msg.a;
					var notificationId = msg.b;
					var page = function () {
						var _v139 = model.E.V;
						switch (_v139) {
							case 0:
								return $author$project$Route$MyJobs;
							case 1:
								return $author$project$Route$Inbox;
							default:
								return $author$project$Route$Inbox;
						}
					}();
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						A2(
							$author$project$MainMsg$ViewThenMarkAsRead,
							page,
							_List_fromArray(
								[notificationId])),
						A4(
							$author$project$Main$updateTwilioData,
							_Utils_update(
								$author$project$Message$emptyFromTwilioPayload,
								{z: 'switchChannel'}),
							model,
							convoId,
							_List_fromArray(
								[$author$project$User$emptyUserConvoInfo])));
				case 234:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{by: !model.by}),
						$elm$core$Platform$Cmd$none);
				case 235:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{a6: false, by: false}),
						$elm$core$Platform$Cmd$none);
				case 236:
					var res = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 237:
					var res = msg.a;
					if (!res.$) {
						var userConvoInfo = res.a;
						return A4(
							$author$project$Main$updateTwilioData,
							_Utils_update(
								$author$project$Message$emptyFromTwilioPayload,
								{z: 'gotUserConvoInfo'}),
							model,
							'',
							userConvoInfo);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 304:
					return (model.S.fF === '') ? _Utils_Tuple2(
						_Utils_update(
							model,
							{
								S: A2($author$project$Main$updateJobPageData, $author$project$Job$SearchingJobs, model.S)
							}),
						A2($author$project$Api$Request$searchJobs, model.hI, '-1')) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								S: A2($author$project$Main$updateJobPageData, $author$project$Job$SearchingJobs, model.S)
							}),
						A2($author$project$Api$Request$searchJobs, model.hI, model.S.fF));
				case 305:
					var res = msg.a;
					if (!res.$) {
						var jobs = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									S: A2(
										$author$project$Main$updateJobPageData,
										$author$project$Job$SearchResults(jobs),
										model.S),
									ac: A2(
										$elm$core$Maybe$withDefault,
										$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
										$elm$core$List$head(jobs)).aa
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 105:
					var res = msg.a;
					if (!res.$) {
						var agents = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Success!'),
									h: $author$project$Main$closeAddAgentForm(model.h),
									E: A2($author$project$Main$updateAgentsList, model.E, agents)
								}),
							$author$project$Main$dismissAlert);
					} else {
						var error = res.a;
						if (error.$ === 3) {
							var a = error.a;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Error with agent!')
									}),
								$author$project$Main$dismissAlert);
						} else {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						}
					}
				case 104:
					var agentId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ad: false}),
						A3($author$project$Api$Request$deleteAgent, agentId, model.E.gj.aa, model.hI));
				case 238:
					var page = msg.a;
					var notificationIds = msg.b;
					if (page.$ === 24) {
						var projectId = page.a;
						var scheduleType = page.b;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$View(
								A2($author$project$Route$SchedulePage, projectId, scheduleType)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										by: false,
										E: A2($author$project$Main$updateNotifications, model.E, notificationIds)
									}),
								A2($author$project$Api$Request$markNotificationsAsRead, model.hI, notificationIds)));
					} else {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$RedirectPage(page),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										by: false,
										E: A2($author$project$Main$updateNotifications, model.E, notificationIds)
									}),
								A2($author$project$Api$Request$markNotificationsAsRead, model.hI, notificationIds)));
					}
				case 103:
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$addUpdateAgent, model.h.bL, model.E.gj.aa, model.hI));
				case 241:
					var notifications = msg.a;
					var notificationIds = A2(
						$elm$core$List$map,
						function ($) {
							return $.aa;
						},
						notifications);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								E: A2($author$project$Main$updateNotifications, model.E, notificationIds)
							}),
						A2($author$project$Api$Request$markNotificationsAsRead, model.hI, notificationIds));
				case 242:
					var projectMenuMsg = msg.a;
					return A2($author$project$Main$updateProjectMenuState, model, projectMenuMsg);
				case 245:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c_: true}),
						$elm$core$Platform$Cmd$none);
				case 246:
					var talentFilter = msg.a;
					return A2($author$project$Main$updateTalentFilterExpand, model, talentFilter);
				case 247:
					var allTalent = function () {
						var _v145 = model.bg;
						if (_v145.$ === 3) {
							var searchResultTalentProfileList = _v145.a;
							return searchResultTalentProfileList;
						} else {
							return _List_Nil;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{B: allTalent}),
						$elm$core$Platform$Cmd$none);
				case 251:
					var allGenders = ($elm$core$List$length(model.V.hs) > 0) ? _List_Nil : model.hs;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								V: A2($author$project$Main$updateRoleGenders, model.V, allGenders)
							}),
						$elm$core$Platform$Cmd$none);
				case 252:
					var allEthnicities = ($elm$core$List$length(model.V.eg) > 0) ? _List_Nil : model.eg;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								V: A2($author$project$Main$updateRoleEthnicities, model.V, allEthnicities)
							}),
						$elm$core$Platform$Cmd$none);
				case 253:
					var imageId = msg.a;
					return _Utils_Tuple2(
						model,
						A2(
							$author$project$Api$Request$getProxiedImage,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$User$emptyImage,
								$elm$core$List$head(
									A2(
										$elm$core$List$filter,
										A2(
											$author$project$Utils$eq,
											function ($) {
												return $.aa;
											},
											imageId),
										model.l))),
							model.hI));
				case 303:
					var jobPageMsg = msg.a;
					var url = function () {
						if (jobPageMsg.$ === 3) {
							var projectId = jobPageMsg.a;
							return $author$project$Route$Job(projectId);
						} else {
							return model.o;
						}
					}();
					var selectedJob = function () {
						if (jobPageMsg.$ === 3) {
							var projectId = jobPageMsg.a;
							return projectId;
						} else {
							return '';
						}
					}();
					if (jobPageMsg.$ === 1) {
						var newId = model.b5 + 1;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									S: A2($author$project$Main$updateJobPageData, jobPageMsg, model.S),
									ac: selectedJob,
									b5: newId
								}),
							A3(
								$andrewMacmurray$elm_delay$Delay$after,
								500,
								0,
								A2($author$project$MainMsg$Timeout, newId, 0)));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									o: url,
									S: A2($author$project$Main$updateJobPageData, jobPageMsg, model.S),
									ac: selectedJob
								}),
							$elm$core$Platform$Cmd$none);
					}
				case 258:
					var res = msg.a;
					if (!res.$) {
						var image = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{aA: true, aE: image}),
							$author$project$Main$kickOffResizing(''));
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 318:
					var fullImageModal = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{cj: fullImageModal}),
						$elm$core$Platform$Cmd$none);
				case 254:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aA: false, aE: $author$project$User$emptyProxyImage}),
						$elm$core$Platform$Cmd$none);
				case 255:
					var url = msg.a;
					var _v150 = A5($author$project$Main$removeOriginalImage, model.hI, model.g1, url, model.aE, model.l);
					var images = _v150.a;
					var deleteMessage = _v150.b;
					var uploadMessage = _v150.c;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aA: false, l: images}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[deleteMessage, uploadMessage])));
				case 256:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 257:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 259:
					var id = msg.a;
					var searchType = msg.b;
					if (_Utils_eq(id, model.b5)) {
						var $temp$msg = $author$project$MainMsg$TypingEnded(searchType),
							$temp$model = model;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 263:
					var search = msg.a;
					if (search === 1) {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SearchUsers,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					} else {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$SearchJobs,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
					}
				case 267:
					var res = msg.a;
					if (!res.$) {
						var collaborators = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									b$: A2(
										$author$project$Main$updateCollaborator,
										model.b$,
										$author$project$SharedProjectRoleSchedules$UpdateCollaborators(collaborators))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 265:
					var amsg = msg.a;
					var message = function () {
						switch (amsg.$) {
							case 0:
								return (!model.b$.bI.c9) ? $author$project$Api$Request$getCollaborators(model.hI) : $elm$core$Platform$Cmd$none;
							case 10:
								var _v154 = model.b$.aK;
								if (_v154.$ === 5) {
									var projectId = _v154.a;
									var scheduleId = _v154.b;
									return model.b$.bI.cZ ? A3($author$project$Api$Request$addCollaborator, model.b$.bI, model.hI, projectId) : $elm$core$Platform$Cmd$none;
								} else {
									return $elm$core$Platform$Cmd$none;
								}
							default:
								return $elm$core$Platform$Cmd$none;
						}
					}();
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$VerifyCollabForm($author$project$SharedProjectRoleSchedules$VerifyForm),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									b$: A2($author$project$Main$updateCollaborator, model.b$, amsg)
								}),
							message));
				case 266:
					var amsg = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2($author$project$Main$updateCollaborator, model.b$, amsg)
							}),
						$elm$core$Platform$Cmd$none);
				case 268:
					var res = msg.a;
					if (!res.$) {
						var collaborators = res.a;
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$UpdateCollaboratorData(
								$author$project$SharedProjectRoleSchedules$CollaboratorAdded(collaborators)),
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Collaboration invitation sent to user'),
										cP: collaborators
									}),
								$author$project$Main$dismissAlert));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 109:
					var agentId = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: A3($author$project$Main$toggleAgentForm, model.h, agentId, model.E)
							}),
						$elm$core$Platform$Cmd$none);
				case 110:
					var agentInfo = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: A2($author$project$Main$updateAgentInfo, model.h, agentInfo)
							}),
						$elm$core$Platform$Cmd$none);
				case 269:
					var res = msg.a;
					if (!res.$) {
						var invitation = res.a;
						var message = (invitation.cc && (model.hI === '')) ? $elm$core$Platform$Cmd$none : ((invitation.cc && (model.hI !== '')) ? $author$project$Main$removeUserToken('') : $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Main$goTo, model, $author$project$Route$Login),
									$author$project$Main$removeUserToken('')
								])));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									R: 0,
									bv: invitation.f_.bv,
									aZ: A2($author$project$Main$updateCollaboratorProfile, model.aZ, invitation.f_)
								}),
							message);
					} else {
						return _Utils_Tuple2(
							model,
							A2($author$project$Main$goTo, model, $author$project$Route$Login));
					}
				case 108:
					var res = msg.a;
					if (!res.$) {
						var invitation = res.a;
						var message = (invitation.cc && (model.hI === '')) ? $elm$core$Platform$Cmd$none : ((invitation.cc && (model.hI !== '')) ? $author$project$Main$removeUserToken('') : $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Main$goTo, model, $author$project$Route$Login),
									$author$project$Main$removeUserToken('')
								])));
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									R: 0,
									bv: invitation.f_.bv,
									aZ: A2($author$project$Main$updateCollaboratorProfile, model.aZ, invitation.f_)
								}),
							message);
					} else {
						return _Utils_Tuple2(
							model,
							A2($author$project$Main$goTo, model, $author$project$Route$Login));
					}
				case 270:
					var res = msg.a;
					if (!res.$) {
						var projects = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dW: projects}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 271:
					var projectId = msg.a;
					var scheduleId = msg.b;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$View(
							A2($author$project$Route$DayOfPage, projectId, scheduleId)),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{d6: projectId}),
							$elm$core$Platform$Cmd$none));
				case 273:
					var roleMemberId = msg.a;
					var vote = msg.b;
					var timeSlotId = msg.c;
					return _Utils_Tuple2(
						model,
						A5($author$project$Api$Request$submitVote, roleMemberId, vote, model.b$.cb, model.hI, timeSlotId));
				case 272:
					var res = msg.a;
					if (!res.$) {
						var timeSlot = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Vote Successfully Recorded!'),
									b$: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$UpdateTimeSlot(timeSlot))
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 274:
					var response = msg.a;
					var invitationId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$updateInvitation, response, invitationId, model.hI));
				case 275:
					var res = msg.a;
					if (!res.$) {
						var projects = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{dW: projects}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 276:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2($author$project$Main$updateSchedulePageData, model, $author$project$Schedule$UpdateCollaboratorsModal)
							}),
						$elm$core$Platform$Cmd$none);
				case 277:
					var res = msg.a;
					if (!res.$) {
						var collaborators = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cP: collaborators}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 278:
					var invitationId = msg.a;
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$removeCollaborator, invitationId, model.hI));
				case 279:
					var res = msg.a;
					if (!res.$) {
						var collaborators = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Collaborator Successfully Removed'),
									cP: collaborators
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 280:
					var comment = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								b$: A2(
									$author$project$Main$updateSchedulePageData,
									model,
									$author$project$Schedule$UpdateMyComment(comment))
							}),
						$elm$core$Platform$Cmd$none);
				case 281:
					var time = msg.a;
					var projectId = msg.b;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($author$project$Api$Request$getProjectData, model.hI, projectId),
									A2($author$project$Api$Request$getCollaboratorsOnProject, projectId, model.hI)
								])));
				case 282:
					var timeSlotId = msg.a;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$submitVotingComment, model.b$.cb, model.hI, timeSlotId));
				case 283:
					var res = msg.a;
					if (!res.$) {
						var timeSlot = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Comment Successfully submitted!'),
									b$: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										$author$project$Schedule$UpdateTimeSlot(timeSlot))
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 295:
					var pageIndex = msg.a;
					var savingAction = ((_Utils_cmp(
						pageIndex + 1,
						$elm$core$List$length(model.E.ct)) > 0) || (pageIndex < 0)) ? $elm$core$Platform$Cmd$none : $author$project$Api$Request$updateUserProfilePageChange(model);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: A2($author$project$Main$updateCurrentProfilePage, model.h, pageIndex)
							}),
						savingAction);
				case 296:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: $author$project$Main$toggleProfilePageNav(model.h)
							}),
						$elm$core$Platform$Cmd$none);
				case 297:
					var res = msg.a;
					if (!res.$) {
						var questions = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									h: A2($author$project$Main$updateQuestions, model.h, questions)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 298:
					var value = msg.a;
					var questionId = msg.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: A3($author$project$Main$updateQuestionsForm, value, questionId, model.h)
							}),
						$elm$core$Platform$Cmd$none);
				case 300:
					var pmsg = msg.a;
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				case 299:
					var res = msg.a;
					if (!res.$) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Failed to update profile!')
								}),
							$author$project$Main$dismissAlert);
					}
				case 301:
					var res = msg.a;
					if (!res.$) {
						var agencies = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									h: A2($author$project$Main$updateAgencies, agencies, model.h)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 33:
					var res = msg.a;
					if (!res.$) {
						var userProfile = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Successfully Removed Agent'),
									E: userProfile
								}),
							$author$project$Main$dismissAlert);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 302:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								h: $author$project$Main$toggleAgencyFields(model.h),
								E: $author$project$Main$clearAgencyInfo(model.E)
							}),
						$elm$core$Platform$Cmd$none);
				case 42:
					var associationId = msg.a;
					var agentId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$deleteTalentAgent, associationId, agentId, model.hI));
				case 306:
					return _Utils_Tuple2(
						model,
						A2($author$project$Api$Request$createAgency, model.E.cE, model.hI));
				case 307:
					var res = msg.a;
					if (!res.$) {
						var userProfile = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Successfully Added Agency!'),
									h: $author$project$Main$toggleAgencyFields(model.h),
									E: userProfile
								}),
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$author$project$Main$dismissAlert,
										$author$project$Api$Request$getAgencies(model.hI)
									])));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Failed to add agency. Please fill out all fields!')
								}),
							$author$project$Main$dismissAlert);
					}
				case 308:
					return (model.bv === '') ? _Utils_Tuple2(
						_Utils_update(
							model,
							{b0: 'Please provide a valid email to send password reset to!'}),
						$author$project$Main$resetErrorMessage) : _Utils_Tuple2(
						model,
						$author$project$Main$sendPasswordResetEmail(model.bv));
				case 310:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{b0: ''}),
						$elm$core$Platform$Cmd$none);
				case 309:
					var status = msg.a;
					switch (status) {
						case 'success':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Sent Password Reset email to ' + model.bv)
									}),
								$author$project$Main$dismissAlert);
						case 'error':
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Failed to send password reset email. Please ensure that your email is correct.')
									}),
								$author$project$Main$dismissAlert);
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 3:
					var aMsg = msg.a;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								gj: A2($author$project$Main$updateAgency, model.gj, aMsg)
							}),
						$elm$core$Platform$Cmd$none);
				case 260:
					var res = msg.a;
					if (!res.$) {
						var talent = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									W: A5(
										$author$project$Main$updateTalentMenuOptions,
										$author$project$User$GotTalentInfo(talent),
										model.W,
										'',
										'',
										_List_Nil),
									v: talent
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				case 5:
					var invalidForm = A2(
						$elm$core$List$member,
						'',
						_List_fromArray(
							[model.gj.cF, model.gj.bv, model.gj.bF, model.gj.a0, model.gj.bf, model.gj.dv, model.gj.eZ, model.gj.cL]));
					var message = invalidForm ? $author$project$Model$Showing('Form is not valid') : $author$project$Model$Hiding;
					var submitAction = invalidForm ? _List_fromArray(
						[$author$project$Main$dismissAlert]) : _List_fromArray(
						[
							$author$project$Main$dismissAlert,
							$author$project$Main$fireBaseSignUp(
							_Utils_Tuple2(model.gj.bv, model.gj.eZ))
						]);
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								f: message,
								aZ: $author$project$Main$setUserDataToAgency(model.aZ)
							}),
						$elm$core$Platform$Cmd$batch(submitAction));
				case 312:
					var projectId = msg.a;
					var column = A2(
						$elm$core$Maybe$withDefault,
						$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$author$project$Utils$eq,
									function ($) {
										return $.aa;
									},
									projectId),
								model.S.fh))).hO;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$SearchUsers,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{aR: column, aV: projectId, ac: projectId}),
							$elm$core$Platform$Cmd$none));
				case 313:
					var roleId = msg.a;
					var role = A2(
						$elm$core$Maybe$withDefault,
						$author$project$SharedProjectRoleSchedules$emptyRole,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$author$project$Utils$eq,
									function ($) {
										return $.c$;
									},
									roleId),
								model.aB)));
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$SearchUsers,
						_Utils_Tuple2(
							_Utils_update(
								model,
								{
									bZ: roleId,
									bA: roleId,
									r: A2($author$project$Main$updateFiltersBasedOnRole, role, model.r)
								}),
							$elm$core$Platform$Cmd$none));
				case 314:
					var projectId = msg.a;
					var roleId = msg.b;
					var columnId = msg.c;
					return A3(
						$ccapndave$elm_update_extra$Update$Extra$andThen,
						$author$project$Main$update,
						$author$project$MainMsg$RedirectPage($author$project$Route$TalentSearch),
						_Utils_Tuple2(
							_Utils_update(
								model,
								{aR: columnId, aV: projectId, bZ: roleId, ac: projectId, bA: roleId}),
							$elm$core$Platform$Cmd$none));
				case 315:
					var res = msg.a;
					if (!res.$) {
						var talent = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{cG: talent}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 317:
					var status = msg.a;
					var membershipId = msg.b;
					return _Utils_Tuple2(
						model,
						A3($author$project$Api$Request$updateTalentMembership, status, membershipId, model.hI));
				case 316:
					var res = msg.a;
					if (!res.$) {
						var returnedTalent = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									cG: A2(
										$elm$core$List$map,
										function (talent) {
											return _Utils_eq(talent.aa, returnedTalent.aa) ? returnedTalent : talent;
										},
										model.cG),
									ad: false
								}),
							$author$project$Api$Request$getDashboardData(model.hI));
					} else {
						return $author$project$Main$handleError(model);
					}
				case 290:
					var res = msg.a;
					if (!res.$) {
						var schedule = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									b$: A2(
										$author$project$Main$updateSchedulePageData,
										model,
										A2(
											$author$project$Schedule$ScheduleProjectUpdate,
											model.m.k,
											A2($author$project$SharedProjectRoleSchedules$ScheduleDayOfPage, model.m.c$, schedule.aa)))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 319:
					var res = msg.a;
					if (!res.$) {
						var data = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									S: A2(
										$author$project$Main$updateJobPageData,
										$author$project$Job$LandedOnPage(data),
										model.S)
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return $author$project$Main$handleError(model);
					}
				case 40:
					var res = msg.a;
					if (!res.$) {
						var data = res.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{g3: data}),
							$elm$core$Platform$Cmd$none);
					} else {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							$author$project$MainMsg$Logout,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Session has ended, please login again!')
									}),
								$author$project$Main$dismissAlert));
					}
				case 320:
					var tMsg = msg.a;
					var message = function () {
						if (tMsg.$ === 3) {
							var talentProfile = tMsg.a;
							return (!model.W.dr) ? $elm$core$Platform$Cmd$none : A3($author$project$Api$Request$getDetailedTalentInfo, model.hI, model.ac, talentProfile.c$);
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								W: A5($author$project$Main$updateTalentMenuOptions, tMsg, model.W, model.ac, model.bA, model.aB)
							}),
						message);
				case 322:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{W: $author$project$User$initialTalentMenuOptions}),
						A2($author$project$Api$Request$removeTalent, model.W, model.hI));
				case 323:
					var res = msg.a;
					var pageActions = function () {
						var _v179 = model.o;
						if (_v179.$ === 21) {
							var projectId = _v179.a;
							return _List_fromArray(
								[
									$author$project$Main$fetchPipeline(
									{d6: projectId, hI: model.hI, i2: model.i2}),
									$author$project$Main$dismissAlert
								]);
						} else {
							return _List_fromArray(
								[$author$project$Main$dismissAlert]);
						}
					}();
					var action = function () {
						var _v178 = model.E.V;
						if (!_v178) {
							return $author$project$MainMsg$SearchJobs;
						} else {
							return $author$project$MainMsg$SearchUsers;
						}
					}();
					if (!res.$) {
						return A3(
							$ccapndave$elm_update_extra$Update$Extra$andThen,
							$author$project$Main$update,
							action,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										f: $author$project$Model$Showing('Successfully Removed Talent')
									}),
								$elm$core$Platform$Cmd$batch(pageActions)));
					} else {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									f: $author$project$Model$Showing('Error removing talent!')
								}),
							$author$project$Main$dismissAlert);
					}
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Main$updateTalentFilterValues = F2(
	function (fMsg, model) {
		var talentFilterValues = model.r;
		switch (fMsg.$) {
			case 8:
				var gender = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{
										hr: A2($author$project$Main$updateFilterValues, gender, model.r.hr),
										id: 0
									})
							}),
						$elm$core$Platform$Cmd$none));
			case 1:
				var height = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{hY: height, id: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 2:
				var height = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{hR: height, id: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 0:
				var weight = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{eQ: weight, id: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 3:
				var weight = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{eM: weight, id: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 4:
				var size = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{hX: size, id: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 5:
				var size = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{hQ: size, id: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 6:
				var age = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{c4: age, id: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 7:
				var age = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{c2: age, id: 0})
							}),
						$elm$core$Platform$Cmd$none));
			case 9:
				var val = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{
										hj: A2($author$project$Main$updateFilterValues, val, model.r.hj),
										id: 0
									})
							}),
						$elm$core$Platform$Cmd$none));
			case 10:
				var val = fMsg.a;
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								r: _Utils_update(
									talentFilterValues,
									{
										id: 0,
										iB: A2($author$project$Main$updateFilterValues, val, model.r.iB)
									})
							}),
						$elm$core$Platform$Cmd$none));
			case 11:
				var val = fMsg.a;
				var newId = model.b5 + 1;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							r: _Utils_update(
								talentFilterValues,
								{id: 0, iS: val}),
							b5: newId
						}),
					A3(
						$andrewMacmurray$elm_delay$Delay$after,
						500,
						0,
						A2($author$project$MainMsg$Timeout, newId, 1)));
			case 12:
				var val = fMsg.a;
				var clearedFilters = function () {
					switch (val) {
						case 0:
							return _Utils_update(
								model,
								{
									r: _Utils_update(
										talentFilterValues,
										{hr: _List_Nil})
								});
						case 4:
							return _Utils_update(
								model,
								{
									r: _Utils_update(
										talentFilterValues,
										{c2: '', c4: ''})
								});
						case 2:
							return _Utils_update(
								model,
								{
									r: _Utils_update(
										talentFilterValues,
										{eM: '', eQ: ''})
								});
						case 1:
							return _Utils_update(
								model,
								{
									r: _Utils_update(
										talentFilterValues,
										{hR: '', hY: ''})
								});
						case 6:
							return _Utils_update(
								model,
								{
									r: _Utils_update(
										talentFilterValues,
										{iB: _List_Nil})
								});
						case 5:
							return _Utils_update(
								model,
								{
									r: _Utils_update(
										talentFilterValues,
										{hj: _List_Nil})
								});
						case 3:
							return _Utils_update(
								model,
								{
									r: _Utils_update(
										talentFilterValues,
										{hQ: '', hX: ''})
								});
						case 7:
							return model;
						default:
							return model;
					}
				}();
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(clearedFilters, $elm$core$Platform$Cmd$none));
			default:
				return A3(
					$ccapndave$elm_update_extra$Update$Extra$andThen,
					$author$project$Main$update,
					$author$project$MainMsg$SearchUsers,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{ac: '', bA: '', r: $author$project$InitData$initTalentFilterValues}),
						$elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Main$validateProfileFields = F2(
	function (userProfile, model) {
		return ((userProfile.g5 === '0') || ((userProfile.h$ === '0') || (userProfile.jE === '0'))) ? A3(
			$ccapndave$elm_update_extra$Update$Extra$andThen,
			$author$project$Main$update,
			$author$project$MainMsg$GoToPage(1),
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						f: $author$project$Model$Showing('Please enter your birthday!')
					}),
				$author$project$Main$dismissAlert)) : _Utils_Tuple2(
			_Utils_update(
				model,
				{fa: '', ay: $author$project$User$initialProfileValidations}),
			$author$project$Api$Request$updateUserProfile(model));
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Main$messageBox = function (model) {
	var _v0 = model.f;
	if (_v0.$ === 1) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert')
				]),
			_List_Nil);
	} else {
		var alert = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('alert showing'),
					$elm$html$Html$Events$onClick($author$project$MainMsg$DismissAlert)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(alert)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('exit-alert'),
							$elm$html$Html$Events$onClick($author$project$MainMsg$DismissAlert)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('X')
						]))
				]));
	}
};
var $author$project$MainMsg$CloseAllMenus = {$: 235};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $author$project$Views$Nav$nothing = $elm$html$Html$text('');
var $author$project$MainMsg$MarkAllNotificationsAsRead = function (a) {
	return {$: 241, a: a};
};
var $author$project$MainMsg$ToggleMenu = {$: 23};
var $author$project$MainMsg$ToggleNotifications = {$: 234};
var $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon = function (a) {
	return {$: 0, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$bars = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('bars');
var $frandibar$elm_font_awesome_5$FontAwesome$bell = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('bell');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $frandibar$elm_font_awesome_5$FontAwesome$Solid = 0;
var $frandibar$elm_font_awesome_5$FontAwesome$animationClass = function (animation) {
	if (!animation) {
		return 'fa-spin';
	} else {
		return 'fa-pulse';
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$borderClass = 'fa-border';
var $frandibar$elm_font_awesome_5$FontAwesome$invertClass = 'fa-inverse';
var $frandibar$elm_font_awesome_5$FontAwesome$pullClass = function (p) {
	if (!p) {
		return 'fa-pull-left';
	} else {
		return 'fa-pull-right';
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$sizeClass = function (size) {
	switch (size.$) {
		case 0:
			return 'fa-xs';
		case 1:
			return 'fa-sm';
		case 2:
			return 'fa-lg';
		default:
			var n = size.a;
			return 'fa-' + ($elm$core$String$fromInt(n) + 'x');
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$widthClass = 'fa-fw';
var $frandibar$elm_font_awesome_5$FontAwesome$className = function (opt) {
	switch (opt.$) {
		case 0:
			var animation = opt.a;
			return _Utils_Tuple2(
				$frandibar$elm_font_awesome_5$FontAwesome$animationClass(animation),
				true);
		case 1:
			return _Utils_Tuple2($frandibar$elm_font_awesome_5$FontAwesome$borderClass, true);
		case 2:
			return _Utils_Tuple2($frandibar$elm_font_awesome_5$FontAwesome$widthClass, true);
		case 4:
			return _Utils_Tuple2($frandibar$elm_font_awesome_5$FontAwesome$invertClass, true);
		case 6:
			var direction = opt.a;
			return _Utils_Tuple2(
				$frandibar$elm_font_awesome_5$FontAwesome$pullClass(direction),
				true);
		case 7:
			var size = opt.a;
			return _Utils_Tuple2(
				$frandibar$elm_font_awesome_5$FontAwesome$sizeClass(size),
				true);
		default:
			return _Utils_Tuple2('', false);
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$iconClass = function (iconOrLogo) {
	var root = function () {
		if (!iconOrLogo.$) {
			var name = iconOrLogo.a;
			return name;
		} else {
			var name = iconOrLogo.a;
			return name;
		}
	}();
	return 'fa-' + root;
};
var $frandibar$elm_font_awesome_5$FontAwesome$styleClass = F2(
	function (iconOrLogo, style) {
		if (iconOrLogo.$ === 1) {
			return 'fab';
		} else {
			switch (style) {
				case 0:
					return 'fas';
				case 1:
					return 'far';
				default:
					return 'fal';
			}
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$classes = F3(
	function (iconUnstyled, style, options) {
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					A2($frandibar$elm_font_awesome_5$FontAwesome$styleClass, iconUnstyled, style),
					true),
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						$frandibar$elm_font_awesome_5$FontAwesome$iconClass(iconUnstyled),
						true),
					A2($elm$core$List$map, $frandibar$elm_font_awesome_5$FontAwesome$className, options))));
	});
var $frandibar$elm_font_awesome_5$FontAwesome$Utils$onlyOne = F3(
	function (f, curr, _v0) {
		var found = _v0.a;
		var list = _v0.b;
		var _v1 = _Utils_Tuple2(
			f(curr),
			found);
		if (_v1.a) {
			if (!_v1.b) {
				return _Utils_Tuple2(
					true,
					A2($elm$core$List$cons, curr, list));
			} else {
				return _Utils_Tuple2(found, list);
			}
		} else {
			return _Utils_Tuple2(
				found,
				A2($elm$core$List$cons, curr, list));
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup = F2(
	function (f, list) {
		return A3(
			$elm$core$List$foldr,
			$frandibar$elm_font_awesome_5$FontAwesome$Utils$onlyOne(f),
			_Utils_Tuple2(false, _List_Nil),
			list).b;
	});
var $frandibar$elm_font_awesome_5$FontAwesome$isAnimation = function (option) {
	if (!option.$) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isBorder = function (option) {
	if (option.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isHtmlTag = function (option) {
	if (option.$ === 3) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isInvertColor = function (option) {
	if (option.$ === 4) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isMask = function (option) {
	if (option.$ === 5) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isPull = function (option) {
	if (option.$ === 6) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isSize = function (option) {
	if (option.$ === 7) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isTransform = function (option) {
	if (option.$ === 8) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$isWidth = function (option) {
	if (option.$ === 2) {
		return true;
	} else {
		return false;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$filterAttrs = function (options) {
	return A2(
		$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
		$frandibar$elm_font_awesome_5$FontAwesome$isWidth,
		A2(
			$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
			$frandibar$elm_font_awesome_5$FontAwesome$isTransform,
			A2(
				$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
				$frandibar$elm_font_awesome_5$FontAwesome$isSize,
				A2(
					$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
					$frandibar$elm_font_awesome_5$FontAwesome$isPull,
					A2(
						$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
						$frandibar$elm_font_awesome_5$FontAwesome$isMask,
						A2(
							$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
							$frandibar$elm_font_awesome_5$FontAwesome$isInvertColor,
							A2(
								$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
								$frandibar$elm_font_awesome_5$FontAwesome$isHtmlTag,
								A2(
									$frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup,
									$frandibar$elm_font_awesome_5$FontAwesome$isBorder,
									A2($frandibar$elm_font_awesome_5$FontAwesome$Utils$dedup, $frandibar$elm_font_awesome_5$FontAwesome$isAnimation, options)))))))));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $frandibar$elm_font_awesome_5$FontAwesome$mask = F2(
	function (opt, opts) {
		if (opt.$ === 5) {
			var maskIcon = opt.a;
			var style = opt.b;
			var val = A2($frandibar$elm_font_awesome_5$FontAwesome$styleClass, maskIcon, style) + (' ' + $frandibar$elm_font_awesome_5$FontAwesome$iconClass(maskIcon));
			return A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'data-fa-mask', val),
				opts);
		} else {
			return opts;
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$maskAttr = function (options) {
	return A3($elm$core$List$foldr, $frandibar$elm_font_awesome_5$FontAwesome$mask, _List_Nil, options);
};
var $frandibar$elm_font_awesome_5$FontAwesome$transformVal = function (transformValue) {
	switch (transformValue.$) {
		case 0:
			var n = transformValue.a;
			return 'grow-' + $elm$core$String$fromFloat(n);
		case 1:
			var n = transformValue.a;
			return 'shrink-' + $elm$core$String$fromFloat(n);
		case 2:
			var n = transformValue.a;
			return 'down-' + $elm$core$String$fromFloat(n);
		case 3:
			var n = transformValue.a;
			return 'left-' + $elm$core$String$fromFloat(n);
		case 4:
			var n = transformValue.a;
			return 'right-' + $elm$core$String$fromFloat(n);
		case 5:
			var n = transformValue.a;
			return 'up-' + $elm$core$String$fromFloat(n);
		case 6:
			var n = transformValue.a;
			return 'rotate-' + $elm$core$String$fromFloat(n);
		case 7:
			return 'flip-h';
		default:
			return 'flip-v';
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$transform = F2(
	function (opt, opts) {
		if (opt.$ === 8) {
			var transforms = opt.a;
			var val = A2(
				$elm$core$String$join,
				' ',
				A2($elm$core$List$map, $frandibar$elm_font_awesome_5$FontAwesome$transformVal, transforms));
			return A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'data-fa-transform', val),
				opts);
		} else {
			return opts;
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$transformAttr = function (options) {
	return A3($elm$core$List$foldr, $frandibar$elm_font_awesome_5$FontAwesome$transform, _List_Nil, options);
};
var $frandibar$elm_font_awesome_5$FontAwesome$htmlAttrs = F2(
	function (options, htmlAttributes) {
		return _Utils_ap(
			$frandibar$elm_font_awesome_5$FontAwesome$transformAttr(options),
			_Utils_ap(
				$frandibar$elm_font_awesome_5$FontAwesome$maskAttr(options),
				htmlAttributes));
	});
var $frandibar$elm_font_awesome_5$FontAwesome$I = 0;
var $frandibar$elm_font_awesome_5$FontAwesome$findTag = F2(
	function (option, previousTag) {
		if (option.$ === 3) {
			var newTag = option.a;
			return newTag;
		} else {
			return previousTag;
		}
	});
var $elm$html$Html$i = _VirtualDom_node('i');
var $frandibar$elm_font_awesome_5$FontAwesome$htmlTag = function (opts) {
	var foundTag = A3($elm$core$List$foldl, $frandibar$elm_font_awesome_5$FontAwesome$findTag, 0, opts);
	if (!foundTag) {
		return $elm$html$Html$i;
	} else {
		return $elm$html$Html$span;
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions = F4(
	function (iconName, style, options, htmlAttributes) {
		var opts = $frandibar$elm_font_awesome_5$FontAwesome$filterAttrs(options);
		return A3(
			$frandibar$elm_font_awesome_5$FontAwesome$htmlTag,
			opts,
			A2(
				$elm$core$List$cons,
				A3($frandibar$elm_font_awesome_5$FontAwesome$classes, iconName, style, opts),
				A2($frandibar$elm_font_awesome_5$FontAwesome$htmlAttrs, opts, htmlAttributes)),
			_List_Nil);
	});
var $frandibar$elm_font_awesome_5$FontAwesome$icon = function (iconName) {
	return A4($frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions, iconName, 0, _List_Nil, _List_Nil);
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$img = _VirtualDom_node('img');
var $author$project$MainMsg$GoToConversationPage = F2(
	function (a, b) {
		return {$: 233, a: a, b: b};
	});
var $author$project$Views$Nav$notificationAction = F2(
	function (notification, userProfile) {
		var _v0 = notification.hK;
		switch (_v0) {
			case 0:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iw),
					_List_fromArray(
						[notification.aa]));
			case 2:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.aa]));
			case 3:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iw),
					_List_fromArray(
						[notification.aa]));
			case 4:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iw),
					_List_fromArray(
						[notification.aa]));
			case 5:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.aa]));
			case 6:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iw, 'Audition'),
					_List_fromArray(
						[notification.aa]));
			case 7:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iw, 'Audition'),
					_List_fromArray(
						[notification.aa]));
			case 8:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iw, 'Audition'),
					_List_fromArray(
						[notification.aa]));
			case 12:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iw, 'Callback'),
					_List_fromArray(
						[notification.aa]));
			case 13:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iw, 'Callback'),
					_List_fromArray(
						[notification.aa]));
			case 14:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					A2($author$project$Route$SchedulePage, notification.iw, 'Callback'),
					_List_fromArray(
						[notification.aa]));
			case 11:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.aa]));
			case 9:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.aa]));
			case 15:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.aa]));
			case 10:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.aa]));
			case 16:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.aa]));
			case 18:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iw),
					_List_fromArray(
						[notification.aa]));
			case 19:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Project(notification.iw),
					_List_fromArray(
						[notification.aa]));
			case 17:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$MyJobs,
					_List_fromArray(
						[notification.aa]));
			case 20:
				return A2($author$project$MainMsg$GoToConversationPage, notification.gV, notification.aa);
			default:
				return A2(
					$author$project$MainMsg$ViewThenMarkAsRead,
					$author$project$Route$Dashboard,
					_List_fromArray(
						[notification.aa]));
		}
	});
var $author$project$Views$Nav$notificationText = F2(
	function (notification, userProfile) {
		var _v0 = userProfile.V;
		switch (_v0) {
			case 4:
				var _v1 = notification.hK;
				switch (_v1) {
					case 0:
						return notification.jf + (' applied to ' + (notification.iL + (' in ' + notification.ix)));
					case 2:
						return notification.jf + (' has been invited to apply to ' + (notification.iL + (' in ' + notification.ix)));
					case 3:
						return notification.jf + (' ACCEPTED application request for ' + (notification.iL + (' in ' + notification.ix)));
					case 4:
						return notification.jf + (' REJECTED application request for ' + (notification.iL + (' in ' + notification.ix)));
					case 5:
						return notification.jf + (' has a pending audition request for ' + (notification.iL + (' in ' + notification.ix)));
					case 6:
						return notification.jf + (' ACCEPTED audition schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 7:
						return notification.jf + (' REJECTED audition schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 8:
						return notification.jf + (' requested to be RESCHEDULED for the audition for ' + (notification.iL + (' in ' + notification.ix)));
					case 12:
						return notification.jf + (' ACCEPTED callback schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 13:
						return notification.jf + (' REJECTED callback schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 14:
						return notification.jf + (' has requested to be RESCHEDULED for the callback for ' + (notification.iL + (' in ' + notification.ix)));
					case 11:
						return notification.jf + (' has a new callback schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 9:
						return notification.jf + (' has been RESCHEDULED for ' + (notification.iL + (' in ' + notification.ix)));
					case 15:
						return notification.jf + ('\'s callback has been RESCHEDULED for ' + (notification.iL + (' in ' + notification.ix)));
					case 10:
						return notification.jf + ('\'s audition has been canceled for ' + (notification.iL + (' in ' + notification.ix)));
					case 16:
						return notification.jf + ('\'s callback has been canceled for ' + (notification.iL + (' in ' + notification.ix)));
					case 18:
						return notification.jf + (' ACCEPTED booking request for ' + (notification.iL + (' in ' + notification.ix)));
					case 19:
						return notification.jf + (' REJECTED booking request for ' + (notification.iL + (' in ' + notification.ix)));
					case 17:
						return notification.jf + (' has a pending booking request for ' + (notification.iL + (' in ' + notification.ix)));
					case 21:
						return notification.iL + ' has been canceled until further notice.';
					case 22:
						var _v2 = userProfile.V;
						switch (_v2) {
							case 0:
								return 'Your role in project ' + (notification.ix + (' has been switched to ' + notification.iL));
							case 1:
								return 'Talent has switched their role in ' + (notification.ix + (' to ' + notification.iL));
							default:
								return 'Role has been switch in ' + (notification.ix + (' to ' + notification.iL));
						}
					case 25:
						return 'Agent has removed ' + (notification.jf + (' from project ' + notification.iL));
					case 24:
						return notification.jf + (' has been removed by casting from ' + notification.iL);
					case 23:
						return notification.jf + (' removed themselves from role ' + notification.iL);
					case 20:
						return (notification.d0 > 1) ? ('You have ' + ($elm$core$String$fromInt(notification.d0) + ' new messages')) : 'You have a new message!';
					default:
						return 'NEW NOTIFICATION!';
				}
			case 3:
				var _v3 = notification.hK;
				switch (_v3) {
					case 0:
						return notification.jf + (' applied to ' + (notification.iL + (' in ' + notification.ix)));
					case 2:
						return notification.jf + (' has been invited to apply to ' + (notification.iL + (' in ' + notification.ix)));
					case 3:
						return notification.jf + (' ACCEPTED application request for ' + (notification.iL + (' in ' + notification.ix)));
					case 4:
						return notification.jf + (' REJECTED application request for ' + (notification.iL + (' in ' + notification.ix)));
					case 5:
						return notification.jf + (' has a pending audition request for ' + (notification.iL + (' in ' + notification.ix)));
					case 6:
						return notification.jf + (' ACCEPTED audition schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 7:
						return notification.jf + (' REJECTED audition schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 8:
						return notification.jf + (' requested to be RESCHEDULED for the audition for ' + (notification.iL + (' in ' + notification.ix)));
					case 12:
						return notification.jf + (' ACCEPTED callback schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 13:
						return notification.jf + (' REJECTED callback schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 14:
						return notification.jf + (' has requested to be RESCHEDULED for the callback for ' + (notification.iL + (' in ' + notification.ix)));
					case 11:
						return notification.jf + (' has a new callback schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 9:
						return notification.jf + (' has been RESCHEDULED for ' + (notification.iL + (' in ' + notification.ix)));
					case 15:
						return notification.jf + ('\'s callback has been RESCHEDULED for ' + (notification.iL + (' in ' + notification.ix)));
					case 10:
						return notification.jf + ('\'s audition has been canceled for ' + (notification.iL + (' in ' + notification.ix)));
					case 16:
						return notification.jf + ('\'s callback has been canceled for ' + (notification.iL + (' in ' + notification.ix)));
					case 18:
						return notification.jf + (' ACCEPTED booking request for ' + (notification.iL + (' in ' + notification.ix)));
					case 19:
						return notification.jf + (' REJECTED booking request for ' + (notification.iL + (' in ' + notification.ix)));
					case 17:
						return notification.jf + (' has a pending booking request for ' + (notification.iL + (' in ' + notification.ix)));
					case 21:
						return notification.iL + ' has been canceled until further notice.';
					case 22:
						var _v4 = userProfile.V;
						switch (_v4) {
							case 0:
								return 'Your role in project ' + (notification.ix + (' has been switched to ' + notification.iL));
							case 1:
								return 'Talent has switched their role in ' + (notification.ix + (' to ' + notification.iL));
							default:
								return 'Role has been switch in ' + (notification.ix + (' to ' + notification.iL));
						}
					case 25:
						return 'Agent has removed ' + (notification.jf + (' from project ' + notification.iL));
					case 24:
						return notification.jf + (' has been removed by casting from ' + notification.iL);
					case 23:
						return notification.jf + (' removed themselves from role ' + notification.iL);
					case 20:
						return (notification.d0 > 1) ? ('You have ' + ($elm$core$String$fromInt(notification.d0) + ' new messages')) : 'You have a new message!';
					default:
						return 'NEW NOTIFICATION!';
				}
			default:
				var _v5 = notification.hK;
				switch (_v5) {
					case 0:
						return notification.jf + ' applied to your role!';
					case 2:
						return 'Congratulations! You have been selected to apply for the part of  ' + (notification.iL + (' in ' + notification.ix));
					case 3:
						return notification.jf + (' ACCEPTED your application request for ' + (notification.iL + (' in ' + notification.ix)));
					case 4:
						return notification.jf + (' REJECTED your application request for ' + (notification.iL + (' in ' + notification.ix)));
					case 5:
						return 'You\'ve got a new audition request for ' + (notification.iL + (' in ' + notification.ix));
					case 6:
						return notification.jf + (' ACCEPTED your audition schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 7:
						return notification.jf + (' REJECTED your audition schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 8:
						return notification.jf + (' has requested to be RESCHEDULED for the audition for ' + (notification.iL + (' in ' + notification.ix)));
					case 12:
						return notification.jf + (' ACCEPTED your callback schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 13:
						return notification.jf + (' REJECTED your callback schedule request for ' + (notification.iL + (' in ' + notification.ix)));
					case 14:
						return notification.jf + (' has requested to be RESCHEDULED for the callback for ' + (notification.iL + (' in ' + notification.ix)));
					case 11:
						return 'You have a new callback schedule request for ' + (notification.iL + (' in ' + notification.ix));
					case 9:
						return 'Your audition has been RESCHEDULED for ' + (notification.iL + (' in ' + notification.ix));
					case 15:
						return 'Your callback has been RESCHEDULED for ' + (notification.iL + (' in ' + notification.ix));
					case 10:
						return 'Your audition has been canceled for ' + (notification.iL + (' in ' + notification.ix));
					case 16:
						return 'Your callback has been canceled for ' + (notification.iL + (' in ' + notification.ix));
					case 18:
						return notification.jf + (' ACCEPTED your booking request for ' + (notification.iL + (' in ' + notification.ix)));
					case 19:
						return notification.jf + (' REJECTED your booking request for ' + (notification.iL + (' in ' + notification.ix)));
					case 17:
						return 'Congratulations! You\'ve been selected for the part of  ' + (notification.iL + (' in ' + notification.ix));
					case 21:
						return notification.iL + ' has been canceled until further notice.';
					case 22:
						var _v6 = userProfile.V;
						switch (_v6) {
							case 0:
								return 'Your role in project ' + (notification.ix + (' has been switched to ' + notification.iL));
							case 1:
								return 'Talent has switched their role in ' + (notification.ix + (' to ' + notification.iL));
							default:
								return 'Role has been switch in ' + (notification.ix + (' to ' + notification.iL));
						}
					case 25:
						return 'Agent has removed ' + (notification.jf + (' from project ' + notification.iL));
					case 24:
						return 'You\'ve been removed by casting from ' + notification.iL;
					case 23:
						return notification.jf + ('removed themselves from role ' + notification.iL);
					case 20:
						return (notification.d0 > 1) ? ('You have ' + ($elm$core$String$fromInt(notification.d0) + ' new messages')) : 'You have a new message!';
					default:
						return 'NEW NOTIFICATION!';
				}
		}
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Views$Nav$notificationItem = F2(
	function (notification, userProfile) {
		var bodyText = function () {
			var _v2 = notification.hK;
			switch (_v2) {
				case 20:
					return notification.dP;
				case 4:
					return notification.dP;
				case 7:
					return notification.dP;
				case 19:
					return notification.dP;
				case 13:
					return notification.dP;
				case 8:
					return notification.dP;
				case 14:
					return notification.dP;
				default:
					return '';
			}
		}();
		var _v0 = function () {
			var _v1 = userProfile.V;
			switch (_v1) {
				case 0:
					var jobPosterAvatar = (notification.hF === '') ? '/default_user.png' : notification.hF;
					return _Utils_Tuple2(jobPosterAvatar, notification.hH);
				case 1:
					var talentAvatar = (notification.jc === '') ? '/default_user.png' : notification.jc;
					return _Utils_Tuple2(notification.jc, notification.jf);
				default:
					return _Utils_Tuple2('/default_user.png', '');
			}
		}();
		var avatar = _v0.a;
		var name = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('notification-item-container', true),
							_Utils_Tuple2('notification-container-dimmed', notification.hE)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('notification-sender-info-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('avatar-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(avatar)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('notification-time-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(notification.fY)
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										]))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('new-notification-icon', true),
											_Utils_Tuple2('hide-new-icon', notification.hE)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('New!')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('notification-info-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($author$project$Views$Nav$notificationText, notification, userProfile))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('notification-body-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(bodyText)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('see-more-button'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Views$Nav$notificationAction, notification, userProfile))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('SEE MORE')
						]))
				]));
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Views$Nav$notificationList = function (userProfile) {
	return (!$elm$core$List$length(userProfile.bU)) ? A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('empty-notifications')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('No Notifications')
					]))
			])) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('notification-list')
			]),
		A2(
			$elm$core$List$map,
			function (notification) {
				return A2($author$project$Views$Nav$notificationItem, notification, userProfile);
			},
			userProfile.bU));
};
var $author$project$Views$Nav$notificationsModal = F2(
	function (newNotifications, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('right')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('notifications')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('notifications'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleNotifications)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification-text envelope')
										]),
									_List_fromArray(
										[
											$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$bell)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification-text notifications')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Notifications')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('notification-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(
												$elm$core$List$length(newNotifications)))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('notification-container', true),
											_Utils_Tuple2('notifications-open', model.by)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'showing-no-new',
													!$elm$core$List$length(newNotifications)),
													_Utils_Tuple2('no-new-notifications', true)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('No New Notifications')
										])),
									$author$project$Views$Nav$notificationList(model.E),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('mark-as-read-button'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$MarkAllNotificationsAsRead(newNotifications))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Mark All As Read')
										]))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
							$elm$html$Html$Attributes$class('show-menu'),
							$elm$html$Html$Attributes$id('hamburger')
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$bars)
						])),
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
							$elm$html$Html$Attributes$class('show-menu menu-text button'),
							$elm$html$Html$Attributes$id('menu-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Menu')
						]))
				]));
	});
var $author$project$Views$Nav$pageTitle = function (model) {
	var _v0 = model.o;
	switch (_v0.$) {
		case 6:
			return 'Account';
		case 13:
			return 'Dashboard';
		case 14:
			return 'Profile';
		case 10:
			return 'Inbox';
		case 20:
			return 'Talent Search';
		case 21:
			return 'Projects';
		case 19:
			var s = _v0.a;
			return 'Account';
		case 12:
			return 'Roles';
		case 11:
			return 'Roles';
		case 22:
			var id = _v0.a;
			var code = _v0.b;
			return 'Account Verification';
		case 7:
			return 'Job Listing Details';
		case 8:
			return 'Discover Jobs';
		case 9:
			return 'My Jobs';
		case 23:
			return 'Schedules';
		case 24:
			return 'Schedules';
		default:
			return '';
	}
};
var $author$project$Views$Nav$showAgencyMenu = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu', true),
						_Utils_Tuple2('menu-open', model.a6)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Menu')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
								$elm$html$Html$Attributes$class('close-menu')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ｘ')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Dashboard))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dashboard')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$AgencyProfile))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$TalentSearch))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Talent Search')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Views$Nav$showAgentMenu = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu', true),
						_Utils_Tuple2('menu-open', model.a6)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Menu')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
								$elm$html$Html$Attributes$class('close-menu')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ｘ')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Dashboard))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dashboard')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$AgentProfile))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$TalentSearch))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Talent Search')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$SharedProjectRoleSchedules$firstBasicProject = function (allProjects) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
		$elm$core$List$head(allProjects));
};
var $author$project$Views$Nav$showDirectorMenu = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu', true),
						_Utils_Tuple2('menu-open', model.a6)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Menu')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
								$elm$html$Html$Attributes$class('close-menu')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ｘ')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Dashboard))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dashboard')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Account))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$TalentSearch))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Talent Search')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View(
									$author$project$Route$Project(
										$author$project$SharedProjectRoleSchedules$firstBasicProject(model.g3.fh).aa)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Projects')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$ScheduleIndex))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Schedules')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Inbox))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Inbox')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$Views$Nav$showTalentMenu = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('menu', true),
						_Utils_Tuple2('menu-open', model.a6)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h1,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Menu')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleMenu),
								$elm$html$Html$Attributes$class('close-menu')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('ｘ')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Dashboard))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Dashboard')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$Account))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Profile')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View(
									$author$project$Route$Job('1')))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Discover Jobs')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$View($author$project$Route$MyJobs))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('My Jobs')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Logout')
							]))
					]))
			]));
};
var $author$project$MainMsg$ViewProfileSubPage = function (a) {
	return {$: 22, a: a};
};
var $author$project$Views$Nav$pageSubTitle = function (page) {
	return 'Profile Info';
};
var $author$project$Views$Nav$subNavBarItem = F2(
	function (currentPage, page) {
		return A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ViewProfileSubPage(page)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'highlight',
							_Utils_eq(
								currentPage,
								$author$project$Route$ProfileSubPage(page)))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Views$Nav$pageSubTitle(page))
				]));
	});
var $author$project$Views$Nav$subNavBarItems = function (currentPage) {
	var item = $author$project$Views$Nav$subNavBarItem(currentPage);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('account-sub-nav')
			]),
		_List_fromArray(
			[
				item(0)
			]));
};
var $author$project$Views$Nav$subNavBar = function (model) {
	var _v0 = model.o;
	if (_v0.$ === 19) {
		return $author$project$Views$Nav$subNavBarItems(model.o);
	} else {
		return $author$project$Views$Nav$nothing;
	}
};
var $author$project$Views$Nav$navBar = function (model) {
	var newNotifications = A2(
		$elm$core$List$filter,
		function (notification) {
			return !notification.hE;
		},
		model.E.bU);
	var notifications = function () {
		var _v1 = model.E.V;
		if (_v1 === 2) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collaborator-logout'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$Logout)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('logout')
					]));
		} else {
			return A2($author$project$Views$Nav$notificationsModal, newNotifications, model);
		}
	}();
	var menu = function () {
		var _v0 = model.E.V;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Nav$showTalentMenu(model)
						]));
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Nav$showDirectorMenu(model)
						]));
			case 3:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Nav$showAgencyMenu(model)
						]));
			case 4:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$Nav$showAgentMenu(model)
						]));
			default:
				return $author$project$Views$Nav$nothing;
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$nav,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('nav-menu')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('main-nav')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('logo-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('logo-link'),
												$elm$html$Html$Attributes$href('/dashboard')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('logo')
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$h1,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Views$Nav$pageTitle(model))
											]))
									])),
								notifications,
								$author$project$Views$Nav$subNavBar(model)
							])),
						menu,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('clip')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('invisible-modal', true),
										_Utils_Tuple2('showing-invisible-modal', model.by || model.a6)
									])),
								$elm$html$Html$Events$onClick($author$project$MainMsg$CloseAllMenus)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$MainMsg$DeleteImage = function (a) {
	return {$: 135, a: a};
};
var $author$project$MainMsg$ToggleDeleteConfirmation = F2(
	function (a, b) {
		return {$: 83, a: a, b: b};
	});
var $author$project$MainMsg$DeleteAgent = function (a) {
	return {$: 104, a: a};
};
var $author$project$MainMsg$ToggleAddAgentForm = function (a) {
	return {$: 109, a: a};
};
var $author$project$MainMsg$AddAgent = {$: 103};
var $author$project$User$CurrentAgentCity = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$CurrentAgentFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$CurrentAgentLastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$UpdateAgentInfoMsg = function (a) {
	return {$: 110, a: a};
};
var $author$project$User$CurrentAgentEmail = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Views$Profile$agentEmailField = function (profilePageData) {
	return (profilePageData.bL.aa === '') ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Agent Email')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgentInfoMsg, $author$project$User$CurrentAgentEmail)),
						$elm$html$Html$Attributes$value(profilePageData.bL.bv),
						$elm$html$Html$Attributes$placeholder('Agent Email')
					]),
				_List_Nil)
			])) : A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(profilePageData.bL.bv)
			]));
};
var $author$project$Views$Profile$agentSubmitText = function (agent) {
	return (agent.aa !== '') ? 'Update Agent' : 'Add Agent';
};
var $author$project$Views$Profile$addAgentForm = function (profilePageData) {
	return profilePageData.b6 ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('add-agent-form')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Agent First Name')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgentInfoMsg, $author$project$User$CurrentAgentFirstName)),
						$elm$html$Html$Attributes$value(profilePageData.bL.bx),
						$elm$html$Html$Attributes$placeholder('Agent First Name')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Agent Last Name')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgentInfoMsg, $author$project$User$CurrentAgentLastName)),
						$elm$html$Html$Attributes$value(profilePageData.bL.bP),
						$elm$html$Html$Attributes$placeholder('Agent Last Name')
					]),
				_List_Nil),
				$author$project$Views$Profile$agentEmailField(profilePageData),
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('Agent City')
					])),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgentInfoMsg, $author$project$User$CurrentAgentCity)),
						$elm$html$Html$Attributes$value(profilePageData.bL.a0),
						$elm$html$Html$Attributes$placeholder('Agent City')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('close-agent-form'),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$ToggleAddAgentForm(''))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('submit-agent-button'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$AddAgent)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Views$Profile$agentSubmitText(profilePageData.bL))
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Profile$deleteAgentButton = function (agent) {
	var _v0 = agent.hK;
	if (_v0 === 4) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$ToggleDeleteConfirmation, agent.aa, ''))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Delete')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Views$Profile$agentItem = function (agent) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-image-info-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('agent-image-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(agent.ey)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('agent-info')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(agent.bx + (' ' + agent.bP))
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(agent.a0)
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-action-items')
					]),
				_List_fromArray(
					[
						$author$project$Views$Profile$deleteAgentButton(agent),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleAddAgentForm(agent.aa))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit')
							]))
					]))
			]));
};
var $author$project$Views$Profile$agentList = function (agents) {
	return (!$elm$core$List$length(agents)) ? A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('There are no agents assocated with this agency.'),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$ToggleAddAgentForm('123'))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('ADD AGENT')
					]))
			])) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-list')
			]),
		A2($elm$core$List$map, $author$project$Views$Profile$agentItem, agents));
};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$Views$Confirmations$deleteConfirmation = F4(
	function (showConfirmation, deleteMessage, toggleMessage, deleteText) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal', true),
									_Utils_Tuple2('modal-open', showConfirmation)
								])),
							$elm$html$Html$Events$onClick(toggleMessage)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('delete-confirmation', true),
									_Utils_Tuple2('delete-showing', showConfirmation)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(deleteText)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick(deleteMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick(toggleMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No')
								]))
						]))
				]));
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Views$Profile$agencyAgents = F4(
	function (agents, profilePageData, showDeleteConfirmation, deleteID) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('agents-container')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$Views$Confirmations$deleteConfirmation,
					showDeleteConfirmation,
					$author$project$MainMsg$DeleteAgent(deleteID),
					A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
					'Are you sure you want to delete this agent?'),
					A2(
					$elm$html$Html$h4,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Agents')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$ToggleAddAgentForm('123'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('ADD AGENT')
						])),
					$author$project$Views$Profile$agentList(agents),
					$author$project$Views$Profile$addAgentForm(profilePageData)
				]));
	});
var $author$project$User$AuditionNotification = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$MessageNotification = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$ProfileNotification = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$ProjectNotification = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$TalentNotification = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$UpdateNotificationSettings = function (a) {
	return {$: 106, a: a};
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Events$targetChecked = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'checked']),
	$elm$json$Json$Decode$bool);
var $elm$html$Html$Events$onCheck = function (tagger) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetChecked));
};
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Views$Profile$agencyNotificationSettings = function (notificationSettings) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-profile-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Please select the notifcations you would like to receive from Slayt. Please keep in mind you can come back and change these notfications at any time.')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.aj),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$ProjectNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project Emails')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You will receive an email whenever a new project is posted.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.jb),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$TalentNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Talent Bookings')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You will receive an email notifiying you that any of your registered talent have booking requests.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.gw),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$AuditionNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Audition Notifications')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You will receive an email when talent receives audition/callback requests.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.is),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$ProfileNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Talent Profile Updates')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Whenever a talent changes their profile, which includes images, agency representation, sizes or videos, you will receive a notification.')
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification-selection-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$type_('checkbox'),
										$elm$html$Html$Attributes$checked(notificationSettings.hV),
										$elm$html$Html$Events$onCheck(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateNotificationSettings, $author$project$User$MessageNotification))
									]),
								_List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('selection-title')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('In App Messages')
											])),
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('selection-sub-text')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You will be cc\'d on all communication through our in app messaging service.')
											]))
									]))
							]))
					]))
			]));
};
var $author$project$User$AgencyName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$AgentAddress1 = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$AgentAddress2 = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$AgentCity = function (a) {
	return {$: 7, a: a};
};
var $author$project$User$AgentState = function (a) {
	return {$: 8, a: a};
};
var $author$project$User$AgentZip = function (a) {
	return {$: 9, a: a};
};
var $author$project$User$ProfileAgency = function (a) {
	return {$: 16, a: a};
};
var $author$project$MainMsg$UserProfileMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Profile$agencyProfileAttributes = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-profile-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgencyName(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gj.cF),
										$elm$html$Html$Attributes$placeholder('Agency Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Email')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(userProfile.bv)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency Address')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentAddress1(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gj.bF),
										$elm$html$Html$Attributes$placeholder('Address')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency Address Line 2')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentAddress2(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gj.bG),
										$elm$html$Html$Attributes$placeholder('Address Line 2')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency City')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentCity(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gj.a0),
										$elm$html$Html$Attributes$placeholder('City')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency State')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentState(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gj.bf),
										$elm$html$Html$Attributes$placeholder('State')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Agency Zipcode')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										function (input) {
											return $author$project$MainMsg$UserProfileMsg(
												$author$project$User$ProfileAgency(
													$author$project$User$AgentZip(input)));
										}),
										$elm$html$Html$Attributes$value(userProfile.gj.dv),
										$elm$html$Html$Attributes$placeholder('Zip Code')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $elm$html$Html$form = _VirtualDom_node('form');
var $author$project$MainMsg$OpenCropper = function (a) {
	return {$: 253, a: a};
};
var $author$project$MainMsg$ImageRequested = function (a) {
	return {$: 114, a: a};
};
var $author$project$SharedProjectRoleSchedules$ReplaceFile = 0;
var $author$project$Views$Profile$replaceImageText = F2(
	function (image, images) {
		return ($elm$core$List$length(images) > 1) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$ToggleDeleteConfirmation, image.aa, ''))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Remove image')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image-upload-button'),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ImageRequested(0))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Replace image')
				]));
	});
var $author$project$Views$Profile$imageItem = F2(
	function (image, images) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(image.js)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image-options')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$Profile$replaceImageText, image, images),
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-crop-alt crop-image'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$OpenCropper(image.aa))
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$MainMsg$CloseResizingModal = {$: 254};
var $author$project$Views$Profile$imageResizeWindow = F2(
	function (resizing, image) {
		return resizing ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image-resizing-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('resizing-modal'),
							$elm$html$Html$Events$onClick($author$project$MainMsg$CloseResizingModal)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('resizing-inner-window')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-to-resize')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('overlay')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('overlay-inner')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resize-image'),
											$elm$html$Html$Attributes$src(image.js)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('crop-pro-tip')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Pro Tip: Hold down shift to preserve aspect ratio')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('cancel-button'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$CloseResizingModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('btn-crop js-crop')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Crop Image')
								]))
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$MainMsg$Cancel = {$: 130};
var $author$project$MainMsg$DragFileEnter = {$: 256};
var $author$project$MainMsg$DragFileLeave = {$: 257};
var $author$project$SharedProjectRoleSchedules$NewFile = 1;
var $elm$core$Basics$round = _Basics_round;
var $author$project$Utils$createPercent = function (fraction) {
	return $elm$core$String$fromInt(
		$elm$core$Basics$round(100 * fraction));
};
var $author$project$MainMsg$GotFiles = F2(
	function (a, b) {
		return {$: 124, a: a, b: b};
	});
var $elm$file$File$decoder = _File_decoder;
var $elm$json$Json$Decode$oneOrMoreHelp = F2(
	function (toValue, xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$fail('a ARRAY with at least ONE element');
		} else {
			var y = xs.a;
			var ys = xs.b;
			return $elm$json$Json$Decode$succeed(
				A2(toValue, y, ys));
		}
	});
var $elm$json$Json$Decode$oneOrMore = F2(
	function (toValue, decoder) {
		return A2(
			$elm$json$Json$Decode$andThen,
			$elm$json$Json$Decode$oneOrMoreHelp(toValue),
			$elm$json$Json$Decode$list(decoder));
	});
var $author$project$Views$Profile$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2($elm$json$Json$Decode$oneOrMore, $author$project$MainMsg$GotFiles, $elm$file$File$decoder));
var $author$project$Views$Profile$hijack = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$Views$Profile$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Views$Profile$hijack, decoder));
	});
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $elm$html$Html$progress = _VirtualDom_node('progress');
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$Views$Profile$uploadGallery = F2(
	function (imageUpload, images) {
		switch (imageUpload.$) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image-upload-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-upload-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Upload Image')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('upload-drop-zone'),
									A2(
									$author$project$Views$Profile$hijackOn,
									'dragenter',
									$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileEnter)),
									A2(
									$author$project$Views$Profile$hijackOn,
									'dragover',
									$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileEnter)),
									A2(
									$author$project$Views$Profile$hijackOn,
									'dragleave',
									$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileLeave)),
									A2($author$project$Views$Profile$hijackOn, 'drop', $author$project$Views$Profile$dropDecoder)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Drag a photo here')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Or')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image-upload-button'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$ImageRequested(1))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Select Photos')
										]))
								]))
						]));
			case 1:
				var fraction = imageUpload.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$progress,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$value(
									$author$project$Utils$createPercent(fraction)),
									$elm$html$Html$Attributes$max('100'),
									A2($elm$html$Html$Attributes$style, 'display', 'block')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$MainMsg$Cancel)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-upload-button-disabled')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Upload Image')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('upload-button-message')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('(max reached)')
								]))
						]));
			default:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$ImageRequested(1))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Image Upload Failed!')
						]));
		}
	});
var $author$project$Views$Profile$agencyQuestionsSection = function (model) {
	var _v0 = model.h.d5;
	switch (_v0) {
		case 0:
			return $author$project$Views$Profile$agencyProfileAttributes(model.E);
		case 1:
			return $author$project$Views$Profile$agencyNotificationSettings(model.E.ic);
		case 2:
			return A4($author$project$Views$Profile$agencyAgents, model.E.gj.gp, model.h, model.ad, model.as);
		case 3:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-view-page')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-container')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Views$Confirmations$deleteConfirmation,
								model.ad,
								$author$project$MainMsg$DeleteImage(model.as),
								A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
								'Are you sure you want to remove this image?'),
								A2($author$project$Views$Profile$imageResizeWindow, model.aA, model.aE),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form main-form')
									]),
								_List_fromArray(
									[
										A2($author$project$Views$Profile$uploadGallery, model.ab, model.l),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-preview-gallery')
											]),
										A2(
											$elm$core$List$map,
											function (image) {
												return A2($author$project$Views$Profile$imageItem, image, model.l);
											},
											model.l))
									]))
							]))
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$MainMsg$UpdateProfileInfo = {$: 41};
var $author$project$Views$Profile$nextButton = F2(
	function (currentPageIndex, pageCount) {
		return (_Utils_cmp(currentPageIndex + 1, pageCount) < 0) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$GoToPage(currentPageIndex + 1))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('next-button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Next'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateProfileInfo)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('next-button save-exit-next')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Save and Exit'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Views$Profile$agentAgencyProfileFooter = F2(
	function (currentPageIndex, pageCount) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('profile-page-footer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pro-tip-footer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						])),
					A2($author$project$Views$Profile$nextButton, currentPageIndex, pageCount)
				]));
	});
var $author$project$MainMsg$ToggleProfilePageNav = {$: 296};
var $elm_community$list_extra$List$Extra$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$findIndex = $elm_community$list_extra$List$Extra$findIndexHelp(0);
var $elm_community$list_extra$List$Extra$elemIndex = function (x) {
	return $elm_community$list_extra$List$Extra$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Views$Profile$profilePageSelection = F3(
	function (page, activePage, pages) {
		var pageIndex = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm_community$list_extra$List$Extra$elemIndex,
				page,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.x;
					},
					pages)));
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$GoToPage(pageIndex)),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('profile-page-option', true),
							_Utils_Tuple2(
							'active',
							_Utils_eq(page, activePage))
						]))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(page)
				]));
	});
var $author$project$Views$Profile$talentProfileHeader = F4(
	function (pages, activePage, currentPageIndex, navOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('profile-header-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$GoToPage(currentPageIndex - 1))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-left')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Back')
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selected-profile-page'),
							$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleProfilePageNav)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(activePage.x),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('fas fa-chevron-down', !navOpen),
											_Utils_Tuple2('fas fa-chevron-up', navOpen)
										]))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('profile-page-selection', true),
									_Utils_Tuple2('nav-open', navOpen)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (page) {
							return A3($author$project$Views$Profile$profilePageSelection, page.x, activePage.x, pages);
						},
						pages)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('profile-next-button'),
							$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateProfileInfo)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('EXIT')
						]))
				]));
	});
var $author$project$Views$Profile$agencyProfileView = function (model) {
	var _v0 = model.h.E;
	switch (_v0.$) {
		case 1:
			return $elm$html$Html$text('');
		case 2:
			return $elm$html$Html$text('');
		case 0:
			return $elm$html$Html$text('');
		default:
			var profile = _v0.a;
			var pageArray = $elm$core$Array$fromList(profile.ct);
			var activePage = A2(
				$elm$core$Maybe$withDefault,
				$author$project$User$emptyProfilePage,
				A2($elm$core$Array$get, model.h.d5, pageArray));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('profile-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('profile-container')
							]),
						_List_fromArray(
							[
								A4($author$project$Views$Profile$talentProfileHeader, profile.ct, activePage, model.h.d5, model.h.de),
								$author$project$Views$Profile$agencyQuestionsSection(model),
								A2(
								$author$project$Views$Profile$agentAgencyProfileFooter,
								model.h.d5,
								$elm$core$List$length(profile.ct))
							]))
					]));
	}
};
var $author$project$MainMsg$RegisterAgency = {$: 5};
var $author$project$User$AgencyPassword = function (a) {
	return {$: 10, a: a};
};
var $author$project$User$AgencyPasswordConfirmation = function (a) {
	return {$: 11, a: a};
};
var $author$project$User$AgentEmail = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$AgentFirstName = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$AgentLastName = function (a) {
	return {$: 2, a: a};
};
var $author$project$MainMsg$UpdateAgencyMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Auth$agencySignupForm = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgencyName)),
									$elm$html$Html$Attributes$placeholder('Agency Name')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentFirstName)),
									$elm$html$Html$Attributes$placeholder('Account owners First Name')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentLastName)),
									$elm$html$Html$Attributes$placeholder('Account owners Last Name')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentEmail)),
									$elm$html$Html$Attributes$placeholder('Account owners Email')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentAddress1)),
									$elm$html$Html$Attributes$placeholder('Address')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentAddress2)),
									$elm$html$Html$Attributes$placeholder('Address Line 2')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentCity)),
									$elm$html$Html$Attributes$placeholder('City')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentState)),
									$elm$html$Html$Attributes$placeholder('State')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgentZip)),
									$elm$html$Html$Attributes$placeholder('Zip Code')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgencyPassword)),
									$elm$html$Html$Attributes$placeholder('Password'),
									$elm$html$Html$Attributes$type_('password')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateAgencyMsg, $author$project$User$AgencyPasswordConfirmation)),
									$elm$html$Html$Attributes$placeholder('Confirm Password'),
									$elm$html$Html$Attributes$type_('password')
								]),
							_List_Nil)
						]))
				]))
		]));
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Views$Auth$errorMessage = function (error) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('error-message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Views$Auth$logoImage = function (logoPath) {
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src(logoPath),
				$elm$html$Html$Attributes$class('logo-primary')
			]),
		_List_Nil);
};
var $author$project$Views$Auth$agencySignupView = F3(
	function (err, email, logoPath) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Agency Sign Up')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$agencySignupForm,
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterAgency),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('NEXT')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-switch-container')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Already have an account?'),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$Login)),
											$elm$html$Html$Attributes$class('link-button signup-switch')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Login »')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sign-up-options')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$DirectorRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Casting Director Sign-Up »')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$TalentRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Talent Sign-Up »')
										]))
								]))
						]))
				]));
	});
var $author$project$User$ProfileFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$ProfileLastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$ProfilePhoneNumber = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Profile$agentProfileAttributes = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-profile-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('First Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileFirstName)),
										$elm$html$Html$Attributes$value(userProfile.bx),
										$elm$html$Html$Attributes$placeholder('First Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Last Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileLastName)),
										$elm$html$Html$Attributes$value(userProfile.bP),
										$elm$html$Html$Attributes$placeholder('Last Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Email')
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(userProfile.bv)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Phone Number')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfilePhoneNumber)),
										$elm$html$Html$Attributes$value(userProfile.e0),
										$elm$html$Html$Attributes$placeholder('Phone Number')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Views$Profile$agentQuestionsSection = function (model) {
	var _v0 = model.h.d5;
	switch (_v0) {
		case 0:
			return $author$project$Views$Profile$agentProfileAttributes(model.E);
		case 1:
			return $author$project$Views$Profile$agencyNotificationSettings(model.E.ic);
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-view-page')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-container')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Views$Confirmations$deleteConfirmation,
								model.ad,
								$author$project$MainMsg$DeleteImage(model.as),
								A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
								'Are you sure you want to remove this image?'),
								A2($author$project$Views$Profile$imageResizeWindow, model.aA, model.aE),
								A2(
								$elm$html$Html$form,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form main-form')
									]),
								_List_fromArray(
									[
										A2($author$project$Views$Profile$uploadGallery, model.ab, model.l),
										A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('image-preview-gallery')
											]),
										A2(
											$elm$core$List$map,
											function (image) {
												return A2($author$project$Views$Profile$imageItem, image, model.l);
											},
											model.l))
									]))
							]))
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Views$Profile$agentProfileView = function (model) {
	var _v0 = model.h.E;
	switch (_v0.$) {
		case 1:
			return $elm$html$Html$text('');
		case 2:
			return $elm$html$Html$text('');
		case 0:
			return $elm$html$Html$text('');
		default:
			var profile = _v0.a;
			var pageArray = $elm$core$Array$fromList(profile.ct);
			var activePage = A2(
				$elm$core$Maybe$withDefault,
				$author$project$User$emptyProfilePage,
				A2($elm$core$Array$get, model.h.d5, pageArray));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('profile-wrapper')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('profile-container')
							]),
						_List_fromArray(
							[
								A4($author$project$Views$Profile$talentProfileHeader, profile.ct, activePage, model.h.d5, model.h.de),
								$author$project$Views$Profile$agentQuestionsSection(model),
								A2(
								$author$project$Views$Profile$agentAgencyProfileFooter,
								model.h.d5,
								$elm$core$List$length(profile.ct))
							]))
					]));
	}
};
var $author$project$MainMsg$RegisterUser = {$: 19};
var $author$project$User$Company = function (a) {
	return {$: 6, a: a};
};
var $author$project$MainMsg$UpdateUserMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$User$UserFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$UserLastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$UserPassword = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$UserPasswordConfirmation = function (a) {
	return {$: 4, a: a};
};
var $author$project$Views$Auth$agentsSignupForm = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bx),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserFirstName)),
										$elm$html$Html$Attributes$placeholder('First Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bP),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserLastName)),
										$elm$html$Html$Attributes$placeholder('Last Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bv),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserEmail)),
										$elm$html$Html$Attributes$placeholder('Email')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.cK),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$Company)),
										$elm$html$Html$Attributes$placeholder('Company Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPassword)),
										$elm$html$Html$Attributes$placeholder('Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPasswordConfirmation)),
										$elm$html$Html$Attributes$placeholder('Confirm Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$MainMsg$DirectorConfirmationRedirect = {$: 20};
var $author$project$Views$Auth$showSignUpConfirmationModal = function (isOpen) {
	if (isOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('director-signup-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick($author$project$MainMsg$DirectorConfirmationRedirect),
							$elm$html$Html$Attributes$class('close')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('X')
						])),
					A2(
					$elm$html$Html$h3,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirmation-modal-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Thanks for signing up!')
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('confirmation-modal-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(' Thanks for signing up with Talent Source! Please check your email to confirm your registration.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$View($author$project$Route$Login))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('return to login page.')
						])),
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href('/talent-search'),
							$elm$html$Html$Attributes$class('temp-access-link')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('** Access Director Portal **')
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Auth$agentsSignupView = F4(
	function (isOpen, userProfile, logoPath, err) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Agents Signup')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$agentsSignupForm(userProfile),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterUser),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Create Account')
												]))
										]))
								])),
							$author$project$Views$Auth$showSignUpConfirmationModal(isOpen)
						]))
				]));
	});
var $author$project$Views$Auth$collaboratorsSignupForm = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bx),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserFirstName)),
										$elm$html$Html$Attributes$placeholder('First Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bP),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserLastName)),
										$elm$html$Html$Attributes$placeholder('Last Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.bv),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserEmail)),
										$elm$html$Html$Attributes$placeholder('Email')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(userProfile.cK),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$Company)),
										$elm$html$Html$Attributes$placeholder('Company Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPassword)),
										$elm$html$Html$Attributes$placeholder('Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPasswordConfirmation)),
										$elm$html$Html$Attributes$placeholder('Confirm Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Views$Auth$collaboratorsSignupView = F4(
	function (isOpen, userProfile, logoPath, err) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Collaborator Signup')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$collaboratorsSignupForm(userProfile),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterUser),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Create Account')
												]))
										]))
								])),
							$author$project$Views$Auth$showSignUpConfirmationModal(isOpen)
						]))
				]));
	});
var $author$project$MainMsg$UpdateTalentMembership = F2(
	function (a, b) {
		return {$: 317, a: a, b: b};
	});
var $author$project$Views$Dashboard$agentImageWidget = function (profile) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-profile-info-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$User$emptyImage,
							$elm$core$List$head(profile.l)).js)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(profile.bx + (' ' + profile.bP))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(profile.gj.cF)
							]))
					]))
			]));
};
var $author$project$MainMsg$FindJob = function (a) {
	return {$: 55, a: a};
};
var $author$project$Views$Dashboard$agentProjectLi = function (project) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href('/discover-jobs/' + project.aa),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$FindJob(project.aa))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(project.bS)
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(project.e4)
							]))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'(' + ($elm$core$String$fromInt(
							$elm$core$List$length(project.ft)) + ' Roles)'))
					]))
			]));
};
var $author$project$Views$Dashboard$agentProjectsWidget = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-projects-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-widget-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Open Projects')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-projects-list')
					]),
				A2($elm$core$List$map, $author$project$Views$Dashboard$agentProjectLi, model.g3.fh))
			]));
};
var $author$project$Views$Schedule$getVoteTotal = F2(
	function (votes, vote) {
		return $elm$core$String$fromInt(
			$elm$core$List$length(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.f5;
						},
						vote),
					votes)));
	});
var $frandibar$elm_font_awesome_5$FontAwesome$calendarTimes = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('calendar-times');
var $frandibar$elm_font_awesome_5$FontAwesome$check = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('check');
var $frandibar$elm_font_awesome_5$FontAwesome$hourglassStart = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('hourglass-start');
var $author$project$Views$Schedule$statusHoverText = F2(
	function (scheduleMembers, scheduleType) {
		var scheduleMember = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fB;
						},
						scheduleType),
					scheduleMembers)));
		var _v0 = scheduleMember.dj;
		switch (_v0) {
			case 6:
				return _Utils_Tuple2('Accepted Audition Request', '');
			case 7:
				return _Utils_Tuple2('Rejected Audition', scheduleMember.dP);
			case 8:
				return _Utils_Tuple2('Requested to be rescheduled', scheduleMember.dP);
			case 9:
				return _Utils_Tuple2('Pending response from user', '');
			case 5:
				return _Utils_Tuple2('Pending response from user', '');
			case 12:
				return _Utils_Tuple2('Accepted Callback Request', '');
			case 13:
				return _Utils_Tuple2('Rejected Callback', scheduleMember.dP);
			case 14:
				return _Utils_Tuple2('Requested to be rescheduled for callback', scheduleMember.dP);
			case 15:
				return _Utils_Tuple2('Pending response from user', '');
			case 11:
				return _Utils_Tuple2('Pending response from user', '');
			default:
				return _Utils_Tuple2('', '');
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$times = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('times');
var $author$project$Views$Schedule$timeSlotStatus = F2(
	function (user, scheduleType) {
		var scheduleMember = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fB;
						},
						scheduleType),
					user.fA)));
		var scheduleStatus = function () {
			var _v1 = scheduleMember.dj;
			switch (_v1) {
				case 5:
					return {cC: '', e$: 'active', ak: '', al: ''};
				case 11:
					return {cC: '', e$: 'active', ak: '', al: ''};
				case 6:
					return {cC: 'active', e$: '', ak: '', al: ''};
				case 7:
					return {cC: '', e$: '', ak: 'active', al: ''};
				case 8:
					return {cC: '', e$: '', ak: '', al: 'active'};
				case 12:
					return {cC: 'active', e$: '', ak: '', al: ''};
				case 13:
					return {cC: '', e$: '', ak: 'active', al: ''};
				case 14:
					return {cC: '', e$: '', ak: '', al: 'active'};
				case 9:
					return {cC: '', e$: 'active', ak: '', al: ''};
				case 15:
					return {cC: '', e$: 'active', ak: '', al: ''};
				default:
					return {cC: '', e$: '', ak: '', al: ''};
			}
		}();
		var _v0 = A2($author$project$Views$Schedule$statusHoverText, user.fA, scheduleType);
		var statusText = _v0.a;
		var statusReason = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('day-of-status')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('accepted-schedule-icon ' + scheduleStatus.cC)
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$check)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('rejected-schedule-icon ' + scheduleStatus.ak)
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$times)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pending-icon ' + scheduleStatus.e$)
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$hourglassStart)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('reschedule-icon ' + scheduleStatus.al)
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$calendarTimes)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('status-verbiage')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('schedule-status-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(statusText)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('status-body-text')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(statusReason)
								]))
						]))
				]));
	});
var $author$project$Views$Schedule$dashboardDayOfScheduleTimeSlot = F2(
	function (timeSlot, scheduleType) {
		var yes = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f6, 'yes');
		var no = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f6, 'no');
		var maybe = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f6, 'maybe');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('day-of-schedule-item-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$User$emptyImage,
										$elm$core$List$head(timeSlot.f_.l)).js)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('user-name-role-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timeSlot.f_.bx + (' ' + timeSlot.f_.bP))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('role')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timeSlot.f_.V.bS)
										]))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(scheduleType)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(timeSlot.eq)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$Schedule$timeSlotStatus, timeSlot.f_, scheduleType)
						]))
				]));
	});
var $author$project$Views$Dashboard$agentScheduleInfo = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dashboard-time-slots')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-talent-schedules')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Schedules')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
					]),
				A2(
					$elm$core$List$map,
					function (timeSlot) {
						return A2($author$project$Views$Schedule$dashboardDayOfScheduleTimeSlot, timeSlot, timeSlot.fB);
					},
					A2(
						$elm$core$List$filter,
						function (timeSlot) {
							return timeSlot.f_.c$ !== '';
						},
						model.g3.jl)))
			]));
};
var $author$project$Views$Dashboard$acceptedStatusButton = function (talent) {
	var _v0 = talent.cC;
	switch (_v0) {
		case 0:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('accepted-icon')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Accepted')
					]));
		case 1:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('rejected-icon')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Rejected')
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('pending-icons')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('accept-membership-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$ToggleDeleteConfirmation, 'Accepted', talent.hS))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Accept')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('reject-membership-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$ToggleDeleteConfirmation, 'Rejected', talent.hS))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Reject')
							]))
					]));
	}
};
var $author$project$Views$Dashboard$talentLi = function (talent) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('talent-user-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-image-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(talent.ir)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(talent.bS)
							]))
					])),
				$author$project$Views$Dashboard$acceptedStatusButton(talent)
			]));
};
var $author$project$Views$Dashboard$agentTalentWidget = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agent-talent-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-widget-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('My Talent')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-talent-list')
					]),
				A2($elm$core$List$map, $author$project$Views$Dashboard$talentLi, model.g3.jb))
			]));
};
var $author$project$Views$Dashboard$agencyWidgets = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('widget')
			]),
		_List_fromArray(
			[
				$author$project$Views$Dashboard$agentImageWidget(model.E),
				$author$project$Views$Dashboard$agentProjectsWidget(model),
				$author$project$Views$Dashboard$agentTalentWidget(model),
				$author$project$Views$Dashboard$agentScheduleInfo(model),
				A4(
				$author$project$Views$Confirmations$deleteConfirmation,
				model.ad,
				A2($author$project$MainMsg$UpdateTalentMembership, model.as, model.d8),
				A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
				'Are you sure you want to respond with ' + (model.as + ' for this talent?'))
			]));
};
var $elm$html$Html$b = _VirtualDom_node('b');
var $author$project$Project$AcceptInvitation = 0;
var $author$project$MainMsg$OpenDayOfPage = F2(
	function (a, b) {
		return {$: 271, a: a, b: b};
	});
var $author$project$Project$RejectInvitation = 1;
var $author$project$MainMsg$UpdateInvitationStatus = F2(
	function (a, b) {
		return {$: 274, a: a, b: b};
	});
var $author$project$Views$Project$collaboratingProjectLink = function (project) {
	return project.cC ? A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A2($author$project$MainMsg$OpenDayOfPage, project.aa, project.fC))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(project.bS)
			])) : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collab-project-link')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(project.bS)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collab-action-buttons'),
						$elm$html$Html$Events$onClick(
						A2($author$project$MainMsg$UpdateInvitationStatus, 0, project.aa))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('ACCEPT INVITATION')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collab-action-buttons'),
						$elm$html$Html$Events$onClick(
						A2($author$project$MainMsg$UpdateInvitationStatus, 1, project.aa))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('REJECT INVITATION')
					]))
			]));
};
var $author$project$Views$Dashboard$collaboratingProjectList = function (model) {
	return A2(
		$elm$core$List$map,
		function (project) {
			return $author$project$Views$Project$collaboratingProjectLink(project);
		},
		model.dW);
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Views$Dashboard$collaboratorWidgets = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('widget')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('header-and-body')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$b,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('title')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Collaborating Projects')
									]))
							])),
						A2($elm$html$Html$hr, _List_Nil, _List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('collaborator-body')
							]),
						$author$project$Views$Dashboard$collaboratingProjectList(model))
					]))
			]));
};
var $author$project$Project$CreateProjectForm = 0;
var $author$project$Views$Dashboard$directorLinks = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$ToggleFormOpen(0))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Create Project')
			]))
	]);
var $author$project$Views$ModalOverlay$modal = F2(
	function (toggleMsg, open) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal', true),
							_Utils_Tuple2('modal-open', open)
						])),
					$elm$html$Html$Events$onClick(toggleMsg)
				]),
			_List_Nil);
	});
var $author$project$Project$AuditionLocation = function (a) {
	return {$: 11, a: a};
};
var $author$project$Project$CallbackLocation = function (a) {
	return {$: 14, a: a};
};
var $author$project$Project$NonUnion = function (a) {
	return {$: 21, a: a};
};
var $author$project$Project$NotesAgent = function (a) {
	return {$: 17, a: a};
};
var $author$project$Project$NotesTalent = function (a) {
	return {$: 18, a: a};
};
var $author$project$Project$ProjectDescription = function (a) {
	return {$: 16, a: a};
};
var $author$project$Project$ProjectDescriptionValidation = 1;
var $author$project$Project$ProjectLocationAddress1 = function (a) {
	return {$: 6, a: a};
};
var $author$project$Project$ProjectLocationAddress2 = function (a) {
	return {$: 7, a: a};
};
var $author$project$Project$ProjectLocationCity = function (a) {
	return {$: 8, a: a};
};
var $author$project$Project$ProjectLocationState = function (a) {
	return {$: 9, a: a};
};
var $author$project$Project$ProjectLocationZip = function (a) {
	return {$: 10, a: a};
};
var $author$project$MainMsg$ProjectMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Project$ProjectName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Project$ProjectNameValidation = 0;
var $author$project$Project$ProjectRate = function (a) {
	return {$: 19, a: a};
};
var $author$project$MainMsg$ProjectValidationMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Project$Union = function (a) {
	return {$: 20, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$calendar = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('calendar');
var $author$project$Views$FormValidation$invalidField = F2(
	function (touched, field) {
		return touched && (field === '');
	});
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $CurrySoftware$elm_datepicker$DatePicker$Blur = {$: 6};
var $CurrySoftware$elm_datepicker$DatePicker$Focus = {$: 5};
var $CurrySoftware$elm_datepicker$DatePicker$SubmitText = {$: 4};
var $CurrySoftware$elm_datepicker$DatePicker$Text = function (a) {
	return {$: 3, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$ChangeFocus = function (a) {
	return {$: 1, a: a};
};
var $justinmimbs$date$Date$Months = 1;
var $CurrySoftware$elm_datepicker$DatePicker$MouseDown = {$: 7};
var $CurrySoftware$elm_datepicker$DatePicker$MouseUp = {$: 8};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.jE - 1)) + ($justinmimbs$date$Date$monthToNumber(date.h$) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.g5,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$changeYear = F2(
	function (current, newYear) {
		var _v0 = $elm$core$String$toInt(newYear);
		if (!_v0.$) {
			var year = _v0.a;
			return A3(
				$justinmimbs$date$Date$fromCalendarDate,
				year,
				$justinmimbs$date$Date$month(current),
				$justinmimbs$date$Date$day(current));
		} else {
			return current;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$groupDates = function (dates) {
	var go = F4(
		function (i, xs, racc, acc) {
			go:
			while (true) {
				if (!xs.b) {
					return $elm$core$List$reverse(acc);
				} else {
					var x = xs.a;
					var xxs = xs.b;
					if (i === 6) {
						var $temp$i = 0,
							$temp$xs = xxs,
							$temp$racc = _List_Nil,
							$temp$acc = A2(
							$elm$core$List$cons,
							$elm$core$List$reverse(
								A2($elm$core$List$cons, x, racc)),
							acc);
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					} else {
						var $temp$i = i + 1,
							$temp$xs = xxs,
							$temp$racc = A2($elm$core$List$cons, x, racc),
							$temp$acc = acc;
						i = $temp$i;
						xs = $temp$xs;
						racc = $temp$racc;
						acc = $temp$acc;
						continue go;
					}
				}
			}
		});
	return A4(go, 0, dates, _List_Nil, _List_Nil);
};
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$maybeOr = F2(
	function (lhs, rhs) {
		if (!rhs.$) {
			return rhs;
		} else {
			return lhs;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$mkClass = F2(
	function (_v0, c) {
		var classNamespace = _v0.bp;
		return $elm$html$Html$Attributes$class(
			_Utils_ap(classNamespace, c));
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $elm$html$Html$option = _VirtualDom_node('option');
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$date$Date$Weeks = 2;
var $justinmimbs$date$Date$Years = 0;
var $justinmimbs$date$Date$intervalToUnits = function (interval) {
	switch (interval) {
		case 0:
			return _Utils_Tuple2(1, 0);
		case 1:
			return _Utils_Tuple2(3, 1);
		case 2:
			return _Utils_Tuple2(1, 1);
		case 11:
			return _Utils_Tuple2(1, 3);
		default:
			var week = interval;
			return _Utils_Tuple2(1, 2);
	}
};
var $justinmimbs$date$Date$ceiling = F2(
	function (interval, date) {
		var floored = A2($justinmimbs$date$Date$floor, interval, date);
		if (_Utils_eq(date, floored)) {
			return date;
		} else {
			var _v0 = $justinmimbs$date$Date$intervalToUnits(interval);
			var n = _v0.a;
			var unit = _v0.b;
			return A3($justinmimbs$date$Date$add, unit, n, floored);
		}
	});
var $justinmimbs$date$Date$rangeHelp = F5(
	function (unit, step, until, revList, current) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(current, until) < 0) {
				var _v0 = A3($justinmimbs$date$Date$add, unit, step, current);
				var next = _v0;
				var $temp$unit = unit,
					$temp$step = step,
					$temp$until = until,
					$temp$revList = A2($elm$core$List$cons, current, revList),
					$temp$current = next;
				unit = $temp$unit;
				step = $temp$step;
				until = $temp$until;
				revList = $temp$revList;
				current = $temp$current;
				continue rangeHelp;
			} else {
				return $elm$core$List$reverse(revList);
			}
		}
	});
var $justinmimbs$date$Date$range = F4(
	function (interval, step, _v0, _v1) {
		var start = _v0;
		var until = _v1;
		var _v2 = $justinmimbs$date$Date$intervalToUnits(interval);
		var n = _v2.a;
		var unit = _v2.b;
		var _v3 = A2($justinmimbs$date$Date$ceiling, interval, start);
		var first = _v3;
		return (_Utils_cmp(first, until) < 0) ? A5(
			$justinmimbs$date$Date$rangeHelp,
			unit,
			A2($elm$core$Basics$max, 1, step) * n,
			until,
			_List_Nil,
			first) : _List_Nil;
	});
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval = function (weekday) {
	switch (weekday) {
		case 0:
			return 4;
		case 1:
			return 5;
		case 2:
			return 6;
		case 3:
			return 7;
		case 4:
			return 8;
		case 5:
			return 9;
		default:
			return 10;
	}
};
var $CurrySoftware$elm_datepicker$DatePicker$prepareDates = F2(
	function (date, firstDayOfWeek) {
		var weekdayAsInterval = $CurrySoftware$elm_datepicker$DatePicker$Date$weekdayToInterval(firstDayOfWeek);
		var start = A2(
			$justinmimbs$date$Date$floor,
			weekdayAsInterval,
			A3(
				$justinmimbs$date$Date$fromCalendarDate,
				$justinmimbs$date$Date$year(date),
				$justinmimbs$date$Date$month(date),
				1));
		var firstOfMonth = A3(
			$justinmimbs$date$Date$fromCalendarDate,
			$justinmimbs$date$Date$year(date),
			$justinmimbs$date$Date$month(date),
			1);
		var end = A2(
			$justinmimbs$date$Date$ceiling,
			weekdayAsInterval,
			A3($justinmimbs$date$Date$add, 1, 1, firstOfMonth));
		return {
			d3: A4($justinmimbs$date$Date$range, 11, 1, start, end),
			cQ: date
		};
	});
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $CurrySoftware$elm_datepicker$DatePicker$Pick = function (a) {
	return {$: 2, a: a};
};
var $CurrySoftware$elm_datepicker$DatePicker$mkClassList = F2(
	function (_v0, cs) {
		var classNamespace = _v0.bp;
		return $elm$html$Html$Attributes$classList(
			A2(
				$elm$core$List$map,
				function (_v1) {
					var c = _v1.a;
					var b = _v1.b;
					return _Utils_Tuple2(
						_Utils_ap(classNamespace, c),
						b);
				},
				cs));
	});
var $CurrySoftware$elm_datepicker$DatePicker$viewDay = F5(
	function (settings, picked, isOtherMonth, isToday, d) {
		var disabled = settings.bO(d);
		var props = (!disabled) ? _List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$CurrySoftware$elm_datepicker$DatePicker$Pick(d))
			]) : _List_Nil;
		var classList = $CurrySoftware$elm_datepicker$DatePicker$mkClassList(settings);
		return A2(
			$elm$html$Html$td,
			_Utils_ap(
				_List_fromArray(
					[
						classList(
						_List_fromArray(
							[
								_Utils_Tuple2('day', true),
								_Utils_Tuple2('disabled', disabled),
								_Utils_Tuple2(
								'picked',
								picked(d)),
								_Utils_Tuple2(
								'today',
								isToday(d)),
								_Utils_Tuple2(
								'other-month',
								isOtherMonth(d))
							]))
					]),
				props),
			_List_fromArray(
				[
					settings.cJ(
					$elm$core$String$fromInt(
						$justinmimbs$date$Date$day(d)))
				]));
	});
var $CurrySoftware$elm_datepicker$DatePicker$Date$yearRange = F2(
	function (_v0, range) {
		var currentMonth = _v0.cQ;
		var today = _v0.bi;
		switch (range.$) {
			case 1:
				var num = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(currentMonth) - num,
					$justinmimbs$date$Date$year(currentMonth) + num);
			case 2:
				var start = range.a;
				var end = range.b;
				return A2($elm$core$List$range, start, end);
			case 3:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					year_,
					$justinmimbs$date$Date$year(today));
			case 4:
				var year_ = range.a;
				return A2(
					$elm$core$List$range,
					$justinmimbs$date$Date$year(today),
					year_);
			default:
				return _List_Nil;
		}
	});
var $CurrySoftware$elm_datepicker$DatePicker$yearRangeActive = function (yearRange) {
	return !_Utils_eq(yearRange, $CurrySoftware$elm_datepicker$DatePicker$Date$Off);
};
var $CurrySoftware$elm_datepicker$DatePicker$datePicker = F3(
	function (pickedDate, settings, model) {
		var focused = model.ah;
		var today = model.bi;
		var picked = function (d) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function (pdate) {
						return _Utils_eq(
							$justinmimbs$date$Date$toRataDie(pdate),
							$justinmimbs$date$Date$toRataDie(d));
					},
					pickedDate));
		};
		var onChange = function (handler) {
			return A2(
				$elm$html$Html$Events$on,
				'change',
				A2($elm$json$Json$Decode$map, handler, $elm$html$Html$Events$targetValue));
		};
		var isToday = function (d) {
			return _Utils_eq(
				$justinmimbs$date$Date$toRataDie(d),
				$justinmimbs$date$Date$toRataDie(today));
		};
		var firstDayOffset = $justinmimbs$date$Date$weekdayToNumber(settings.ci) - 1;
		var dpClass = $CurrySoftware$elm_datepicker$DatePicker$mkClass(settings);
		var currentDate = A2(
			$elm$core$Maybe$withDefault,
			today,
			A2($CurrySoftware$elm_datepicker$DatePicker$maybeOr, pickedDate, focused));
		var isOtherMonth = function (d) {
			return !_Utils_eq(
				$justinmimbs$date$Date$month(currentDate),
				$justinmimbs$date$Date$month(d));
		};
		var arrow = F2(
			function (className, message) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							dpClass(className),
							$elm$html$Html$Events$onClick(message),
							$elm$html$Html$Attributes$tabindex(-1),
							$elm$html$Html$Attributes$type_('button')
						]),
					_List_Nil);
			});
		var _v0 = A2($CurrySoftware$elm_datepicker$DatePicker$prepareDates, currentDate, settings.ci);
		var currentMonth = _v0.cQ;
		var currentDates = _v0.d3;
		var dayList = A2(
			$elm$core$List$map,
			function (rowDays) {
				return A2(
					$elm$html$Html$tr,
					_List_fromArray(
						[
							dpClass('row')
						]),
					A2(
						$elm$core$List$map,
						A4($CurrySoftware$elm_datepicker$DatePicker$viewDay, settings, picked, isOtherMonth, isToday),
						rowDays));
			},
			$CurrySoftware$elm_datepicker$DatePicker$groupDates(currentDates));
		var isCurrentYear = function (selectedYear) {
			return _Utils_eq(
				$justinmimbs$date$Date$year(currentMonth),
				selectedYear);
		};
		var yearOption = F2(
			function (index, selectedYear) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(index),
					A2(
						$elm$html$Html$option,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(
								$elm$core$String$fromInt(selectedYear)),
								$elm$html$Html$Attributes$selected(
								isCurrentYear(selectedYear))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedYear))
							])));
			});
		var dropdownYear = A3(
			$elm$html$Html$Keyed$node,
			'select',
			_List_fromArray(
				[
					onChange(
					A2(
						$elm$core$Basics$composeR,
						$CurrySoftware$elm_datepicker$DatePicker$Date$changeYear(currentDate),
						$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus)),
					dpClass('year-menu')
				]),
			A2(
				$elm$core$List$indexedMap,
				yearOption,
				A2(
					$CurrySoftware$elm_datepicker$DatePicker$Date$yearRange,
					{cQ: currentMonth, bi: today},
					settings.b9)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					dpClass('picker'),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mousedown',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseDown, true))),
					A2(
					$elm$html$Html$Events$stopPropagationOn,
					'mouseup',
					$elm$json$Json$Decode$succeed(
						_Utils_Tuple2($CurrySoftware$elm_datepicker$DatePicker$MouseUp, true)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							dpClass('picker-header')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('prev-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'prev',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, -1, currentDate)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('month-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('month')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											settings.c5(
												$justinmimbs$date$Date$month(currentMonth)))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											dpClass('year')
										]),
									_List_fromArray(
										[
											(!$CurrySoftware$elm_datepicker$DatePicker$yearRangeActive(settings.b9)) ? $elm$html$Html$text(
											settings.du(
												$justinmimbs$date$Date$year(currentMonth))) : A3(
											$elm$html$Html$Keyed$node,
											'span',
											_List_Nil,
											_List_fromArray(
												[
													_Utils_Tuple2(
													$elm$core$String$fromInt(
														$justinmimbs$date$Date$year(currentMonth)),
													dropdownYear)
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									dpClass('next-container')
								]),
							_List_fromArray(
								[
									A2(
									arrow,
									'next',
									$CurrySoftware$elm_datepicker$DatePicker$ChangeFocus(
										A3($justinmimbs$date$Date$add, 1, 1, currentDate)))
								]))
						])),
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							dpClass('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$thead,
							_List_fromArray(
								[
									dpClass('weekdays')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (d) {
											return A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														dpClass('dow')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														settings.cU(d))
													]));
										},
										A2(
											$elm$core$List$take,
											7,
											A2(
												$elm$core$List$drop,
												firstDayOffset,
												$elm$core$List$concat(
													A2(
														$elm$core$List$repeat,
														2,
														_List_fromArray(
															[0, 1, 2, 3, 4, 5, 6])))))))
								])),
							A2(
							$elm$html$Html$tbody,
							_List_fromArray(
								[
									dpClass('days')
								]),
							dayList)
						]))
				]));
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onFocus = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'focus',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $CurrySoftware$elm_datepicker$DatePicker$view = F3(
	function (pickedDate, settings, _v0) {
		var datepicker = _v0;
		var model = datepicker;
		var potentialInputId = A3(
			$elm$core$Basics$composeR,
			$elm$core$List$singleton,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			A2($elm$core$Maybe$map, $elm$html$Html$Attributes$id, settings.hz));
		var inputClasses = _Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(settings.bp + 'input', true)
				]),
			settings.hy);
		var inputCommon = function (xs) {
			return A2(
				$elm$html$Html$input,
				_Utils_ap(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(inputClasses),
							$elm$html$Html$Attributes$name(
							A2($elm$core$Maybe$withDefault, '', settings.c1)),
							$elm$html$Html$Attributes$type_('text'),
							A2(
							$elm$html$Html$Events$on,
							'change',
							$elm$json$Json$Decode$succeed($CurrySoftware$elm_datepicker$DatePicker$SubmitText)),
							$elm$html$Html$Events$onInput($CurrySoftware$elm_datepicker$DatePicker$Text),
							$elm$html$Html$Events$onBlur($CurrySoftware$elm_datepicker$DatePicker$Blur),
							$elm$html$Html$Events$onClick($CurrySoftware$elm_datepicker$DatePicker$Focus),
							$elm$html$Html$Events$onFocus($CurrySoftware$elm_datepicker$DatePicker$Focus)
						]),
					_Utils_ap(
						settings.c0,
						_Utils_ap(potentialInputId, xs))),
				_List_Nil);
		};
		var dateInput = inputCommon(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$placeholder(settings.dc),
					$elm$html$Html$Attributes$value(
					A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$core$Maybe$withDefault,
							'',
							A2($elm$core$Maybe$map, settings.cS, pickedDate)),
						model.at))
				]));
		var containerClassList = A2(
			$elm$core$List$cons,
			_Utils_Tuple2(settings.bp + 'container', true),
			settings.cM);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(containerClassList)
				]),
			_List_fromArray(
				[
					dateInput,
					model.c9 ? A3($CurrySoftware$elm_datepicker$DatePicker$datePicker, pickedDate, settings, model) : $elm$html$Html$text('')
				]));
	});
var $author$project$Views$DatePicker$datePickerInput = F6(
	function (date, settings, datePicker, datePickerMsg, dateText, _v0) {
		var touched = _v0.a;
		var field = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('date-input-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$map,
					datePickerMsg,
					A3($CurrySoftware$elm_datepicker$DatePicker$view, date, settings, datePicker)),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('date-input-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(dateText)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'invalid-date-field',
									A2($author$project$Views$FormValidation$invalidField, touched, field))
								]))
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$calendar)
						]))
				]));
	});
var $author$project$Project$findDeadline = F2(
	function (deadlines, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyDeadline,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (deadline) {
						return _Utils_eq(deadline.bS, name);
					},
					deadlines)));
	});
var $author$project$Views$Project$endDateFilledOut = F2(
	function (deadlines, name) {
		return $elm$core$String$length(
			A2($author$project$Project$findDeadline, deadlines, name).ee) > 0;
	});
var $author$project$Views$DatePicker$isDisabled = F2(
	function (dateInput, beginning) {
		if (dateInput.$ === 1) {
			return $CurrySoftware$elm_datepicker$DatePicker$defaultSettings.bO;
		} else {
			var date = dateInput.a;
			return function (d) {
				return (beginning === 'start') ? ((_Utils_cmp(
					$justinmimbs$date$Date$toRataDie(d),
					$justinmimbs$date$Date$toRataDie(date)) > 0) || $CurrySoftware$elm_datepicker$DatePicker$defaultSettings.bO(d)) : ((_Utils_cmp(
					$justinmimbs$date$Date$toRataDie(d),
					$justinmimbs$date$Date$toRataDie(date)) < 0) || $CurrySoftware$elm_datepicker$DatePicker$defaultSettings.bO(d));
			};
		}
	});
var $author$project$Views$DatePicker$endSettings = function (startDate) {
	return _Utils_update(
		$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
		{
			bO: A2($author$project$Views$DatePicker$isDisabled, startDate, 'end'),
			dc: ''
		});
};
var $author$project$Utils$monthTranslation = function (num) {
	switch (num) {
		case 1:
			return 'January';
		case 2:
			return 'February';
		case 3:
			return 'March';
		case 4:
			return 'April';
		case 5:
			return 'May';
		case 6:
			return 'June';
		case 7:
			return 'July';
		case 8:
			return 'August';
		case 9:
			return 'September';
		case 10:
			return 'October';
		case 11:
			return 'November';
		case 12:
			return 'December';
		default:
			return '';
	}
};
var $author$project$Utils$formatDate = function (date) {
	return $author$project$Utils$monthTranslation(
		A2(
			$elm$core$Maybe$withDefault,
			0,
			$elm$core$String$toInt(
				A3($elm$core$String$slice, 5, 7, date)))) + (' ' + (A3($elm$core$String$slice, 8, 10, date) + (', ' + A3($elm$core$String$slice, 0, 4, date))));
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$MainMsg$CreateProject = {$: 47};
var $author$project$MainMsg$UpdateProject = {$: 49};
var $author$project$Views$Project$updating = function (id) {
	return $elm$core$String$length(id) > 0;
};
var $author$project$Views$Project$projectSubmitButton = function (model) {
	return $author$project$Views$Project$updating(model.aj.c$) ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateProject),
				$elm$html$Html$Attributes$class('next-step-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('SAVE')
			])) : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$CreateProject),
				$elm$html$Html$Attributes$class('next-step-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('NEXT STEP')
			]));
};
var $author$project$Views$Project$startDateFilledOut = F2(
	function (deadlines, name) {
		return $elm$core$String$length(
			A2($author$project$Project$findDeadline, deadlines, name).fP) > 0;
	});
var $author$project$Views$DatePicker$startSettings = function (endDate) {
	return _Utils_update(
		$CurrySoftware$elm_datepicker$DatePicker$defaultSettings,
		{
			bO: A2($author$project$Views$DatePicker$isDisabled, endDate, 'start'),
			dc: ''
		});
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Views$Project$projectForm = function (model) {
	var projectDeadline = A2($author$project$Project$findDeadline, model.aj.g6, 'Project');
	var _v0 = function () {
		var _v1 = model.aU;
		switch (_v1) {
			case 1:
				return _Utils_Tuple2('create-project-modal form-hiding', '');
			case 0:
				return _Utils_Tuple2('create-project-modal', 'Create New Project');
			case 2:
				return _Utils_Tuple2('create-project-modal collapse-form', 'Creating Project...');
			default:
				return _Utils_Tuple2('create-project-modal form-complete', 'Creating Project...');
		}
	}();
	var formClass = _v0.a;
	var headerText = _v0.b;
	return A2(
		$elm$html$Html$form,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(formClass),
				$elm$html$Html$Attributes$autocomplete(false),
				$elm$html$Html$Events$onSubmit($author$project$MainMsg$NoOp)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-project-header')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(headerText)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('close-button'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleFormOpen(4))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('X')
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-project-details-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-errors')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(model.df)
									])),
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('PROJECT DETAILS')
									])),
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Project Name')
									])),
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'invalid-field',
												A2($author$project$Views$FormValidation$invalidField, model.aW.bS, model.aj.bS))
											])),
										$elm$html$Html$Attributes$placeholder('Drink commerical'),
										$elm$html$Html$Events$onFocus(
										$author$project$MainMsg$ProjectValidationMsg(0)),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectName)),
										$elm$html$Html$Attributes$value(model.aj.bS)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('range-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project Start')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.az.gy,
										$author$project$Views$DatePicker$startSettings(model.az.iu),
										model.G.fg,
										$author$project$MainMsg$ToProjectStartDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.aj.g6, 'Project').fP),
										_Utils_Tuple2(
											A2($author$project$Views$Project$endDateFilledOut, model.aj.g6, 'Project'),
											A2($author$project$Project$findDeadline, model.aj.g6, 'Project').fP))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project End')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.az.iu,
										$author$project$Views$DatePicker$endSettings(model.az.iz),
										model.G.fd,
										$author$project$MainMsg$ToProjectEndDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.aj.g6, 'Project').ee),
										_Utils_Tuple2(
											A2($author$project$Views$Project$startDateFilledOut, model.aj.g6, 'Project'),
											A2($author$project$Project$findDeadline, model.aj.g6, 'Project').ee))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Project Location')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('location-fields')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$placeholder('Address Line 1'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationAddress1)),
														$elm$html$Html$Attributes$value(projectDeadline.bF)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$placeholder('Address Line 2'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationAddress2)),
														$elm$html$Html$Attributes$value(projectDeadline.bG)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$placeholder('City'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationCity)),
														$elm$html$Html$Attributes$value(projectDeadline.a0)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$placeholder('State'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationState)),
														$elm$html$Html$Attributes$value(projectDeadline.bf)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$placeholder('Zip-Code'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectLocationZip)),
												$elm$html$Html$Attributes$value(projectDeadline.dv)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Description')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'invalid-field',
												A2($author$project$Views$FormValidation$invalidField, model.aW.it, model.aj.it))
											])),
										$elm$html$Html$Attributes$placeholder('Include important details about this project here...'),
										$elm$html$Html$Events$onFocus(
										$author$project$MainMsg$ProjectValidationMsg(1)),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectDescription)),
										$elm$html$Html$Attributes$value(model.aj.it)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Project Notes To Agent')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Include important notes to agents here...'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$NotesAgent)),
										$elm$html$Html$Attributes$value(model.aj.gk)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Project Notes To Talent')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$placeholder('Include important notes to talent here...'),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$NotesTalent)),
										$elm$html$Html$Attributes$value(model.aj.jg)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-project-schedule-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('SCHEDULE')
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('SUBMIT BY')
									])),
								A6(
								$author$project$Views$DatePicker$datePickerInput,
								model.az.i7,
								$author$project$Views$DatePicker$dateSettings,
								model.G.fS,
								$author$project$MainMsg$ToSubDatePicker,
								$author$project$Utils$formatDate(
									A2($author$project$Project$findDeadline, model.aj.g6, 'Submission').ee),
								_Utils_Tuple2(false, ''))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('range-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Audition Start Date')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.az.gy,
										$author$project$Views$DatePicker$startSettings(model.az.gx),
										model.G.dM,
										$author$project$MainMsg$ToAudStartDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.aj.g6, 'Audition').fP),
										_Utils_Tuple2(
											A2($author$project$Views$Project$endDateFilledOut, model.aj.g6, 'Audition'),
											A2($author$project$Project$findDeadline, model.aj.g6, 'Audition').fP))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Audition End Date')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.az.gx,
										$author$project$Views$DatePicker$endSettings(model.az.gy),
										model.G.dL,
										$author$project$MainMsg$ToAudEndDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.aj.g6, 'Audition').ee),
										_Utils_Tuple2(
											A2($author$project$Views$Project$startDateFilledOut, model.aj.g6, 'Audition'),
											A2($author$project$Project$findDeadline, model.aj.g6, 'Audition').ee))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Audition Location')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$placeholder('123 Main St. Los Angeles, CA'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$AuditionLocation)),
												$elm$html$Html$Attributes$value(
												A2($author$project$Project$findDeadline, model.aj.g6, 'Audition').hM)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('range-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Callback Start Date')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.az.gG,
										$author$project$Views$DatePicker$startSettings(model.az.gF),
										model.G.dS,
										$author$project$MainMsg$ToCallStartDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.aj.g6, 'Callback').fP),
										_Utils_Tuple2(
											A2($author$project$Views$Project$endDateFilledOut, model.aj.g6, 'Callback'),
											A2($author$project$Project$findDeadline, model.aj.g6, 'Callback').fP))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Callback End Date')
											])),
										A6(
										$author$project$Views$DatePicker$datePickerInput,
										model.az.gF,
										$author$project$Views$DatePicker$endSettings(model.az.gG),
										model.G.dR,
										$author$project$MainMsg$ToCallEndDatePicker,
										$author$project$Utils$formatDate(
											A2($author$project$Project$findDeadline, model.aj.g6, 'Callback').ee),
										_Utils_Tuple2(
											A2($author$project$Views$Project$startDateFilledOut, model.aj.g6, 'Callback'),
											A2($author$project$Project$findDeadline, model.aj.g6, 'Callback').ee))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Callback Location')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$placeholder('123 Main St. Los Angeles, CA'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$CallbackLocation)),
												$elm$html$Html$Attributes$value(
												A2($author$project$Project$findDeadline, model.aj.g6, 'Callback').hM)
											]),
										_List_Nil)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Fitting Date')
									])),
								A6(
								$author$project$Views$DatePicker$datePickerInput,
								model.az.ho,
								$author$project$Views$DatePicker$startSettings(model.az.ho),
								model.G.eo,
								$author$project$MainMsg$ToFittingDatePicker,
								$author$project$Utils$formatDate(
									A2($author$project$Project$findDeadline, model.aj.g6, 'Fitting').ee),
								_Utils_Tuple2(false, ''))
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Shoot Date')
									])),
								A6(
								$author$project$Views$DatePicker$datePickerInput,
								model.az.i0,
								$author$project$Views$DatePicker$startSettings(model.az.i0),
								model.G.fI,
								$author$project$MainMsg$ToShootDatePicker,
								$author$project$Utils$formatDate(
									A2($author$project$Project$findDeadline, model.aj.g6, 'Shoot').ee),
								_Utils_Tuple2(false, ''))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('range-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input rate-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Rate')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$type_('number'),
												$elm$html$Html$Attributes$value(model.aj.iy),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$ProjectRate))
											]),
										_List_Nil)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input union-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('UNION'),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$value('union'),
														$elm$html$Html$Attributes$name('union'),
														$elm$html$Html$Events$onCheck(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$Union)),
														$elm$html$Html$Attributes$checked(model.aj.jo)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('NON-UNION'),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$value('non-union'),
														$elm$html$Html$Attributes$name('union'),
														$elm$html$Html$Events$onCheck(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$ProjectMsg, $author$project$Project$NonUnion)),
														$elm$html$Html$Attributes$checked(!model.aj.jo)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('NON-UNION')
													]))
											]))
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-project-footer')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Pro tip: You can always add or edit your project once it has been created.')
							])),
						$author$project$Views$Project$projectSubmitButton(model)
					]))
			]));
};
var $author$project$Views$Project$createProjectModal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('create-project-form-modal')
			]),
		_List_fromArray(
			[
				$author$project$Views$Project$projectForm(model),
				A2(
				$author$project$Views$ModalOverlay$modal,
				$author$project$MainMsg$ToggleFormOpen(4),
				model.aU !== 1)
			]));
};
var $author$project$RoleForms$AgeMax = function (a) {
	return {$: 5, a: a};
};
var $author$project$RoleForms$AgeMin = function (a) {
	return {$: 4, a: a};
};
var $author$project$RoleForms$MaxHeight = function (a) {
	return {$: 8, a: a};
};
var $author$project$RoleForms$MinHeight = function (a) {
	return {$: 7, a: a};
};
var $author$project$RoleForms$RoleDescription = function (a) {
	return {$: 2, a: a};
};
var $author$project$RoleForms$RoleDescriptionValidation = 2;
var $author$project$MainMsg$RoleMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$RoleForms$RoleName = function (a) {
	return {$: 0, a: a};
};
var $author$project$RoleForms$RoleNameValidation = 0;
var $author$project$RoleForms$RoleRate = function (a) {
	return {$: 1, a: a};
};
var $author$project$RoleForms$RoleRateValidation = 1;
var $author$project$MainMsg$RoleValidationMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$RoleForms$WeightMax = function (a) {
	return {$: 10, a: a};
};
var $author$project$RoleForms$WeightMin = function (a) {
	return {$: 9, a: a};
};
var $author$project$InitData$heightValues = _List_fromArray(
	[
		{j: '0', g: 'ANY'},
		{j: '48', g: '4\' 0\"'},
		{j: '49', g: '4\' 1\"'},
		{j: '50', g: '4\' 2\"'},
		{j: '51', g: '4\' 3\"'},
		{j: '52', g: '4\' 4\"'},
		{j: '53', g: '4\' 5\"'},
		{j: '54', g: '4\' 6\"'},
		{j: '55', g: '4\' 7\"'},
		{j: '56', g: '4\' 8\"'},
		{j: '57', g: '4\' 9\"'},
		{j: '58', g: '4\' 10\"'},
		{j: '59', g: '4\' 11\"'},
		{j: '60', g: '5\' 0\"'},
		{j: '61', g: '5\' 1\"'},
		{j: '62', g: '5\' 2\"'},
		{j: '63', g: '5\' 3\"'},
		{j: '64', g: '5\' 4\"'},
		{j: '65', g: '5\' 5\"'},
		{j: '66', g: '5\' 6\"'},
		{j: '67', g: '5\' 7\"'},
		{j: '68', g: '5\' 8\"'},
		{j: '69', g: '5\' 9\"'},
		{j: '70', g: '5\' 10\"'},
		{j: '71', g: '5\' 11\"'},
		{j: '72', g: '6\' 0\"'},
		{j: '73', g: '6\' 1\"'},
		{j: '74', g: '6\' 2\"'},
		{j: '75', g: '6\' 3\"'},
		{j: '76', g: '6\' 4\"'},
		{j: '77', g: '6\' 5\"'},
		{j: '78', g: '6\' 6\"'},
		{j: '79', g: '6\' 7\"'},
		{j: '80', g: '6\' 8\"'},
		{j: '81', g: '6\' 9\"'},
		{j: '82', g: '6\' 10\"'},
		{j: '83', g: '6\' 11\"'},
		{j: '84', g: '7\' 0\"'},
		{j: '85', g: '7\' 1\"'},
		{j: '86', g: '7\' 2\"'},
		{j: '87', g: '7\' 3\"'},
		{j: '88', g: '7\' 4\"'},
		{j: '89', g: '7\' 5\"'},
		{j: '90', g: '7\' 6\"'}
	]);
var $author$project$MainMsg$AddAllEthnicities = {$: 252};
var $author$project$MainMsg$AddAllGenders = {$: 251};
var $author$project$MainMsg$AddEthnicityItem = function (a) {
	return {$: 144, a: a};
};
var $author$project$MainMsg$AddGenderItem = function (a) {
	return {$: 143, a: a};
};
var $author$project$MainMsg$UserAddEthnicityItem = function (a) {
	return {$: 145, a: a};
};
var $author$project$Views$Form$addAllButton = F2(
	function (selectedOptions, aMsg) {
		return (selectedOptions > 0) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('all-button'),
					$elm$html$Html$Events$onClick(aMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('clear all')
				])) : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('all-button'),
					$elm$html$Html$Events$onClick(aMsg)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('add all')
				]));
	});
var $elm$virtual_dom$VirtualDom$lazy2 = _VirtualDom_lazy2;
var $elm$html$Html$Lazy$lazy2 = $elm$virtual_dom$VirtualDom$lazy2;
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Views$Form$multiOptionField = F2(
	function (item, itemList) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item.aa),
					$elm$html$Html$Attributes$disabled(
					A2($elm$core$List$member, item.bS, itemList))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.bS)
				]));
	});
var $author$project$MainMsg$RemoveAllItems = function (a) {
	return {$: 151, a: a};
};
var $author$project$Views$Form$removeAllVisible = F2(
	function (values, msg) {
		return ($elm$core$List$length(values) >= 1) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$RemoveAllItems(msg)),
					$elm$html$Html$Attributes$class('remove-all-items-icon')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('x')
				])) : $elm$html$Html$text('');
	});
var $elm$html$Html$select = _VirtualDom_node('select');
var $author$project$MainMsg$RemoveItem = F2(
	function (a, b) {
		return {$: 146, a: a, b: b};
	});
var $author$project$Views$Form$valueLi = F3(
	function (value, multiMsg, options) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected-item')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							A2($author$project$MainMsg$RemoveItem, multiMsg, value)),
							$elm$html$Html$Attributes$class('remove-item')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('X')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('option-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(value)
						]))
				]));
	});
var $author$project$Views$Form$multiSelect = F4(
	function (labelText, options, values, multiMsg) {
		switch (multiMsg) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('multi-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$author$project$Views$Form$addAllButton,
							$elm$core$List$length(values),
							$author$project$MainMsg$AddAllGenders),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2($elm$json$Json$Decode$map, $author$project$MainMsg$AddGenderItem, $elm$html$Html$Events$targetValue)),
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value('')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$multiOptionField, option, values);
								},
								options)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selected-items')
								]),
							A2(
								$elm$core$List$map,
								function (value) {
									return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Form$valueLi, value, multiMsg, options);
								},
								values)),
							A2($author$project$Views$Form$removeAllVisible, values, 0)
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('multi-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$author$project$Views$Form$addAllButton,
							$elm$core$List$length(values),
							$author$project$MainMsg$AddAllEthnicities),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2($elm$json$Json$Decode$map, $author$project$MainMsg$AddEthnicityItem, $elm$html$Html$Events$targetValue)),
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value('')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$multiOptionField, option, values);
								},
								options)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selected-items')
								]),
							A2(
								$elm$core$List$map,
								function (value) {
									return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Form$valueLi, value, multiMsg, options);
								},
								values)),
							A2($author$project$Views$Form$removeAllVisible, values, 2)
						]));
			case 3:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('multi-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Events$on,
									'change',
									A2($elm$json$Json$Decode$map, $author$project$MainMsg$UserAddEthnicityItem, $elm$html$Html$Events$targetValue)),
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value('')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A2($author$project$Views$Form$multiOptionField, option, values);
								},
								options)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selected-items')
								]),
							A2(
								$elm$core$List$map,
								function (value) {
									return A3($author$project$Views$Form$valueLi, value, multiMsg, options);
								},
								values)),
							A2($author$project$Views$Form$removeAllVisible, values, 3)
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('multi-select')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(labelText)
								])),
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value('-')
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$multiOptionField, option, values);
								},
								options)),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('selected-items')
								]),
							A2(
								$elm$core$List$map,
								function (value) {
									return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Form$valueLi, value, multiMsg, options);
								},
								values))
						]));
		}
	});
var $frandibar$elm_font_awesome_5$FontAwesome$Animation = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$SetProjectId = function (a) {
	return {$: 69, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$Spin = 0;
var $author$project$MainMsg$UpdateRole = {$: 62};
var $author$project$MainMsg$CreateRoleAndOpenNewForm = {$: 152};
var $author$project$Views$Project$anotherRoleDisabled = function (role) {
	return ((role.bS === '') && (role.iI === '')) ? $author$project$MainMsg$NoOp : $author$project$MainMsg$CreateRoleAndOpenNewForm;
};
var $author$project$MainMsg$CreateRole = {$: 60};
var $author$project$Views$Project$createOrExitRoleForm = function (role) {
	return (role.bS !== '') ? $author$project$MainMsg$CreateRole : $author$project$MainMsg$ToggleFormOpen(4);
};
var $frandibar$elm_font_awesome_5$FontAwesome$spinner = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('spinner');
var $author$project$Views$Project$roleSubmitButton = F3(
	function (role, flow, currentId) {
		switch (flow) {
			case 0:
				return $author$project$Views$Project$updating(role.c$) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateRole)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Update Role')
								]))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$SetProjectId(currentId))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Edit Project')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Views$Project$anotherRoleDisabled(role))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('ADD ANOTHER ROLE')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$Views$Project$createOrExitRoleForm(role))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('DONE')
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A4(
											$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
											$frandibar$elm_font_awesome_5$FontAwesome$spinner,
											0,
											_List_fromArray(
												[
													$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
												]),
											_List_Nil)
										]))
								]))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Form$heightOptionField = F2(
	function (item, selectedValue) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item.j),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item.j, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.g)
				]));
	});
var $author$project$Views$Form$selectHeightField = F5(
	function (aMsg, bMsg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, aMsg, bMsg)),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$heightOptionField, option, valueText);
					},
					options))
			]);
	});
var $author$project$Views$Form$convertIntOptionsToString = function (options) {
	return A2($elm$core$List$map, $elm$core$String$fromInt, options);
};
var $author$project$Views$Form$stringOptionField = F2(
	function (item, selectedValue) {
		var _default = (item === '0') ? 'Select Option' : item;
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(_default),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(_default, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(_default)
				]));
	});
var $author$project$Views$Form$selectIntField = F4(
	function (msg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(msg),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionField, option, valueText);
					},
					A2(
						$elm$core$List$cons,
						'ANY',
						$author$project$Views$Form$convertIntOptionsToString(options))))
			]);
	});
var $author$project$Views$Project$roleForm = function (model) {
	var _v0 = function () {
		var _v1 = model.am;
		switch (_v1) {
			case 1:
				return _Utils_Tuple2('create-role-form-container form-hiding', '');
			case 0:
				return _Utils_Tuple2('create-role-form-container', 'Create Role');
			case 2:
				return _Utils_Tuple2('create-role-form-container collapse-form', 'Creating Role...');
			default:
				return _Utils_Tuple2('create-role-form-container form-complete', 'Creating Role...');
		}
	}();
	var formClass = _v0.a;
	var headerText = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class(formClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('create-role-form')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-header')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(headerText)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('close-role'),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$ToggleFormOpen(4))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('X')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('create-role-form-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-left')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Role Name ')
											])),
										A2(
										$elm$html$Html$input,
										_List_fromArray(
											[
												$elm$html$Html$Events$onFocus(
												$author$project$MainMsg$RoleValidationMsg(0)),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'invalid-field',
														A2($author$project$Views$FormValidation$invalidField, model.Z.bS, model.V.bS))
													])),
												$elm$html$Html$Attributes$placeholder('Director'),
												$elm$html$Html$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$RoleName)),
												$elm$html$Html$Attributes$value(model.V.bS)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Description')
													])),
												A2(
												$elm$html$Html$textarea,
												_List_fromArray(
													[
														$elm$html$Html$Events$onFocus(
														$author$project$MainMsg$RoleValidationMsg(2)),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'invalid-field',
																A2($author$project$Views$FormValidation$invalidField, model.Z.iI, model.V.iI))
															])),
														$elm$html$Html$Attributes$placeholder('Write a brief description of the role.'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$RoleDescription)),
														$elm$html$Html$Attributes$value(model.V.iI)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Rate')
													])),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Events$onFocus(
														$author$project$MainMsg$RoleValidationMsg(1)),
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'invalid-field',
																A2($author$project$Views$FormValidation$invalidField, model.Z.iM, model.V.iM))
															])),
														$elm$html$Html$Attributes$placeholder('$1000 + 15% agency fee'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$RoleRate)),
														$elm$html$Html$Attributes$value(model.V.iM)
													]),
												_List_Nil)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-right')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A4(
												$author$project$Views$Form$multiSelect,
												'Gender',
												A2(
													$elm$core$List$cons,
													{aa: '', bS: ''},
													model.hs),
												A2(
													$elm$core$List$map,
													function (option) {
														return option.bS;
													},
													model.V.hs),
												0)
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A4(
												$author$project$Views$Form$multiSelect,
												'Ethnic Appearance',
												A2(
													$elm$core$List$cons,
													{aa: '', bS: ''},
													model.eg),
												A2(
													$elm$core$List$map,
													function (option) {
														return option.bS;
													},
													model.V.eg),
												2)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('height-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A4(
													$author$project$Views$Form$selectIntField,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$AgeMin),
													'Minimum Age',
													A2($elm$core$List$range, 0, model.V.c2),
													$elm$core$String$fromInt(model.V.c4))),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A4(
													$author$project$Views$Form$selectIntField,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$AgeMax),
													'Maximum Age',
													A2($elm$core$List$range, model.V.c4, 75),
													$elm$core$String$fromInt(model.V.c2)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('height-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A5(
													$author$project$Views$Form$selectHeightField,
													$author$project$MainMsg$RoleMsg,
													$author$project$RoleForms$MinHeight,
													'Minimum Height',
													$author$project$InitData$heightValues,
													$elm$core$String$fromInt(model.V.hW))),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A5(
													$author$project$Views$Form$selectHeightField,
													$author$project$MainMsg$RoleMsg,
													$author$project$RoleForms$MaxHeight,
													'Maximum Height',
													$author$project$InitData$heightValues,
													$elm$core$String$fromInt(model.V.hP)))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('height-section')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A4(
													$author$project$Views$Form$selectIntField,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$WeightMin),
													'Minimum Weight',
													A2(
														$elm$core$List$range,
														60,
														$elm$core$Basics$round(model.V.eM)),
													$elm$core$String$fromFloat(model.V.eQ))),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('half')
													]),
												A4(
													$author$project$Views$Form$selectIntField,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$RoleMsg, $author$project$RoleForms$WeightMax),
													'Maximum Weight',
													A2(
														$elm$core$List$range,
														$elm$core$Basics$round(model.V.eQ),
														500),
													$elm$core$String$fromFloat(model.V.eM)))
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-footer')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Pro tip: You can always add or edit roles once project is created.')
									])),
								A3($author$project$Views$Project$roleSubmitButton, model.V, model.am, model.d6)
							]))
					]))
			]));
};
var $author$project$Views$Project$createRoleModal = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('role-form')
			]),
		_List_fromArray(
			[
				A2(
				$author$project$Views$ModalOverlay$modal,
				$author$project$MainMsg$ToggleFormOpen(4),
				model.am !== 1),
				$author$project$Views$Project$roleForm(model)
			]));
};
var $author$project$Views$Project$directorModals = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Views$Project$createProjectModal(model),
				$author$project$Views$Project$createRoleModal(model)
			]));
};
var $author$project$Views$Dashboard$senderName = F3(
	function (role, jobPosterName, talentName) {
		switch (role) {
			case 0:
				return jobPosterName;
			case 1:
				return talentName;
			default:
				return talentName;
		}
	});
var $author$project$Views$Dashboard$listInbox = function (model) {
	var lastMessages = A2(
		$elm$core$List$map,
		function (channel) {
			return {gV: channel.aa, hH: channel.hH, hL: channel.hL, jf: channel.jf, jq: channel.bD};
		},
		A2($elm$core$List$take, 3, model.p.n));
	return A2(
		$elm$core$List$map,
		function (message) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2($author$project$MainMsg$GoToConversationPage, message.gV, '')),
						$elm$html$Html$Attributes$class('inbox-widget-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(
								A3($author$project$Views$Dashboard$senderName, model.E.V, message.hH, message.jf))
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(message.hL)
							]))
					]));
		},
		lastMessages);
};
var $author$project$Views$Dashboard$listProjects = function (model) {
	return A2(
		$elm$core$List$map,
		function (project) {
			var roleCount = $elm$core$List$length(project.ft);
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/projects/' + project.aa),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateCurrentProjectId(project.aa)),
						$elm$html$Html$Attributes$class('widget-list-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('project-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(project.bS)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('project-roles')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'(' + ($elm$core$String$fromInt(roleCount) + ' Roles)'))
									]))
							]))
					]));
		},
		model.g3.fh);
};
var $author$project$Views$Dashboard$listRoles = function (model) {
	return A2(
		$elm$core$List$map,
		function (role) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/projects/' + role.iw),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateCurrentProjectId(role.iw)),
						$elm$html$Html$Attributes$class('widget-list-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(role.bS)
									])),
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-parent-project')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(role.ix)
									]))
							]))
					]));
		},
		model.g3.ft);
};
var $author$project$Views$Dashboard$directorWidgets = function (model) {
	var firstProject = A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptyBasicProjectData,
		$elm$core$List$head(model.g3.fh)).aa;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('widgets-list')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('widget')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-and-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$b,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Recent Projects')
											]))
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('body')
									]),
								$author$project$Views$Dashboard$listProjects(model))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('footer')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('see-more'),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$View(
											$author$project$Route$Project(firstProject)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('View All Projects')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('widget')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-and-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$b,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Recent Roles')
											]))
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('body')
									]),
								$author$project$Views$Dashboard$listRoles(model))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('footer')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('see-more'),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$View(
											$author$project$Route$Project(firstProject)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('View All Roles')
									]))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('widget')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-and-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$b,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Inbox')
											]))
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('body')
									]),
								$author$project$Views$Dashboard$listInbox(model))
							]))
					]))
			]));
};
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$Views$Dashboard$talentLinks = _List_fromArray(
	[
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$View($author$project$Route$MyJobs))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Details for your upcoming casting call ')
			])),
		A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$View(
					$author$project$Route$ProfileSubPage(0)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Finish Profile Setup')
			]))
	]);
var $author$project$Views$Job$itemList = function (items) {
	var _v0 = $elm$core$List$head(items);
	if (!_v0.$) {
		var item = _v0.a;
		return A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(item + ' ')
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Dashboard$listJobs = function (model) {
	return A2(
		$elm$core$List$map,
		function (project) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href('/discover-jobs/' + project.aa),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$FindJob(project.aa)),
						$elm$html$Html$Attributes$class('widget-list-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('role-name')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(project.bS)
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Featured | ')
											])),
										$author$project$Views$Job$itemList(
										A2(
											$elm$core$List$map,
											function ($) {
												return $.bS;
											},
											project.ft))
									]))
							]))
					]));
		},
		model.g3.fh);
};
var $author$project$Views$Dashboard$actionRequired = function (job) {
	return A2(
		$elm$core$List$member,
		job.bf,
		_List_fromArray(
			[2, 17])) || (A2(
		$elm$core$List$member,
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(job.fA)).dj,
		_List_fromArray(
			[5, 17, 11, 15, 9])) || A2(
		$elm$core$List$member,
		A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				$elm$core$List$reverse(job.fA))).dj,
		_List_fromArray(
			[5, 17, 11, 15, 9])));
};
var $author$project$Views$Dashboard$listMyJobs = function (model) {
	return A2(
		$elm$core$List$map,
		function (job) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$View($author$project$Route$MyJobs)),
						$elm$html$Html$Attributes$class('inbox-widget-item')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-name')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(job.V.ix + (': ' + job.V.bS))
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('action-text', true),
										_Utils_Tuple2(
										'showing-action-text',
										$author$project$Views$Dashboard$actionRequired(job))
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Action Required')
							]))
					]));
		},
		A2($elm$core$List$take, 3, model.g3.eR));
};
var $author$project$Views$Dashboard$talentWidgets = function (model) {
	var page = function () {
		var _v0 = model.E.V;
		switch (_v0) {
			case 0:
				return $author$project$MainMsg$View($author$project$Route$MyJobs);
			case 1:
				return $author$project$MainMsg$View($author$project$Route$Inbox);
			default:
				return $author$project$MainMsg$View($author$project$Route$Inbox);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('widgets-list')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('widget')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-and-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$b,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('DISCOVER')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('see-more'),
												$elm$html$Html$Events$onClick(
												$author$project$MainMsg$View(
													$author$project$Route$Job('1')))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('SEE MORE')
											]))
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('body')
									]),
								$author$project$Views$Dashboard$listJobs(model))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('widget')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-and-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$b,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('MY JOBS')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('see-more'),
												$elm$html$Html$Events$onClick(
												$author$project$MainMsg$View($author$project$Route$MyJobs))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('SEE MORE')
											]))
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('body')
									]),
								$author$project$Views$Dashboard$listMyJobs(model))
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('widget')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('header-and-body')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('header')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$b,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('title')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('INBOX')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('see-more'),
												$elm$html$Html$Events$onClick(page)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('SEE MORE')
											]))
									])),
								A2($elm$html$Html$hr, _List_Nil, _List_Nil),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('body')
									]),
								$author$project$Views$Dashboard$listInbox(model))
							]))
					]))
			]));
};
var $author$project$Views$Dashboard$dashboardView = function (model) {
	var widgets = function () {
		var _v4 = model.E.V;
		switch (_v4) {
			case 0:
				return $author$project$Views$Dashboard$talentWidgets(model);
			case 1:
				return $author$project$Views$Dashboard$directorWidgets(model);
			case 2:
				return $author$project$Views$Dashboard$collaboratorWidgets(model);
			case 3:
				return $author$project$Views$Dashboard$agencyWidgets(model);
			case 4:
				return $author$project$Views$Dashboard$agencyWidgets(model);
			default:
				return $elm$html$Html$text('');
		}
	}();
	var welcomeText = function () {
		var _v3 = model.E.V;
		switch (_v3) {
			case 0:
				return 'Welcome to your living resume. In this section you are able to show what skills and characteristics you possess. Filling this section out fully and accurately will enable you to be connected with the greatest number of relevant jobs.';
			case 1:
				return 'Welcome to your Dashboard. Here you can see all your active projects, roles and messages all in one place.';
			case 3:
				return '';
			case 4:
				return '';
			default:
				return 'Welcome to your Dashboard. Here you can see all your collaborated projects. Click on one to go to Day of schedule page.';
		}
	}();
	var modals = function () {
		var _v2 = model.E.V;
		switch (_v2) {
			case 0:
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			case 1:
				return $author$project$Views$Project$directorModals(model);
			default:
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		}
	}();
	var mainSection = function () {
		var _v1 = model.E.V;
		switch (_v1) {
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hi ' + (model.E.bx + '.'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(welcomeText)
								])),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						]));
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Hi ' + (model.E.bx + '.'))
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(welcomeText)
								])),
							A2($elm$html$Html$hr, _List_Nil, _List_Nil)
						]));
			default:
				return $elm$html$Html$text('');
		}
	}();
	var links = function () {
		var _v0 = model.E.V;
		switch (_v0) {
			case 0:
				return $author$project$Views$Dashboard$talentLinks;
			case 1:
				return $author$project$Views$Dashboard$directorLinks;
			default:
				return _List_fromArray(
					[
						$elm$html$Html$text('')
					]);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$section,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dashboard')
					]),
				_List_fromArray(
					[
						mainSection,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('links')
							]),
						links),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('widgets')
							]),
						_List_fromArray(
							[widgets])),
						modals
					]))
			]));
};
var $author$project$Views$Auth$directorSignupForm = function (email) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserFirstName)),
										$elm$html$Html$Attributes$placeholder('First Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserLastName)),
										$elm$html$Html$Attributes$placeholder('Last Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$value(email),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserEmail)),
										$elm$html$Html$Attributes$placeholder('Email')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$Company)),
										$elm$html$Html$Attributes$placeholder('Company Name')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPassword)),
										$elm$html$Html$Attributes$placeholder('Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPasswordConfirmation)),
										$elm$html$Html$Attributes$placeholder('Confirm Password'),
										$elm$html$Html$Attributes$type_('password')
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Views$Auth$directorSignupView = F4(
	function (isOpen, err, email, logoPath) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Casting Director Registration')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$directorSignupForm(email),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterUser),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Create Account')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-switch-container')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Already have an account?'),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$Login)),
											$elm$html$Html$Attributes$class('link-button signup-switch')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Login »')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sign-up-options')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$TalentRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch talent-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Talent Sign-up »')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$AgencyRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Agency Sign-Up »')
										]))
								])),
							$author$project$Views$Auth$showSignUpConfirmationModal(isOpen)
						]))
				]));
	});
var $author$project$Project$InboxPage = 5;
var $author$project$MainMsg$ToggleConfirmation = F2(
	function (a, b) {
		return {$: 97, a: a, b: b};
	});
var $author$project$MainMsg$UpdateUsersRoleStage = F4(
	function (a, b, c, d) {
		return {$: 155, a: a, b: b, c: c, d: d};
	});
var $author$project$MainMsg$ChatFileRequested = function (a) {
	return {$: 116, a: a};
};
var $author$project$MainMsg$SendMessage = {$: 102};
var $elm$html$Html$Attributes$accept = $elm$html$Html$Attributes$stringProperty('accept');
var $frandibar$elm_font_awesome_5$FontAwesome$fileImage = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('file-image');
var $frandibar$elm_font_awesome_5$FontAwesome$paperclip = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('paperclip');
var $author$project$Views$Messages$chatInputBox = F4(
	function (body, convoId, chatFileText, channel) {
		return channel.dI ? A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('disabled-text')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Conversation has been disabled')
				])) : A2(
			$elm$html$Html$form,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('chat-input-box-container', true),
							_Utils_Tuple2('chat-input-hidden', (channel.aa === '') || channel.dI)
						])),
					$elm$html$Html$Events$onSubmit($author$project$MainMsg$SendMessage)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chat-input-icon')
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$paperclip)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chat-input-icon')
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$fileImage)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('file'),
							$elm$html$Html$Attributes$id('chat-file-input'),
							$elm$html$Html$Attributes$accept('image/*, application/pdf'),
							$elm$html$Html$Events$onInput($author$project$MainMsg$ChatFileRequested),
							$elm$html$Html$Attributes$disabled(channel.dI)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id('chat-file-text'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'chat-file-text-hidden',
									!$elm$core$String$length(chatFileText))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(chatFileText)
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Attributes$class('chat-input-field'),
							$elm$html$Html$Attributes$disabled(channel.dI),
							$elm$html$Html$Attributes$placeholder('Write Something here...'),
							$elm$html$Html$Attributes$value(body),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
							$elm$html$Html$Attributes$disabled(channel.aa === '')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('chat-submit-button', true),
									_Utils_Tuple2('submit-button-diabled', channel.dI)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Send')
						]))
				]));
	});
var $author$project$MainMsg$ToggleNotificationModalFromMessages = F4(
	function (a, b, c, d) {
		return {$: 222, a: a, b: b, c: c, d: d};
	});
var $author$project$Views$Messages$findProjectId = F2(
	function (conversation, projects) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyProject,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.bS;
						},
						conversation.ix),
					projects))).c$;
	});
var $author$project$Views$Messages$scheduleForCallbackButton = F2(
	function (projects, conversation) {
		var project = A2($author$project$Utils$findProject, projects, conversation.iw);
		var deadline = A2($author$project$Project$findDeadline, project.g6, 'Callback');
		return (deadline.bS !== '') ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('quick-action-button')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(
							'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Callback'))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Schedule for callback')
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Messages$chatQuickActions = F5(
	function (notificationData, stage, user, conversation, projects) {
		if (!user.V) {
			switch (stage) {
				case 2:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Accepted Application', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept Application')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reject-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Rejected Application', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reject Application')
									]))
							]));
				case 5:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Quick Actions')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Audition Accepted', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept Audition Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reject-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Audition Rejected', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reject Audition Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Audition Reschedule Requested', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Request Reschedule')
									]))
							]));
				case 11:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Quick Actions')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Callback Accepted', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept Callback Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reject-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Callback Rejected', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reject Callback Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Callback Reschedule Requested', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Request Reschedule')
									]))
							]));
				case 17:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Quick Actions')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Accepted', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Accept Booking Request')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reject-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Rejected', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Reject Booking Request')
									]))
							]));
				default:
					return A2($elm$html$Html$span, _List_Nil, _List_Nil);
			}
		} else {
			switch (stage) {
				case 0:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: User Applied to the role.')
									]))
							]));
				case 2:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Waiting for response to application request.')
									]))
							]));
				case 3:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Accepted Application Request')
									]))
							]));
				case 4:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Rejected Application Request')
									]))
							]));
				case 5:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Waiting for response to audition scheduling request.')
									]))
							]));
				case 6:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2($author$project$Views$Messages$scheduleForCallbackButton, projects, conversation),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Accepted audition schedule. ')
									]))
							]));
				case 7:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Audition'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Rejected audition schedule.')
									]))
							]));
				case 8:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Audition'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Requested to reschedule audition.')
									]))
							]));
				case 9:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Audition'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Requested to reschedule audition.')
									]))
							]));
				case 11:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Waiting for response to callback scheduling request.')
									]))
							]));
				case 12:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Accepted callback schedule.')
									]))
							]));
				case 14:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Callback'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Requested to reschedule callback')
									]))
							]));
				case 13:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Callback'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Rejected callback schedule.')
									]))
							]));
				case 15:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('QUICK ACTIONS:')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button reschedule-button')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												'/schedules/' + (A2($author$project$Views$Messages$findProjectId, conversation, projects) + '/Callback'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reschedule Candidate')
											]))
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-button accept-button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, conversation.aX, conversation.eE, 'Booking Request', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Book Candidate')
									])),
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Requested to reschedule callback')
									]))
							]));
				case 17:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Waiting for response to booking request.')
									]))
							]));
				case 18:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Accepted booking request.')
									]))
							]));
				case 19:
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-quick-actions-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('quick-action-status-text')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('CURRENT STATUS: Rejected booking request.')
									]))
							]));
				default:
					return $elm$html$Html$text('');
			}
		}
	});
var $author$project$Views$Messages$chatBoxFooter = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-footer-container')
			]),
		_List_fromArray(
			[
				A5($author$project$Views$Messages$chatQuickActions, model.bT, model.ce, model.E, model.t, model.F),
				A4($author$project$Views$Messages$chatInputBox, model.hU, model.t.aa, model.bo, model.t)
			]));
};
var $author$project$MainMsg$CloseTalentConversationContainer = {$: 231};
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $author$project$Views$Messages$chatBoxProjectInfo = function (_v0) {
	var currentChannel = _v0.t;
	var viewingTalentResult = _v0.v;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-project-info')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(currentChannel.ix)
					])),
				A2(
				$elm$html$Html$h5,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(currentChannel.iL)
					]))
			]));
};
var $author$project$MainMsg$ToggleTalentResultModal = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Views$Messages$headerInfo = F3(
	function (userProfile, channel, talentProfile) {
		var _v0 = userProfile.V;
		switch (_v0) {
			case 1:
				var avatar = (channel.jc === '') ? '/default_user.png' : channel.jc;
				return _Utils_Tuple2(avatar, channel.jf);
			case 0:
				var avatar = (channel.hF === '') ? '/default_user.png' : channel.hF;
				return _Utils_Tuple2(avatar, channel.hH);
			default:
				return _Utils_Tuple2('', '');
		}
	});
var $author$project$Views$Messages$chatBoxUserInfo = function (model) {
	var _v0 = A3($author$project$Views$Messages$headerInfo, model.E, model.t, model.v);
	var avatar = _v0.a;
	var name = _v0.b;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-user-info'),
				$elm$html$Html$Events$onClick(
				A3($author$project$MainMsg$ToggleTalentResultModal, model.v, $author$project$Job$emptyApplicant, ''))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chat-box-avatar-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$src(avatar)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chat-box-user-info')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(name)
							])),
						A2(
						$elm$html$Html$h5,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('')
							]))
					]))
			]));
};
var $author$project$Views$Messages$chatBoxHeader = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-header')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$MainMsg$CloseTalentConversationContainer),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('close-conversation-button', true),
								_Utils_Tuple2('close-conversation-hidden', model.E.V === 1)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('close')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('far fa-times-circle')
							]),
						_List_Nil)
					])),
				$author$project$Views$Messages$chatBoxUserInfo(model),
				$author$project$Views$Messages$chatBoxProjectInfo(model)
			]));
};
var $author$project$Views$Messages$correctAvatar = F3(
	function (creatorId, conversation, userProfile) {
		return _Utils_eq(creatorId, userProfile.c$) ? A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyImage,
			$elm$core$List$head(userProfile.l)).js : ((_Utils_eq(conversation.jd, creatorId) && (conversation.jc !== '')) ? conversation.jc : (((!_Utils_eq(creatorId, conversation.jd)) && (conversation.hF !== '')) ? conversation.hF : '/default_user.png'));
	});
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Views$Messages$messageContainer = F3(
	function (message, userProfile, conversation) {
		var _v0 = _Utils_eq(message.gW, userProfile.c$) ? _Utils_Tuple2(
			A3($author$project$Views$Messages$correctAvatar, message.gW, conversation, userProfile),
			'left') : _Utils_Tuple2(
			A3($author$project$Views$Messages$correctAvatar, message.gW, conversation, userProfile),
			'right');
		var messageAvatar = _v0.a;
		var side = _v0.b;
		var _v1 = message.aF;
		switch (_v1) {
			case 'media':
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('message', true),
											_Utils_Tuple2(side, true)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('message-avatar-container', true)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(messageAvatar)
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message-text-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message-text')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$a,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$href(message.bN),
															$elm$html$Html$Attributes$target('blank')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(message.dP)
														]))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message-time')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message.bh)
												]))
										]))
								]))
						]));
			case 'text':
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('message-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('message', true),
											_Utils_Tuple2(side, true)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('message-avatar-container', true)
												]))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$img,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$src(messageAvatar)
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('message-text-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message-text')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message.dP)
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('message-time')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message.bh)
												]))
										]))
								]))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Job$NotificationBody = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$NotificationFormMsg = function (a) {
	return {$: 223, a: a};
};
var $author$project$Views$Confirmations$notificationModal = F2(
	function (notification, isOpen) {
		var textType = function () {
			var _v2 = notification.hK;
			switch (_v2) {
				case 'Audition Rejected':
					return 'Reject ';
				case 'Audition Rescheduled':
					return 'Reschedule ';
				case 'Audition Reschedule Requested':
					return 'Reschedule ';
				case 'Audition Accepted':
					return 'Accept ';
				case 'Callback Rejected':
					return 'Reject ';
				case 'Callback Rescheduled':
					return 'Reschedule ';
				case 'Callback Reschedule Requested':
					return 'Reschedule ';
				case 'Callback Accepted':
					return 'Accept ';
				case 'Booking Accepted':
					return 'Accept ';
				case 'Booking Rejected':
					return 'Reject ';
				case 'Rejected Application':
					return 'Reject ';
				case 'Accepted Application':
					return 'Accept ';
				case 'Booking Request':
					return 'send ';
				default:
					return 'Send';
			}
		}();
		var textArea = function () {
			switch (textType) {
				case 'Accept ':
					return $elm$html$Html$text('');
				case 'send ':
					return $elm$html$Html$text('');
				default:
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Rejection Response:')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$NotificationFormMsg, $author$project$Job$NotificationBody)),
										$elm$html$Html$Attributes$placeholder('Please let casting know why you are unable to make this scheduled time....'),
										$elm$html$Html$Attributes$value(notification.dP)
									]),
								_List_Nil)
							]));
			}
		}();
		if (isOpen) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirmation-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to ' + (textType + ' this request?'))
							])),
						textArea,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('controls')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$UpdateUsersRoleStage, notification, notification.aX, notification.hK, notification.cA))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(textType + ' Request')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										A4($author$project$MainMsg$ToggleNotificationModalFromMessages, '', '', '', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Messages$chatBoxContainer = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-box-container')
			]),
		_List_fromArray(
			[
				$author$project$Views$Messages$chatBoxHeader(model),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('messages-container')
					]),
				A2(
					$elm$core$List$map,
					function (message) {
						return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Messages$messageContainer, message, model.E, model.t);
					},
					model.t.hV)),
				$author$project$Views$Messages$chatBoxFooter(model),
				A2($author$project$Views$Confirmations$notificationModal, model.bT, model.q)
			]));
};
var $author$project$MainMsg$ArchiveConversation = function (a) {
	return {$: 232, a: a};
};
var $author$project$MainMsg$SwitchConversation = function (a) {
	return {$: 226, a: a};
};
var $author$project$Views$Messages$archiveText = function (archived) {
	return archived ? 'Restore Conversation' : 'Archive Conversation';
};
var $author$project$Views$Messages$channelList = F4(
	function (conversation, userProfile, currentConversation, viewingTalent) {
		var selected = _Utils_eq(conversation.aa, currentConversation.aa);
		var _v0 = A3($author$project$Views$Messages$headerInfo, userProfile, conversation, viewingTalent);
		var avatar = _v0.a;
		var name = _v0.b;
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('selected-conversation', selected),
							_Utils_Tuple2('conversation-list-item', true)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$SwitchConversation(conversation.aa))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('archive-conversation-button', true),
									_Utils_Tuple2('restore-button', conversation.dI)
								])),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$ArchiveConversation(conversation.aa))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$Messages$archiveText(conversation.dI))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chat-index-image')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chat-image-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('new-message-indicator', true),
													_Utils_Tuple2('showing-indicator', conversation.bD > 0)
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$elm$core$String$fromInt(conversation.bD))
										])),
									A2(
									$elm$html$Html$img,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$src(avatar)
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chat-index-name-last-message-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(name)
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(conversation.hL)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('chat-index-project-time-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h5,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(conversation.ix)
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(conversation.cT)
								]))
						]))
				]));
	});
var $author$project$Message$ArchivedFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Message$ChatSearchTerm = function (a) {
	return {$: 4, a: a};
};
var $author$project$Message$ProjectFilter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Message$RoleFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$UpdateChatFilterValues = function (a) {
	return {$: 229, a: a};
};
var $author$project$Views$Messages$filterChatRoleNames = F2(
	function (projects, projectName) {
		return A2(
			$elm$core$List$map,
			function ($) {
				return $.bS;
			},
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$SharedProjectRoleSchedules$emptyProject,
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						A2(
							$author$project$Utils$eq,
							function ($) {
								return $.bS;
							},
							projectName),
						projects))).ft);
	});
var $frandibar$elm_font_awesome_5$FontAwesome$search = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('search');
var $frandibar$elm_font_awesome_5$FontAwesome$chevronDown = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('chevron-down');
var $author$project$Views$Form$selectFieldRegular = F4(
	function (aMsg, placeholderText, options, valueText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('select-field-regular')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(aMsg),
							$elm$html$Html$Attributes$placeholder(placeholderText),
							$elm$html$Html$Attributes$class('select-field')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionField, option, valueText);
						},
						options))
				]));
	});
var $author$project$Views$Messages$chatSortsAndFilters = function (_v0) {
	var chatFilterValues = _v0.ca;
	var allProjects = _v0.F;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-filters-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chat-search-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$search)
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateChatFilterValues, $author$project$Message$ChatSearchTerm))
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('chat-project-role-filters-container')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$Views$Form$selectFieldRegular,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateChatFilterValues, $author$project$Message$ProjectFilter),
						'Project',
						A2(
							$elm$core$List$cons,
							'Project',
							A2(
								$elm$core$List$map,
								function ($) {
									return $.bS;
								},
								allProjects)),
						chatFilterValues.iv),
						A4(
						$author$project$Views$Form$selectFieldRegular,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateChatFilterValues, $author$project$Message$RoleFilter),
						'Role',
						A2(
							$elm$core$List$cons,
							'Role',
							A2($author$project$Views$Messages$filterChatRoleNames, allProjects, chatFilterValues.iv)),
						chatFilterValues.fr)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('archived-read-filter-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								A3($elm$core$Basics$composeL, $author$project$MainMsg$UpdateChatFilterValues, $author$project$Message$ArchivedFilter, !chatFilterValues.gu)),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('active-option', chatFilterValues.gu)
									]))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Archived')
							]))
					]))
			]));
};
var $elm$virtual_dom$VirtualDom$lazy4 = _VirtualDom_lazy4;
var $elm$html$Html$Lazy$lazy4 = $elm$virtual_dom$VirtualDom$lazy4;
var $elm$core$String$toLower = _String_toLower;
var $author$project$Views$Messages$matchingChatsBySearchTerm = F2(
	function (term, conversations) {
		return (term !== '') ? A2(
			$elm$core$List$filter,
			function (channel) {
				var _v0 = _Utils_Tuple3(
					$elm$core$String$toLower(channel.jf),
					$elm$core$String$toLower(channel.iL),
					$elm$core$String$toLower(channel.ix));
				var talentName = _v0.a;
				var roleName = _v0.b;
				var projectName = _v0.c;
				return A2($elm$core$String$contains, term, talentName) || (A2($elm$core$String$contains, term, projectName) || A2($elm$core$String$contains, term, roleName));
			},
			conversations) : conversations;
	});
var $author$project$Views$Messages$matchingProjectChat = F2(
	function (project, conversations) {
		return (project !== 'Project') ? A2(
			$elm$core$List$filter,
			A2(
				$author$project$Utils$eq,
				function ($) {
					return $.ix;
				},
				project),
			conversations) : conversations;
	});
var $author$project$Views$Messages$matchingRoleChat = F2(
	function (role, conversations) {
		return (role !== 'Role') ? A2(
			$elm$core$List$filter,
			A2(
				$author$project$Utils$eq,
				function ($) {
					return $.iL;
				},
				role),
			conversations) : conversations;
	});
var $author$project$Views$Messages$filterChannels = F2(
	function (channels, filters) {
		return A2(
			$author$project$Views$Messages$matchingRoleChat,
			filters.fr,
			A2(
				$author$project$Views$Messages$matchingProjectChat,
				filters.iv,
				A2($author$project$Views$Messages$matchingChatsBySearchTerm, filters.fF, channels)));
	});
var $author$project$Views$Messages$showArchived = F2(
	function (channels, chatFilters) {
		return chatFilters.gu ? A2(
			$elm$core$List$filter,
			function (channel) {
				return channel.dI;
			},
			A2($author$project$Views$Messages$filterChannels, channels, chatFilters)) : A2(
			$elm$core$List$filter,
			function (channel) {
				return !channel.dI;
			},
			A2($author$project$Views$Messages$filterChannels, channels, chatFilters));
	});
var $author$project$Views$Messages$chatIndexContainer = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('chat-index-container')
			]),
		_List_fromArray(
			[
				$author$project$Views$Messages$chatSortsAndFilters(model),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (channel) {
						return A5($elm$html$Html$Lazy$lazy4, $author$project$Views$Messages$channelList, channel, model.E, model.t, model.v);
					},
					A2($author$project$Views$Messages$showArchived, model.n, model.ca)))
			]));
};
var $frandibar$elm_font_awesome_5$FontAwesome$circleNotch = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('circle-notch');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Views$Confirmations$confirmation = F5(
	function (showConfirmation, actionMessage, toggleMessage, confirmationText, destructiveActions) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal', true),
									_Utils_Tuple2('modal-open', showConfirmation)
								])),
							$elm$html$Html$Events$onClick(toggleMessage)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('delete-confirmation', true),
									_Utils_Tuple2('delete-showing', showConfirmation)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('JUST MAKING SURE...')
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(confirmationText)
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('destructive-actions')
								]),
							A2(
								$elm$core$List$map,
								function (action) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(action)
											]));
								},
								destructiveActions)),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirmation-button'),
									$elm$html$Html$Events$onClick(actionMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('confirmation-cancel-button'),
									$elm$html$Html$Events$onClick(toggleMessage)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No')
								]))
						]))
				]));
	});
var $author$project$SharedProjectRoleSchedules$ImagesShowing = 1;
var $author$project$Project$SchedulingDayOfPage = 6;
var $author$project$MainMsg$ToggleFullPageImages = function (a) {
	return {$: 318, a: a};
};
var $author$project$MainMsg$ToggleAttributes = {$: 291};
var $author$project$Views$TalentModal$attributesButton = F2(
	function (attributesShowing, modalPage) {
		if (modalPage === 6) {
			return attributesShowing ? A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggle-attributes'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleAttributes)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-chevron-left')
							]),
						_List_Nil),
						$elm$html$Html$text('Videos')
					])) : A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('toggle-attributes'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleAttributes)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Attributes'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-chevron-right')
							]),
						_List_Nil)
					]));
		} else {
			return $elm$html$Html$text('\'');
		}
	});
var $author$project$Views$TalentModal$contactInfoSection = function (viewingTalentResult) {
	var agent = A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyAgent,
		$elm$core$List$head(viewingTalentResult.gj.gp));
	return (viewingTalentResult.gj.aa === '') ? A2(
		$elm$html$Html$table,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Location:')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(viewingTalentResult.a0 + (', ' + viewingTalentResult.bf))
							]))
					]))
			])) : A2(
		$elm$html$Html$table,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Location:')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(viewingTalentResult.gj.a0 + (', ' + viewingTalentResult.gj.bf))
							]))
					])),
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Agent:')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(agent.bx)
							]))
					])),
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Phone:')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(agent.e0)
							]))
					])),
				A2(
				$elm$html$Html$tr,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-title')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Email')
							])),
						A2(
						$elm$html$Html$td,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('table-value')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(agent.bv)
							]))
					]))
			]));
};
var $author$project$Utils$convertHeightToFeetInches = function (height) {
	return A2(
		$elm$core$Maybe$withDefault,
		{j: '', g: 'N/A'},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (value) {
					return _Utils_eq(
						value.j,
						$elm$core$String$fromInt(height));
				},
				$author$project$InitData$heightValues)));
};
var $author$project$Views$TalentModal$fullPageImageContainer = F3(
	function (imageView, currentImage, otherImages) {
		var modalClass = function () {
			if (!imageView) {
				return 'full-page-images-modal';
			} else {
				return 'full-page-images-modal showing-full';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(modalClass),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ToggleFullPageImages(0))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('full-size-image-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(currentImage.js)
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Views$TalentModal$createBlanks = function (num) {
	return A2(
		$elm$core$List$repeat,
		num,
		A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('empty-image')
				]),
			_List_Nil));
};
var $author$project$MainMsg$ToggleCurrentGalleryImage = function (a) {
	return {$: 220, a: a};
};
var $author$project$Views$TalentModal$createImagePreviews = function (images) {
	return A2(
		$elm$core$List$map,
		function (image) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-preview-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$img,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleCurrentGalleryImage(image)),
								$elm$html$Html$Attributes$src(image.js)
							]),
						_List_Nil)
					]));
		},
		images);
};
var $author$project$Views$TalentModal$mergeImagesAndBlanks = F2(
	function (images, blanks) {
		return A2($elm$core$List$append, images, blanks);
	});
var $author$project$Views$TalentModal$moreImages = function (images) {
	return ($elm$core$List$length(images) < 5) ? A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-images')
			]),
		A2(
			$elm$core$List$map,
			function (image) {
				return image;
			},
			A2(
				$author$project$Views$TalentModal$mergeImagesAndBlanks,
				$author$project$Views$TalentModal$createImagePreviews(images),
				$author$project$Views$TalentModal$createBlanks(
					5 - $elm$core$List$length(images))))) : A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('more-images')
			]),
		A2(
			$elm$core$List$map,
			function (image) {
				return image;
			},
			$author$project$Views$TalentModal$createImagePreviews(
				A2($elm$core$List$take, 5, images))));
};
var $author$project$SharedProjectRoleSchedules$ChangeRole = 2;
var $author$project$MainMsg$ChangeUsersRole = {$: 217};
var $author$project$SharedProjectRoleSchedules$Move = 0;
var $author$project$MainMsg$MoveAllCandidates = {$: 163};
var $author$project$MainMsg$MoveExistingCandidate = function (a) {
	return {$: 162, a: a};
};
var $author$project$MainMsg$MoveNewCandidate = F2(
	function (a, b) {
		return {$: 164, a: a, b: b};
	});
var $author$project$MainMsg$RemoveAllCandidates = {$: 178};
var $author$project$MainMsg$ToggleQuickActionView = function (a) {
	return {$: 149, a: a};
};
var $author$project$MainMsg$ToggleSelectedTalent = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$MainMsg$UpdateGoToColumn = function (a) {
	return {$: 161, a: a};
};
var $author$project$MainMsg$UpdateGoToProject = function (a) {
	return {$: 165, a: a};
};
var $author$project$MainMsg$UpdateGoToRole = function (a) {
	return {$: 166, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$chevronLeft = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('chevron-left');
var $author$project$Views$TalentModal$columnNamesAndIds = function (columns) {
	return A2(
		$elm$core$List$map,
		function (column) {
			return (column.g2 !== '') ? {aa: column.aa, bS: column.g2} : {aa: column.aa, bS: column.bS};
		},
		A2(
			$elm$core$List$filter,
			function (column) {
				return (!column.hC) && ((column.bS === 'Matching Candidates') || (column.bS === 'Selected Candidates'));
			},
			columns));
};
var $author$project$Views$TalentModal$enableBookingButton = function (stage) {
	return !A2(
		$elm$core$List$member,
		stage,
		_List_fromArray(
			[18, 17, 19, 4, 2]));
};
var $author$project$Views$TalentModal$enableMoveButton = function (stage) {
	return !A2(
		$elm$core$List$member,
		stage,
		_List_fromArray(
			[4, 2]));
};
var $author$project$Views$TalentModal$projectNamesAndIds = function (projects) {
	return A2(
		$elm$core$List$map,
		function (project) {
			return {aa: project.c$, bS: project.bS};
		},
		A2(
			$elm$core$List$filter,
			function (p) {
				return p.hB;
			},
			projects));
};
var $author$project$Views$TalentModal$quickActionButton = F3(
	function (action, buttonName, show) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('action', true),
							_Utils_Tuple2('show-action', show)
						])),
					$elm$html$Html$Events$onClick(action)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(buttonName)
				]));
	});
var $author$project$MainMsg$UpdateChangeRoleInfo = F3(
	function (a, b, c) {
		return {$: 218, a: a, b: b, c: c};
	});
var $author$project$Views$TalentModal$optionField = F2(
	function (item, selectedId) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item.aa),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item.aa, selectedId))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.bS)
				]));
	});
var $author$project$Views$TalentModal$roleChangeSelectBox = F5(
	function (placeholderText, options, roleMemberId, userId, selectedId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						function (selection) {
							return A3($author$project$MainMsg$UpdateChangeRoleInfo, roleMemberId, selection, userId);
						}),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A2($author$project$Views$TalentModal$optionField, option, selectedId);
					},
					options))
			]);
	});
var $author$project$Views$TalentModal$roleNamesAndIds = F2(
	function (roles, projectId) {
		return A2(
			$elm$core$List$map,
			function (role) {
				return {aa: role.c$, bS: role.bS};
			},
			A2(
				$elm$core$List$filter,
				function (role) {
					return _Utils_eq(role.iw, projectId);
				},
				roles));
	});
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $author$project$Views$Form$optionField = function (item) {
	return A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(item.aa)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(item.bS)
			]));
};
var $author$project$Views$Form$selectField = F3(
	function (aMsg, placeholderText, options) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(aMsg),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A2($elm$html$Html$Lazy$lazy, $author$project$Views$Form$optionField, option);
					},
					options))
			]);
	});
var $author$project$Views$TalentModal$selectedUser = F2(
	function (user, selectedTalent) {
		return A2(
			$elm$core$List$member,
			user.c$,
			A2(
				$elm$core$List$map,
				function (talent) {
					return talent.c$;
				},
				selectedTalent));
	});
var $author$project$Views$TalentModal$selectionText = F2(
	function (user, selectedUsers) {
		return A2($author$project$Views$TalentModal$selectedUser, user, selectedUsers) ? 'Unselect Candidate' : 'Select Candidate';
	});
var $author$project$MainMsg$CreateConversation = function (a) {
	return {$: 111, a: a};
};
var $author$project$Views$TalentModal$sendMessage = F3(
	function (userId, bodyText, status) {
		return ((bodyText === '') || (!status)) ? $author$project$MainMsg$NoOp : $author$project$MainMsg$CreateConversation(userId);
	});
var $author$project$Views$TalentModal$sendMessageButtonText = function (status) {
	switch (status) {
		case 0:
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
						$frandibar$elm_font_awesome_5$FontAwesome$spinner,
						0,
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
							]),
						_List_Nil)
					]));
		case 3:
			return $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$check);
		case 2:
			return $elm$html$Html$text('Send');
		default:
			return $elm$html$Html$text('Send');
	}
};
var $author$project$MainMsg$RegisterVote = F3(
	function (a, b, c) {
		return {$: 273, a: a, b: b, c: c};
	});
var $author$project$MainMsg$SubmitComment = function (a) {
	return {$: 282, a: a};
};
var $author$project$Views$TalentModal$commentItem = F2(
	function (comment, userProfile) {
		var editButton = _Utils_eq(comment.gW, userProfile.c$) ? A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('comment-edit-button')
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('edit')
				])) : $elm$html$Html$text('');
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('comment-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('user-comment-photo')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(comment.d1)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('creator-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(comment.d2)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('created-date')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(comment.fY)
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('comment-body')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(comment.dP)
						]))
				]));
	});
var $author$project$SharedProjectRoleSchedules$emptyTimeSlot = {
	d_: _List_Nil,
	hd: $elm$time$Time$millisToPosix(0),
	eq: '',
	aa: '',
	iO: '',
	fB: '',
	f_: $author$project$User$emptyPipelineUser,
	f6: _List_Nil
};
var $author$project$SharedProjectRoleSchedules$emptyVote = {aa: '', aX: '', f5: '', f7: '', f8: ''};
var $author$project$MainMsg$ToggleCommentExpand = {$: 284};
var $author$project$Views$TalentModal$expandButton = function (action) {
	switch (action) {
		case 4:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('comments-expand'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleCommentExpand)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Expand Comments'),
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-plus')
							]),
						_List_Nil)
					]));
		case 5:
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('comments-expand'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleCommentExpand)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Collapse Comments'),
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-minus')
							]),
						_List_Nil)
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$Views$TalentModal$widthCalculation = F2(
	function (votes, timeSlot) {
		return (timeSlot.f_.c$ === '') ? '0%' : ($elm$core$String$fromFloat(
			(votes / $elm$core$List$length(timeSlot.f6)) * 100) + '%');
	});
var $author$project$Views$TalentModal$votingModal = F5(
	function (schedulePageData, viewingTalentResult, userProfile, voting, action) {
		var timeSlot = A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyTimeSlot,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (ts) {
						return _Utils_eq(ts.f_.c$, viewingTalentResult.c$);
					},
					schedulePageData.cf.jl)));
		var yesVotes = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (vote) {
					return vote.f5 === 'yes';
				},
				timeSlot.f6));
		var noVotes = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (vote) {
					return vote.f5 === 'no';
				},
				timeSlot.f6));
		var myVote = A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptyVote,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (vote) {
						return _Utils_eq(vote.f7, userProfile.c$);
					},
					timeSlot.f6)));
		var maybeVotes = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function (vote) {
					return vote.f5 === 'maybe';
				},
				timeSlot.f6));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(voting)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('voting-details-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('yes-button', true),
											_Utils_Tuple2('yes-colored', myVote.f5 === 'yes')
										])),
									$elm$html$Html$Events$onClick(
									A3($author$project$MainMsg$RegisterVote, timeSlot.f_.aX, 'yes', timeSlot.aa))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('maybe-button', true),
											_Utils_Tuple2('maybe-colored', myVote.f5 === 'maybe')
										])),
									$elm$html$Html$Events$onClick(
									A3($author$project$MainMsg$RegisterVote, timeSlot.f_.aX, 'maybe', timeSlot.aa))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Maybe')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('no-button', true),
											_Utils_Tuple2('no-colored', myVote.f5 === 'no')
										])),
									$elm$html$Html$Events$onClick(
									A3($author$project$MainMsg$RegisterVote, timeSlot.f_.aX, 'no', timeSlot.aa))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('No')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('voting-breakdown-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('vote-bar-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('vote-total')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(yesVotes))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('yes-bar'),
													A2(
													$elm$html$Html$Attributes$style,
													'width',
													A2($author$project$Views$TalentModal$widthCalculation, yesVotes, timeSlot))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('vote-bar-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('vote-total')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(maybeVotes))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('maybe-bar'),
													A2(
													$elm$html$Html$Attributes$style,
													'width',
													A2($author$project$Views$TalentModal$widthCalculation, maybeVotes, timeSlot))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('vote-bar-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('vote-total')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													$elm$core$String$fromInt(noVotes))
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('no-bar'),
													A2(
													$elm$html$Html$Attributes$style,
													'width',
													A2($author$project$Views$TalentModal$widthCalculation, noVotes, timeSlot))
												]),
											_List_Nil)
										]))
								])),
							$author$project$Views$TalentModal$expandButton(action)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('comment-section-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('comments-section')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('comments')
										]),
									A2(
										$elm$core$List$map,
										function (comment) {
											return A2($author$project$Views$TalentModal$commentItem, comment, userProfile);
										},
										timeSlot.d_)),
									A2(
									$elm$html$Html$form,
									_List_fromArray(
										[
											$elm$html$Html$Events$onSubmit(
											$author$project$MainMsg$SubmitComment(timeSlot.aa)),
											$elm$html$Html$Attributes$class('comment-form-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('user-comment-photo')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$img,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$src(
															A2(
																$elm$core$Maybe$withDefault,
																$author$project$User$emptyImage,
																$elm$core$List$head(userProfile.l)).js)
														]),
													_List_Nil)
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(schedulePageData.cb),
													$elm$html$Html$Attributes$placeholder('Write a comment...'),
													$elm$html$Html$Events$onInput($author$project$MainMsg$UpdateVotingComment)
												]),
											_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('comment-submit-button'),
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$SubmitComment(timeSlot.aa))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Submit')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Views$TalentModal$quickActionBar = function (action) {
	return function (viewingTalentResult) {
		return function (selectedTalent) {
			return function (applicant) {
				return function (pipeline) {
					return function (modalPage) {
						return function (projects) {
							return function (roles) {
								return function (projectId) {
									return function (currentColumnId) {
										return function (project) {
											return function (selectedRoleId) {
												return function (twilioStatus) {
													return function (userProfile) {
														return function (newMessageBody) {
															return function (creatorId) {
																return function (schedulePageData) {
																	var _v0 = function () {
																		switch (action) {
																			case 3:
																				return {a$: 'change-role action-hidden', a7: 'send-message action-hidden', a8: 'move-candidate action-hidden', a9: 'options', bz: 'request-candidate action-hidden', bl: 'vote-section action-hidden'};
																			case 1:
																				return {a$: 'change-role action-hidden', a7: 'send-message', a8: 'move-candidate action-hidden', a9: 'options action-hidden', bz: 'request-candidate action-hidden', bl: 'vote-section action-hidden'};
																			case 2:
																				return {a$: 'change-role', a7: 'send-message action-hidden', a8: 'move-candidate action-hidden', a9: 'options action-hidden', bz: 'request-candidate action-hidden', bl: 'vote-section action-hidden'};
																			case 0:
																				return {a$: 'change-role action-hidden', a7: 'send-message action-hidden', a8: 'move-candidate', a9: 'options action-hidden', bz: 'request-candidate action-hidden', bl: 'vote-section action-hidden'};
																			case 4:
																				return {a$: 'change-role action-hidden', a7: 'send-message action-hidden', a8: 'move-candidate action-hidden', a9: 'options action-hidden', bz: 'request-candidate action-hidden', bl: 'vote-section'};
																			default:
																				return {a$: 'change-role action-hidden', a7: 'send-message action-hidden', a8: 'move-candidate action-hidden', a9: 'options action-hidden', bz: 'request-candidate action-hidden', bl: 'vote-section'};
																		}
																	}();
																	var opt = _v0.a9;
																	var mes = _v0.a7;
																	var move = _v0.a8;
																	var change = _v0.a$;
																	var voting = _v0.bl;
																	switch (modalPage) {
																		case 1:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A2($author$project$MainMsg$ToggleSelectedTalent, viewingTalentResult.c$, viewingTalentResult),
																								A2($author$project$Views$TalentModal$selectionText, viewingTalentResult, selectedTalent),
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(0),
																								'Move Candidate',
																								$author$project$Views$TalentModal$enableMoveButton(viewingTalentResult.i3)),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(1),
																								'Send Message',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(2),
																								'Change Role',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aX, userProfile.c$, 'Booking Request', ''),
																								'Send Booking Request',
																								$author$project$Views$TalentModal$enableBookingButton(viewingTalentResult.i3))
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(move)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_Nil,
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToColumn,
																									'Move To:',
																									$author$project$Views$TalentModal$columnNamesAndIds(pipeline))),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('move-candidate-button'),
																										$elm$html$Html$Events$onClick(
																										$author$project$MainMsg$MoveExistingCandidate(viewingTalentResult.aX))
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Move Candidate')
																									]))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(change)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_Nil,
																								A5(
																									$author$project$Views$TalentModal$roleChangeSelectBox,
																									'Change Role To:',
																									A2(
																										$elm$core$List$cons,
																										{aa: '', bS: ''},
																										A2(
																											$elm$core$List$map,
																											function (role) {
																												return {aa: role.c$, bS: role.bS};
																											},
																											project.ft)),
																									viewingTalentResult.aX,
																									viewingTalentResult.c$,
																									selectedRoleId)),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('move-candidate-button'),
																										$elm$html$Html$Events$onClick($author$project$MainMsg$ChangeUsersRole)
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Change Role')
																									]))
																							]))
																					]));
																		case 2:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3($author$project$Views$TalentModal$quickActionButton, $author$project$MainMsg$RemoveAllCandidates, 'Unselect All', true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(0),
																								'Move Candidates',
																								true),
																								A3($author$project$Views$TalentModal$quickActionButton, $author$project$MainMsg$NoOp, 'Schedule Candidates', false)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2(move, true),
																										_Utils_Tuple2('move-to-pipe', true)
																									]))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToProject,
																									'Select Project',
																									A2(
																										$elm$core$List$cons,
																										{aa: '', bS: ''},
																										$author$project$Views$TalentModal$projectNamesAndIds(projects)))),
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToRole,
																									'Select Role',
																									A2(
																										$elm$core$List$cons,
																										{aa: '', bS: ''},
																										A2($author$project$Views$TalentModal$roleNamesAndIds, roles, projectId)))),
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToColumn,
																									'Select Stage',
																									A2(
																										$elm$core$List$cons,
																										{aa: '', bS: ''},
																										$author$project$Views$TalentModal$columnNamesAndIds(pipeline)))),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$classList(
																										_List_fromArray(
																											[
																												_Utils_Tuple2('move-candidate-button', true),
																												_Utils_Tuple2('to-pipe-button', true)
																											])),
																										$elm$html$Html$Events$onClick(
																										A2($author$project$MainMsg$MoveNewCandidate, selectedTalent, projectId))
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Move Candidates')
																									]))
																							]))
																					]));
																		case 3:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A3($author$project$Views$TalentModal$quickActionButton, $author$project$MainMsg$RemoveAllCandidates, 'Unselect All', true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(0),
																								'Move Candidates',
																								true)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(move)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_Nil,
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToColumn,
																									'Move To:',
																									$author$project$Views$TalentModal$columnNamesAndIds(
																										A2($elm$core$List$cons, $author$project$Pipeline$emptyColumn, pipeline)))),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('move-candidate-button'),
																										$elm$html$Html$Events$onClick($author$project$MainMsg$MoveAllCandidates)
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Move Candidates')
																									]))
																							]))
																					]));
																		case 0:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A2($author$project$MainMsg$ToggleSelectedTalent, viewingTalentResult.c$, viewingTalentResult),
																								A2($author$project$Views$TalentModal$selectionText, viewingTalentResult, selectedTalent),
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(0),
																								'Add To Project',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aX, userProfile.c$, 'Booking Request', ''),
																								'Request Candidate',
																								!applicant.i3),
																								A3($author$project$Views$TalentModal$quickActionButton, $author$project$MainMsg$NoOp, 'Schedule Candidate', false)
																							])),
																						A2(
																						$elm$html$Html$div,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2(move, true),
																										_Utils_Tuple2('move-to-pipe', true)
																									]))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToProject,
																									'Select Project',
																									A2(
																										$elm$core$List$cons,
																										{aa: '', bS: ''},
																										$author$project$Views$TalentModal$projectNamesAndIds(projects)))),
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToRole,
																									'Select Role',
																									A2(
																										$elm$core$List$cons,
																										{aa: '', bS: ''},
																										A2($author$project$Views$TalentModal$roleNamesAndIds, roles, projectId)))),
																								A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('talent-search-moving')
																									]),
																								A3(
																									$author$project$Views$Form$selectField,
																									$author$project$MainMsg$UpdateGoToColumn,
																									'Select Stage',
																									A2(
																										$elm$core$List$cons,
																										{aa: '', bS: ''},
																										$author$project$Views$TalentModal$columnNamesAndIds(pipeline)))),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$classList(
																										_List_fromArray(
																											[
																												_Utils_Tuple2('move-candidate-button', true),
																												_Utils_Tuple2('to-pipe-button', true)
																											])),
																										$elm$html$Html$Events$onClick(
																										A2(
																											$author$project$MainMsg$MoveNewCandidate,
																											_List_fromArray(
																												[viewingTalentResult]),
																											projectId))
																									]),
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Move Candidate')
																									]))
																							]))
																					]));
																		case 4:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(1),
																								'Send Message',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aX, userProfile.c$, 'Booking Request', ''),
																								'Request Candidate',
																								!applicant.i3)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							]))
																					]));
																		case 5:
																			return A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(1),
																								'Send Message',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aX, userProfile.c$, 'Booking Request', ''),
																								'Request Candidate',
																								!applicant.i3)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							]))
																					]));
																		default:
																			return ((userProfile.V === 2) || (!_Utils_eq(userProfile.c$, creatorId))) ? A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(4),
																								'Votes',
																								true)
																							])),
																						A5($author$project$Views$TalentModal$votingModal, schedulePageData, viewingTalentResult, userProfile, voting, action)
																					])) : A2(
																				$elm$html$Html$div,
																				_List_Nil,
																				_List_fromArray(
																					[
																						A2(
																						$elm$html$Html$span,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$classList(
																								_List_fromArray(
																									[
																										_Utils_Tuple2('back-button', true),
																										_Utils_Tuple2('back-hidden', action === 3)
																									])),
																								$elm$html$Html$Events$onClick(
																								$author$project$MainMsg$ToggleQuickActionView(3))
																							]),
																						_List_fromArray(
																							[
																								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft)
																							])),
																						A2(
																						$elm$html$Html$ul,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(opt)
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$h3,
																								_List_Nil,
																								_List_fromArray(
																									[
																										$elm$html$Html$text('Quick Actions:')
																									])),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(1),
																								'Send Message',
																								true),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								A4($author$project$MainMsg$ToggleNotificationModalFromMessages, viewingTalentResult.aX, userProfile.c$, 'Booking Request', ''),
																								'Request Candidate',
																								!applicant.i3),
																								A3(
																								$author$project$Views$TalentModal$quickActionButton,
																								$author$project$MainMsg$ToggleQuickActionView(4),
																								'Votes',
																								true)
																							])),
																						A2(
																						$elm$html$Html$form,
																						_List_fromArray(
																							[
																								$elm$html$Html$Attributes$class(mes),
																								$elm$html$Html$Events$onSubmit(
																								A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$elm$html$Html$input,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$type_('text'),
																										$elm$html$Html$Events$onInput(
																										A2($elm$core$Basics$composeL, $author$project$MainMsg$NewMessageMsg, $elm$core$Basics$identity)),
																										$elm$html$Html$Attributes$value(newMessageBody)
																									]),
																								_List_Nil),
																								A2(
																								$elm$html$Html$span,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$class('send-message-button'),
																										$elm$html$Html$Events$onClick(
																										A3($author$project$Views$TalentModal$sendMessage, viewingTalentResult.c$, newMessageBody, twilioStatus))
																									]),
																								_List_fromArray(
																									[
																										$author$project$Views$TalentModal$sendMessageButtonText(twilioStatus)
																									]))
																							])),
																						A5($author$project$Views$TalentModal$votingModal, schedulePageData, viewingTalentResult, userProfile, voting, action)
																					]));
																	}
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$TalentModal$resumeSection = function (maybeResume) {
	if (maybeResume.$ === 1) {
		return $elm$html$Html$text('');
	} else {
		var resume = maybeResume.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-item-icon')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(resume),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fa fa-file')
								]),
							_List_Nil),
							$elm$html$Html$text('View Resume')
						]))
				]));
	}
};
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $author$project$MainMsg$VideoRequested = {$: 115};
var $author$project$Views$TalentModal$uploadingButton = F2(
	function (collaborator, videoUpload) {
		if (collaborator) {
			return $elm$html$Html$text('');
		} else {
			switch (videoUpload.$) {
				case 0:
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-videos-button'),
								$elm$html$Html$Events$onClick($author$project$MainMsg$VideoRequested)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('upload media')
							]));
				case 1:
					var fraction = videoUpload.a;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('add-videos-button')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('fas fa-circle-notch fa-spin')
									]),
								_List_Nil),
								$elm$html$Html$text('Processing...')
							]));
				default:
					return $elm$html$Html$text('');
			}
		}
	});
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$MainMsg$ChangeVideo = function (a) {
	return {$: 285, a: a};
};
var $author$project$MainMsg$DeleteVideo = function (a) {
	return {$: 289, a: a};
};
var $author$project$MainMsg$ToggleVideoVisibility = function (a) {
	return {$: 288, a: a};
};
var $author$project$Views$TalentModal$formatLength = function (length) {
	var total_length = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toFloat(length));
	return (total_length > 60) ? ($elm$core$String$fromInt(
		$elm$core$Basics$floor(total_length / 60.0)) + ' minutes') : (((total_length > 1) && (total_length < 2)) ? ($elm$core$String$fromInt(
		$elm$core$Basics$floor(total_length)) + ' second') : ($elm$core$String$fromInt(
		$elm$core$Basics$floor(total_length)) + ' seconds'));
};
var $author$project$Views$TalentModal$videoLi = F3(
	function (video, currentVideo, collaborator) {
		var _v0 = (video.fb === '0%') ? _Utils_Tuple2(
			'Queued',
			$elm$html$Html$text('')) : ((video.fb === '100%') ? _Utils_Tuple2(
			'Finalizing',
			$elm$html$Html$text('')) : _Utils_Tuple2(
			'Processing...',
			A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-circle-notch fa-spin')
					]),
				_List_Nil)));
		var stage = _v0.a;
		var loader = _v0.b;
		var videoDetails = (video.bS === '') ? $elm$html$Html$text('') : ((video.e$ && (video.bS !== '')) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('video-li')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(video.bS)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							loader,
							$elm$html$Html$text(stage)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-loading-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('loading-status-bar'),
									A2($elm$html$Html$Attributes$style, 'width', video.fb)
								]),
							_List_Nil)
						]))
				])) : (video.ef ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('video-li')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('delete-video fas fa-trash-alt'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$DeleteVideo(video.aa))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(video.bS)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Failed to process.')
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('video-li')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('delete-video fas fa-trash-alt'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$DeleteVideo(video.aa))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('video-name')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(video.bS)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$TalentModal$formatLength(video.eI))
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('visible'),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(video.ds),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$ToggleVideoVisibility(video.aa))
								]),
							_List_Nil)
						]))
				]))));
		return collaborator ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('video-li', true),
							_Utils_Tuple2(
							'active-video',
							_Utils_eq(video.aa, currentVideo.aa))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ChangeVideo(video))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(video.bS)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$TalentModal$formatLength(video.eI))
						]))
				])) : A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'active-video',
							_Utils_eq(video.aa, currentVideo.aa))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$ChangeVideo(video))
				]),
			_List_fromArray(
				[videoDetails]));
	});
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Views$TalentModal$videoSection = F6(
	function (showVideo, videos, currentVideo, userProfile, creatorId, videoUpload) {
		var collaborator = (userProfile.V === 2) || (!_Utils_eq(userProfile.c$, creatorId));
		var videoList = collaborator ? A2(
			$elm$core$List$filter,
			function (video) {
				return video.ds;
			},
			videos) : videos;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('video-container', true),
							_Utils_Tuple2('showing-video', showVideo)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$video,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$width(400),
							$elm$html$Html$Attributes$height(240),
							$elm$html$Html$Attributes$controls(true),
							$elm$html$Html$Attributes$src(currentVideo.js)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Views$TalentModal$uploadingButton, collaborator, videoUpload),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('video-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Available Videos')
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('availiable-videos')
								]),
							A2(
								$elm$core$List$map,
								function (video) {
									return A3($author$project$Views$TalentModal$videoLi, video, currentVideo, collaborator);
								},
								videoList))
						]))
				]));
	});
var $author$project$Views$TalentModal$talentSearchResultModal = function (viewingTalentResult) {
	return function (currentGalleryImage) {
		return function (selectedTalent) {
			return function (open) {
				return function (action) {
					return function (applicantData) {
						return function (pipeline) {
							return function (modalPage) {
								return function (projects) {
									return function (roles) {
										return function (projectId) {
											return function (currentColumnId) {
												return function (project) {
													return function (selectedRoleId) {
														return function (twilioStatus) {
															return function (userProfile) {
																return function (newMessageBody) {
																	return function (creatorId) {
																		return function (schedulePageData) {
																			return function (currentVideo) {
																				return function (videoUpload) {
																					return function (attributesShowing) {
																						return function (fullImageModal) {
																							var videoShowing = (modalPage === 6) && (!attributesShowing);
																							var age = ((viewingTalentResult.dA > 0) && (viewingTalentResult.dA < 18)) ? ($elm$core$String$fromInt(viewingTalentResult.dA) + ' (underage)') : (((viewingTalentResult.dA > 0) && (viewingTalentResult.dA < 100)) ? $elm$core$String$fromInt(viewingTalentResult.dA) : 'N/A');
																							return A2(
																								$elm$html$Html$div,
																								_List_fromArray(
																									[
																										$elm$html$Html$Attributes$classList(
																										_List_fromArray(
																											[
																												_Utils_Tuple2('talent-search-profile__container', true),
																												_Utils_Tuple2('talent-search-profile__container--open', open)
																											]))
																									]),
																								_List_fromArray(
																									[
																										A2(
																										$author$project$Views$ModalOverlay$modal,
																										A3($author$project$MainMsg$ToggleTalentResultModal, viewingTalentResult, $author$project$Job$emptyApplicant, ''),
																										open),
																										A3($author$project$Views$TalentModal$fullPageImageContainer, fullImageModal, currentGalleryImage, viewingTalentResult.l),
																										A2(
																										$elm$html$Html$div,
																										_List_fromArray(
																											[
																												$elm$html$Html$Attributes$classList(
																												_List_fromArray(
																													[
																														_Utils_Tuple2('talent-search-profile', true),
																														_Utils_Tuple2('talent-profile-open', open)
																													]))
																											]),
																										_List_fromArray(
																											[
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$class('profile-header')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$h3,
																														_List_Nil,
																														_List_fromArray(
																															[
																																$elm$html$Html$text(viewingTalentResult.bx + (' ' + viewingTalentResult.bP))
																															])),
																														A2(
																														$elm$html$Html$span,
																														_List_fromArray(
																															[
																																$elm$html$Html$Events$onClick(
																																A3($author$project$MainMsg$ToggleTalentResultModal, $author$project$User$emptySearchTalentProfile, $author$project$Job$emptyApplicant, ''))
																															]),
																														_List_fromArray(
																															[
																																$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$times)
																															]))
																													])),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$class('profile-images')
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$img,
																														_List_fromArray(
																															[
																																$elm$html$Html$Attributes$src(currentGalleryImage.js),
																																$elm$html$Html$Attributes$class('active-image')
																															]),
																														_List_Nil),
																														A2(
																														$elm$html$Html$span,
																														_List_fromArray(
																															[
																																$elm$html$Html$Attributes$class('fas fa-expand-arrows-alt'),
																																$elm$html$Html$Events$onClick(
																																$author$project$MainMsg$ToggleFullPageImages(1))
																															]),
																														_List_Nil),
																														$author$project$Views$TalentModal$moreImages(viewingTalentResult.l),
																														$author$project$Views$TalentModal$resumeSection(viewingTalentResult.iH)
																													])),
																												A6($author$project$Views$TalentModal$videoSection, videoShowing, viewingTalentResult.a_, currentVideo, userProfile, creatorId, videoUpload),
																												A2($author$project$Views$TalentModal$attributesButton, attributesShowing, modalPage),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$classList(
																														_List_fromArray(
																															[
																																_Utils_Tuple2('attributes-container', true),
																																_Utils_Tuple2('video-present', videoShowing),
																																_Utils_Tuple2('attributes-showing', attributesShowing)
																															]))
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$h3,
																														_List_Nil,
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Attributes')
																															])),
																														A2(
																														$elm$html$Html$table,
																														_List_Nil,
																														_List_fromArray(
																															[
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Gender:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(viewingTalentResult.hq)
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Height:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				$author$project$Utils$convertHeightToFeetInches(viewingTalentResult.ht).g)
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Weight:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				$elm$core$String$fromInt(viewingTalentResult.jC))
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Waist Size:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(
																																				$elm$core$String$fromFloat(viewingTalentResult.jA) + '\"')
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Hair/Length:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('')
																																			]))
																																	])),
																																A2(
																																$elm$html$Html$tr,
																																_List_Nil,
																																_List_fromArray(
																																	[
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-title')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text('Age:')
																																			])),
																																		A2(
																																		$elm$html$Html$td,
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$Attributes$class('table-value')
																																			]),
																																		_List_fromArray(
																																			[
																																				$elm$html$Html$text(age)
																																			]))
																																	]))
																															]))
																													])),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$classList(
																														_List_fromArray(
																															[
																																_Utils_Tuple2('contact-container', true),
																																_Utils_Tuple2('attributes-container', true),
																																_Utils_Tuple2('video-present', videoShowing),
																																_Utils_Tuple2('attributes-showing', attributesShowing)
																															]))
																													]),
																												_List_fromArray(
																													[
																														A2(
																														$elm$html$Html$h3,
																														_List_Nil,
																														_List_fromArray(
																															[
																																$elm$html$Html$text('Contact')
																															])),
																														$author$project$Views$TalentModal$contactInfoSection(viewingTalentResult)
																													])),
																												A2(
																												$elm$html$Html$div,
																												_List_fromArray(
																													[
																														$elm$html$Html$Attributes$classList(
																														_List_fromArray(
																															[
																																_Utils_Tuple2('profile-footer', true),
																																_Utils_Tuple2('voting-section-expanded', action === 4),
																																_Utils_Tuple2('voting-section-expanded comment-section-expanded', action === 5)
																															]))
																													]),
																												_List_fromArray(
																													[
																														$author$project$Views$TalentModal$quickActionBar(action)(viewingTalentResult)(selectedTalent)(applicantData)(pipeline)(modalPage)(projects)(roles)(projectId)(currentColumnId)(project)(selectedRoleId)(twilioStatus)(userProfile)(newMessageBody)(creatorId)(schedulePageData)
																													]))
																											]))
																									]));
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Messages$inboxView = function (model) {
	var _v0 = model.E.V;
	var _v1 = model.aO;
	switch (_v1) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('LOADING...')
					]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inbox-view')
					]),
				_List_fromArray(
					[
						$author$project$Views$Messages$chatIndexContainer(model),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-loading-icon')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A4(
										$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
										$frandibar$elm_font_awesome_5$FontAwesome$circleNotch,
										0,
										_List_fromArray(
											[
												$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
											]),
										_List_Nil)
									]))
							])),
						A5(
						$author$project$Views$Confirmations$confirmation,
						model.aL,
						A4($author$project$MainMsg$UpdateUsersRoleStage, model.bT, model.t.aX, 'Booking Request', model.bT.cA),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Are you sure you want to send a booking request to ' + (model.t.jf + '?'),
						_List_Nil)
					]));
		case 3:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inbox-view')
					]),
				_List_fromArray(
					[
						$author$project$Views$Messages$chatIndexContainer(model),
						$author$project$Views$Messages$chatBoxContainer(model),
						A5(
						$author$project$Views$Confirmations$confirmation,
						model.aL,
						A4($author$project$MainMsg$UpdateUsersRoleStage, model.bT, model.t.aX, 'Booking Request', model.bT.cA),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Are you sure you want to send a booking request to ' + (model.t.jf + '?'),
						_List_Nil),
						$author$project$Views$TalentModal$talentSearchResultModal(model.v)(model.bq)(model.B)(model.aN)(model.aJ)(model.cH)(model.A)(5)(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyProject]))(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyRole]))(model.aV)(model.d6)($author$project$SharedProjectRoleSchedules$emptyProject)(model.bd.h4)(model.aO)(model.E)(model.L.dP)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)($author$project$User$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.cj)
					]));
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('inbox-view')
					]),
				_List_fromArray(
					[
						$author$project$Views$Messages$chatIndexContainer(model),
						$author$project$Views$Messages$chatBoxContainer(model),
						A5(
						$author$project$Views$Confirmations$confirmation,
						model.aL,
						A4($author$project$MainMsg$UpdateUsersRoleStage, model.bT, model.t.aX, 'Booking Request', model.bT.cA),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Are you sure you want to send a booking request to ' + (model.t.jf + '?'),
						_List_Nil),
						$author$project$Views$TalentModal$talentSearchResultModal(model.v)(model.bq)(model.B)(model.aN)(model.aJ)(model.cH)(model.A)(5)(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyProject]))(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyRole]))(model.aV)(model.d6)($author$project$SharedProjectRoleSchedules$emptyProject)(model.bd.h4)(model.aO)(model.E)(model.L.dP)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)($author$project$User$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.cj)
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('ERROR FETCHING DATA!')
					]));
	}
};
var $author$project$MainMsg$ToggleApplicationConfirmationModal = {$: 27};
var $author$project$MainMsg$FindJobAndOpenDetails = function (a) {
	return {$: 57, a: a};
};
var $author$project$MainMsg$NewApplication = {$: 65};
var $author$project$Views$Job$applicationConfirmationModal = function (isOpen) {
	if (isOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('confirmation-modal')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Are you sure you want to apply to this job?')
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' (You can only apply to 1 role per project)')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('controls')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$NewApplication)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Yes')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleApplicationConfirmationModal)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Go Back')
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $frandibar$elm_font_awesome_5$FontAwesome$angleDoubleDown = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('angle-double-down');
var $frandibar$elm_font_awesome_5$FontAwesome$angleDoubleUp = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('angle-double-up');
var $author$project$Utils$chevronDirection = function (open) {
	return open ? $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$angleDoubleUp) : $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$angleDoubleDown);
};
var $author$project$MainMsg$FindJobAndOpenModal = F2(
	function (a, b) {
		return {$: 56, a: a, b: b};
	});
var $author$project$Views$Job$interestedButton = F3(
	function (id, projectId, myJobs) {
		var projectIds = A2(
			$elm$core$List$map,
			function (role) {
				return role.iw;
			},
			A2(
				$elm$core$List$map,
				function ($) {
					return $.V;
				},
				myJobs));
		return A2(
			$elm$core$List$member,
			id,
			A2(
				$elm$core$List$map,
				function (job) {
					return job.V.c$;
				},
				myJobs)) ? A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href('/jobs')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Check Status')
						]))
				])) : (A2($elm$core$List$member, projectId, projectIds) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('')
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$FindJobAndOpenModal, id, projectId))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('I\'m Interested')
				])));
	});
var $author$project$Views$Job$ageRow = function (job) {
	if ((job.c4 > 0) || (job.c2 > 0)) {
		var min = (job.c4 > 0) ? $elm$core$String$fromInt(job.c4) : 'ANY';
		var max = (job.c2 > 0) ? $elm$core$String$fromInt(job.c2) : 'ANY';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('head')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Age Range')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(min + (' - ' + (max + ' years')))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Utils$formatHeight = function (totalHeight) {
	var inches = $elm$core$String$fromInt(
		A2($elm$core$Basics$modBy, 12, totalHeight));
	var feet = $elm$core$String$fromInt((totalHeight / 12) | 0);
	return A2(
		$elm$html$Html$span,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(feet + ('\' ' + (inches + '\'\' ')))
			]));
};
var $author$project$Views$Job$heightRow = function (job) {
	if ((job.hW > 0) || (job.hP > 0)) {
		var min = (job.hW > 0) ? $author$project$Utils$formatHeight(job.hW) : $elm$html$Html$text('ANY');
		var max = (job.hP > 0) ? $author$project$Utils$formatHeight(job.hP) : $elm$html$Html$text('ANY');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('head')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Height Range')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							min,
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('- ')
								])),
							max
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Job$jobAttributeList = function (list) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		A2(
			$elm$core$List$map,
			function (l) {
				return A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('detail')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(l.bS)
						]));
			},
			list));
};
var $author$project$Views$Job$projectLocation = function (location) {
	return (location === '') ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('project-location-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-map-marker-alt')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('project-location')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(location)
					]))
			]));
};
var $author$project$Views$Job$weightRow = function (job) {
	if ((job.eQ > 0) || (job.eM > 0)) {
		var min = (job.eQ > 0) ? $elm$core$String$fromFloat(job.eQ) : 'ANY';
		var max = (job.eM > 0) ? $elm$core$String$fromFloat(job.eM) : 'ANY';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-detail')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('head')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Size Range')
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(min + (' - ' + (max + ' pounds')))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Job$talentJobView = function (model) {
	var jobs = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (job) {
				return _Utils_eq(job.c$, model.g$);
			},
			model.aB));
	if (!jobs.$) {
		var job = jobs.a;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-details-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-details-titles')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-details-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(job.ix)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('role-details-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-title')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Role: ')
														])),
													$elm$html$Html$text(job.bS)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-rate')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Rate: ')
														])),
													$elm$html$Html$text('$' + job.iM)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-details-row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-card-dates')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('far fa-calendar-alt')
														]),
													_List_Nil),
													$elm$html$Html$text(
													$author$project$Utils$formatDate(
														A2($author$project$Project$findDeadline, job.g6, 'Project').fP) + (' - ' + $author$project$Utils$formatDate(
														A2($author$project$Project$findDeadline, job.g6, 'Project').ee)))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fas fa-map-marker-alt')
														]),
													_List_Nil),
													$elm$html$Html$text(
													A2($author$project$Project$findDeadline, job.g6, 'Project').hM)
												]))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('job-detail')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail notes head')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('PROJECT DESCRIPTION')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail content')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(job.it)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-details')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('job-detail')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail notes head')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('ROLE DESCRIPTION')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail content')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(job.iI)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-listing-details-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('role-details')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-user-alt')
										]),
									_List_Nil),
									A2(
									$elm$html$Html$h3,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('ROLE DETAILS')
										])),
									(!_Utils_eq(job.hs, _List_Nil)) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail job-details-list')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('head')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Gender')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													$author$project$Views$Job$jobAttributeList(job.hs)
												]))
										])) : $elm$html$Html$text(''),
									$author$project$Views$Job$ageRow(job),
									$author$project$Views$Job$heightRow(job),
									$author$project$Views$Job$weightRow(job),
									(!_Utils_eq(job.eg, _List_Nil)) ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail job-details-list')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('head')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Appearance')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													$author$project$Views$Job$jobAttributeList(job.eg)
												]))
										])) : $elm$html$Html$text(''),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('job-detail')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('head')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Rate ')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('content')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('$' + job.iM)
												]))
										])),
									A2(
									$elm$html$Html$h4,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('payment-details head')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('schedule-details')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('far fa-calendar-alt')
												]),
											_List_Nil),
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('SCHEDULE DETAILS')
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('JOB DATES')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.g6, 'Project').fP) + (' - ' + $author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.g6, 'Project').ee)))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.g6, 'Project').hM)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('AUDITION')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.g6, 'Audition').fP))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.g6, 'Audition').hM)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('CALLBACK')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.g6, 'Callback').fP))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.g6, 'Callback').hM)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('FITTING')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.g6, 'Fitting').fP))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.g6, 'Fitting').hM)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('job-detail')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h4,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('head')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('SHOOT')
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('content')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, job.g6, 'Shoot').fP))
																])),
															$author$project$Views$Job$projectLocation(
															A2($author$project$Project$findDeadline, job.g6, 'Shoot').hM)
														]))
												]))
										]))
								]))
						]))
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Job$jobDropDownDetails = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('drop-down-wrapper')
			]),
		_List_fromArray(
			[
				$author$project$Views$Job$talentJobView(model)
			]));
};
var $author$project$Views$Job$jobRow = F3(
	function (model, multiModalStatus, confirmationOpen) {
		return A2(
			$elm$core$List$map,
			function (role) {
				var showDetails = _Utils_eq(
					multiModalStatus,
					$author$project$Utils$Open(role.c$)) ? $author$project$Views$Job$jobDropDownDetails(model) : $elm$html$Html$text('');
				var iconDirection = _Utils_eq(
					multiModalStatus,
					$author$project$Utils$Open(role.c$)) ? $author$project$Utils$chevronDirection(model.bX) : $author$project$Utils$chevronDirection(false);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('apply-container')
								]),
							_List_fromArray(
								[
									A3($author$project$Views$Job$interestedButton, role.c$, role.iw, model.eR)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('details-container'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$FindJobAndOpenDetails(role.c$))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('image-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[iconDirection]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('header-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(role.ix)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-details-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('role-title')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Role: ')
																])),
															$elm$html$Html$text(role.bS)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('role-rate')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_Nil,
															_List_fromArray(
																[
																	$elm$html$Html$text('Rate: ')
																])),
															$elm$html$Html$text('$' + role.iM)
														]))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-details-row')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('role-card-dates')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$i,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('far fa-calendar-alt')
																]),
															_List_Nil),
															$elm$html$Html$text(
															$author$project$Utils$formatDate(
																A2($author$project$Project$findDeadline, role.g6, 'Project').fP) + (' - ' + $author$project$Utils$formatDate(
																A2($author$project$Project$findDeadline, role.g6, 'Project').ee)))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$i,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('fas fa-map-marker-alt')
																]),
															_List_Nil),
															$elm$html$Html$text(
															A2($author$project$Project$findDeadline, role.g6, 'Project').hM)
														]))
												])),
											$author$project$Views$Job$applicationConfirmationModal(confirmationOpen),
											showDetails
										]))
								]))
						]));
			},
			model.aB);
	});
var $author$project$Views$Job$jobIndexView = F3(
	function (model, multiModalStatus, confirmationOpen) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('modal', true),
									_Utils_Tuple2('modal-open', confirmationOpen)
								])),
							$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleApplicationConfirmationModal)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('main-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Let\'s work.')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('body')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Looking for work? Here\'s some we think you might find interesting.')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('card-container')
						]),
					A3($author$project$Views$Job$jobRow, model, multiModalStatus, confirmationOpen))
				]));
	});
var $author$project$Job$ChangeJob = function (a) {
	return {$: 3, a: a};
};
var $author$project$MainMsg$UpdateJobPageData = function (a) {
	return {$: 303, a: a};
};
var $author$project$Views$Job$inRoleBadge = function (job) {
	return (job.jb.i3 !== 27) ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('in-role-badge')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Applied')
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Job$jobLi = F2(
	function (job, model) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$UpdateJobPageData(
						$author$project$Job$ChangeJob(job.aa))),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'selected-job',
							_Utils_eq(job.aa, model.S.fG.aa))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('job-name-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h4,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(job.bS)
								])),
							$author$project$Views$Job$inRoleBadge(job)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('job-stat-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-attribute', true),
											_Utils_Tuple2('hiding-attribute', job.iy === '0')
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-money-check-alt job-icon')
										]),
									_List_Nil),
									$elm$html$Html$text(job.iy)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-attribute', true),
											_Utils_Tuple2('hiding-attribute', job.ff === '')
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-map-marker-alt job-icon')
										]),
									_List_Nil),
									$elm$html$Html$text(job.ff)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-attribute', true),
											_Utils_Tuple2('hiding-attribute', job.fc === '')
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('fas fa-calendar-alt job-icon')
										]),
									_List_Nil),
									$elm$html$Html$text(job.fc)
								]))
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-description')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(job.br)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('posted-date')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Posted ' + job.e4)
						]))
				]));
	});
var $author$project$Views$Job$jobList = function (model) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('job-list-container')
			]),
		A2(
			$elm$core$List$map,
			function (job) {
				return A2($author$project$Views$Job$jobLi, job, model);
			},
			model.S.fh));
};
var $author$project$Views$Job$noJobContainer = function (model) {
	return (!$elm$core$List$length(model.S.fh)) ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('No Found Jobs...')
			])) : $elm$html$Html$text('');
};
var $author$project$Utils$roleOptions = function (roles) {
	return A2(
		$elm$core$List$map,
		function (role) {
			return {aa: role.aa, bS: role.bS};
		},
		roles);
};
var $author$project$Job$Search = function (a) {
	return {$: 1, a: a};
};
var $author$project$Views$Job$resetSearchButton = function (model) {
	return (model.S.fF !== '') ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('fas fa-times'),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateJobPageData(
					$author$project$Job$Search('')))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('')
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Job$searchWidget = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('search-widget-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('search-input-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$placeholder('Search'),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateJobPageData, $author$project$Job$Search)),
								$elm$html$Html$Attributes$value(model.S.fF)
							]),
						_List_Nil),
						$author$project$Views$Job$resetSearchButton(model)
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('fas fa-circle-notch fa-spin', !model.S.fE),
								_Utils_Tuple2('search-projects-indicator', true)
							]))
					]),
				_List_Nil)
			]));
};
var $author$project$Views$Job$searchingText = function (model) {
	return (model.S.fF !== '') ? A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('job-search-text')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Searching: '),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('job-search-term')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(model.S.fF)
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$MainMsg$UpdateTalentMenuOptions = function (a) {
	return {$: 320, a: a};
};
var $author$project$User$NewRoleSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$ToggleModalView = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$SwitchRole = {$: 321};
var $author$project$Views$TalentOptions$changeRoleSubmitButton = function (talentMenu) {
	return (talentMenu.fs === '') ? $elm$html$Html$text('') : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$SwitchRole)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Submit')
			]));
};
var $author$project$User$emptyRoleOption = {aa: '', bS: ''};
var $author$project$Views$TalentOptions$roleOption = F2(
	function (role, usersRole) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(role.aa),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(role.bS, usersRole))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(role.bS)
				]));
	});
var $author$project$Views$TalentOptions$changeRoleForm = F2(
	function (talentMenu, roles) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('change-role-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('change-role-label')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select New Role')
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentMenuOptions, $author$project$User$NewRoleSelected))
						]),
					A2(
						$elm$core$List$map,
						function (role) {
							return A2($author$project$Views$TalentOptions$roleOption, role, talentMenu.jb.iL);
						},
						A2(
							$elm$core$List$cons,
							$author$project$User$emptyRoleOption,
							A2(
								$elm$core$List$map,
								function (role) {
									return {aa: role.aa, bS: role.bS};
								},
								roles)))),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$changeRoleSubmitButton(talentMenu),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$OptionsModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]))
				]));
	});
var $author$project$User$ChangeRoleModal = {$: 4};
var $author$project$User$DeclineApplication = 3;
var $author$project$User$DeclineBooking = 6;
var $author$project$User$ReasonModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$RemoveTalent = 0;
var $author$project$MainMsg$ApplyToRole = F2(
	function (a, b) {
		return {$: 261, a: a, b: b};
	});
var $author$project$Views$TalentOptions$applyToRoleButton = F2(
	function (talentMenu, role) {
		return (role !== '') ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$ApplyToRole, talentMenu.g_, talentMenu.fs))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Apply To Role')
				])) : A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Select Role')
				]));
	});
var $author$project$Views$TalentOptions$createNotificationData = F2(
	function (talentMenu, kind) {
		return {dP: talentMenu.iD, gV: '', hK: kind, aX: talentMenu.jb.aX, cA: talentMenu.jb.c$};
	});
var $author$project$User$AuditionDeclineSchedule = 2;
var $author$project$User$AuditionRescheduleTalent = 1;
var $author$project$User$CallbackDeclineSchedule = 5;
var $author$project$User$CallbackRescheduleTalent = 4;
var $author$project$Views$TalentOptions$acceptAuditionRequest = function (talentMenu) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A4(
					$author$project$MainMsg$UpdateUsersRoleStage,
					A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Audition Accepted'),
					talentMenu.jb.aX,
					'Audition Accepted',
					talentMenu.jb.c$))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Accept Audition Request')
			]));
};
var $author$project$Views$TalentOptions$acceptCallbackRequest = function (talentMenu) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				A4(
					$author$project$MainMsg$UpdateUsersRoleStage,
					A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Callback Accepted'),
					talentMenu.jb.aX,
					'Callback Accepted',
					talentMenu.jb.c$))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Accept Callback Request')
			]));
};
var $author$project$Views$TalentOptions$rejectionRescheduleRequest = F2(
	function (scheduleStatus, reason) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$UpdateTalentMenuOptions(
						$author$project$User$ToggleModalView(
							$author$project$User$ReasonModal(reason))))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(scheduleStatus)
				]));
	});
var $author$project$Views$TalentOptions$agencyTalentSchedulingOptions = F2(
	function (scheduleMember, talentMenu) {
		var _v0 = scheduleMember.dj;
		switch (_v0) {
			case 5:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptAuditionRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Audition Request', 1),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Audition Request', 2)
						]));
			case 6:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Audition Request', 1),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Audition Request', 2)
						]));
			case 7:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptAuditionRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Audition Request', 1)
						]));
			case 9:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptAuditionRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Audition Request', 1),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Audition Request', 2)
						]));
			case 11:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptCallbackRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Callback Request', 4),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Callback Request', 5)
						]));
			case 12:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Callback Request', 4),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Callback Request', 5)
						]));
			case 13:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptCallbackRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Callback Request', 4)
						]));
			case 15:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							$author$project$Views$TalentOptions$acceptCallbackRequest(talentMenu),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reschedule Callback Request', 4),
							A2($author$project$Views$TalentOptions$rejectionRescheduleRequest, 'Reject Callback Request', 5)
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$rescheduleTalent = F2(
	function (scheduleId, scheduleType) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$View(
						A2($author$project$Route$SchedulePage, scheduleId, scheduleType)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Reschedule Talent')
				]));
	});
var $author$project$Views$TalentOptions$directorSchedulingOptions = F2(
	function (scheduleMember, talentMenu) {
		var callbackActions = _List_fromArray(
			[
				A2($author$project$Views$TalentOptions$rescheduleTalent, talentMenu.g_, 'Callback'),
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateTalentMenuOptions(
							$author$project$User$ToggleModalView(
								$author$project$User$ReasonModal(0))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Remove from Role')
					]))
			]);
		var auditionActions = _List_fromArray(
			[
				A2($author$project$Views$TalentOptions$rescheduleTalent, talentMenu.g_, 'Audition'),
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateTalentMenuOptions(
							$author$project$User$ToggleModalView(
								$author$project$User$ReasonModal(0))))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Remove from Role')
					]))
			]);
		var _v0 = scheduleMember.dj;
		switch (_v0) {
			case 5:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 6:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 7:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 8:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 9:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					auditionActions);
			case 11:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			case 14:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			case 12:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			case 13:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			case 15:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					callbackActions);
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$scheduleOption = F3(
	function (scheduleMember, userProfile, talentMenu) {
		var _v0 = userProfile.V;
		if (_v0 === 1) {
			return A2($author$project$Views$TalentOptions$directorSchedulingOptions, scheduleMember, talentMenu);
		} else {
			return A2($author$project$Views$TalentOptions$agencyTalentSchedulingOptions, scheduleMember, talentMenu);
		}
	});
var $author$project$Views$TalentOptions$schedulingOptions = F2(
	function (talentMenu, userProfile) {
		return ($elm$core$List$length(talentMenu.jb.fA) > 1) ? A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (scheduleMember) {
					return A3($author$project$Views$TalentOptions$scheduleOption, scheduleMember, userProfile, talentMenu);
				},
				talentMenu.jb.fA)) : function (scheduleMember) {
			return A3($author$project$Views$TalentOptions$scheduleOption, scheduleMember, userProfile, talentMenu);
		}(
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$User$emptyScheduleMember,
				$elm$core$List$head(talentMenu.jb.fA)));
	});
var $author$project$Views$TalentOptions$agencyTalentOptions = F3(
	function (talentMenu, userProfile, roles) {
		var _v0 = talentMenu.jb.i3;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 24:
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Removed from role by casting')
						]));
			case 25:
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Removed from role by Agent')
						]));
			case 1:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A4(
										$author$project$MainMsg$UpdateUsersRoleStage,
										A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Accepted Application'),
										talentMenu.jb.aX,
										'Accepted Application',
										talentMenu.jb.c$))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept Application Request')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(3))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Decline Application Request')
								]))
						]));
			case 3:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 4:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A4(
										$author$project$MainMsg$UpdateUsersRoleStage,
										A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Accepted Application'),
										talentMenu.jb.aX,
										'Accepted Application',
										talentMenu.jb.c$))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept Application Request')
								]))
						]));
			case 17:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A4(
										$author$project$MainMsg$UpdateUsersRoleStage,
										A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Booking Accepted'),
										talentMenu.jb.aX,
										'Booking Accepted',
										talentMenu.jb.c$))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept Booking Request')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(6))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Reject Booking Request')
								]))
						]));
			case 18:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(6))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Reject Booking Request')
								]))
						]));
			case 19:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A4(
										$author$project$MainMsg$UpdateUsersRoleStage,
										A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Booking Accepted'),
										talentMenu.jb.aX,
										'Booking Accepted',
										talentMenu.jb.c$))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Accept Booking Request')
								]))
						]));
			case 26:
				return A2($author$project$Views$TalentOptions$schedulingOptions, talentMenu, userProfile);
			case 27:
				var _v1 = userProfile.V;
				if (!_v1) {
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-option-buttons')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$select,
								_List_fromArray(
									[
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentMenuOptions, $author$project$User$NewRoleSelected))
									]),
								A2(
									$elm$core$List$map,
									function (role) {
										return A2(
											$elm$html$Html$option,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$value(role.aa)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(role.bS)
												]));
									},
									A2($elm$core$List$cons, $author$project$User$emptyRoleOption, roles))),
								A2($author$project$Views$TalentOptions$applyToRoleButton, talentMenu, talentMenu.fs)
							]));
				} else {
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-option-buttons')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Events$onClick(
										A2(
											$author$project$MainMsg$MoveNewCandidate,
											_List_fromArray(
												[talentMenu.jb]),
											''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Submit Talent')
									]))
							]));
				}
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$directorOptions = F2(
	function (talentMenu, userProfile) {
		var _v0 = talentMenu.jb.i3;
		switch (_v0) {
			case 0:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 24:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								]))
						]));
			case 1:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 2:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 3:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 4:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$ChangeRoleModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Change Role')
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 17:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 18:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 19:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView(
											$author$project$User$ReasonModal(0))))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Remove from Role')
								]))
						]));
			case 26:
				return A2($author$project$Views$TalentOptions$schedulingOptions, talentMenu, userProfile);
			case 27:
				return A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-option-buttons')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(
										$author$project$MainMsg$MoveNewCandidate,
										_List_fromArray(
											[talentMenu.jb]),
										''))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add To Role')
								]))
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$optionButtons = F3(
	function (talentMenu, userProfile, roles) {
		var _v0 = userProfile.V;
		if (_v0 === 1) {
			return A2($author$project$Views$TalentOptions$directorOptions, talentMenu, userProfile);
		} else {
			return A3($author$project$Views$TalentOptions$agencyTalentOptions, talentMenu, userProfile, roles);
		}
	});
var $author$project$User$UpdateReason = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$RemoveTalentFromRole = {$: 322};
var $author$project$Views$TalentOptions$reasonSubmitButton = F2(
	function (talentMenu, reason) {
		if (talentMenu.iD !== '') {
			var action = function () {
				switch (reason) {
					case 0:
						return $author$project$MainMsg$RemoveTalentFromRole;
					case 1:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Audition Reschedule Requested'),
							talentMenu.jb.aX,
							'Audition Reschedule Requested',
							talentMenu.jb.c$);
					case 2:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Audition Rejected'),
							talentMenu.jb.aX,
							'Audition Rejected',
							talentMenu.jb.c$);
					case 4:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Callback Reschedule Requested'),
							talentMenu.jb.aX,
							'Callback Reschedule Requested',
							talentMenu.jb.c$);
					case 5:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Callback Rejected'),
							talentMenu.jb.aX,
							'Callback Rejected',
							talentMenu.jb.c$);
					case 3:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Rejected Application'),
							talentMenu.jb.aX,
							'Rejected Application',
							talentMenu.jb.c$);
					case 6:
						return A4(
							$author$project$MainMsg$UpdateUsersRoleStage,
							A2($author$project$Views$TalentOptions$createNotificationData, talentMenu, 'Booking Rejected'),
							talentMenu.jb.aX,
							'Booking Rejected',
							talentMenu.jb.c$);
					default:
						return $author$project$MainMsg$NoOp;
				}
			}();
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(action)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Submit')
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$TalentOptions$reasonForm = F2(
	function (talentMenu, reasonAction) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-options-form')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(talentMenu.h_)
						])),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Reason')
						])),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('text'),
							$elm$html$Html$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentMenuOptions, $author$project$User$UpdateReason))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Views$TalentOptions$reasonSubmitButton, talentMenu, reasonAction),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleModalView($author$project$User$OptionsModal)))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								]))
						]))
				]));
	});
var $author$project$Views$TalentOptions$modalContent = F3(
	function (talentMenu, userProfile, roles) {
		var _v0 = talentMenu.bR;
		switch (_v0.$) {
			case 0:
				return $elm$html$Html$text('');
			case 2:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('fas fa-circle-notch fa-spin')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]));
			case 1:
				var reason = _v0.a;
				return A2($author$project$Views$TalentOptions$reasonForm, talentMenu, reason);
			case 3:
				return A3($author$project$Views$TalentOptions$optionButtons, talentMenu, userProfile, roles);
			default:
				return A2($author$project$Views$TalentOptions$changeRoleForm, talentMenu, roles);
		}
	});
var $author$project$Views$TalentOptions$scheduleText = function (scheduleMember) {
	var scheduleStatus = function () {
		var _v0 = scheduleMember.dj;
		switch (_v0) {
			case 5:
				return 'Pending audition for: ';
			case 6:
				return 'Accepted audition for: ';
			case 7:
				return 'Rejected audition for: ';
			case 8:
				return 'Awaiting rescheduling of audition for: ';
			case 9:
				return 'Rescheduled audition for: ';
			case 10:
				return 'Canceled audition for: ';
			case 11:
				return 'Pending callback for: ';
			case 12:
				return 'Accepted callback for: ';
			case 13:
				return 'Rejected callback for: ';
			case 14:
				return 'Awaiting rescheduling of callback for: ';
			case 15:
				return 'Rescheduled callback for: ';
			case 16:
				return 'Canceled callback for: ';
			default:
				return '';
		}
	}();
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('scheduled-time-container')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				_Utils_ap(scheduleStatus, scheduleMember.fD))
			]));
};
var $author$project$Views$TalentOptions$scheduledTime = function (talent) {
	return ($elm$core$List$length(talent.fA) > 0) ? A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2($elm$core$List$map, $author$project$Views$TalentOptions$scheduleText, talent.fA)) : $elm$html$Html$text('');
};
var $author$project$Views$TalentOptions$userRoleText = F2(
	function (userProfile, talentMenu) {
		if (talentMenu.jb.iL !== '') {
			var _v0 = userProfile.V;
			if (!_v0) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You are currently in the ' + (talentMenu.jb.iL + ' role'))
						]));
			} else {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(talentMenu.jb.bx + (' is currently in ' + talentMenu.jb.iL))
						]));
			}
		} else {
			if (_Utils_eq(talentMenu.bR, $author$project$User$LoadingTalentDetails)) {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Getting Role Details')
						]));
			} else {
				return A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Not currently associated to any roles in project')
						]));
			}
		}
	});
var $author$project$Views$TalentOptions$talentOptionsModal = F3(
	function (talentMenu, userProfile, roles) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('talent-options-top-container', true),
							_Utils_Tuple2('talent-options-open', !talentMenu.dr)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateTalentMenuOptions(
								$author$project$User$ToggleMenuModal($author$project$User$emptySearchTalentProfile))),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('talent-options-modal', true),
									_Utils_Tuple2('talent-options-open', !talentMenu.dr)
								]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('talent-options-container', true),
									_Utils_Tuple2('talent-options-open', !talentMenu.dr)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('Manage Role')
								])),
							A2($author$project$Views$TalentOptions$userRoleText, userProfile, talentMenu),
							$author$project$Views$TalentOptions$scheduledTime(talentMenu.jb),
							A3($author$project$Views$TalentOptions$modalContent, talentMenu, userProfile, roles)
						]))
				]));
	});
var $author$project$Job$ToggleViewingJobState = {$: 4};
var $author$project$MainMsg$GoToTalentSearch = F3(
	function (a, b, c) {
		return {$: 314, a: a, b: b, c: c};
	});
var $author$project$SharedProjectRoleSchedules$emptyBasicRoleData = {dC: '', br: '', eg: '', hs: '', aa: '', bS: '', iw: '', ix: ''};
var $author$project$Views$Job$manageButton = F2(
	function (jobPageData, userProfile) {
		var _v0 = userProfile.V;
		if (!_v0) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('manage-button'),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateTalentMenuOptions(
							$author$project$User$ToggleMenuModal(jobPageData.fG.jb)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Manage Role')
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('manage-button'),
						$elm$html$Html$Events$onClick(
						A3(
							$author$project$MainMsg$GoToTalentSearch,
							jobPageData.fG.aa,
							A2(
								$elm$core$Maybe$withDefault,
								$author$project$SharedProjectRoleSchedules$emptyBasicRoleData,
								$elm$core$List$head(jobPageData.fG.ft)).aa,
							jobPageData.fG.hO))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add Talent')
					]));
		}
	});
var $author$project$Views$Job$roleLi = F2(
	function (role, project) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-detail')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(role.bS + (' / Ages: ' + (role.dC + (' / Genders: ' + (role.hs + (' / Ethnicities: ' + role.eg))))))
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(role.br)
						]))
				]));
	});
var $author$project$Views$Job$viewingJob = function (_v0) {
	var jobPageData = _v0.S;
	var userProfile = _v0.E;
	return (jobPageData.fG.aa === '') ? A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('No found job')
			])) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('viewing-job-container', true),
						_Utils_Tuple2('viewing-container-closed', jobPageData.f3 === 1)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('job-title-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h3,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(jobPageData.fG.bS)
									])),
								A2($author$project$Views$Job$manageButton, jobPageData, userProfile)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-times'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$UpdateJobPageData($author$project$Job$ToggleViewingJobState))
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Project Description')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(jobPageData.fG.br)
							])),
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Roles')
									]))
							])),
						A2(
						$elm$html$Html$ul,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (role) {
								return A2($author$project$Views$Job$roleLi, role, jobPageData.fG);
							},
							jobPageData.fG.ft))
					]))
			]));
};
var $author$project$Views$Job$jobView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Views$Job$searchWidget(model),
				$author$project$Views$Job$searchingText(model),
				$author$project$Views$Job$noJobContainer(model),
				$author$project$Views$Job$jobList(model),
				$author$project$Views$Job$viewingJob(model),
				A3(
				$author$project$Views$TalentOptions$talentOptionsModal,
				model.W,
				model.E,
				$author$project$Utils$roleOptions(model.S.fG.ft))
			]));
};
var $author$project$Views$Job$jobViewListing = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('job-detail-listing')
			]),
		_List_fromArray(
			[
				$author$project$Views$Job$jobView(model)
			]));
};
var $author$project$Utils$loader = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('Loading...')
		]));
var $author$project$Main$loadingView = $author$project$Utils$loader;
var $author$project$MainMsg$SendPasswordResetEmail = {$: 308};
var $author$project$MainMsg$SigninEmail = function (a) {
	return {$: 30, a: a};
};
var $author$project$MainMsg$SigninPassword = function (a) {
	return {$: 31, a: a};
};
var $author$project$MainMsg$Signin = {$: 17};
var $author$project$Views$Auth$loginButton = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Events$onClick($author$project$MainMsg$Signin),
			$elm$html$Html$Attributes$class('button full'),
			$elm$html$Html$Attributes$id('signin')
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('Login')
		]));
var $author$project$Views$Auth$loginView = F2(
	function (err, logoPath) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tagline')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Transparent. Accessible. Safe.')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form login main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Events$onInput($author$project$MainMsg$SigninEmail),
													$elm$html$Html$Attributes$placeholder('Email')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Events$onInput($author$project$MainMsg$SigninPassword),
													$elm$html$Html$Attributes$type_('password'),
													$elm$html$Html$Attributes$placeholder('Password')
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[$author$project$Views$Auth$loginButton])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick($author$project$MainMsg$SendPasswordResetEmail),
											$elm$html$Html$Attributes$class('link-button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Forgot password?')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('account-signup-container')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Don\'t have an account?'),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$View($author$project$Route$TalentRegistration)),
													$elm$html$Html$Attributes$class('link-button')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Sign up »')
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$MainMsg$ToggleNotificationModal = F3(
	function (a, b, c) {
		return {$: 221, a: a, b: b, c: c};
	});
var $author$project$MainMsg$ResponseInvalid = {$: 245};
var $author$project$Views$Job$validateRejectionResponse = F2(
	function (notification, userJob) {
		return A2(
			$elm$core$List$member,
			notification.hK,
			_List_fromArray(
				['Audition Rejected', 'Audition Rescheduled', 'Callback Rescheduled', 'Callback Reschedule Requested', 'Audition Reschedule Requested', 'Audition Rescheduled', 'Callback Rejected', 'Callback Rescheduled', 'Booking Rejected', 'Rejected Application'])) ? (($elm$core$String$length(notification.dP) <= 1) ? $author$project$MainMsg$ResponseInvalid : A4($author$project$MainMsg$UpdateUsersRoleStage, notification, notification.aX, notification.hK, notification.cA)) : A4($author$project$MainMsg$UpdateUsersRoleStage, notification, notification.aX, notification.hK, notification.cA);
	});
var $author$project$Views$Job$notificationModal = F6(
	function (notification, userJob, isOpen, userId, roleId, formInvalid) {
		var textType = function () {
			var _v2 = notification.hK;
			switch (_v2) {
				case 'Audition Rejected':
					return 'Reject ';
				case 'Audition Rescheduled':
					return 'Reschedule ';
				case 'Audition Accepted':
					return 'Accept ';
				case 'Audition Reschedule Requested':
					return 'Reschedule ';
				case 'Callback Rejected':
					return 'Reject ';
				case 'Callback Rescheduled':
					return 'Reschedule ';
				case 'Callback Accepted':
					return 'Accept ';
				case 'Callback Reschedule Requested':
					return 'Reschedule';
				case 'Booking Accepted':
					return 'Accept ';
				case 'Booking Rejected':
					return 'Reject ';
				case 'Rejected Application':
					return 'Reject ';
				case 'Accepted Application':
					return 'Accept ';
				default:
					return 'Send';
			}
		}();
		var textArea = function () {
			switch (textType) {
				case 'Accept ':
					return $elm$html$Html$text('');
				case 'Reschedule ':
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rejection-input-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('* Reschedule Response:')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('invalid-response', formInvalid)
											])),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$NotificationFormMsg, $author$project$Job$NotificationBody)),
										$elm$html$Html$Attributes$placeholder('Please let casting know what your needs are for rescheduling...'),
										$elm$html$Html$Attributes$value(notification.dP)
									]),
								_List_Nil)
							]));
				default:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('rejection-input-container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$label,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('* Rejection Response:')
									])),
								A2(
								$elm$html$Html$textarea,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('invalid-response', formInvalid)
											])),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$MainMsg$NotificationFormMsg, $author$project$Job$NotificationBody)),
										$elm$html$Html$Attributes$placeholder('Please let casting know why you are unable to make this scheduled time....'),
										$elm$html$Html$Attributes$value(notification.dP)
									]),
								_List_Nil)
							]));
			}
		}();
		if (isOpen) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('confirmation-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h3,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to ' + (textType + ' this request?'))
							])),
						textArea,
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('controls')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										A2($author$project$Views$Job$validateRejectionResponse, notification, userJob))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(textType + ' Request')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										A3($author$project$MainMsg$ToggleNotificationModal, userJob, '', ''))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back')
									]))
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Job$candidateAction = F7(
	function (notification, job, userId, isOpen, schedulingAction, scheduleStatus, formInvalid) {
		if (schedulingAction) {
			switch (scheduleStatus) {
				case 5:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('We would love to Audition you for this role. Please accept our request below!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reschedule-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Reschedule Requested', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request Reschedule')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.V.c$, formInvalid)
									]))
							]));
				case 9:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Your Audition time has been changed, let casting know if you can make it!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reschedule-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Audition Reschedule Requested', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request Reschedule')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.V.c$, formInvalid)
									]))
							]));
				case 6:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Congratulations You\'ve landed an Audition!')
									]))
							]));
				case 7:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve rejected this Audition Request.')
									]))
							]));
				case 8:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve requested a reschedule for this Audition time. Stay tuned!')
									]))
							]));
				case 10:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You have been removed from this Audition Schedule.')
									]))
							]));
				case 11:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('We would love to see you at our CallBack for this role. Please accept our request below!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reschedule-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Reschedule Requested', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request Reschedule')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.V.c$, formInvalid)
									]))
							]));
				case 15:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Your CallBack time has been changed, let casting know if you can make it!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Schedule Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reschedule-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Callback Reschedule Requested', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Request Reschedule')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.V.c$, formInvalid)
									]))
							]));
				case 12:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Congratulations You\'ve landed a Callback!')
									]))
							]));
				case 13:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve rejected this Callback Request.')
									]))
							]));
				case 14:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve requested a reschedule for this CallBack time. Stay tuned!')
									]))
							]));
				case 16:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('you have been removed from this CallBack Schedule.')
									]))
							]));
				default:
					return $elm$html$Html$text('');
			}
		} else {
			var _v1 = job.bf;
			switch (_v1) {
				case 17:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('We would love to book you for this role. Please accept our request below!')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('action-buttons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button accept-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Booking Accepted', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Accept Booking Request')
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-action-button reject-button'),
												$elm$html$Html$Events$onClick(
												A3($author$project$MainMsg$ToggleNotificationModal, job, 'Booking Rejected', ''))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Reject Booking Request')
											])),
										A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.V.c$, formInvalid)
									]))
							]));
				case 18:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Congratulations You\'ve landed the spot!')
									]))
							]));
				case 19:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('job-status-row')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-message')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('You\'ve rejected the booking request')
									]))
							]));
				default:
					var _v2 = job.gt;
					switch (_v2) {
						case 0:
							return A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('You applied to this role. Stay tuned!')
									]));
						case 2:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-status-message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You have been invited to this role! Please accept or reject request below')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('action-buttons')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('job-action-button accept-button'),
														$elm$html$Html$Events$onClick(
														A3($author$project$MainMsg$ToggleNotificationModal, job, 'Accepted Application', ''))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Accept Invitation')
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('job-action-button reject-button'),
														$elm$html$Html$Events$onClick(
														A3($author$project$MainMsg$ToggleNotificationModal, job, 'Rejected Application', ''))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Reject Invitation')
													])),
												A6($author$project$Views$Job$notificationModal, notification, job, isOpen, userId, job.V.c$, formInvalid)
											]))
									]));
						case 3:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-status-message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You Accepted the Invitation request. Stay tuned!')
											]))
									]));
						case 4:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('job-status-row')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$p,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('job-status-message')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('You\'ve rejected this role invitation')
											]))
									]));
						default:
							return $elm$html$Html$text('');
					}
			}
		}
	});
var $author$project$MainMsg$OpenTalentConversationContainer = function (a) {
	return {$: 230, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$commentAlt = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('comment-alt');
var $author$project$Views$Job$chatMessages = F2(
	function (twilioData, job) {
		var chat = $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (channel) {
					return _Utils_eq(channel.ix, job.V.ix);
				},
				twilioData.n));
		if (!chat.$) {
			var conversation = chat.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('chat-icon-container', true),
								_Utils_Tuple2('chat-icon-inactive', conversation.dI)
							])),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$OpenTalentConversationContainer(conversation.aa))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('chat-message-count')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(conversation.bD))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-message-icon')
							]),
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$commentAlt)
							]))
					]));
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Job$emptyBasicSchedulingInfo = {hd: '', fB: ''};
var $author$project$Views$Job$scheduleTimeDisplay = F6(
	function (job, scheduleType, notification, userId, isOpen, formInvalid) {
		var scheduleStatus = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fB;
						},
						scheduleType),
					job.fA))).dj;
		var eventTime = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Job$emptyBasicSchedulingInfo,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fB;
						},
						scheduleType),
					job.jl))).hd;
		var scheduleText = function () {
			switch (scheduleStatus) {
				case 5:
					return 'Pending Audition  Scheduled For: ' + eventTime;
				case 11:
					return 'Pending Callback Scheduled For: ' + eventTime;
				case 12:
					return 'Confirmed Callback Scheduled For: ' + eventTime;
				case 6:
					return 'Confirmed Audition Scheduled For: ' + eventTime;
				case 7:
					return 'Rejected Audition Scheduled For: ' + eventTime;
				case 13:
					return 'Rejected Callback Scheduled For: ' + eventTime;
				case 8:
					return 'Pending Audition Scheduled For: ' + eventTime;
				case 14:
					return 'Pending Callback Scheduled For: ' + eventTime;
				case 15:
					return 'Rescheduled Callback Scheduled For: ' + eventTime;
				case 9:
					return 'Rescheduled Audition Scheduled For: ' + eventTime;
				default:
					return '';
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('job-action-row')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(scheduleText)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('candidate-actions')
						]),
					_List_fromArray(
						[
							A7($author$project$Views$Job$candidateAction, notification, job, userId, isOpen, true, scheduleStatus, formInvalid)
						]))
				]));
	});
var $author$project$Views$Job$appliedJobRow = F6(
	function (notification, job, userId, twilioData, isOpen, formInvalid) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('role-card')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('details-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image-container')
								]),
							_List_fromArray(
								[
									A2($elm$html$Html$span, _List_Nil, _List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('header-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$FindJob(job.V.c$))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(job.V.ix)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$FindJob(job.V.c$)),
											$elm$html$Html$Attributes$class('role-details-container')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-title')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Role: ')
														])),
													$elm$html$Html$text(job.V.bS)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-rate')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('Rate: ')
														])),
													$elm$html$Html$text('$' + job.V.iM)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-details-row')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('role-card-dates')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('far fa-calendar-alt')
														]),
													_List_Nil),
													$elm$html$Html$text(
													$author$project$Utils$formatDate(
														A2($author$project$Project$findDeadline, job.V.g6, 'Project').fP) + (' - ' + $author$project$Utils$formatDate(
														A2($author$project$Project$findDeadline, job.V.g6, 'Project').ee)))
												])),
											A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$i,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('fas fa-map-marker-alt')
														]),
													_List_Nil),
													$elm$html$Html$text(
													A2($author$project$Project$findDeadline, job.V.g6, 'Project').hM)
												]))
										])),
									A6($author$project$Views$Job$scheduleTimeDisplay, job, 'Audition', notification, userId, isOpen, formInvalid),
									A6($author$project$Views$Job$scheduleTimeDisplay, job, 'Callback', notification, userId, isOpen, formInvalid),
									A7($author$project$Views$Job$candidateAction, notification, job, userId, isOpen, false, 27, formInvalid)
								]))
						])),
					A2($author$project$Views$Job$chatMessages, twilioData, job)
				]));
	});
var $author$project$Views$Job$appliedJobs = F2(
	function (model, isOpen) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (job) {
					return A6($author$project$Views$Job$appliedJobRow, model.bT, job, model.g1, model.p, isOpen, model.c_);
				},
				A2(
					$elm$core$List$filter,
					function (j) {
						return j.V.bS !== '';
					},
					model.eR)));
	});
var $author$project$Views$Job$myJobsView = F2(
	function (model, isOpen) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('job-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('modal', true),
											_Utils_Tuple2('modal-open', isOpen)
										])),
									$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleApplicationConfirmationModal)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('main-section')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Jobs')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('body')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Here\'s a List of your current jobs and status. Stay up-to-date.')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('my-jobs-count')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											'YOUR JOBS (' + ($elm$core$String$fromInt(
												$elm$core$List$length(model.eR)) + ')'))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('card-container current-cards')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Views$Job$appliedJobs, model, isOpen)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('chat-modal-container', true),
									_Utils_Tuple2('chat-modal-container-open', model.dq)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal'),
									$elm$html$Html$Events$onClick($author$project$MainMsg$CloseTalentConversationContainer)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('talent-chat-window-container')
								]),
							_List_fromArray(
								[
									$author$project$Views$Messages$chatBoxContainer(
									{F: model.F, n: model.p.n, bo: model.bo, q: isOpen, t: model.p.t, ce: model.ce, hU: model.L.dP, hV: model.p.t.hV, bT: model.bT, E: model.E, v: model.v})
								]))
						]))
				]));
	});
var $author$project$Views$Dashboard$notFoundView = A2(
	$elm$html$Html$h1,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('PAGE NOT FOUND')
		]));
var $author$project$User$CompanyName = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$CompanyPhone = function (a) {
	return {$: 2, a: a};
};
var $author$project$MainMsg$CompanyProfileMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$CompanyType = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$CompanyWebAddress = function (a) {
	return {$: 3, a: a};
};
var $author$project$Views$Profile$companyTypes = _List_fromArray(
	['Casting Director', 'Advertisement', 'Marketing', 'Retail', 'Event Planning', 'Ecommerce', 'Individual', ' Other']);
var $author$project$Views$Form$selectStringField = F5(
	function (aMsg, bMsg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(
						A2($elm$core$Basics$composeL, aMsg, bMsg)),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionField, option, valueText);
					},
					options))
			]);
	});
var $author$project$Views$Profile$directorProfileFields = function (model) {
	var profileFormError = $elm$html$Html$text('');
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image-container')
					]),
				_List_fromArray(
					[
						A2($author$project$Views$Profile$uploadGallery, model.ab, model.l),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('image-preview-gallery')
							]),
						A2(
							$elm$core$List$map,
							function (image) {
								return A2($author$project$Views$Profile$imageItem, image, model.l);
							},
							model.l))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Company Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$CompanyProfileMsg, $author$project$User$CompanyName)),
								$elm$html$Html$Attributes$placeholder('Star Talent'),
								$elm$html$Html$Attributes$value(model.bJ.gP)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				A5($author$project$Views$Form$selectStringField, $author$project$MainMsg$CompanyProfileMsg, $author$project$User$CompanyType, 'Company Type', $author$project$Views$Profile$companyTypes, model.bJ.gR)),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Company Phone')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$CompanyProfileMsg, $author$project$User$CompanyPhone)),
								$elm$html$Html$Attributes$placeholder('(555) 555-5555'),
								$elm$html$Html$Attributes$type_('tel'),
								$elm$html$Html$Attributes$value(model.bJ.gQ)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Company Web Address')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$CompanyProfileMsg, $author$project$User$CompanyWebAddress)),
								$elm$html$Html$Attributes$placeholder('https://www.exampleagency.com'),
								$elm$html$Html$Attributes$value(model.bJ.gS)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Direct Number')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfilePhoneNumber)),
								$elm$html$Html$Attributes$placeholder('(555) 555-5555'),
								$elm$html$Html$Attributes$type_('tel'),
								$elm$html$Html$Attributes$value(model.E.e0)
							]),
						_List_Nil)
					])),
				profileFormError
			]));
};
var $author$project$Views$FormValidation$invalidProfileFields = F2(
	function (userProfile, images) {
		return (userProfile.gA === '') || ((!$elm$core$List$length(images)) || ((!userProfile.ht) || ((!userProfile.jC) || ((userProfile.hq === '') || (userProfile.hi === '')))));
	});
var $author$project$Views$Profile$profileInfoView = function (model) {
	var profileFields = $author$project$Views$Profile$directorProfileFields(
		{bJ: model.bJ, ab: model.ab, l: model.l, ay: model.ay, E: model.E});
	var _v0 = model.X;
	switch (_v0.$) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('failed')
					]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('user-form')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-container')
									]),
								_List_Nil)
							]))
					]));
		case 2:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('user-form')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-container')
									]),
								_List_fromArray(
									[$author$project$Utils$loader]))
							]))
					]));
		default:
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('user-form')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('form-container')
									]),
								_List_fromArray(
									[
										A4(
										$author$project$Views$Confirmations$deleteConfirmation,
										model.ad,
										$author$project$MainMsg$DeleteImage(model.as),
										A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
										'Are you sure you want to remove this image?'),
										A2($author$project$Views$Profile$imageResizeWindow, model.aA, model.aE),
										A2(
										$elm$html$Html$form,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('form main-form')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2(
																'invalid-form-container',
																A2($author$project$Views$FormValidation$invalidProfileFields, model.E, model.l) && (!model.E.V)),
																_Utils_Tuple2('invalid-form-container-hidden', true)
															]))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Please fill out your entire profile!')
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('First Name')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Events$onInput(
																A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileFirstName)),
																$elm$html$Html$Attributes$placeholder('John'),
																$elm$html$Html$Attributes$value(model.E.bx)
															]),
														_List_Nil)
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Last Name')
															])),
														A2(
														$elm$html$Html$input,
														_List_fromArray(
															[
																$elm$html$Html$Events$onInput(
																A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileLastName)),
																$elm$html$Html$Attributes$placeholder('Smith'),
																$elm$html$Html$Attributes$value(model.E.bP)
															]),
														_List_Nil)
													])),
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$label,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text('Email')
															])),
														A2(
														$elm$html$Html$p,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(model.E.bv)
															]))
													])),
												profileFields,
												A2(
												$elm$html$Html$div,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Events$onClick($author$project$MainMsg$UpdateProfileInfo),
																$elm$html$Html$Attributes$class('button full')
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Update Profile')
															]))
													]))
											]))
									]))
							]))
					]));
	}
};
var $author$project$Main$profileSettingsView = F2(
	function (model, a) {
		return $author$project$Views$Profile$profileInfoView(
			{aA: model.aA, bJ: model.bJ, as: model.as, eg: model.eg, aE: model.aE, ab: model.ab, l: model.l, ay: model.ay, ad: model.ad, E: model.E, X: model.X});
	});
var $author$project$User$AgencySelected = function (a) {
	return {$: 18, a: a};
};
var $author$project$User$AgentSelected = function (a) {
	return {$: 19, a: a};
};
var $author$project$MainMsg$ToggleAgencyForm = {$: 302};
var $author$project$MainMsg$AddAgentToUser = F2(
	function (a, b) {
		return {$: 264, a: a, b: b};
	});
var $author$project$Views$Profile$addAgentButton = F2(
	function (agentId, agencyId) {
		return ((agentId === '') || (agencyId === '')) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('add-agency-button'),
					$elm$html$Html$Events$onClick(
					A2($author$project$MainMsg$AddAgentToUser, agentId, agencyId))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add Agent')
				]));
	});
var $author$project$MainMsg$DeleteTalentAgent = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Views$Profile$acceptedTalentText = function (accepted) {
	switch (accepted) {
		case 0:
			return 'Agent Accepted';
		case 1:
			return 'Agent Rejected';
		default:
			return 'Pending Acceptance';
	}
};
var $author$project$Views$Profile$agentLi = function (agent) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('agency-info-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verification-agent-badge')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						$author$project$Views$Profile$acceptedTalentText(agent.dx))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agent-info-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agency Name: ' + agent.cF)
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent Name: ' + (agent.bx + (' ' + agent.bP)))
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						A2($author$project$MainMsg$DeleteTalentAgent, agent.dJ, agent.aa))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Remove Agent')
					]))
			]));
};
var $author$project$Views$Profile$agencyInformation = function (agents) {
	return _Utils_eq(agents, _List_Nil) ? $elm$html$Html$text('No Agents Selected') : A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h3,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('My Selected Agents')
					])),
				A2(
				$elm$html$Html$ul,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('agency-list')
					]),
				A2($elm$core$List$map, $author$project$Views$Profile$agentLi, agents))
			]));
};
var $author$project$Views$Form$agencyOptionField = F2(
	function (item, selectedId) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item.aa),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item.aa, selectedId))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.bS)
				]));
	});
var $author$project$Views$Form$agencySelectField = F4(
	function (aMsg, placeholderText, options, valueText) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(placeholderText)
						])),
					A2(
					$elm$html$Html$select,
					_List_fromArray(
						[
							$elm$html$Html$Events$onInput(aMsg),
							$elm$html$Html$Attributes$placeholder(placeholderText),
							$elm$html$Html$Attributes$class('select-field')
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$agencyOptionField, option, valueText);
						},
						options))
				]));
	});
var $author$project$User$AgentPhone = function (a) {
	return {$: 3, a: a};
};
var $author$project$User$ProfileManualAgency = function (a) {
	return {$: 17, a: a};
};
var $author$project$MainMsg$SaveAgencyInfo = {$: 306};
var $author$project$Views$Profile$addManualAgencyButton = function (agency) {
	return ((agency.gm === '') || ((agency.gn === '') || ((agency.gl === '') || (agency.cF === '')))) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$SaveAgencyInfo),
				$elm$html$Html$Attributes$class('agency-save-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Add Agent')
			]));
};
var $author$project$Views$Profile$talentAgencyFields = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleAgencyForm),
						$elm$html$Html$Attributes$class('agency-toggle-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Find Agency')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agency Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgencyName(input)));
								}),
								$elm$html$Html$Attributes$placeholder('Brown Agency'),
								$elm$html$Html$Attributes$value(userProfile.cE.cF)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent First Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgentFirstName(input)));
								}),
								$elm$html$Html$Attributes$placeholder('Bob Smith'),
								$elm$html$Html$Attributes$value(userProfile.cE.gm)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent Last Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgentLastName(input)));
								}),
								$elm$html$Html$Attributes$placeholder('Bob Smith'),
								$elm$html$Html$Attributes$value(userProfile.cE.gn)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent Phone Number')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgentPhone(input)));
								}),
								$elm$html$Html$Attributes$placeholder('(555) 555-5555'),
								$elm$html$Html$Attributes$type_('tel'),
								$elm$html$Html$Attributes$value(userProfile.cE.go)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Agent Email')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								function (input) {
									return $author$project$MainMsg$UserProfileMsg(
										$author$project$User$ProfileManualAgency(
											$author$project$User$AgentEmail(input)));
								}),
								$elm$html$Html$Attributes$placeholder('agent@email.com'),
								$elm$html$Html$Attributes$type_('text'),
								$elm$html$Html$Attributes$value(userProfile.cE.gl)
							]),
						_List_Nil)
					])),
				$author$project$Views$Profile$addManualAgencyButton(userProfile.cE)
			]));
};
var $author$project$Views$Profile$addAgencyFields = F2(
	function (userProfile, profilePageData) {
		if (profilePageData.fK) {
			return $author$project$Views$Profile$talentAgencyFields(userProfile);
		} else {
			var selectedAgent = A2(
				$elm$core$Maybe$withDefault,
				$author$project$User$emptyAgent,
				$elm$core$List$head(userProfile.gj.gp));
			var agents = _Utils_ap(
				_List_fromArray(
					[
						{aa: '', bS: ''}
					]),
				A2(
					$elm$core$List$map,
					function (agent) {
						return {aa: agent.aa, bS: agent.bx + (' ' + agent.bP)};
					},
					A2(
						$elm$core$Maybe$withDefault,
						$author$project$User$emptyAgency,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$author$project$Utils$eq,
									function ($) {
										return $.aa;
									},
									userProfile.gj.aa),
								profilePageData.cD))).gp));
			var agencies = _Utils_ap(
				_List_fromArray(
					[
						{aa: '', bS: ''}
					]),
				A2(
					$elm$core$List$map,
					function (agency) {
						return {aa: agency.aa, bS: agency.cF};
					},
					profilePageData.cD));
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleAgencyForm),
								$elm$html$Html$Attributes$class('agency-toggle-button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Enter manually')
							])),
						A4(
						$author$project$Views$Form$agencySelectField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$AgencySelected),
						'Select Agency',
						agencies,
						userProfile.gj.aa),
						A4(
						$author$project$Views$Form$agencySelectField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$AgentSelected),
						'Select Agent',
						agents,
						selectedAgent.aa),
						A2($author$project$Views$Profile$addAgentButton, selectedAgent.aa, userProfile.gj.aa),
						$author$project$Views$Profile$agencyInformation(userProfile.gp)
					]));
		}
	});
var $author$project$SharedProjectRoleSchedules$DeleteFile = 2;
var $author$project$MainMsg$ResumeRequested = function (a) {
	return {$: 113, a: a};
};
var $author$project$MainMsg$DropResume = F2(
	function (a, b) {
		return {$: 120, a: a, b: b};
	});
var $author$project$Views$ProfileResumeUploader$dropDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['dataTransfer', 'files']),
	A2($elm$json$Json$Decode$oneOrMore, $author$project$MainMsg$DropResume, $elm$file$File$decoder));
var $author$project$Utils$Hijack$hijack = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $author$project$Utils$Hijack$hijackOn = F2(
	function (event, decoder) {
		return A2(
			$elm$html$Html$Events$preventDefaultOn,
			event,
			A2($elm$json$Json$Decode$map, $author$project$Utils$Hijack$hijack, decoder));
	});
var $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('file-upload-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Upload your resume')
							])),
						$elm$html$Html$text('Your resume will be availble to casting directors and any agencies that you belong to.')
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[content]))
			]));
};
var $elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var $author$project$Views$ProfileResumeUploader$profileResumeUploader = F2(
	function (status, maybeResume) {
		var _v0 = _Utils_Tuple2(status, maybeResume);
		switch (_v0.a.$) {
			case 0:
				if (_v0.b.$ === 1) {
					var _v1 = _v0.a;
					var _v2 = _v0.b;
					return $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resume-drop-zone'),
											A2(
											$author$project$Utils$Hijack$hijackOn,
											'dragenter',
											$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileEnter)),
											A2(
											$author$project$Utils$Hijack$hijackOn,
											'dragover',
											$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileEnter)),
											A2(
											$author$project$Utils$Hijack$hijackOn,
											'dragleave',
											$elm$json$Json$Decode$succeed($author$project$MainMsg$DragFileLeave)),
											A2($author$project$Utils$Hijack$hijackOn, 'drop', $author$project$Views$ProfileResumeUploader$dropDecoder)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Drag your resume here')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('Or')
												])),
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('resume-upload-button'),
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$ResumeRequested(1))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Select Resume')
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('file-upload-allowed-types')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Supported file types *.doc, *.docx, *.pdf, *.txt')
										]))
								])));
				} else {
					var _v3 = _v0.a;
					var resume = _v0.b.a;
					return $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer(
						A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resume-view-link'),
											$elm$html$Html$Attributes$href(resume),
											$elm$html$Html$Attributes$rel('noopener noreferrer'),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('fa fa-file')
												]),
											_List_Nil),
											$elm$html$Html$text('Resume')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('resume-actions')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('resume-link'),
													$elm$html$Html$Events$onClick(
													$author$project$MainMsg$ResumeRequested(2))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remove')
												]))
										]))
								])));
				}
			case 1:
				var file = _v0.a.a;
				return $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer(
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Uploading resume...')
							])));
			default:
				var _v4 = _v0.a;
				return $author$project$Views$ProfileResumeUploader$profileResumeUploaderContainer(
					$elm$html$Html$text('Resume upload Failed!'));
		}
	});
var $author$project$User$Day = function (a) {
	return {$: 1, a: a};
};
var $author$project$User$Month = function (a) {
	return {$: 0, a: a};
};
var $author$project$User$ProfileBirthDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$User$ProfileEyeColor = function (a) {
	return {$: 4, a: a};
};
var $author$project$User$ProfileGender = function (a) {
	return {$: 6, a: a};
};
var $author$project$User$ProfileHeightInFeet = function (a) {
	return {$: 9, a: a};
};
var $author$project$User$ProfileHeightInInches = function (a) {
	return {$: 8, a: a};
};
var $author$project$User$ProfileWaistSize = function (a) {
	return {$: 11, a: a};
};
var $author$project$User$ProfileWeight = function (a) {
	return {$: 10, a: a};
};
var $author$project$User$Year = function (a) {
	return {$: 2, a: a};
};
var $author$project$Views$Project$convertHeightToFeet = function (height) {
	return $elm$core$String$fromInt((height / 12) | 0);
};
var $author$project$Utils$days = function (month) {
	switch (month) {
		case 2:
			return A2($elm$core$List$range, 0, 28);
		case 4:
			return A2($elm$core$List$range, 0, 30);
		case 6:
			return A2($elm$core$List$range, 0, 30);
		case 9:
			return A2($elm$core$List$range, 0, 30);
		case 11:
			return A2($elm$core$List$range, 0, 30);
		default:
			return A2($elm$core$List$range, 0, 31);
	}
};
var $author$project$InitData$eyeColors = _List_fromArray(
	['Blue', 'Brown', 'Gray', 'Green', 'Hazel']);
var $author$project$InitData$genders = _List_fromArray(
	['Male', 'Female', 'Other']);
var $author$project$Views$Project$getLeftOverInches = function (height) {
	return $elm$core$String$fromInt(height % 12);
};
var $author$project$Utils$months = _List_fromArray(
	[
		{aa: '00', bS: 'Select Month'},
		{aa: '01', bS: 'Jan'},
		{aa: '02', bS: 'Feb'},
		{aa: '03', bS: 'March'},
		{aa: '04', bS: 'April'},
		{aa: '05', bS: 'May'},
		{aa: '06', bS: 'June'},
		{aa: '07', bS: 'July'},
		{aa: '08', bS: 'Aug'},
		{aa: '09', bS: 'Sept'},
		{aa: '10', bS: 'Oct'},
		{aa: '11', bS: 'Nov'},
		{aa: '12', bS: 'Dec'}
	]);
var $author$project$Utils$parseDay = function (day) {
	return A2(
		$elm$core$List$member,
		day,
		_List_fromArray(
			['00', '01', '02', '03', '04', '05', '06', '07', '08', '09'])) ? A2($elm$core$String$dropLeft, 1, day) : day;
};
var $author$project$Views$Form$floatOptionField = F2(
	function (item, selectedValue) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromFloat(item.bj)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item.bj, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item.g)
				]));
	});
var $author$project$Views$Form$selectFloatField = F4(
	function (inputChange, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(inputChange),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$floatOptionField, option, valueText);
					},
					options))
			]);
	});
var $author$project$Views$Form$stringOptionFieldProfile = F2(
	function (item, selectedValue) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(item, selectedValue))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item)
				]));
	});
var $author$project$Views$Form$selectIntFieldProfile = F4(
	function (msg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(msg),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionFieldProfile, option, valueText);
					},
					$author$project$Views$Form$convertIntOptionsToString(options)))
			]);
	});
var $author$project$Views$Form$selectProfileIntField = F4(
	function (msg, placeholderText, options, valueText) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(placeholderText)
					])),
				A2(
				$elm$html$Html$select,
				_List_fromArray(
					[
						$elm$html$Html$Events$onInput(msg),
						$elm$html$Html$Attributes$placeholder(placeholderText),
						$elm$html$Html$Attributes$class('select-field')
					]),
				A2(
					$elm$core$List$map,
					function (option) {
						return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Form$stringOptionField, option, valueText);
					},
					$author$project$Views$Form$convertIntOptionsToString(options)))
			]);
	});
var $author$project$Talent$waistSizes = _List_fromArray(
	[
		{g: 'ANY', bj: 0},
		{g: '26.5\"', bj: 26.5},
		{g: '27\"', bj: 27.0},
		{g: '27.5\"', bj: 27.5},
		{g: '28\"', bj: 28.0},
		{g: '28.5\"', bj: 28.5},
		{g: '29\"', bj: 29.0},
		{g: '29.5\"', bj: 29.5},
		{g: '30\"', bj: 30.0},
		{g: '30.5\"', bj: 30.5},
		{g: '31\"', bj: 31.0},
		{g: '31.5\"', bj: 31.5},
		{g: '32\"', bj: 32.0},
		{g: '32.5\"', bj: 32.5},
		{g: '33\"', bj: 33.0},
		{g: '33.5\"', bj: 33.5},
		{g: '34\"', bj: 34.0},
		{g: '34.5\"', bj: 34.5},
		{g: '35\"', bj: 35.0},
		{g: '35.5\"', bj: 35.5},
		{g: '36\"', bj: 36.0},
		{g: '36.5\"', bj: 36.5},
		{g: '37\"', bj: 37.0},
		{g: '37.5\"', bj: 37.5},
		{g: '38\"', bj: 38.0},
		{g: '38.5\"', bj: 38.5},
		{g: '39\"', bj: 39.0},
		{g: '39.5\"', bj: 39.5},
		{g: '40\"', bj: 40.0},
		{g: '40.5\"', bj: 40.5},
		{g: '41\"', bj: 41.0},
		{g: '41.5\"', bj: 41.5},
		{g: '42\"', bj: 42.0},
		{g: '42.5\"', bj: 42.5},
		{g: '43\"', bj: 43.0},
		{g: '43.5\"', bj: 43.5},
		{g: '44\"', bj: 44.0},
		{g: '44.5\"', bj: 44.5},
		{g: '45\"', bj: 45.0},
		{g: '45.5\"', bj: 45.5},
		{g: '46\"', bj: 46.0},
		{g: '46.5\"', bj: 46.5},
		{g: '47\"', bj: 47.0},
		{g: '47.5\"', bj: 47.5},
		{g: '48\"', bj: 48.0},
		{g: '48.5\"', bj: 48.5},
		{g: '49\"', bj: 49.0},
		{g: '49.5\"', bj: 49.5},
		{g: '50\"', bj: 50.0},
		{g: '50.5\"', bj: 50.5},
		{g: '51\"', bj: 51.0},
		{g: '51.5\"', bj: 51.5}
	]);
var $author$project$Views$Profile$talentAttributesFields = F2(
	function (userProfile, ethnicities) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A5(
						$author$project$Views$Form$selectStringField,
						$author$project$MainMsg$UserProfileMsg,
						$author$project$User$ProfileEyeColor,
						'* Eye Color',
						A2($elm$core$List$cons, '', $author$project$InitData$eyeColors),
						userProfile.hi)),
					A2(
					$elm$html$Html$label,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('Birthday')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('birthdate-input')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$Views$Form$agencySelectField,
									A2(
										$elm$core$Basics$composeL,
										A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileBirthDate),
										$author$project$User$Month),
									'Month',
									$author$project$Utils$months,
									userProfile.h$)
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A4(
								$author$project$Views$Form$selectProfileIntField,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileBirthDate),
									$author$project$User$Day),
								'Day',
								$author$project$Utils$days(
									A2(
										$elm$core$Maybe$withDefault,
										0,
										$elm$core$String$toInt(userProfile.h$))),
								$author$project$Utils$parseDay(userProfile.g5))),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							A4(
								$author$project$Views$Form$selectProfileIntField,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileBirthDate),
									$author$project$User$Year),
								'Year',
								A2(
									$elm$core$List$cons,
									0,
									A2($elm$core$List$range, 1920, 2019)),
								userProfile.jE))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A5(
						$author$project$Views$Form$selectStringField,
						$author$project$MainMsg$UserProfileMsg,
						$author$project$User$ProfileGender,
						'* Gender',
						A2($elm$core$List$cons, '', $author$project$InitData$genders),
						userProfile.hq)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4(
							$author$project$Views$Form$multiSelect,
							'Ethnic Appearance',
							A2(
								$elm$core$List$cons,
								{aa: '', bS: ''},
								ethnicities),
							A2(
								$elm$core$List$map,
								function (option) {
									return option.bS;
								},
								userProfile.eg),
							3)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('height-section')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('half')
								]),
							A4(
								$author$project$Views$Form$selectIntFieldProfile,
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileHeightInFeet),
								'* Height in Feet',
								_Utils_ap(
									_List_fromArray(
										[0]),
									A2($elm$core$List$range, 3, 7)),
								$author$project$Views$Project$convertHeightToFeet(userProfile.ht))),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('half')
								]),
							A4(
								$author$project$Views$Form$selectIntFieldProfile,
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileHeightInInches),
								'* Height in Inches',
								A2($elm$core$List$range, 0, 12),
								$author$project$Views$Project$getLeftOverInches(userProfile.ht)))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$label,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text('* Weight')
								])),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onInput(
									A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileWeight)),
									$elm$html$Html$Attributes$placeholder('135'),
									$elm$html$Html$Attributes$value(
									$elm$core$String$fromInt(userProfile.jC))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A4(
						$author$project$Views$Form$selectFloatField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileWaistSize),
						'Waist Size',
						$author$project$Talent$waistSizes,
						userProfile.jA))
				]));
	});
var $author$project$User$ProfileCity = function (a) {
	return {$: 12, a: a};
};
var $author$project$User$ProfileState = function (a) {
	return {$: 13, a: a};
};
var $author$project$Views$Profile$talentContactInformationFields = function (userProfile) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('First Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileFirstName)),
								$elm$html$Html$Attributes$placeholder('John'),
								$elm$html$Html$Attributes$value(userProfile.bx)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Last Name')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileLastName)),
								$elm$html$Html$Attributes$placeholder('Smith'),
								$elm$html$Html$Attributes$value(userProfile.bP)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Email')
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(userProfile.bv)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('City')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileCity)),
								$elm$html$Html$Attributes$placeholder('Austin'),
								$elm$html$Html$Attributes$value(userProfile.a0)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('State')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfileState)),
								$elm$html$Html$Attributes$placeholder('TX'),
								$elm$html$Html$Attributes$value(userProfile.bf)
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$label,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Phone Number')
							])),
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UserProfileMsg, $author$project$User$ProfilePhoneNumber)),
								$elm$html$Html$Attributes$placeholder('(555) 555-5555'),
								$elm$html$Html$Attributes$type_('tel'),
								$elm$html$Html$Attributes$value(userProfile.e0)
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Views$Profile$questionsSection = function (pageIndex) {
	return function (userProfile) {
		return function (ethnicities) {
			return function (images) {
				return function (profilePageData) {
					return function (imageUpload) {
						return function (resumeUpload) {
							return function (deleteID) {
								return function (showDeleteConfirmation) {
									return function (adjustingImage) {
										return function (imageToAdjust) {
											switch (pageIndex) {
												case 0:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Views$Profile$talentContactInformationFields(userProfile)
																			]))
																	]))
															]));
												case 1:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				A2($author$project$Views$Profile$talentAttributesFields, userProfile, ethnicities)
																			]))
																	]))
															]));
												case 2:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				A2($author$project$Views$Profile$addAgencyFields, userProfile, profilePageData)
																			]))
																	]))
															]));
												case 3:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A4(
																		$author$project$Views$Confirmations$deleteConfirmation,
																		showDeleteConfirmation,
																		$author$project$MainMsg$DeleteImage(deleteID),
																		A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
																		'Are you sure you want to remove this image?'),
																		A2($author$project$Views$Profile$imageResizeWindow, adjustingImage, imageToAdjust),
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				A2($author$project$Views$Profile$uploadGallery, imageUpload, images),
																				A2(
																				$elm$html$Html$ul,
																				_List_fromArray(
																					[
																						$elm$html$Html$Attributes$class('image-preview-gallery')
																					]),
																				A2(
																					$elm$core$List$map,
																					function (image) {
																						return A2($author$project$Views$Profile$imageItem, image, images);
																					},
																					images))
																			]))
																	]))
															]));
												case 4:
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('talent-view-page')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('form-container')
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$form,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('form main-form')
																			]),
																		_List_fromArray(
																			[
																				A2($author$project$Views$ProfileResumeUploader$profileResumeUploader, resumeUpload, userProfile.iH)
																			]))
																	]))
															]));
												default:
													return $elm$html$Html$text('');
											}
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Profile$talentProfileFooter = F2(
	function (currentPageIndex, pageCount) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('profile-page-footer')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('pro-tip-footer')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Pro tip: The more information you fill out, the more jobs you will land.')
						])),
					A2($author$project$Views$Profile$nextButton, currentPageIndex, pageCount)
				]));
	});
var $author$project$Views$Profile$talentProfileView = function (profilePageData) {
	return function (userProfile) {
		return function (ethnicities) {
			return function (images) {
				return function (imageUpload) {
					return function (resumeUploadStatus) {
						return function (deleteID) {
							return function (showDeleteConfirmation) {
								return function (adjustingImage) {
									return function (imageToAdjust) {
										var _v0 = profilePageData.E;
										switch (_v0.$) {
											case 1:
												return $elm$html$Html$text('');
											case 2:
												return $elm$html$Html$text('');
											case 0:
												return $elm$html$Html$text('');
											default:
												var profile = _v0.a;
												var pageArray = $elm$core$Array$fromList(profile.ct);
												var activePage = A2(
													$elm$core$Maybe$withDefault,
													$author$project$User$emptyProfilePage,
													A2($elm$core$Array$get, profilePageData.d5, pageArray));
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('profile-wrapper')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('profile-container')
																]),
															_List_fromArray(
																[
																	A4($author$project$Views$Profile$talentProfileHeader, profile.ct, activePage, profilePageData.d5, profilePageData.de),
																	$author$project$Views$Profile$questionsSection(profilePageData.d5)(userProfile)(ethnicities)(images)(profilePageData)(imageUpload)(resumeUploadStatus)(deleteID)(showDeleteConfirmation)(adjustingImage)(imageToAdjust),
																	A2(
																	$author$project$Views$Profile$talentProfileFooter,
																	profilePageData.d5,
																	$elm$core$List$length(profile.ct))
																]))
														]));
										}
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Main$profileSettingsViewContent = F2(
	function (model, a) {
		if (a === 'profile') {
			var _v1 = model.E.V;
			switch (_v1) {
				case 0:
					return $author$project$Views$Profile$talentProfileView(model.h)(model.E)(model.eg)(model.l)(model.ab)(model.cx)(model.as)(model.ad)(model.aA)(model.aE);
				case 1:
					return $author$project$Views$Profile$profileInfoView(
						{aA: model.aA, bJ: model.bJ, as: model.as, eg: model.eg, aE: model.aE, ab: model.ab, l: model.l, ay: model.ay, ad: model.ad, E: model.E, X: model.X});
				default:
					return $elm$html$Html$text('');
			}
		} else {
			return $author$project$Views$Dashboard$notFoundView;
		}
	});
var $author$project$Project$BulkExisting = 3;
var $author$project$Project$Existing = 1;
var $author$project$Project$dnames = function (deadlines) {
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.bS;
		},
		deadlines);
};
var $author$project$Pipeline$CondensedView = 1;
var $author$project$Project$OntoElement = function (a) {
	return {$: 0, a: a};
};
var $visotype$elm_dom$Dom$Internal$Element = $elm$core$Basics$identity;
var $visotype$elm_dom$Dom$Internal$modify = F2(
	function (f, _v0) {
		var data = _v0;
		return f(data);
	});
var $visotype$elm_dom$Dom$addClass = function (s) {
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					aQ: A2(
						$elm$core$List$append,
						n.aQ,
						_List_fromArray(
							[s]))
				});
		});
};
var $visotype$elm_dom$Dom$addClassConditional = F2(
	function (s, test) {
		if (test) {
			return $visotype$elm_dom$Dom$addClass(s);
		} else {
			return function (x) {
				return x;
			};
		}
	});
var $visotype$elm_dom$Dom$addAction = function (_v0) {
	var event = _v0.a;
	var msg = _v0.b;
	var handler = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $elm$virtual_dom$VirtualDom$Normal);
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					u: A2(
						$elm$core$List$append,
						n.u,
						_List_fromArray(
							[
								_Utils_Tuple2(
								event,
								handler(msg))
							]))
				});
		});
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $visotype$elm_dom$Dom$Internal$render = function (_v0) {
	var data = _v0;
	var prependStyles = function () {
		var _v8 = data.fR;
		if (!_v8.b) {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$append(
				A2(
					$elm$core$List$map,
					function (_v9) {
						var k = _v9.a;
						var v = _v9.b;
						return A2($elm$virtual_dom$VirtualDom$style, k, v);
					},
					data.fR));
		}
	}();
	var prependListeners = function () {
		var _v6 = data.u;
		if (!_v6.b) {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$append(
				A2(
					$elm$core$List$map,
					function (_v7) {
						var k = _v7.a;
						var v = _v7.b;
						return A2($elm$virtual_dom$VirtualDom$on, k, v);
					},
					data.u));
		}
	}();
	var consTextKeyed = function () {
		var _v5 = data.g;
		if (_v5 === '') {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$cons(
				A2(
					$elm$core$Tuple$pair,
					'rendered-internal-text',
					$elm$virtual_dom$VirtualDom$text(data.g)));
		}
	}();
	var consText = function () {
		var _v4 = data.g;
		if (_v4 === '') {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$cons(
				$elm$virtual_dom$VirtualDom$text(data.g));
		}
	}();
	var consId = function () {
		var _v3 = data.aa;
		if (_v3 === '') {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$cons(
				A2(
					$elm$virtual_dom$VirtualDom$property,
					'id',
					$elm$json$Json$Encode$string(data.aa)));
		}
	}();
	var consClassName = function () {
		var _v2 = data.aQ;
		if (!_v2.b) {
			return function (x) {
				return x;
			};
		} else {
			return $elm$core$List$cons(
				A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(
						A2($elm$core$String$join, ' ', data.aQ))));
		}
	}();
	var allAttributes = consId(
		consClassName(
			prependStyles(
				prependListeners(data.bn))));
	var _v1 = _Utils_Tuple2(data.h1, data.hJ);
	if (_v1.a === '') {
		if (!_v1.b.b) {
			return A3(
				$elm$virtual_dom$VirtualDom$node,
				data.dp,
				allAttributes,
				consText(data.gL));
		} else {
			return A3(
				$elm$virtual_dom$VirtualDom$keyedNode,
				data.dp,
				allAttributes,
				consTextKeyed(
					A3($elm$core$List$map2, $elm$core$Tuple$pair, data.hJ, data.gL)));
		}
	} else {
		if (!_v1.b.b) {
			return A4(
				$elm$virtual_dom$VirtualDom$nodeNS,
				data.h1,
				data.dp,
				allAttributes,
				consText(data.gL));
		} else {
			return A4(
				$elm$virtual_dom$VirtualDom$keyedNodeNS,
				data.h1,
				data.dp,
				allAttributes,
				consTextKeyed(
					A3($elm$core$List$map2, $elm$core$Tuple$pair, data.hJ, data.gL)));
		}
	}
};
var $visotype$elm_dom$Dom$appendChild = function (e) {
	var r = $visotype$elm_dom$Dom$Internal$render(e);
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					gL: A2(
						$elm$core$List$append,
						n.gL,
						_List_fromArray(
							[r]))
				});
		});
};
var $visotype$elm_dom$Dom$element = function (tag) {
	return {bn: _List_Nil, gL: _List_Nil, aQ: _List_Nil, aa: '', hJ: _List_Nil, u: _List_Nil, h1: '', fR: _List_Nil, dp: tag, g: ''};
};
var $author$project$Views$Pipeline$addTalentButton = F3(
	function (nameOfColumn, projectPublished, projectId) {
		return ((nameOfColumn === 'Matching Candidates') && projectPublished) ? A2(
			$visotype$elm_dom$Dom$appendChild,
			A2(
				$visotype$elm_dom$Dom$addClass,
				'fas fa-plus',
				$visotype$elm_dom$Dom$element('span')),
			A2(
				$visotype$elm_dom$Dom$addAction,
				_Utils_Tuple2(
					'click',
					A3($author$project$MainMsg$GoToTalentSearch, projectId, '', '')),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'add-talent-button',
					$visotype$elm_dom$Dom$element('div')))) : $visotype$elm_dom$Dom$element('span');
	});
var $visotype$elm_dom$Dom$appendChildList = function (le) {
	var lr = A2($elm$core$List$map, $visotype$elm_dom$Dom$Internal$render, le);
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					gL: A2($elm$core$List$append, n.gL, lr)
				});
		});
};
var $author$project$Pipeline$ColumnName = function (a) {
	return {$: 0, a: a};
};
var $author$project$MainMsg$SubmitUpdatedColumnName = {$: 170};
var $author$project$MainMsg$ToggleEditingColumn = function (a) {
	return {$: 168, a: a};
};
var $author$project$MainMsg$UpdateColumn = function (a) {
	return {$: 169, a: a};
};
var $visotype$elm_dom$Dom$Internal$captureStopPropagation = F2(
	function (_v0, token) {
		var field = _v0.a;
		var decoder = _v0.b;
		return $elm$virtual_dom$VirtualDom$MayStopPropagation(
			A2(
				$elm$json$Json$Decode$map,
				function (x) {
					return _Utils_Tuple2(x, true);
				},
				A2(
					$elm$json$Json$Decode$map,
					token,
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['target', field]),
						decoder))));
	});
var $visotype$elm_dom$Dom$addInputHandler = function (token) {
	var handler = $visotype$elm_dom$Dom$Internal$captureStopPropagation(
		_Utils_Tuple2('value', $elm$json$Json$Decode$string));
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					u: A2(
						$elm$core$List$append,
						n.u,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'input',
								handler(token))
							]))
				});
		});
};
var $elm$core$String$append = _String_append;
var $visotype$elm_dom$Dom$appendText = function (s) {
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					g: A2($elm$core$String$append, n.g, s)
				});
		});
};
var $author$project$Views$Pipeline$columnName = function (item) {
	return (item.g2 !== '') ? item.g2 : item.bS;
};
var $author$project$Views$Pipeline$columnEditingView = F2(
	function (editing, item) {
		return A2(
			$visotype$elm_dom$Dom$appendChild,
			A2(
				$visotype$elm_dom$Dom$appendText,
				$author$project$Views$Pipeline$columnName(item),
				A2(
					$visotype$elm_dom$Dom$addInputHandler,
					A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateColumn, $author$project$Pipeline$ColumnName),
					$visotype$elm_dom$Dom$element('input'))),
			A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$addAction,
							_Utils_Tuple2('click', $author$project$MainMsg$SubmitUpdatedColumnName),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'fas fa-check',
								$visotype$elm_dom$Dom$element('span'))),
							A2(
							$visotype$elm_dom$Dom$addAction,
							_Utils_Tuple2(
								'click',
								$author$project$MainMsg$ToggleEditingColumn($author$project$Pipeline$emptyColumn)),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'fas fa-times',
								$visotype$elm_dom$Dom$element('span')))
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'update-icons',
						$visotype$elm_dom$Dom$element('div'))),
				A3(
					$visotype$elm_dom$Dom$addClassConditional,
					'editing-mode',
					_Utils_eq(
						editing,
						$author$project$Project$Edit(item.aa)),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-edit-box',
						$visotype$elm_dom$Dom$element('div')))));
	});
var $author$project$Pipeline$CondensedFullPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$MainMsg$FilterCandidates = F2(
	function (a, b) {
		return {$: 180, a: a, b: b};
	});
var $author$project$MainMsg$SelectAllCandidates = function (a) {
	return {$: 177, a: a};
};
var $author$project$MainMsg$SortCandidates = F2(
	function (a, b) {
		return {$: 179, a: a, b: b};
	});
var $author$project$MainMsg$TogglePageView = function (a) {
	return {$: 189, a: a};
};
var $author$project$MainMsg$UpdateUserView = function (a) {
	return {$: 188, a: a};
};
var $author$project$Views$Pipeline$menuItem = F3(
	function (title, amsg, active) {
		return A2(
			$visotype$elm_dom$Dom$appendText,
			title,
			A2(
				$visotype$elm_dom$Dom$addAction,
				_Utils_Tuple2('click', amsg),
				A3(
					$visotype$elm_dom$Dom$addClassConditional,
					'active-section',
					active,
					$visotype$elm_dom$Dom$element('li'))));
	});
var $author$project$Views$Pipeline$menuOpen = F2(
	function (id, multiModalStatus) {
		if (!multiModalStatus.$) {
			var str = multiModalStatus.a;
			return _Utils_eq(str, id);
		} else {
			return false;
		}
	});
var $author$project$Views$Pipeline$columnMenu = F3(
	function (multiModalStatus, item, userView) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$appendText,
							'Sort By:',
							$visotype$elm_dom$Dom$element('h6')),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Date Created (Newest - Oldest)',
							A2($author$project$MainMsg$SortCandidates, 0, item.aa),
							!item.i2),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Date Created (Oldest - Newest)',
							A2($author$project$MainMsg$SortCandidates, 1, item.aa),
							item.i2 === 1),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Role',
							A2($author$project$MainMsg$SortCandidates, 2, item.aa),
							item.i2 === 2),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Status',
							A2($author$project$MainMsg$SortCandidates, 3, item.aa),
							item.i2 === 3)
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-menu-section',
						$visotype$elm_dom$Dom$element('ul'))),
					A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$appendText,
							'Filter By:',
							$visotype$elm_dom$Dom$element('h6')),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Clear Filter',
							A2($author$project$MainMsg$FilterCandidates, 3, item.aa),
							item.hm === 3),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Applied',
							A2($author$project$MainMsg$FilterCandidates, 0, item.aa),
							!item.hm),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Invited To Apply',
							A2($author$project$MainMsg$FilterCandidates, 1, item.aa),
							item.hm === 1),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Accepted Application Invitation',
							A2($author$project$MainMsg$FilterCandidates, 2, item.aa),
							item.hm === 2)
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-menu-section',
						$visotype$elm_dom$Dom$element('ul'))),
					A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$appendText,
							'View:',
							$visotype$elm_dom$Dom$element('h6')),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Standard List',
							$author$project$MainMsg$UpdateUserView(0),
							!userView),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Condensed List',
							$author$project$MainMsg$UpdateUserView(1),
							userView === 1),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Full Page View',
							$author$project$MainMsg$TogglePageView(
								$author$project$Pipeline$CondensedFullPage(item.aa)),
							false)
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-menu-section',
						$visotype$elm_dom$Dom$element('ul'))),
					A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$appendText,
							'Edit:',
							$visotype$elm_dom$Dom$element('h6')),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Select All Candidates',
							$author$project$MainMsg$SelectAllCandidates(
								A2(
									$elm$core$List$map,
									function (user) {
										return $author$project$Utils$transformToSearchResultTalentProfile(user);
									},
									item.jx)),
							false),
							A3(
							$author$project$Views$Pipeline$menuItem,
							'Rename List',
							$author$project$MainMsg$ToggleEditingColumn(item),
							false)
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'column-menu-section',
						$visotype$elm_dom$Dom$element('ul')))
				]),
			A3(
				$visotype$elm_dom$Dom$addClassConditional,
				'menu-open',
				A2($author$project$Views$Pipeline$menuOpen, item.aa, multiModalStatus),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'column-menu',
					$visotype$elm_dom$Dom$element('ul'))));
	});
var $author$project$Views$Pipeline$columnTitle = F3(
	function (item, editing, multiModalStatus) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A2(
					$visotype$elm_dom$Dom$appendText,
					$author$project$Views$Pipeline$columnName(item) + (' (' + ($elm$core$String$fromInt(
						$elm$core$List$length(item.jx)) + ')')),
					A2(
						$visotype$elm_dom$Dom$addAction,
						_Utils_Tuple2(
							'click',
							$author$project$MainMsg$ToggleEditingColumn(item)),
						A3(
							$visotype$elm_dom$Dom$addClassConditional,
							'title-hidden',
							_Utils_eq(
								editing,
								$author$project$Project$Edit(item.aa)),
							$visotype$elm_dom$Dom$element('h4')))),
					A3(
					$visotype$elm_dom$Dom$addClassConditional,
					'menu-icon-open',
					A2($author$project$Views$Pipeline$menuOpen, item.aa, multiModalStatus),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'menu-icon',
						A2(
							$visotype$elm_dom$Dom$addAction,
							_Utils_Tuple2(
								'click',
								$author$project$MainMsg$ToggleColumnMenu(item.aa)),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'fas fa-ellipsis-h',
								$visotype$elm_dom$Dom$element('i')))))
				]),
			A2(
				$visotype$elm_dom$Dom$addClass,
				'column-title',
				$visotype$elm_dom$Dom$element('div')));
	});
var $author$project$MainMsg$MoveCanceled = {$: 186};
var $author$project$MainMsg$MoveCompleted = F2(
	function (a, b) {
		return {$: 187, a: a, b: b};
	});
var $author$project$MainMsg$MoveStarted = function (a) {
	return {$: 184, a: a};
};
var $author$project$MainMsg$MoveTargetChanged = function (a) {
	return {$: 185, a: a};
};
var $author$project$MainMsg$dragDropMessages = {d9: $author$project$MainMsg$MoveCanceled, ea: $author$project$MainMsg$MoveStarted, eb: $author$project$MainMsg$MoveTargetChanged, ec: $author$project$MainMsg$MoveCompleted};
var $author$project$Views$ModalOverlay$invisibleModalDom = F2(
	function (toggleMsg, open) {
		return A2(
			$visotype$elm_dom$Dom$addAction,
			_Utils_Tuple2('click', toggleMsg),
			A3(
				$visotype$elm_dom$Dom$addClassConditional,
				'invisible-modal-open',
				open,
				A2(
					$visotype$elm_dom$Dom$addClass,
					'invisible-modal',
					$visotype$elm_dom$Dom$element('div'))));
	});
var $visotype$elm_dom$Dom$addAttribute = function (a) {
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					bn: A2(
						$elm$core$List$append,
						n.bn,
						_List_fromArray(
							[a]))
				});
		});
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$isCurrentDropTarget = F2(
	function (_v0, id) {
		var state = _v0;
		var _v1 = _Utils_Tuple2(
			state.bs,
			_Utils_eq(
				state.bs,
				$arsduo$elm_dom_drag_drop$Dom$DragDrop$State$SpecificDropTarget(id)));
		if ((_v1.a.$ === 1) && _v1.b) {
			return true;
		} else {
			return false;
		}
	});
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragHelper = F2(
	function (eventName, message) {
		return A2(
			$elm$html$Html$Events$on,
			eventName,
			$elm$json$Json$Decode$succeed(message));
	});
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnter = function (message) {
	return A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragHelper, 'dragenter', message);
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable = F4(
	function (state, dropTargetId, messages, element) {
		var droppableElement = A2(
			$visotype$elm_dom$Dom$addAttribute,
			$arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnter(
				messages.eb(dropTargetId)),
			element);
		var _v0 = A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$isCurrentDropTarget, state, dropTargetId);
		if (_v0) {
			return A2($visotype$elm_dom$Dom$addClass, 'drop-target', droppableElement);
		} else {
			return droppableElement;
		}
	});
var $visotype$elm_dom$Dom$prependChildList = function (le) {
	var lr = A2($elm$core$List$map, $visotype$elm_dom$Dom$Internal$render, le);
	return $visotype$elm_dom$Dom$Internal$modify(
		function (n) {
			return _Utils_update(
				n,
				{
					gL: A2($elm$core$List$append, lr, n.gL)
				});
		});
};
var $visotype$elm_dom$Dom$render = $visotype$elm_dom$Dom$Internal$render;
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$currentlyDraggedObject = function (_v0) {
	var stateData = _v0;
	return stateData.cg;
};
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$MainMsg$OpenMessageScreen = function (a) {
	return {$: 175, a: a};
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnd = function (message) {
	return A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragHelper, 'dragend', message);
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragStart = function (message) {
	return A2($arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragHelper, 'dragstart', message);
};
var $arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDraggable = F4(
	function (state, draggedElementId, messages, element) {
		var _v0 = $arsduo$elm_dom_drag_drop$Dom$DragDrop$currentlyDraggedObject(state);
		if (_v0.$ === 1) {
			return A2(
				$visotype$elm_dom$Dom$addAttribute,
				$arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragStart(
					messages.ea(draggedElementId)),
				A2(
					$visotype$elm_dom$Dom$addAttribute,
					A2(
						$elm$virtual_dom$VirtualDom$property,
						'draggable',
						$elm$json$Json$Encode$bool(true)),
					element));
		} else {
			var anObject = _v0.a;
			var _v1 = state;
			var stateData = _v1;
			var draggedElement = A3(
				$visotype$elm_dom$Dom$addClassConditional,
				'being-dragged',
				_Utils_eq(
					stateData.cg,
					$elm$core$Maybe$Just(draggedElementId)),
				element);
			var _v2 = stateData.bs;
			if (_v2.$ === 1) {
				var dropTargetId = _v2.a;
				return A2(
					$visotype$elm_dom$Dom$addAttribute,
					$arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnd(
						A2(messages.ec, draggedElementId, dropTargetId)),
					draggedElement);
			} else {
				return A2(
					$visotype$elm_dom$Dom$addAttribute,
					$arsduo$elm_dom_drag_drop$Dom$DragDrop$Events$onDragEnd(messages.d9),
					draggedElement);
			}
		}
	});
var $author$project$Utils$selectedUser = F2(
	function (userId, selectedTalentIds) {
		return A2($elm$core$List$member, userId, selectedTalentIds);
	});
var $author$project$Utils$stageText = function (stage) {
	switch (stage) {
		case 0:
			return 'Talent applied';
		case 1:
			return 'Agent added';
		case 2:
			return 'Invited to apply';
		case 3:
			return 'Accepted application request';
		case 4:
			return 'Rejected application Request';
		case 5:
			return 'Audition is scheduled';
		case 6:
			return 'Audition schedule accepted';
		case 7:
			return 'Audition schedule rejected';
		case 8:
			return 'Audition schedule needs to be rescheduled';
		case 9:
			return 'Audition schedule was rescheduled';
		case 10:
			return 'Audition was canceled';
		case 11:
			return 'Callback schedule requested';
		case 12:
			return 'Callback schedule accepted';
		case 13:
			return 'Callback schedule rejected';
		case 14:
			return 'Callback schedule needs to be rescheduled';
		case 15:
			return 'Callback schedule was rescheduled';
		case 16:
			return 'Callback schedule cancelled';
		case 17:
			return 'Booking request pending';
		case 18:
			return 'Accepted Booking Request';
		case 19:
			return 'Rejected Booking Request';
		case 21:
			return 'Role was cancelled';
		case 22:
			return 'Role was changed';
		case 26:
			return 'Scheduled';
		case 25:
			return 'Removed by agent';
		case 24:
			return 'Removed by Director';
		case 23:
			return 'Removed by Talent';
		default:
			return '';
	}
};
var $author$project$Utils$userInRoleDom = F2(
	function (user, menuToggle) {
		return user.ez ? A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A2(
					$visotype$elm_dom$Dom$appendText,
					$author$project$Utils$stageText(user.i3),
					$visotype$elm_dom$Dom$element('span')),
					A2(
					$visotype$elm_dom$Dom$addAction,
					_Utils_Tuple2('click', menuToggle),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'manage-talent-button fas fa-user-cog',
						$visotype$elm_dom$Dom$element('span')))
				]),
			A2(
				$visotype$elm_dom$Dom$addClass,
				'user-status-section',
				$visotype$elm_dom$Dom$element('div'))) : $visotype$elm_dom$Dom$element('span');
	});
var $author$project$Utils$talentDomCardV2 = function (user) {
	return function (dragDropState) {
		return function (matchingUser) {
			return function (showingUser) {
				return function (columnId) {
					return function (toggleTalentResultModal) {
						return function (toggleSelectedTalent) {
							return function (openMessageScreen) {
								return function (dragMessages) {
									return function (dragDropInfo) {
										return function (selectedTalent) {
											return function (menuToggle) {
												return A2(
													$visotype$elm_dom$Dom$appendChild,
													A2($author$project$Utils$userInRoleDom, user, menuToggle),
													A2(
														$visotype$elm_dom$Dom$appendChild,
														A2(
															$visotype$elm_dom$Dom$appendChildList,
															_List_fromArray(
																[
																	A2(
																	$visotype$elm_dom$Dom$appendText,
																	user.bx + (' ' + user.bP),
																	$visotype$elm_dom$Dom$element('span')),
																	A2(
																	$visotype$elm_dom$Dom$addAction,
																	_Utils_Tuple2('click', toggleTalentResultModal),
																	A2(
																		$visotype$elm_dom$Dom$addClass,
																		'fas fa-info-circle',
																		$visotype$elm_dom$Dom$element('span')))
																]),
															$visotype$elm_dom$Dom$element('p')),
														A2(
															$visotype$elm_dom$Dom$appendChildList,
															_List_fromArray(
																[
																	A2(
																	$visotype$elm_dom$Dom$appendChild,
																	A2(
																		$visotype$elm_dom$Dom$addAction,
																		_Utils_Tuple2('click', toggleSelectedTalent),
																		A2(
																			$visotype$elm_dom$Dom$addAttribute,
																			$elm$html$Html$Attributes$src(
																				A2(
																					$elm$core$Maybe$withDefault,
																					$author$project$User$emptyImage,
																					$elm$core$List$head(user.l)).js),
																			$visotype$elm_dom$Dom$element('img'))),
																	A2(
																		$visotype$elm_dom$Dom$addClass,
																		'talent-card-image-container',
																		$visotype$elm_dom$Dom$element('div')))
																]),
															A3(
																$visotype$elm_dom$Dom$addClassConditional,
																'selected-talent',
																A2(
																	$author$project$Utils$selectedUser,
																	user.c$,
																	A2(
																		$elm$core$List$map,
																		function ($) {
																			return $.c$;
																		},
																		selectedTalent)),
																A2(
																	$visotype$elm_dom$Dom$addClass,
																	'talent-dom-card-v2',
																	A3(
																		$visotype$elm_dom$Dom$addClassConditional,
																		'showing-user',
																		showingUser,
																		A3(
																			$visotype$elm_dom$Dom$addClassConditional,
																			'matching-user',
																			matchingUser,
																			A4(
																				$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDraggable,
																				dragDropState,
																				dragDropInfo,
																				dragMessages,
																				$visotype$elm_dom$Dom$element('div')))))))));
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Pipeline$userDisplay = F6(
	function (user, dragDropState, columnId, userView, searchQuery, selectedTalent) {
		var showingUser = $elm$core$String$length(searchQuery) <= 0;
		var matchingUser = ($elm$core$String$length(searchQuery) > 1) && (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bx)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bP)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.V.bS)) || A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bx + (' ' + user.bP))))));
		if (!userView) {
			return $author$project$Utils$talentDomCardV2(
				$author$project$Utils$transformToSearchResultTalentProfile(user))(dragDropState)(matchingUser)(showingUser)(columnId)(
				A3(
					$author$project$MainMsg$ToggleTalentResultModal,
					$author$project$Utils$transformToSearchResultTalentProfile(user),
					$author$project$Job$emptyApplicant,
					columnId))(
				A2(
					$author$project$MainMsg$ToggleSelectedTalent,
					user.c$,
					$author$project$Utils$transformToSearchResultTalentProfile(user)))(
				$author$project$MainMsg$OpenMessageScreen(
					$author$project$Utils$transformToSearchResultTalentProfile(user)))($author$project$MainMsg$dragDropMessages)(
				A2($author$project$Project$User, user.aX, user.gY))(selectedTalent)(
				$author$project$MainMsg$UpdateTalentMenuOptions(
					$author$project$User$ToggleMenuModal(
						$author$project$Utils$transformToSearchResultTalentProfile(user))));
		} else {
			return A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendChildList,
					_List_fromArray(
						[
							A2(
							$visotype$elm_dom$Dom$addAttribute,
							$elm$html$Html$Attributes$src(
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$User$emptyImage,
									$elm$core$List$head(user.l)).js),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'square-avatar',
								$visotype$elm_dom$Dom$element('img'))),
							A2(
							$visotype$elm_dom$Dom$appendChildList,
							_List_fromArray(
								[
									A2(
									$visotype$elm_dom$Dom$appendText,
									user.bx + (' ' + user.bP),
									$visotype$elm_dom$Dom$element('h3')),
									A2(
									$visotype$elm_dom$Dom$addClass,
									'pipeline-role-name',
									A2(
										$visotype$elm_dom$Dom$appendText,
										user.V.bS,
										$visotype$elm_dom$Dom$element('span')))
								]),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'user-name-info-container',
								$visotype$elm_dom$Dom$element('div')))
						]),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'condensed-user-info-container',
						$visotype$elm_dom$Dom$element('div'))),
				A3(
					$visotype$elm_dom$Dom$addClassConditional,
					'showing-user',
					showingUser,
					A3(
						$visotype$elm_dom$Dom$addClassConditional,
						'matching-user',
						matchingUser,
						A2(
							$visotype$elm_dom$Dom$addClass,
							'talent-card condensed',
							A2(
								$visotype$elm_dom$Dom$addAction,
								_Utils_Tuple2(
									'click',
									A3(
										$author$project$MainMsg$ToggleTalentResultModal,
										$author$project$Utils$transformToSearchResultTalentProfile(user),
										$author$project$Job$emptyApplicant,
										columnId)),
								A4(
									$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDraggable,
									dragDropState,
									A2($author$project$Project$User, user.aX, user.gY),
									$author$project$MainMsg$dragDropMessages,
									$visotype$elm_dom$Dom$element('div')))))));
		}
	});
var $author$project$Views$Pipeline$userIndex = F2(
	function (user, users) {
		return A2(
			$elm$core$Maybe$withDefault,
			100,
			A2(
				$elm_community$list_extra$List$Extra$elemIndex,
				user.c$,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.c$;
					},
					users)));
	});
var $author$project$Views$Pipeline$talentContents = F5(
	function (users, dragDropState, columnId, userView, searchQuery) {
		return A2(
			$elm$core$List$map,
			function (user) {
				return A6(
					$author$project$Views$Pipeline$userDisplay,
					user,
					dragDropState,
					columnId,
					userView,
					searchQuery,
					A2(
						$elm$core$List$map,
						function (u) {
							return $author$project$Utils$transformToSearchResultTalentProfile(u);
						},
						users));
			},
			A2(
				$elm$core$List$sortWith,
				F2(
					function (id1, id2) {
						return A2(
							$elm$core$Basics$compare,
							A2($author$project$Views$Pipeline$userIndex, id1, users),
							A2($author$project$Views$Pipeline$userIndex, id2, users));
					}),
				users));
	});
var $author$project$Views$Pipeline$talentList = F6(
	function (dragDropState, users, columnId, userView, searchQuery, className) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			function () {
				var _v0 = $arsduo$elm_dom_drag_drop$Dom$DragDrop$currentlyDraggedObject(dragDropState);
				if (_v0.$ === 1) {
					return A5($author$project$Views$Pipeline$talentContents, users, dragDropState, columnId, userView, searchQuery);
				} else {
					return A5($author$project$Views$Pipeline$talentContents, users, dragDropState, columnId, userView, searchQuery);
				}
			}(),
			A2(
				$visotype$elm_dom$Dom$addClass,
				className,
				$visotype$elm_dom$Dom$element('ul')));
	});
var $author$project$Views$Pipeline$column = function (dragDropState) {
	return function (item) {
		return function (multiModalStatus) {
			return function (editing) {
				return function (projectId) {
					return function (selectedTalent) {
						return function (sort) {
							return function (pageView) {
								return function (searchQuery) {
									return function (userView) {
										return function (deadlines) {
											return function (projectPublished) {
												if (!pageView.$) {
													return $visotype$elm_dom$Dom$render(
														A2(
															$visotype$elm_dom$Dom$appendChildList,
															_List_fromArray(
																[
																	A2(
																	$visotype$elm_dom$Dom$appendChildList,
																	A2(
																		$elm$core$List$map,
																		function (user) {
																			return A6($author$project$Views$Pipeline$userDisplay, user, dragDropState, item.aa, userView, searchQuery, selectedTalent);
																		},
																		item.jx),
																	A2(
																		$visotype$elm_dom$Dom$addClass,
																		'user-container',
																		$visotype$elm_dom$Dom$element('div')))
																]),
															A2(
																$visotype$elm_dom$Dom$prependChildList,
																_List_fromArray(
																	[
																		A2(
																		$author$project$Views$ModalOverlay$invisibleModalDom,
																		$author$project$MainMsg$ToggleColumnMenu(''),
																		A2($author$project$Views$Pipeline$menuOpen, item.aa, multiModalStatus)),
																		A2(
																		$visotype$elm_dom$Dom$appendChildList,
																		_List_fromArray(
																			[
																				A2($author$project$Views$Pipeline$columnEditingView, editing, item),
																				A3($author$project$Views$Pipeline$columnTitle, item, editing, multiModalStatus),
																				A3($author$project$Views$Pipeline$columnMenu, multiModalStatus, item, userView),
																				A3($author$project$Views$Pipeline$addTalentButton, item.bS, projectPublished, projectId)
																			]),
																		A2(
																			$visotype$elm_dom$Dom$addClass,
																			'column-info',
																			$visotype$elm_dom$Dom$element('div')))
																	]),
																A4(
																	$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable,
																	dragDropState,
																	$author$project$Project$OntoElement(item.aa),
																	$author$project$MainMsg$dragDropMessages,
																	A3(
																		$visotype$elm_dom$Dom$addClassConditional,
																		'visible-column',
																		!item.hC,
																		A2(
																			$visotype$elm_dom$Dom$addClass,
																			'column-container',
																			$visotype$elm_dom$Dom$element('li')))))));
												} else {
													return $visotype$elm_dom$Dom$render(
														A2(
															$visotype$elm_dom$Dom$prependChildList,
															_List_fromArray(
																[
																	A6($author$project$Views$Pipeline$talentList, dragDropState, item.jx, item.aa, 1, searchQuery, 'full-page-users')
																]),
															A2(
																$visotype$elm_dom$Dom$addClass,
																'full-page-column-container',
																$visotype$elm_dom$Dom$element('li'))));
												}
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Pipeline$defaultImage = function (user) {
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$User$emptyImage,
		$elm$core$List$head(user.l)).js;
};
var $author$project$Views$Pipeline$condensedUser = F3(
	function (user, searchQuery, columnId) {
		var showingUser = $elm$core$String$length(searchQuery) <= 1;
		var matchingParameters = A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bx)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bP)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.V.bS)) || A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bx + (' ' + user.bP)))));
		var matchingUser = ($elm$core$String$length(searchQuery) > 1) && matchingParameters;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('talent-card condensed', true),
							_Utils_Tuple2('matching-user', matchingUser),
							_Utils_Tuple2('showing-user', showingUser)
						])),
					$elm$html$Html$Events$onClick(
					A3(
						$author$project$MainMsg$ToggleTalentResultModal,
						$author$project$Utils$transformToSearchResultTalentProfile(user),
						$author$project$Job$emptyApplicant,
						columnId))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('condensed-info-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									$author$project$Views$Pipeline$defaultImage(user))
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('user-name-info-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(user.bx + (' ' + user.bP))
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('pipeline-role-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(user.V.bS)
								]))
						]))
				]));
	});
var $author$project$MainMsg$SearchFullPageUsers = function (a) {
	return {$: 190, a: a};
};
var $author$project$Views$Pipeline$searchBar = function (searchQuery) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('full-page-search-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$placeholder('Search Role, or Name'),
						$elm$html$Html$Attributes$value(searchQuery),
						$elm$html$Html$Events$onInput($author$project$MainMsg$SearchFullPageUsers)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-search')
					]),
				_List_Nil)
			]));
};
var $author$project$Views$Pipeline$fullPageHeader = F4(
	function (name, userCount, columnId, searchQuery) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('full-page-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							name + (' (' + ($elm$core$String$fromInt(userCount) + ')')))
						])),
					$author$project$Views$Pipeline$searchBar(searchQuery),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('exit-full-page-container'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$TogglePageView($author$project$Pipeline$StandardPipeline))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Exit Full Page View'),
							A2(
							$elm$html$Html$i,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-times')
								]),
							_List_Nil)
						]))
				]));
	});
var $author$project$Views$Pipeline$pipeline = function (dragDropState) {
	return function (columns) {
		return function (multiModalStatus) {
			return function (editing) {
				return function (projectId) {
					return function (selectedTalent) {
						return function (sort) {
							return function (pageView) {
								return function (searchQuery) {
									return function (userView) {
										return function (deadlines) {
											return function (projectPublished) {
												if (!pageView.$) {
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pipeline-container')
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('pipeline')
																	]),
																A2(
																	$elm$core$List$map,
																	function (pipe) {
																		return $author$project$Views$Pipeline$column(dragDropState)(pipe)(multiModalStatus)(editing)(projectId)(selectedTalent)(sort)(pageView)(searchQuery)(userView)(deadlines)(projectPublished);
																	},
																	columns))
															]));
												} else {
													var columnId = pageView.a;
													var matchingColumn = A2(
														$elm$core$Maybe$withDefault,
														$author$project$Pipeline$emptyColumn,
														$elm$core$List$head(
															A2(
																$elm$core$List$filter,
																function (pipe) {
																	return _Utils_eq(columnId, pipe.aa);
																},
																columns)));
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$class('pipeline-container-full-page')
															]),
														_List_fromArray(
															[
																A4(
																$author$project$Views$Pipeline$fullPageHeader,
																matchingColumn.bS,
																$elm$core$List$length(matchingColumn.jx),
																columnId,
																searchQuery),
																A2(
																$elm$html$Html$ul,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('full-page-user-list')
																	]),
																A2(
																	$elm$core$List$map,
																	function (user) {
																		return A4($elm$html$Html$Lazy$lazy3, $author$project$Views$Pipeline$condensedUser, user, searchQuery, columnId);
																	},
																	matchingColumn.jx))
															]));
												}
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$MainMsg$DeleteProject = function (a) {
	return {$: 51, a: a};
};
var $author$project$MainMsg$DeleteRole = function (a) {
	return {$: 64, a: a};
};
var $author$project$MainMsg$UpdateProjectStatus = {$: 96};
var $author$project$MainMsg$UpdateRoleStatus = {$: 243};
var $author$project$Views$Project$destructiveActions = function (active) {
	return active ? _List_fromArray(
		['Talent will be notified by email of the project cancelation', 'Schedules will be removed.', 'Talent will no longer be able to view or apply to roles.']) : _List_fromArray(
		['Talent will be matched to current roles.', 'Talent will be notified by email of the matching role.', 'Talent will be able to view and apply to roles.']);
};
var $author$project$Views$Project$parseScheduleType = function (scheduleType) {
	return (scheduleType === 'Callbacks') ? 'Callback' : scheduleType;
};
var $author$project$Views$Project$publishWarning = F2(
	function (active, warningType) {
		return active ? ('Once you unpublish this ' + (warningType + ', the following actions will take place:')) : ('Once you publish this ' + (warningType + ', the following actions will take place:'));
	});
var $author$project$Views$Project$projectConfirmations = F2(
	function (model, proj) {
		if (model.aL || model.ad) {
			var _v0 = model.ar;
			switch (_v0.$) {
				case 1:
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aL,
						$author$project$MainMsg$UpdateProjectStatus,
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						A2($author$project$Views$Project$publishWarning, proj.hB, 'project'),
						$author$project$Views$Project$destructiveActions(proj.hB));
				case 2:
					var roleData = _v0.a;
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aL,
						$author$project$MainMsg$UpdateRoleStatus,
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						A2($author$project$Views$Project$publishWarning, roleData.gf, 'role'),
						$author$project$Views$Project$destructiveActions(roleData.gf));
				case 0:
					return $elm$html$Html$text('');
				case 4:
					var roleData = _v0.a;
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aL,
						$author$project$MainMsg$DeleteRole(roleData.c$),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Are you sure you want to delete ' + (roleData.bS + ' role?'),
						_List_Nil);
				case 3:
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.ad,
						$author$project$MainMsg$DeleteProject(proj.c$),
						A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
						'Are you sure you want to delete the ' + (model.d8 + ' project?'),
						_List_Nil);
				case 6:
					var scheduleType = _v0.a;
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aL,
						$author$project$MainMsg$View(
							A2(
								$author$project$Route$SchedulePage,
								proj.c$,
								$author$project$Views$Project$parseScheduleType(scheduleType))),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Oops! That user has not been scheduled yet. Would you like to schedule this candidate?',
						_List_Nil);
				case 7:
					return A5(
						$author$project$Views$Confirmations$confirmation,
						model.aL,
						A4($author$project$MainMsg$UpdateUsersRoleStage, model.bT, model.bT.aX, model.bT.hK, model.bT.cA),
						A2($author$project$MainMsg$ToggleConfirmation, '', $author$project$Utils$HiddenConf),
						'Would you like to book this candidate?',
						_List_Nil);
				default:
					return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$MainMsg$ToggleEditOptions = {$: 95};
var $author$project$MainMsg$ToggleProjectInfoContainer = {$: 94};
var $author$project$Utils$UpdateProject = {$: 1};
var $author$project$Utils$dateTextNoTitle = F2(
	function (startDate, endDate) {
		return (($elm$core$String$length(startDate) > 0) && ($elm$core$String$length(endDate) > 0)) ? ($author$project$Utils$formatDate(startDate) + (' - ' + $author$project$Utils$formatDate(endDate))) : 'N/A';
	});
var $author$project$Views$ModalOverlay$invisibleModal = F2(
	function (toggleMsg, open) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('invisible-modal', true),
							_Utils_Tuple2('invisible-modal-open', open)
						])),
					$elm$html$Html$Events$onClick(toggleMsg)
				]),
			_List_Nil);
	});
var $frandibar$elm_font_awesome_5$FontAwesome$plusCircle = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('plus-circle');
var $author$project$Views$Pipeline$projectSearchBar = function (searchQuery) {
	return $visotype$elm_dom$Dom$render(
		A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A2(
					$visotype$elm_dom$Dom$addInputHandler,
					$author$project$MainMsg$SearchFullPageUsers,
					A2(
						$visotype$elm_dom$Dom$addAttribute,
						$elm$html$Html$Attributes$value(searchQuery),
						A2(
							$visotype$elm_dom$Dom$addAttribute,
							$elm$html$Html$Attributes$placeholder('Search Role, or Name'),
							$visotype$elm_dom$Dom$element('input')))),
					A2(
					$visotype$elm_dom$Dom$addClass,
					'fas fa-search',
					$visotype$elm_dom$Dom$element('i'))
				]),
			A2(
				$visotype$elm_dom$Dom$addClass,
				'full-page-search-container',
				$visotype$elm_dom$Dom$element('li'))));
};
var $author$project$Views$Project$publishText = function (isActive) {
	return isActive ? 'Unpublish' : 'Publish';
};
var $author$project$Views$Project$publishedBadge = function (isActive) {
	return isActive ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('published-badge')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('LIVE')
			])) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('draft-badge')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('DRAFT')
			]));
};
var $author$project$MainMsg$FindRole = function (a) {
	return {$: 54, a: a};
};
var $author$project$Views$Project$roleList = F2(
	function (roles, project) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, role) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('role-preview')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h5,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'role-preview-name-' + $elm$core$String$fromInt(index),
												true),
												_Utils_Tuple2('role-preview-name', true)
											])),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$FindRole(role.c$))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(role.bS)
									]))
							]));
				}),
			A2(
				$elm$core$List$filter,
				function (role) {
					return _Utils_eq(role.iw, project.c$);
				},
				roles));
	});
var $author$project$MainMsg$ToggleCandidateScreen = function (a) {
	return {$: 150, a: a};
};
var $author$project$Views$TalentSearch$selectedUsersButton = F5(
	function (selectedTalent, userProfile, talent, searchingProject, searchingRole) {
		if (selectedTalent > 0) {
			var _v0 = userProfile.V;
			switch (_v0) {
				case 3:
					return ((searchingProject !== '') && (searchingRole !== '')) ? A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$MoveNewCandidate, talent, ''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Submit ' + ($elm$core$String$fromInt(selectedTalent) + ' To Role'))
							])) : $elm$html$Html$text('');
				case 4:
					return ((searchingProject !== '') && (searchingRole !== '')) ? A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$MoveNewCandidate, talent, ''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Submit ' + ($elm$core$String$fromInt(selectedTalent) + ' To Role'))
							])) : $elm$html$Html$text('');
				case 1:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleCandidateScreen(2))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedTalent) + ' selected users')
							]));
				default:
					return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$Project$unionText = function (union) {
	return union ? 'Union' : 'Non-Union';
};
var $author$project$Views$Project$projectHeader = F3(
	function (model, project, pageView) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('project-info-container', true),
							_Utils_Tuple2('expanded', model.bX),
							_Utils_Tuple2(
							'project-info-hidden',
							!_Utils_eq(pageView, $author$project$Pipeline$StandardPipeline))
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$Views$ModalOverlay$invisibleModal, $author$project$MainMsg$ToggleEditOptions, model.bt),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-info')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-header')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleProjectInfoContainer)
												]),
											_List_fromArray(
												[
													$author$project$Utils$chevronDirection(model.bX)
												])),
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleProjectInfoContainer),
													$elm$html$Html$Attributes$class('project-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(project.bS),
													$author$project$Views$Project$publishedBadge(project.hB)
												])),
											A5(
											$author$project$Views$TalentSearch$selectedUsersButton,
											$elm$core$List$length(model.B),
											model.E,
											model.B,
											'',
											'')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-search-bar')
										]),
									_List_fromArray(
										[
											$author$project$Views$Pipeline$projectSearchBar(model.iT)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-details-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-details')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-edit-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('PROJECT DETAILS')
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleEditOptions),
															$elm$html$Html$Attributes$class('edit-project-options')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('EDIT')
														])),
													A2(
													$elm$html$Html$ul,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('edit-options-container', true),
																	_Utils_Tuple2('edit-options-open', model.bt)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	$author$project$MainMsg$SetProjectId(project.c$))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Edit Project')
																])),
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	A2($author$project$MainMsg$ToggleConfirmation, project.c$, $author$project$Utils$UpdateProject))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Views$Project$publishText(project.hB))
																])),
															A2(
															$elm$html$Html$li,
															_List_fromArray(
																[
																	$elm$html$Html$Events$onClick(
																	A2($author$project$MainMsg$ToggleDeleteConfirmation, project.c$, project.bS))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Delete Project')
																]))
														]))
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(project.it)
												])),
											A2(
											$elm$html$Html$h5,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('payment-details')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'$' + (project.iy + (' | ' + $author$project$Views$Project$unionText(project.jo))))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('AGENT NOTES')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(project.gk)
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('TALENT NOTES')
												])),
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(project.jg)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('schedule-details')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('SCHEDULE')
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('JOB DATES'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$author$project$Utils$dateTextNoTitle,
																		A2($author$project$Project$findDeadline, project.g6, 'Project').fP,
																		A2($author$project$Project$findDeadline, project.g6, 'Project').ee))
																]))
														]))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('AUDITION'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$author$project$Utils$dateTextNoTitle,
																		A2($author$project$Project$findDeadline, project.g6, 'Audition').fP,
																		A2($author$project$Project$findDeadline, project.g6, 'Audition').ee))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-location')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($author$project$Project$findDeadline, project.g6, 'Project').hM)
																]))
														]))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('CALLBACK'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2(
																		$author$project$Utils$dateTextNoTitle,
																		A2($author$project$Project$findDeadline, project.g6, 'Callback').fP,
																		A2($author$project$Project$findDeadline, project.g6, 'Callback').ee))
																])),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-location')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	A2($author$project$Project$findDeadline, project.g6, 'Callback').hM)
																]))
														]))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('FITTING'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, project.g6, 'Fitting').ee))
																]))
														]))
												])),
											A2(
											$elm$html$Html$h4,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('SHOOT'),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('project-dates')
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(
																	$author$project$Utils$formatDate(
																		A2($author$project$Project$findDeadline, project.g6, 'Shoot').ee))
																]))
														]))
												])),
											A2(
											$elm$html$Html$ul,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-role-list')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h3,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text('ROLES'),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('add-role-button'),
																	$elm$html$Html$Events$onClick(
																	$author$project$MainMsg$ToggleFormOpen(2))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text('Add Role'),
																	$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$plusCircle)
																]))
														])),
													A2(
													$elm$html$Html$div,
													_List_Nil,
													A2($author$project$Views$Project$roleList, model.aB, project))
												]))
										]))
								]))
						]))
				]));
	});
var $author$project$Views$Project$projectLoader = function (loading) {
	return loading ? A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('project-loading-icon-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-back-drop')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A4(
						$frandibar$elm_font_awesome_5$FontAwesome$iconWithOptions,
						$frandibar$elm_font_awesome_5$FontAwesome$circleNotch,
						0,
						_List_fromArray(
							[
								$frandibar$elm_font_awesome_5$FontAwesome$Animation(0)
							]),
						_List_Nil)
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Project$ToggleCollaboratedProjectsExpanded = {$: 2};
var $author$project$Project$ToggleProjectRolesExpanded = {$: 1};
var $author$project$Project$ToggleProjectsExpanded = {$: 0};
var $author$project$Views$Project$collaboratingProjectLi = function (project) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('collab-project-container')
			]),
		_List_fromArray(
			[
				$author$project$Views$Project$collaboratingProjectLink(project)
			]));
};
var $author$project$Project$defaultScheduleType = function (names) {
	return A2($elm$core$List$member, 'Audition', names) ? 'Audition' : 'Callback';
};
var $frandibar$elm_font_awesome_5$FontAwesome$minus = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('minus');
var $frandibar$elm_font_awesome_5$FontAwesome$plus = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('plus');
var $author$project$Views$Project$expandedIcon = function (expanded) {
	return expanded ? $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$minus) : $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$plus);
};
var $author$project$Views$Project$projectLi = function (model) {
	var name = model.bS;
	var isActive = model.hB;
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateCurrentProjectId(model.c$))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(name)
					])),
				$author$project$Views$Project$publishedBadge(isActive)
			]));
};
var $author$project$Utils$DeleteRole = function (a) {
	return {$: 4, a: a};
};
var $author$project$MainMsg$SetRoleId = function (a) {
	return {$: 70, a: a};
};
var $author$project$Utils$UpdateRole = function (a) {
	return {$: 2, a: a};
};
var $author$project$Utils$toggleSwitch = F2(
	function (active, aMsg) {
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('switch')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(active)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('slider round'),
							$elm$html$Html$Events$onClick(aMsg)
						]),
					_List_Nil)
				]));
	});
var $author$project$Views$Project$publishRoleButton = F2(
	function (projectActive, role) {
		return projectActive ? A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					A2(
						$author$project$MainMsg$ToggleConfirmation,
						role.c$,
						$author$project$Utils$UpdateRole(role)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Views$Project$publishText(role.gf))
						])),
					A2(
					$author$project$Utils$toggleSwitch,
					role.gf,
					A2(
						$author$project$MainMsg$ToggleConfirmation,
						role.c$,
						$author$project$Utils$UpdateRole(role)))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Project$roleLi = F3(
	function (currentRole, roleOptions, projectPublished) {
		var open = function () {
			if (!roleOptions.$) {
				var role = roleOptions.a;
				return _Utils_eq(role.c$, currentRole.c$);
			} else {
				return false;
			}
		}();
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('role-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(currentRole.bS)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-name-badge-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Project$publishedBadge(currentRole.gf),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateProjectMenuState(
										$author$project$Project$ToggleRoleMenu(
											$elm$core$Maybe$Just(currentRole)))),
									$elm$html$Html$Attributes$class('fas fa-ellipsis-h')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('role-menu', true),
									_Utils_Tuple2('role-menu-expanded', open)
								]))
						]),
					_List_fromArray(
						[
							A2($author$project$Views$Project$publishRoleButton, projectPublished, currentRole),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$SetRoleId(currentRole.c$))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Edit Role')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									A2(
										$author$project$MainMsg$ToggleConfirmation,
										currentRole.c$,
										$author$project$Utils$DeleteRole(currentRole)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Delete Role')
										]))
								]))
						])),
					A2(
					$author$project$Views$ModalOverlay$invisibleModal,
					$author$project$MainMsg$UpdateProjectMenuState(
						$author$project$Project$ToggleRoleMenu($elm$core$Maybe$Nothing)),
					open)
				]));
	});
var $author$project$Project$hasAudCallDates = function (deadlineNames) {
	return A2($elm$core$List$member, 'Audition', deadlineNames) || A2($elm$core$List$member, 'Callback', deadlineNames);
};
var $author$project$Views$Project$showSchedulesButton = F2(
	function (deadlineNames, isActive) {
		return $author$project$Project$hasAudCallDates(deadlineNames) && isActive;
	});
var $author$project$Views$Project$projectMenu = F3(
	function (model, project, deadlineNames) {
		return A2(
			$elm$html$Html$section,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-menu')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-menu-header-container'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$ToggleFormOpen(0))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-menu-header')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('NEW PROJECT')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-menu-header-container', true),
											_Utils_Tuple2('schedule-button', true),
											_Utils_Tuple2(
											'menu-option-showing',
											A2($author$project$Views$Project$showSchedulesButton, deadlineNames, project.hB))
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-menu-header'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View(
												A2(
													$author$project$Route$SchedulePage,
													project.c$,
													$author$project$Project$defaultScheduleType(deadlineNames))))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('SCHEDULES')
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-menu-header-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('manage-projects-title'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateProjectMenuState($author$project$Project$ToggleProjectsExpanded))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('MANAGE PROJECTS')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('expand-icon')
												]),
											_List_fromArray(
												[
													$author$project$Views$Project$expandedIcon(model.aI.ek)
												]))
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('all-projects-container', true),
											_Utils_Tuple2('all-projects-expanded', model.aI.ek)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('project-menu-projects', true)
												]))
										]),
									A2($elm$core$List$map, $author$project$Views$Project$projectLi, model.F))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('project-menu-header-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('manage-projects-title'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateProjectMenuState($author$project$Project$ToggleProjectRolesExpanded))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h5,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('ROLES FOR THIS PROJECT')
												])),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('expand-icon')
												]),
											_List_fromArray(
												[
													$author$project$Views$Project$expandedIcon(model.aI.el)
												]))
										]))
								])),
							A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('all-projects-container', true),
											_Utils_Tuple2('all-projects-expanded', model.aI.el)
										]))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('new-role-button'),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$ToggleFormOpen(2))
										]),
									_List_fromArray(
										[
											$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$plusCircle),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text('ADD ROLE')
												]))
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('project-menu-roles', true)
												]))
										]),
									A2(
										$elm$core$List$map,
										function (role) {
											return A3($author$project$Views$Project$roleLi, role, model.aI.di, project.hB);
										},
										project.ft))
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('collaborated-project-menu-header-container', true),
									_Utils_Tuple2('collaborated-projects-expanded', model.aI.ej),
									_Utils_Tuple2(
									'showing-collaborated-projects',
									$elm$core$List$length(model.dW) > 0)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('manage-projects-title'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateProjectMenuState($author$project$Project$ToggleCollaboratedProjectsExpanded))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h5,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('COLLABORATED PROJECTS')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('expand-icon')
										]),
									_List_fromArray(
										[
											$author$project$Views$Project$expandedIcon(model.aI.ej)
										]))
								]))
						])),
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('all-collaborated-projects-container', true),
									_Utils_Tuple2('all-projects-expanded', model.aI.ej),
									_Utils_Tuple2(
									'showing-collaborated-projects',
									$elm$core$List$length(model.dW) > 0)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('project-menu-projects', true)
										]))
								]),
							A2($elm$core$List$map, $author$project$Views$Project$collaboratingProjectLi, model.dW))
						]))
				]));
	});
var $author$project$Utils$roleDataOptions = function (roles) {
	return A2(
		$elm$core$List$map,
		function (role) {
			return {aa: role.c$, bS: role.bS};
		},
		roles);
};
var $author$project$Utils$userInRole = F2(
	function (user, menuToggle) {
		return user.ez ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-status-section')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$stageText(user.i3))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('manage-talent-button fas fa-user-cog'),
							$elm$html$Html$Events$onClick(menuToggle)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('')
						]))
				])) : $elm$html$Html$text('');
	});
var $author$project$Utils$talentCard = F5(
	function (user, selectedTalent, toggleTalentResultModal, toggleSelectedTalent, menuToggle) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('talent-card-v2', true),
							_Utils_Tuple2(
							'selected-talent',
							A2(
								$author$project$Utils$selectedUser,
								user.c$,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.c$;
									},
									selectedTalent)))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-card-image-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$User$emptyImage,
										$elm$core$List$head(user.l)).js),
									$elm$html$Html$Events$onClick(toggleSelectedTalent)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(user.bx + (' ' + user.bP)),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-info-circle'),
									$elm$html$Html$Events$onClick(toggleTalentResultModal)
								]),
							_List_Nil)
						])),
					A2($author$project$Utils$userInRole, user, menuToggle)
				]));
	});
var $author$project$Views$TalentSearch$selectedTalentView = function (selections) {
	return function (view) {
		return function (action) {
			return function (projects) {
				return function (roles) {
					return function (pipeline) {
						return function (actionSet) {
							return function (projectId) {
								return function (twilioStatus) {
									return function (userProfile) {
										return function (newMessageBody) {
											switch (view) {
												case 0:
													return A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('selection-container')
																	]),
																_List_Nil)
															]));
												case 2:
													return A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('modal-open'),
																		$elm$html$Html$Events$onClick(
																		$author$project$MainMsg$ToggleCandidateScreen(1))
																	]),
																_List_Nil),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2('full-selections-container', true),
																				_Utils_Tuple2('selections-full', true)
																			]))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$h2,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Selections')
																			])),
																		A2(
																		$elm$html$Html$ul,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('candidates-full-screen')
																			]),
																		A2(
																			$elm$core$List$map,
																			function (talent) {
																				return A5(
																					$author$project$Utils$talentCard,
																					talent,
																					selections,
																					A3($author$project$MainMsg$ToggleTalentResultModal, talent, $author$project$Job$emptyApplicant, ''),
																					A2($author$project$MainMsg$ToggleSelectedTalent, talent.c$, talent),
																					$author$project$MainMsg$UpdateTalentMenuOptions(
																						$author$project$User$ToggleMenuModal(talent)));
																			},
																			selections)),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('bulk-quick-actions-container')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Views$TalentModal$quickActionBar(action)($author$project$User$emptySearchTalentProfile)(selections)($author$project$Job$emptyApplicant)(pipeline)(actionSet)(projects)(roles)(projectId)('')($author$project$SharedProjectRoleSchedules$emptyProject)('')(twilioStatus)(userProfile)(newMessageBody)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)
																			]))
																	]))
															]));
												default:
													return $elm$html$Html$text('');
											}
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$Project$projectView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('project-details-page')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Views$Project$projectMenu,
						model,
						model.m,
						$author$project$Project$dnames(model.m.g6)),
						A3($author$project$Views$Project$projectHeader, model, model.m, model.ii),
						$author$project$Views$Pipeline$pipeline(model.a3)(model.m.A)(model.av)(model.cX)(model.d6)(model.B)(model.i2)(model.ii)(model.iT)(model.jw)(model.m.g6)(model.m.hB),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('bulk-selected-talent-container')
							]),
						_List_fromArray(
							[
								$author$project$Views$TalentSearch$selectedTalentView(model.B)(model.N)(model.aJ)(model.F)(model.aB)(model.m.A)(3)(model.aV)(model.aO)(model.E)(model.L.dP)
							])),
						$author$project$Views$Project$directorModals(model),
						A3(
						$author$project$Views$TalentOptions$talentOptionsModal,
						model.W,
						model.E,
						$author$project$Utils$roleDataOptions(model.m.ft)),
						$author$project$Views$TalentModal$talentSearchResultModal(model.v)(model.bq)(model.B)(model.aN)(model.aJ)(model.cH)(model.m.A)(1)(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyProject]))(
						_List_fromArray(
							[$author$project$SharedProjectRoleSchedules$emptyRole]))(model.aV)(model.d6)(model.m)(model.bd.h4)(model.aO)(model.E)(model.L.dP)(model.b$.cf.gW)(model.b$)($author$project$User$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.cj),
						A2($author$project$Views$Project$projectConfirmations, model, model.m),
						$author$project$Views$Project$projectLoader(model.cu),
						A2($author$project$Views$Confirmations$notificationModal, model.bT, model.q)
					]))
			]));
};
var $author$project$Views$Project$filteredApplicants = F2(
	function (applicants, stage) {
		return A2(
			$elm$core$List$filter,
			function (applicant) {
				return _Utils_eq(applicant.i3, stage);
			},
			applicants);
	});
var $author$project$Views$Project$talentList = F2(
	function (model, users) {
		return A2(
			$elm$core$List$map,
			function (applicant) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-card'),
							$elm$html$Html$Events$onClick(
							A3($author$project$MainMsg$ToggleTalentResultModal, applicant.f_, applicant, ''))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('talent-card-name')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(applicant.f_.bx + (' ' + applicant.f_.bP))
								])),
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$User$emptyImage,
										$elm$core$List$head(applicant.f_.l)).js),
									$elm$html$Html$Attributes$class('square-avatar')
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('chat')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('far fa-comment chat-icon')
										]),
									_List_Nil)
								]))
						]));
			},
			users);
	});
var $author$project$Views$Project$roleView = function (model) {
	var r = $elm$core$List$head(
		A2(
			$elm$core$List$filter,
			function (role) {
				return _Utils_eq(role.c$, model.g$);
			},
			model.aB));
	if (!r.$) {
		var role = r.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('role-content')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$SetRoleId(model.g$)),
											$elm$html$Html$Attributes$class('button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Edit Role')
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											A2($author$project$MainMsg$ToggleDeleteConfirmation, model.g$, role.bS)),
											$elm$html$Html$Attributes$class('button')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Delete Role')
										]))
								])),
							A4(
							$author$project$Views$Confirmations$deleteConfirmation,
							model.ad,
							$author$project$MainMsg$DeleteRole(model.as),
							A2($author$project$MainMsg$ToggleDeleteConfirmation, '', ''),
							'Are you sure you want to delete ' + (model.d8 + ' Role')),
							A2(
							$elm$html$Html$h1,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(role.bS)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(role.iI)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('applied-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Applied')
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$author$project$Views$Project$talentList,
										model,
										A2($author$project$Views$Project$filteredApplicants, model.dD, 0)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('requested-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Requested')
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$author$project$Views$Project$talentList,
										model,
										A2($author$project$Views$Project$filteredApplicants, model.dD, 2)))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('accepted-list')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('column-title')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Accepted')
										])),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									A2(
										$author$project$Views$Project$talentList,
										model,
										A2($author$project$Views$Project$filteredApplicants, model.dD, 3)))
								]))
						])),
					$author$project$Views$TalentModal$talentSearchResultModal(model.v)(model.bq)(model.B)(model.aN)(model.aJ)(model.cH)(model.m.A)(1)(
					_List_fromArray(
						[$author$project$SharedProjectRoleSchedules$emptyProject]))(
					_List_fromArray(
						[$author$project$SharedProjectRoleSchedules$emptyRole]))('')(model.d6)($author$project$SharedProjectRoleSchedules$emptyProject)(model.bd.h4)(model.aO)(model.E)(model.L.dP)(model.b$.cf.gW)(model.b$)($author$project$User$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.cj),
					$author$project$Views$Project$directorModals(model)
				]));
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$MainMsg$CloseUserSwapMenu = function (a) {
	return {$: 209, a: a};
};
var $author$project$MainMsg$ClosedPublishedModal = {$: 215};
var $author$project$MainMsg$ToggleScheduleForm = function (a) {
	return {$: 193, a: a};
};
var $author$project$Project$SchedulingPage = 4;
var $author$project$Views$Schedule$currentPage = function (page) {
	if (page.$ === 25) {
		return 6;
	} else {
		return 4;
	}
};
var $author$project$Views$Schedule$modal = F2(
	function (open, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('modal', true),
							_Utils_Tuple2('modal-open', open)
						])),
					$elm$html$Html$Events$onClick(message)
				]),
			_List_Nil);
	});
var $author$project$MainMsg$MoveSinglePublishedUser = function (a) {
	return {$: 214, a: a};
};
var $author$project$Views$Schedule$movePublishedUserModal = function (model) {
	var _v0 = model.cv;
	switch (_v0) {
		case 0:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('published-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You are trying to make changes to a published Schedule!')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Do you want to move ' + (model.b$.f2.w.bx + '?'))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('swap-action-button button'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$MoveSinglePublishedUser(model.b$.f2))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Move ' + model.b$.f2.w.bx)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('swap-action-button button'),
								$elm$html$Html$Events$onClick($author$project$MainMsg$ClosedPublishedModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							]))
					]));
		case 1:
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('published-modal')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You are trying to remove someone from a published Schedule!')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Are you sure you want to remove ' + (model.b$.f2.w.bx + '?'))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('swap-action-button button')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Move ' + model.b$.f2.w.bx)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('swap-action-button button'),
								$elm$html$Html$Events$onClick($author$project$MainMsg$ClosedPublishedModal)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Cancel')
							]))
					]));
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$MainMsg$PublishSchedule = {$: 204};
var $author$project$MainMsg$TogglePublishConfirmationModal = {$: 203};
var $author$project$Views$Schedule$destructiveActions = _List_fromArray(
	['Scheduled talent will be sent a notification that they have been scheduled for this role.', 'Talent will be able to accept, reject, or request to be rescheduled.', 'You will be able to view schedules on a daily view.']);
var $author$project$Views$Schedule$publishWarning = 'Once this schedule is published the following actions will take place: ';
var $author$project$Views$Schedule$publishConfirmationModal = function (isOpen) {
	if (isOpen) {
		return A5($author$project$Views$Confirmations$confirmation, isOpen, $author$project$MainMsg$PublishSchedule, $author$project$MainMsg$TogglePublishConfirmationModal, $author$project$Views$Schedule$publishWarning, $author$project$Views$Schedule$destructiveActions);
	} else {
		return $elm$html$Html$text('');
	}
};
var $author$project$Views$Schedule$savingScheduleView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('saving-schedule-container', true),
						_Utils_Tuple2('form-hiding', model.b$.b_ !== 3)
					]))
			]),
		_List_fromArray(
			[
				A2($author$project$Views$Schedule$modal, model.b$.b_ === 3, $author$project$MainMsg$NoOp),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('loading-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-circle-notch fa-spin')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Creating Schedule!')
							]))
					]))
			]));
};
var $author$project$Schedule$OntoUserInSchedule = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Schedule$OutOfSchedule = {$: 4};
var $author$project$SharedProjectRoleSchedules$AddCollaborator = {$: 10};
var $author$project$SharedProjectRoleSchedules$CollabCompany = function (a) {
	return {$: 2, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollabEmail = function (a) {
	return {$: 1, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollabFirstName = function (a) {
	return {$: 4, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollabLastName = function (a) {
	return {$: 5, a: a};
};
var $author$project$SharedProjectRoleSchedules$CollabPhone = function (a) {
	return {$: 3, a: a};
};
var $author$project$SharedProjectRoleSchedules$ToggleCollabForm = {$: 0};
var $author$project$SharedProjectRoleSchedules$ToggleEmailFocus = {$: 9};
var $author$project$SharedProjectRoleSchedules$FillInValues = function (a) {
	return {$: 8, a: a};
};
var $author$project$Views$Schedule$collaboratorLi = function (collaborator) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateCollaboratorData(
					$author$project$SharedProjectRoleSchedules$FillInValues(collaborator)))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(collaborator.bv)
			]));
};
var $author$project$Views$Schedule$showingCollaborators = F2(
	function (collaborators, email) {
		var matchingCollaborators = A2(
			$elm$core$List$filter,
			function (user) {
				return A2($elm$core$String$contains, email, user.bv);
			},
			collaborators);
		return (email !== '') && ($elm$core$List$length(matchingCollaborators) >= 1);
	});
var $author$project$Views$Schedule$addCollaboratorsForm = F2(
	function (projectId, data) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('show-collab-form', data.c9),
							_Utils_Tuple2('collaborator-container', true)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('collaborator-modal'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateCollaboratorData($author$project$SharedProjectRoleSchedules$ToggleCollabForm))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('collaborator-form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('collaborator-header')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Add Collaborators')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('collaborator-form'),
									$elm$html$Html$Attributes$autocomplete(false),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateCollaboratorData($author$project$SharedProjectRoleSchedules$ToggleEmailFocus))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Email Address*'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('email'),
													$elm$html$Html$Attributes$value(data.bv),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabEmail))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('saved-collaborators', true),
													_Utils_Tuple2(
													'matching-collaborators',
													A2($author$project$Views$Schedule$showingCollaborators, data.dX, data.bv) && data.a4)
												]))
										]),
									A2(
										$elm$core$List$map,
										$author$project$Views$Schedule$collaboratorLi,
										A2(
											$elm$core$List$filter,
											function (user) {
												return A2($elm$core$String$contains, data.bv, user.bv);
											},
											data.dX))),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('First Name*'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(data.bx),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabFirstName))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Last Name*'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(data.bP),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabLastName))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Company'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('text'),
													$elm$html$Html$Attributes$value(data.cK),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabCompany))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$label,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Phone Number'),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$type_('tel'),
													$elm$html$Html$Attributes$value(data.ik),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateCollaboratorData, $author$project$SharedProjectRoleSchedules$CollabPhone))
												]),
											_List_Nil)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('collab-form-complete', data.cZ),
													_Utils_Tuple2('collab-form-add', true)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateCollaboratorData($author$project$SharedProjectRoleSchedules$AddCollaborator))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('ADD'),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$classList(
													_List_fromArray(
														[
															_Utils_Tuple2('fas fa-circle-notch fa-spin', true),
															_Utils_Tuple2('adding-collaborator', data.gh)
														]))
												]),
											_List_Nil)
										]))
								]))
						]))
				]));
	});
var $author$project$MainMsg$ToggleCollaboratorsModal = {$: 276};
var $author$project$MainMsg$RemoveCollaborator = function (a) {
	return {$: 278, a: a};
};
var $author$project$Views$Schedule$currentCollabLi = function (collaborator) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(collaborator.bx + (' ' + collaborator.bP)),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(collaborator.bv)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						collaborator.cC ? 'Accepted Invitation' : 'Invitation Not Accepted')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('remove-collaborator-button'),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$RemoveCollaborator(collaborator.eC))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('remove')
					]))
			]));
};
var $author$project$Views$Schedule$collaboratorsModal = function (model) {
	return (!_Utils_eq(model.E.c$, model.b$.cf.gW)) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('collaborator-modal-container', true),
						_Utils_Tuple2('collaborator-modal-open', model.b$.dY)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collaborator-modal'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleCollaboratorsModal)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('collaborator-list-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('collaborator-header')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Current Collaborators')
							])),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('collaborators-list')
							]),
						A2($elm$core$List$map, $author$project$Views$Schedule$currentCollabLi, model.cP))
					]))
			]));
};
var $author$project$Views$Schedule$dayOfScheduleHeader = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('day-of-schedule-header')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Name')
				])),
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Stage')
				])),
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Time')
				])),
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Status')
				])),
			A2(
			$elm$html$Html$h5,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text('Votes')
				]))
		]));
var $author$project$MainMsg$OpenVotingScreen = function (a) {
	return {$: 176, a: a};
};
var $author$project$Views$Schedule$availiableVoters = function (totalVoters) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(totalVoters)) > 0;
};
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Utils$formatTime = function (time) {
	var minute = A2($elm$time$Time$toMinute, $elm$time$Time$utc, time);
	var hour = A2($elm$time$Time$toHour, $elm$time$Time$utc, time);
	var formattedMinute = (!minute) ? ($elm$core$String$fromInt(minute) + '0') : $elm$core$String$fromInt(minute);
	var formattedHour = (hour > 12) ? $elm$core$String$fromInt(hour - 12) : ((!hour) ? '12' : $elm$core$String$fromInt(hour));
	var ending = (hour >= 12) ? 'PM' : 'AM';
	return formattedHour + (':' + (formattedMinute + (' ' + ending)));
};
var $author$project$Views$Schedule$voterLi = function (vote) {
	return A2(
		$elm$html$Html$li,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(vote.f8)
			]));
};
var $author$project$Views$Schedule$votersList = F2(
	function (votes, voting_type) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('voter-list')
				]),
			A2(
				$elm$core$List$map,
				function (vote) {
					return $author$project$Views$Schedule$voterLi(vote);
				},
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.f5;
						},
						voting_type),
					votes)));
	});
var $author$project$Views$Schedule$dayOfScheduleTimeSlot = F2(
	function (timeSlot, schedule) {
		var yes = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f6, 'yes');
		var no = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f6, 'no');
		var maybe = A2($author$project$Views$Schedule$getVoteTotal, timeSlot.f6, 'maybe');
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('day-of-schedule-item-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section'),
							$elm$html$Html$Events$onClick(
							A3(
								$author$project$MainMsg$ToggleTalentResultModal,
								$author$project$Utils$transformToSearchResultTalentProfile(timeSlot.f_),
								$author$project$Job$emptyApplicant,
								''))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$User$emptyImage,
										$elm$core$List$head(timeSlot.f_.l)).js)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('user-name-role-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('name')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timeSlot.f_.bx + (' ' + timeSlot.f_.bP))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('role')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(timeSlot.f_.V.bS)
										]))
								]))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(schedule.fB)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Utils$formatTime(timeSlot.hd))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section')
						]),
					_List_fromArray(
						[
							A2($author$project$Views$Schedule$timeSlotStatus, timeSlot.f_, schedule.fB)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-section voting-section'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$OpenVotingScreen(
								$author$project$Utils$transformToSearchResultTalentProfile(timeSlot.f_)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'yes-colored',
											$author$project$Views$Schedule$availiableVoters(yes)),
											_Utils_Tuple2('votes', true)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(yes)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('yes-voters', true),
											_Utils_Tuple2(
											'available-voters',
											$author$project$Views$Schedule$availiableVoters(yes))
										]))
								]),
							_List_fromArray(
								[
									A2($author$project$Views$Schedule$votersList, timeSlot.f6, 'yes')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'maybe-colored',
											$author$project$Views$Schedule$availiableVoters(maybe)),
											_Utils_Tuple2('votes', true)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(maybe)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('maybe-voters', true),
											_Utils_Tuple2(
											'available-voters',
											$author$project$Views$Schedule$availiableVoters(maybe))
										]))
								]),
							_List_fromArray(
								[
									A2($author$project$Views$Schedule$votersList, timeSlot.f6, 'maybe')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'no-colored',
											$author$project$Views$Schedule$availiableVoters(no)),
											_Utils_Tuple2('votes', true)
										]))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(no)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$classList(
									_List_fromArray(
										[
											_Utils_Tuple2('no-voters', true),
											_Utils_Tuple2(
											'available-voters',
											$author$project$Views$Schedule$availiableVoters(no))
										]))
								]),
							_List_fromArray(
								[
									A2($author$project$Views$Schedule$votersList, timeSlot.f6, 'no')
								]))
						]))
				]));
	});
var $author$project$Views$Schedule$dayOfSchedulePage = F3(
	function (model, projectId, scheduleId) {
		var _v0 = model.E.V;
		switch (_v0) {
			case 2:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Schedule$dayOfScheduleHeader,
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
								]),
							A2(
								$elm$core$List$map,
								function (timeSlot) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Schedule$dayOfScheduleTimeSlot, timeSlot, model.b$.cf);
								},
								A2(
									$elm$core$List$filter,
									function (timeSlot) {
										return timeSlot.f_.c$ !== '';
									},
									model.b$.cf.jl)))
						]));
			case 4:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Schedule$dayOfScheduleHeader,
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
								]),
							A2(
								$elm$core$List$map,
								function (timeSlot) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Schedule$dayOfScheduleTimeSlot, timeSlot, model.b$.cf);
								},
								A2(
									$elm$core$List$filter,
									function (timeSlot) {
										return timeSlot.f_.c$ !== '';
									},
									model.b$.cf.jl)))
						]));
			case 3:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Schedule$dayOfScheduleHeader,
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
								]),
							A2(
								$elm$core$List$map,
								function (timeSlot) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Schedule$dayOfScheduleTimeSlot, timeSlot, model.b$.cf);
								},
								A2(
									$elm$core$List$filter,
									function (timeSlot) {
										return timeSlot.f_.c$ !== '';
									},
									model.b$.cf.jl)))
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-container')
						]),
					_List_fromArray(
						[
							$author$project$Views$Schedule$dayOfScheduleHeader,
							A2($author$project$Views$Schedule$addCollaboratorsForm, projectId, model.b$.bI),
							$author$project$Views$Schedule$collaboratorsModal(model),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('day-of-schedule-time-slots-container')
								]),
							A2(
								$elm$core$List$map,
								function (timeSlot) {
									return A3($elm$html$Html$Lazy$lazy2, $author$project$Views$Schedule$dayOfScheduleTimeSlot, timeSlot, model.b$.cf);
								},
								A2(
									$elm$core$List$filter,
									function (timeSlot) {
										return timeSlot.f_.c$ !== '';
									},
									model.b$.cf.jl)))
						]));
		}
	});
var $author$project$SharedProjectRoleSchedules$ScheduleFormOpen = 1;
var $author$project$Views$Schedule$defaultScheduleContainerOptions = function (projectId) {
	return ($elm$core$String$length(projectId) > 0) ? A2(
		$visotype$elm_dom$Dom$appendChildList,
		_List_fromArray(
			[
				A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendText,
					'Create a New Schedule',
					$visotype$elm_dom$Dom$element('p')),
				A2(
					$visotype$elm_dom$Dom$appendChild,
					A2(
						$visotype$elm_dom$Dom$appendChild,
						A2(
							$visotype$elm_dom$Dom$addClass,
							'fas fa-plus',
							$visotype$elm_dom$Dom$element('span')),
						A2(
							$visotype$elm_dom$Dom$addAction,
							_Utils_Tuple2(
								'click',
								$author$project$MainMsg$ToggleScheduleForm(1)),
							A2(
								$visotype$elm_dom$Dom$addClass,
								'default-icon-container',
								$visotype$elm_dom$Dom$element('div')))),
					$visotype$elm_dom$Dom$element('li')))
			]),
		A2(
			$visotype$elm_dom$Dom$addClass,
			'default-options',
			$visotype$elm_dom$Dom$element('ul'))) : $visotype$elm_dom$Dom$element('ul');
};
var $author$project$MainMsg$ScheduleMoveCanceled = {$: 200};
var $author$project$MainMsg$ScheduleMoveCompleted = F2(
	function (a, b) {
		return {$: 201, a: a, b: b};
	});
var $author$project$MainMsg$ScheduleMoveStarted = function (a) {
	return {$: 198, a: a};
};
var $author$project$MainMsg$ScheduleMoveTargetChanged = function (a) {
	return {$: 199, a: a};
};
var $author$project$MainMsg$dragDropMessagesSchedule = {d9: $author$project$MainMsg$ScheduleMoveCanceled, ea: $author$project$MainMsg$ScheduleMoveStarted, eb: $author$project$MainMsg$ScheduleMoveTargetChanged, ec: $author$project$MainMsg$ScheduleMoveCompleted};
var $author$project$Schedule$OntoElement = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Schedule$OntoPublishedElement = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $visotype$elm_dom$Dom$appendChildConditional = F2(
	function (e, test) {
		if (test) {
			return $visotype$elm_dom$Dom$appendChild(e);
		} else {
			return function (x) {
				return x;
			};
		}
	});
var $author$project$Views$Schedule$statusIcon = F2(
	function (user, scheduleType) {
		var memberStatus = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fB;
						},
						scheduleType),
					user.fA))).dj;
		switch (memberStatus) {
			case 5:
				return 'fas fa-hourglass-start';
			case 11:
				return 'fas fa-hourglass-start';
			case 6:
				return 'fas fa-check';
			case 7:
				return 'fas fa-times';
			case 8:
				return 'far fa-calendar-times';
			case 12:
				return 'fas fa-check';
			case 13:
				return 'fas fa-times';
			case 14:
				return 'far fa-calendar-times';
			case 9:
				return 'fas fa-hourglass-start';
			case 15:
				return 'fas fa-hourglass-start';
			default:
				return '';
		}
	});
var $author$project$Views$Schedule$userStatus = F2(
	function (user, scheduleType) {
		var userStage = A2(
			$elm$core$Maybe$withDefault,
			$author$project$User$emptyScheduleMember,
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$author$project$Utils$eq,
						function ($) {
							return $.fB;
						},
						scheduleType),
					user.fA))).dj;
		switch (scheduleType) {
			case 'Audition':
				return A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[6])) ? 'confirmed' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[7])) ? 'rejected' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[5, 9])) ? 'pending' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[8])) ? 'reschedule' : '')));
			case 'Callback':
				return A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[12])) ? 'confirmed' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[13])) ? 'rejected' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[11, 15])) ? 'pending' : (A2(
					$elm$core$List$member,
					userStage,
					_List_fromArray(
						[14])) ? 'reschedule' : '')));
			default:
				return '';
		}
	});
var $author$project$Views$Schedule$userDisplay = F7(
	function (schedulePageData, user, dragDropState, searchQuery, time, timeSlot, dropType) {
		var showingUser = $elm$core$String$length(searchQuery) <= 1;
		var matchingUser = ($elm$core$String$length(searchQuery) > 1) && (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bx)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bP)) || (A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.V.bS)) || A2(
			$elm$core$String$contains,
			$elm$core$String$toLower(searchQuery),
			$elm$core$String$toLower(user.bx + (' ' + user.bP))))));
		var _v0 = A2($author$project$Views$Schedule$statusHoverText, user.fA, schedulePageData.fB);
		var statusText = _v0.a;
		var statusReason = _v0.b;
		return A2(
			$visotype$elm_dom$Dom$appendChild,
			A2(
				$visotype$elm_dom$Dom$appendChildList,
				_List_fromArray(
					[
						A2(
						$visotype$elm_dom$Dom$appendChildList,
						_List_fromArray(
							[
								A2(
								$visotype$elm_dom$Dom$addAttribute,
								$elm$html$Html$Attributes$src(
									A2(
										$elm$core$Maybe$withDefault,
										$author$project$User$emptyImage,
										$elm$core$List$head(user.l)).js),
								A2(
									$visotype$elm_dom$Dom$addClass,
									'square-avatar',
									$visotype$elm_dom$Dom$element('img'))),
								A2(
								$visotype$elm_dom$Dom$appendChildList,
								_List_fromArray(
									[
										A2(
										$visotype$elm_dom$Dom$appendText,
										user.bx + (' ' + user.bP),
										$visotype$elm_dom$Dom$element('h3')),
										A2(
										$visotype$elm_dom$Dom$addClass,
										'pipeline-role-name',
										A2(
											$visotype$elm_dom$Dom$appendText,
											user.V.bS,
											$visotype$elm_dom$Dom$element('span')))
									]),
								A2(
									$visotype$elm_dom$Dom$addClass,
									'user-name-info-container',
									$visotype$elm_dom$Dom$element('div')))
							]),
						A2(
							$visotype$elm_dom$Dom$addClass,
							'time-slot-image-name-role-container',
							$visotype$elm_dom$Dom$element('div'))),
						A2(
						$visotype$elm_dom$Dom$appendChildList,
						_List_fromArray(
							[
								A2(
								$visotype$elm_dom$Dom$addClass,
								'users-time',
								A2(
									$visotype$elm_dom$Dom$appendText,
									time,
									$visotype$elm_dom$Dom$element('span'))),
								A2(
								$visotype$elm_dom$Dom$addClass,
								A2($author$project$Views$Schedule$statusIcon, user, schedulePageData.fB),
								$visotype$elm_dom$Dom$element('span')),
								A2(
								$visotype$elm_dom$Dom$appendChildList,
								_List_fromArray(
									[
										A2(
										$visotype$elm_dom$Dom$appendText,
										statusText,
										A2(
											$visotype$elm_dom$Dom$addClass,
											'schedule-status-text',
											$visotype$elm_dom$Dom$element('span'))),
										A2(
										$visotype$elm_dom$Dom$appendText,
										statusReason,
										A2(
											$visotype$elm_dom$Dom$addClass,
											'status-body-text',
											$visotype$elm_dom$Dom$element('p')))
									]),
								A2(
									$visotype$elm_dom$Dom$addClass,
									'status-verbiage',
									$visotype$elm_dom$Dom$element('div')))
							]),
						A2(
							$visotype$elm_dom$Dom$addClass,
							'user-time-status-container',
							$visotype$elm_dom$Dom$element('div')))
					]),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'time-slot-user-container',
					$visotype$elm_dom$Dom$element('div'))),
			A4(
				$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable,
				dragDropState,
				dropType,
				$author$project$MainMsg$dragDropMessagesSchedule,
				A4(
					$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDraggable,
					dragDropState,
					A2($author$project$Schedule$User, user, timeSlot.aa),
					$author$project$MainMsg$dragDropMessagesSchedule,
					A3(
						$visotype$elm_dom$Dom$addClassConditional,
						'showing-user',
						showingUser,
						A3(
							$visotype$elm_dom$Dom$addClassConditional,
							'matching-user',
							matchingUser,
							A2(
								$visotype$elm_dom$Dom$addAction,
								_Utils_Tuple2(
									'click',
									A3(
										$author$project$MainMsg$ToggleTalentResultModal,
										$author$project$Utils$transformToSearchResultTalentProfile(user),
										$author$project$Job$emptyApplicant,
										'')),
								A2(
									$visotype$elm_dom$Dom$addClass,
									A2($author$project$Views$Schedule$userStatus, timeSlot.f_, schedulePageData.fB),
									A2(
										$visotype$elm_dom$Dom$addClass,
										'talent-card condensed',
										$visotype$elm_dom$Dom$element('div')))))))));
	});
var $author$project$Views$Schedule$slot = F3(
	function (timeSlot, dragDropState, schedulePageData) {
		var elementType = A2(
			$elm$core$Maybe$withDefault,
			$author$project$SharedProjectRoleSchedules$emptySchedule,
			$elm$core$List$head(schedulePageData.k)).bb ? A3($author$project$Schedule$OntoPublishedElement, timeSlot.aa, timeSlot.f_, timeSlot.iO) : A2($author$project$Schedule$OntoElement, timeSlot.aa, timeSlot.iO);
		return A3(
			$visotype$elm_dom$Dom$appendChildConditional,
			A2(
				$visotype$elm_dom$Dom$appendChildList,
				_List_fromArray(
					[
						A7(
						$author$project$Views$Schedule$userDisplay,
						schedulePageData,
						timeSlot.f_,
						dragDropState,
						'',
						$author$project$Utils$formatTime(timeSlot.hd),
						timeSlot,
						A3($author$project$Schedule$OntoUserInSchedule, timeSlot.aa, timeSlot.f_, timeSlot.iO))
					]),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'taken-time-slot',
					$visotype$elm_dom$Dom$element('div'))),
			timeSlot.f_.c$ !== '',
			A3(
				$visotype$elm_dom$Dom$appendChildConditional,
				A2(
					$visotype$elm_dom$Dom$appendChild,
					A2(
						$visotype$elm_dom$Dom$appendText,
						$author$project$Utils$formatTime(timeSlot.hd),
						$visotype$elm_dom$Dom$element('p')),
					A4(
						$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable,
						dragDropState,
						elementType,
						$author$project$MainMsg$dragDropMessagesSchedule,
						A2(
							$visotype$elm_dom$Dom$addClass,
							'empty-time-slot',
							$visotype$elm_dom$Dom$element('div')))),
				timeSlot.f_.c$ === '',
				A2(
					$visotype$elm_dom$Dom$addClass,
					'time-slot',
					$visotype$elm_dom$Dom$element('li'))));
	});
var $author$project$Views$Schedule$slotsContainer = F3(
	function (timeSlots, dragDropState, schedulePageData) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			A2(
				$elm$core$List$map,
				function (singleSlot) {
					return A3($author$project$Views$Schedule$slot, singleSlot, dragDropState, schedulePageData);
				},
				timeSlots),
			A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendText,
					'',
					$visotype$elm_dom$Dom$element('p')),
				$visotype$elm_dom$Dom$element('ul')));
	});
var $author$project$Views$Schedule$buildTimeSlots = F3(
	function (brokenUpTimeSlots, dragDropState, schedulePageData) {
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			A2(
				$elm$core$List$map,
				function (timeSlots) {
					return A3($author$project$Views$Schedule$slotsContainer, timeSlots, dragDropState, schedulePageData);
				},
				brokenUpTimeSlots),
			$visotype$elm_dom$Dom$element('ul'));
	});
var $elm_community$list_extra$List$Extra$groupsOfWithStep = F3(
	function (size, step, xs) {
		var xs_ = A2($elm$core$List$drop, step, xs);
		var thisGroup = A2($elm$core$List$take, size, xs);
		var okayLength = _Utils_eq(
			size,
			$elm$core$List$length(thisGroup));
		var okayArgs = (size > 0) && (step > 0);
		return (okayArgs && okayLength) ? A2(
			$elm$core$List$cons,
			thisGroup,
			A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, step, xs_)) : _List_Nil;
	});
var $elm_community$list_extra$List$Extra$groupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$groupsOfWithStep, size, size, xs);
	});
var $author$project$Views$Schedule$scheduleDay = F3(
	function (schedule, dragDropState, schedulePageData) {
		var brokenUpSlots = A2($elm_community$list_extra$List$Extra$groupsOf, schedule.gH, schedule.jl);
		return A2(
			$visotype$elm_dom$Dom$appendChildList,
			_List_fromArray(
				[
					A3($author$project$Views$Schedule$buildTimeSlots, brokenUpSlots, dragDropState, schedulePageData)
				]),
			A2(
				$visotype$elm_dom$Dom$appendChild,
				A2(
					$visotype$elm_dom$Dom$appendText,
					schedule.fy,
					A2(
						$visotype$elm_dom$Dom$addClass,
						'date-header',
						$visotype$elm_dom$Dom$element('h3'))),
				A2(
					$visotype$elm_dom$Dom$addClass,
					'schedule-day-container',
					$visotype$elm_dom$Dom$element('div'))));
	});
var $author$project$Views$Schedule$talentInfoText = function (scheduleType) {
	switch (scheduleType) {
		case 'Audition':
			return 'Available Talent users for Audition schedules are pulled from \'Selected Candidates\' column in the project pipeline.';
		case 'Callback':
			return 'Available Talent users for callback schedules are pulled from \'Selected Candidates\' and \'Scheduled Audition\' columns in the project project pipeline';
		default:
			return '';
	}
};
var $author$project$Views$Schedule$scheduleContainer = function (model) {
	var _v0 = model.b$.aK;
	switch (_v0.$) {
		case 0:
			return $visotype$elm_dom$Dom$render(
				A2(
					$visotype$elm_dom$Dom$appendChild,
					$author$project$Views$Schedule$defaultScheduleContainerOptions(model.b$.aj.c$),
					A2(
						$visotype$elm_dom$Dom$addClass,
						'schedule-default-page',
						$visotype$elm_dom$Dom$element('div'))));
		case 2:
			return $visotype$elm_dom$Dom$render(
				A2(
					$visotype$elm_dom$Dom$appendChild,
					A2(
						$visotype$elm_dom$Dom$addClass,
						'fas fa-circle-notch fa-spin',
						$visotype$elm_dom$Dom$element('span')),
					A2(
						$visotype$elm_dom$Dom$appendChild,
						A2(
							$visotype$elm_dom$Dom$addClass,
							'modal modal-open',
							$visotype$elm_dom$Dom$element('div')),
						A2(
							$visotype$elm_dom$Dom$addClass,
							'loading-icon',
							$visotype$elm_dom$Dom$element('div')))));
		case 3:
			return $visotype$elm_dom$Dom$render(
				A2(
					$visotype$elm_dom$Dom$appendChildList,
					A2(
						$elm$core$List$map,
						function (schedule) {
							return A3($author$project$Views$Schedule$scheduleDay, schedule, model.be, model.b$);
						},
						model.b$.k),
					A2(
						$visotype$elm_dom$Dom$appendChildList,
						_List_fromArray(
							[
								A2(
								$visotype$elm_dom$Dom$appendChildList,
								A2(
									$elm$core$List$map,
									function (user) {
										return A7(
											$author$project$Views$Schedule$userDisplay,
											model.b$,
											user,
											model.be,
											model.iT,
											'',
											$author$project$SharedProjectRoleSchedules$emptyTimeSlot,
											A3($author$project$Schedule$OntoUserInSchedule, '', $author$project$User$emptyPipelineUser, ''));
									},
									model.b$.I),
								A2(
									$visotype$elm_dom$Dom$appendChild,
									A2(
										$visotype$elm_dom$Dom$addClass,
										'fas fa-exchange-alt',
										$visotype$elm_dom$Dom$element('span')),
									A2(
										$visotype$elm_dom$Dom$appendChild,
										A2(
											$visotype$elm_dom$Dom$appendChildList,
											_List_fromArray(
												[
													A2(
													$visotype$elm_dom$Dom$addClass,
													'fas fa-info-circle',
													$visotype$elm_dom$Dom$element('span')),
													A2(
													$visotype$elm_dom$Dom$appendText,
													$author$project$Views$Schedule$talentInfoText(model.b$.fB),
													A2(
														$visotype$elm_dom$Dom$addClass,
														'schedule-info-container',
														$visotype$elm_dom$Dom$element('div'))),
													A2(
													$visotype$elm_dom$Dom$addClass,
													'talent-to-schedule-title',
													A2(
														$visotype$elm_dom$Dom$appendText,
														'Talent Ready to Schedule' + (' (' + ($elm$core$String$fromInt(
															$elm$core$List$length(model.b$.I)) + ')')),
														$visotype$elm_dom$Dom$element('span')))
												]),
											A2(
												$visotype$elm_dom$Dom$addClass,
												'talent-ready-title-container',
												$visotype$elm_dom$Dom$element('div'))),
										A4(
											$arsduo$elm_dom_drag_drop$Dom$DragDrop$makeDroppable,
											model.be,
											$author$project$Schedule$OutOfSchedule,
											$author$project$MainMsg$dragDropMessagesSchedule,
											A2(
												$visotype$elm_dom$Dom$addClass,
												'available-talent-container',
												$visotype$elm_dom$Dom$element('div'))))))
							]),
						A2(
							$visotype$elm_dom$Dom$addClass,
							'schedules-container',
							$visotype$elm_dom$Dom$element('div')))));
		case 5:
			var projectId = _v0.a;
			var scheduleId = _v0.b;
			return A3($author$project$Views$Schedule$dayOfSchedulePage, model, projectId, scheduleId);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$SharedProjectRoleSchedules$AutoSchedule = function (a) {
	return {$: 12, a: a};
};
var $author$project$SharedProjectRoleSchedules$BreakEnd = function (a) {
	return {$: 5, a: a};
};
var $author$project$SharedProjectRoleSchedules$BreakStart = function (a) {
	return {$: 4, a: a};
};
var $author$project$SharedProjectRoleSchedules$Capacity = function (a) {
	return {$: 6, a: a};
};
var $author$project$Schedule$CurrentScheduleUpdate = function (a) {
	return {$: 2, a: a};
};
var $author$project$SharedProjectRoleSchedules$ManualSchedule = function (a) {
	return {$: 13, a: a};
};
var $author$project$SharedProjectRoleSchedules$ScheduleEndTime = function (a) {
	return {$: 2, a: a};
};
var $author$project$SharedProjectRoleSchedules$ScheduleStartTime = function (a) {
	return {$: 1, a: a};
};
var $author$project$SharedProjectRoleSchedules$ScheduleType = function (a) {
	return {$: 0, a: a};
};
var $author$project$SharedProjectRoleSchedules$SearchRoles = function (a) {
	return {$: 8, a: a};
};
var $author$project$SharedProjectRoleSchedules$TimeIncrements = function (a) {
	return {$: 3, a: a};
};
var $author$project$SharedProjectRoleSchedules$ToggleSelectionList = function (a) {
	return {$: 9, a: a};
};
var $author$project$MainMsg$UpdateSchedulePageData = function (a) {
	return {$: 197, a: a};
};
var $author$project$SharedProjectRoleSchedules$AddAllScheduleRoles = {$: 11};
var $author$project$Views$Schedule$addAllOption = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('add-all-button'),
			$elm$html$Html$Events$onClick(
			$author$project$MainMsg$UpdateSchedulePageData(
				$author$project$Schedule$CurrentScheduleUpdate($author$project$SharedProjectRoleSchedules$AddAllScheduleRoles)))
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('ADD ALL')
		]));
var $author$project$Views$Schedule$timeOptionField = F2(
	function (time, picked) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(time.bj),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(picked, time.bj))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(time.g)
				]));
	});
var $author$project$InitData$hourValues = A2($elm$core$List$range, 0, 23);
var $author$project$InitData$minuteValues = _List_fromArray(
	[0, 10, 20, 30, 40, 50]);
var $author$project$InitData$timeValues = A2(
	$elm$core$List$concatMap,
	function (hour) {
		return A2(
			$elm$core$List$map,
			function (minute) {
				var formattedMinute = (!minute) ? '00' : $elm$core$String$fromInt(minute);
				var _v0 = (hour > 12) ? _Utils_Tuple2(
					$elm$core$String$fromInt(hour - 12),
					'PM') : ((hour === 12) ? _Utils_Tuple2(
					$elm$core$String$fromInt(hour),
					'PM') : ((!hour) ? _Utils_Tuple2('12', 'AM') : _Utils_Tuple2(
					$elm$core$String$fromInt(hour),
					'AM')));
				var formattedHour = _v0.a;
				var ending = _v0.b;
				return {
					g: formattedHour + (':' + (formattedMinute + ending)),
					bj: $elm$core$String$fromInt(hour) + ('.' + formattedMinute)
				};
			},
			$author$project$InitData$minuteValues);
	},
	$author$project$InitData$hourValues);
var $author$project$Views$Schedule$toFloat = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toFloat(value));
};
var $author$project$Views$Schedule$breakEndOptions = F3(
	function (breakStartTime, scheduleEndTime, picked) {
		if ($author$project$Views$Schedule$toFloat(breakStartTime) > 0) {
			var breakValues = A2(
				$elm$core$List$filter,
				function (time) {
					return (_Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.bj),
						$author$project$Views$Schedule$toFloat(breakStartTime)) > -1) && (_Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.bj),
						$author$project$Views$Schedule$toFloat(scheduleEndTime)) < 0);
				},
				$author$project$InitData$timeValues);
			return A2(
				$elm$core$List$map,
				function (time) {
					return A2($author$project$Views$Schedule$timeOptionField, time, picked);
				},
				A2(
					$elm$core$List$cons,
					{g: '', bj: ''},
					breakValues));
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(''),
							$elm$html$Html$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select Break Start Time')
						]))
				]);
		}
	});
var $author$project$Views$Schedule$breakOptions = F3(
	function (startTime, endTime, picked) {
		if (($author$project$Views$Schedule$toFloat(startTime) >= 0) && ($author$project$Views$Schedule$toFloat(endTime) >= 0)) {
			var breakValues = A2(
				$elm$core$List$filter,
				function (time) {
					return (_Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.bj),
						$author$project$Views$Schedule$toFloat(startTime)) > 0) && (_Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.bj),
						$author$project$Views$Schedule$toFloat(endTime)) < 0);
				},
				$author$project$InitData$timeValues);
			return A2(
				$elm$core$List$map,
				function (time) {
					return A2($author$project$Views$Schedule$timeOptionField, time, picked);
				},
				A2(
					$elm$core$List$cons,
					{g: '', bj: ''},
					breakValues));
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(''),
							$elm$html$Html$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select Schedule Start And End Times')
						]))
				]);
		}
	});
var $author$project$Views$Schedule$endTimeOptions = F2(
	function (startTime, picked) {
		if ($author$project$Views$Schedule$toFloat(startTime) >= 0) {
			var endingTimeValues = A2(
				$elm$core$List$filter,
				function (time) {
					return _Utils_cmp(
						$author$project$Views$Schedule$toFloat(time.bj),
						$author$project$Views$Schedule$toFloat(startTime)) > -1;
				},
				$author$project$InitData$timeValues);
			return A2(
				$elm$core$List$map,
				function (time) {
					return A2($author$project$Views$Schedule$timeOptionField, time, picked);
				},
				A2(
					$elm$core$List$cons,
					{g: '', bj: ''},
					endingTimeValues));
		} else {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$option,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$value(''),
							$elm$html$Html$Attributes$selected(true)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select Start Time')
						]))
				]);
		}
	});
var $author$project$SharedProjectRoleSchedules$RemoveAllScheduleRoles = {$: 10};
var $author$project$Views$Schedule$removeAllOption = A2(
	$elm$html$Html$span,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('remove-all-button'),
			$elm$html$Html$Events$onClick(
			$author$project$MainMsg$UpdateSchedulePageData(
				$author$project$Schedule$CurrentScheduleUpdate($author$project$SharedProjectRoleSchedules$RemoveAllScheduleRoles)))
		]),
	_List_fromArray(
		[
			$elm$html$Html$text('REMOVE ALL')
		]));
var $author$project$Views$Schedule$scheduleFormHeader = function (scheduleId) {
	return $author$project$Views$Project$updating(scheduleId) ? A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Edit Current Schedule')
			])) : A2(
		$elm$html$Html$p,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text('Create New Schedule')
			]));
};
var $author$project$MainMsg$VerifySchedule = {$: 195};
var $author$project$Views$Schedule$scheduleSubmitButton = function (scheduleId) {
	return $author$project$Views$Project$updating(scheduleId) ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$VerifySchedule),
				$elm$html$Html$Attributes$class('next-step-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('UPDATE SCHEDULE')
			])) : A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$VerifySchedule),
				$elm$html$Html$Attributes$class('next-step-button')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('CREATE SCHEDULE')
			]));
};
var $author$project$Views$Schedule$scheduleTypeInput = function (model) {
	return (model.fB === 'Audition') ? A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value('Audition')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Audition')
			])) : A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value('Callback')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('Callback')
			]));
};
var $author$project$Views$Schedule$selectIntField = F2(
	function (num, picked) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(num)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						picked,
						$elm$core$String$fromInt(num)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$elm$core$String$fromInt(num))
				]));
	});
var $author$project$SharedProjectRoleSchedules$RoleInput = function (a) {
	return {$: 7, a: a};
};
var $frandibar$elm_font_awesome_5$FontAwesome$checkCircle = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('check-circle');
var $author$project$Views$Schedule$selectOption = F2(
	function (role, selectedList) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$UpdateSchedulePageData(
						$author$project$Schedule$CurrentScheduleUpdate(
							$author$project$SharedProjectRoleSchedules$RoleInput(role)))),
					$elm$html$Html$Attributes$class('role-option')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected-icon', true),
									_Utils_Tuple2(
									'role-selected',
									A2($elm$core$List$member, role, selectedList))
								]))
						]),
					_List_fromArray(
						[
							$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$checkCircle)
						])),
					$elm$html$Html$text(role)
				]));
	});
var $author$project$SharedProjectRoleSchedules$ToggleAllSelectedItems = {$: 14};
var $frandibar$elm_font_awesome_5$FontAwesome$timesCircle = $frandibar$elm_font_awesome_5$FontAwesome$Icon$Icon('times-circle');
var $author$project$Views$Schedule$selectedItem = function (item) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('selected-item'),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateSchedulePageData(
					$author$project$Schedule$CurrentScheduleUpdate(
						$author$project$SharedProjectRoleSchedules$RoleInput(item))))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(item),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$timesCircle)
					]))
			]));
};
var $author$project$Views$Schedule$selectedItems = F2(
	function (items, showingAllItems) {
		return ($elm$core$List$length(items) <= 3) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected-items-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('selected-text', true),
									_Utils_Tuple2(
									'selected-text-showing',
									$elm$core$List$length(items) > 0)
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('ROLES:')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selected-item-list')
						]),
					A2($elm$core$List$map, $author$project$Views$Schedule$selectedItem, items))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('selected-items-container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('ROLES:')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('selected-item-list')
						]),
					A2(
						$elm$core$List$map,
						$author$project$Views$Schedule$selectedItem,
						A2($elm$core$List$take, 3, items))),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateSchedulePageData(
								$author$project$Schedule$CurrentScheduleUpdate($author$project$SharedProjectRoleSchedules$ToggleAllSelectedItems))),
							$elm$html$Html$Attributes$class('additional-text')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							'+' + ($elm$core$String$fromInt(
								$elm$core$List$length(
									A2($elm$core$List$drop, 3, items))) + ' more'))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateSchedulePageData(
								$author$project$Schedule$CurrentScheduleUpdate($author$project$SharedProjectRoleSchedules$ToggleAllSelectedItems))),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('all-options-modal', true),
									_Utils_Tuple2('all-options-modal-showing', showingAllItems)
								]))
						]),
					_List_Nil),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('all-selected-item-list', true),
									_Utils_Tuple2('all-selected-items-showing', showingAllItems)
								]))
						]),
					A2($elm$core$List$map, $author$project$Views$Schedule$selectedItem, items))
				]));
	});
var $author$project$Views$Schedule$timeIncrementField = F2(
	function (increment, picked) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(
					$elm$core$String$fromInt(increment.bj)),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(
						picked,
						$elm$core$String$fromInt(increment.bj)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(increment.g)
				]));
	});
var $author$project$InitData$timeIncrements = _List_fromArray(
	[
		{g: '10 Minutes', bj: 10},
		{g: '20 Minutes', bj: 20},
		{g: '30 Minutes', bj: 30},
		{g: '40 Minutes', bj: 40},
		{g: '50 Minutes', bj: 50},
		{g: '1 Hour', bj: 60}
	]);
var $author$project$Views$Schedule$warningMessage = function (scheduleId) {
	return $author$project$Views$Project$updating(scheduleId) ? A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('warning-message')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('WARNING: Editing schedule will override existing schedule.')
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Schedule$scheduleFormView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$Views$Schedule$modal,
				model.b$.b_ === 1,
				$author$project$MainMsg$ToggleScheduleForm(0)),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('create-project-modal', true),
								_Utils_Tuple2('schedule-form', true),
								_Utils_Tuple2('form-hiding', model.b$.b_ !== 1)
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('create-project-header')
							]),
						_List_fromArray(
							[
								$author$project$Views$Schedule$scheduleFormHeader(model.b$.a2.aa),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('exit-schedule-form'),
										$elm$html$Html$Events$onClick(
										$author$project$MainMsg$ToggleScheduleForm(0))
									]),
								_List_fromArray(
									[
										$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$times)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('schedule-form-errors', true),
												_Utils_Tuple2('schedule-form-errors-showing', model.b$.fz)
											]))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('PLEASE MAKE SURE ALL FIELDS ARE FILLED OUT')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('schedule-project-info')
							]),
						_List_fromArray(
							[
								$author$project$Views$Schedule$warningMessage(model.b$.a2.aa),
								A2(
								$elm$html$Html$h4,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(model.b$.aj.bS)
									])),
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Schedule Dates: ' + ($author$project$Utils$formatDate(model.b$.fP) + (' - ' + $author$project$Utils$formatDate(model.b$.ee))))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('form-inputs')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Type')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field'),
												$elm$html$Html$Attributes$value(model.b$.fB),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$ScheduleType))
											]),
										_List_fromArray(
											[
												$author$project$Views$Schedule$scheduleTypeInput(model.b$)
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Start Time')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field'),
												$elm$html$Html$Attributes$value(model.b$.a2.i4),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$ScheduleStartTime))
											]),
										A2(
											$elm$core$List$map,
											function (time) {
												return A2($author$project$Views$Schedule$timeOptionField, time, model.b$.a2.i4);
											},
											A2(
												$elm$core$List$cons,
												{g: '', bj: ''},
												$author$project$InitData$timeValues)))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule End Time')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field'),
												$elm$html$Html$Attributes$value(model.b$.a2.hc),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$ScheduleEndTime))
											]),
										A2($author$project$Views$Schedule$endTimeOptions, model.b$.a2.i4, model.b$.a2.hc))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Break Start Time')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field half-input'),
												$elm$html$Html$Attributes$value(model.b$.a2.gC),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$BreakStart))
											]),
										A3($author$project$Views$Schedule$breakOptions, model.b$.a2.i4, model.b$.a2.hc, model.b$.a2.gC))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('half-input')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Break End Time')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field half-input'),
												$elm$html$Html$Attributes$value(model.b$.a2.gB),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$BreakEnd))
											]),
										A3($author$project$Views$Schedule$breakEndOptions, model.b$.a2.gC, model.b$.a2.hc, model.b$.a2.gB))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Schedule Increment')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field half-input'),
												$elm$html$Html$Attributes$value(
												$elm$core$String$fromInt(model.b$.a2.jk)),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$TimeIncrements))
											]),
										A2(
											$elm$core$List$map,
											function (increment) {
												return A2(
													$author$project$Views$Schedule$timeIncrementField,
													increment,
													$elm$core$String$fromInt(model.b$.a2.jk));
											},
											A2(
												$elm$core$List$cons,
												{g: '', bj: 0},
												$author$project$InitData$timeIncrements)))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Talent Per Time slot')
											])),
										A2(
										$elm$html$Html$select,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('select-field half-input'),
												$elm$html$Html$Attributes$value(
												$elm$core$String$fromInt(model.b$.a2.gH)),
												$elm$html$Html$Events$onInput(
												A2(
													$elm$core$Basics$composeL,
													A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
													$author$project$SharedProjectRoleSchedules$Capacity))
											]),
										A2(
											$elm$core$List$map,
											function (num) {
												return A2(
													$author$project$Views$Schedule$selectIntField,
													num,
													$elm$core$String$fromInt(model.b$.a2.gH));
											},
											A2($elm$core$List$range, 1, 10)))
									])),
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Auto Schedule'),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$value('True'),
														$elm$html$Html$Attributes$name('autoSchedule'),
														$elm$html$Html$Events$onCheck(
														A2(
															$elm$core$Basics$composeL,
															A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
															$author$project$SharedProjectRoleSchedules$AutoSchedule)),
														$elm$html$Html$Attributes$checked(model.b$.gz)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$label,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('radio-button')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Manual Schedule'),
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('checkbox'),
														$elm$html$Html$Attributes$value('False'),
														$elm$html$Html$Attributes$name('autoSchedule'),
														$elm$html$Html$Events$onCheck(
														A2(
															$elm$core$Basics$composeL,
															A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
															$author$project$SharedProjectRoleSchedules$ManualSchedule)),
														$elm$html$Html$Attributes$checked(!model.b$.gz)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Manual Schedule')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('auto-options', true),
												_Utils_Tuple2('auto-options-showing', model.b$.gz)
											]))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('multi-select-container')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$label,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('Roles to auto schedule')
													])),
												$author$project$Views$Schedule$removeAllOption,
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$type_('text'),
														$elm$html$Html$Attributes$placeholder('Search Roles'),
														$elm$html$Html$Events$onInput(
														A2(
															$elm$core$Basics$composeL,
															A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
															$author$project$SharedProjectRoleSchedules$SearchRoles)),
														$elm$html$Html$Events$onFocus(
														A2(
															$elm$core$Basics$composeL,
															A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateSchedulePageData, $author$project$Schedule$CurrentScheduleUpdate),
															$author$project$SharedProjectRoleSchedules$ToggleSelectionList)(true)),
														$elm$html$Html$Attributes$value(model.b$.a2.iN)
													]),
												_List_Nil),
												A2($author$project$Views$Schedule$selectedItems, model.b$.a2.ft, model.b$.fL),
												$author$project$Views$Schedule$addAllOption,
												A2(
												$elm$html$Html$ul,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$classList(
														_List_fromArray(
															[
																_Utils_Tuple2('selection-list', true),
																_Utils_Tuple2('selection-list-open', model.b$.iW)
															]))
													]),
												A2(
													$elm$core$List$map,
													function (role) {
														return A2($author$project$Views$Schedule$selectOption, role, model.b$.a2.ft);
													},
													model.b$.a2.dh))
											]))
									])),
								$author$project$Views$Schedule$scheduleSubmitButton(model.b$.a2.aa)
							]))
					]))
			]));
};
var $author$project$MainMsg$ChangeSchedule = function (a) {
	return {$: 216, a: a};
};
var $author$project$Views$Schedule$addCollaboratorButton = function (model) {
	return (!_Utils_eq(model.E.c$, model.b$.cf.gW)) ? $elm$html$Html$text('') : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('add-collab-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('add-collaborators-button', true),
								_Utils_Tuple2('showing-add-collaborator-button', model.b$.cf.fB !== '')
							])),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$UpdateCollaboratorData($author$project$SharedProjectRoleSchedules$ToggleCollabForm))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('fas fa-plus')
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('Add Collaborators')
							]))
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(' | ')
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('current-collab-button'),
						$elm$html$Html$Events$onClick($author$project$MainMsg$ToggleCollaboratorsModal)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Current Collaborators')
					]))
			]));
};
var $author$project$Views$Schedule$scheduleToggleFields = function (model) {
	var deadlines = $author$project$Project$dnames(model.b$.aj.g6);
	return (A2($elm$core$List$member, 'Audition', deadlines) && A2($elm$core$List$member, 'Callback', deadlines)) ? _List_fromArray(
		['Audition', 'Callback']) : (A2($elm$core$List$member, 'Audition', deadlines) ? _List_fromArray(
		['Audition']) : _List_fromArray(
		['Callback']));
};
var $author$project$Views$Schedule$selectField = F2(
	function (item, picked) {
		return A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(item),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(picked, item))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(item)
				]));
	});
var $author$project$Views$Schedule$scheduleHeader = function (model) {
	var _v0 = model.b$.aK;
	if (_v0.$ === 5) {
		var projectId = _v0.a;
		var scheduleId = _v0.b;
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('schedule-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('day-of-schedule-type')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									model.b$.cf.fB + (' (' + ($elm$core$String$fromInt(
										$elm$core$List$length(
											A2(
												$elm$core$List$filter,
												function (timeSlot) {
													return timeSlot.f_.c$ !== '';
												},
												model.b$.cf.jl))) + ')')))
								])),
							$author$project$Views$Schedule$addCollaboratorButton(model)
						]))
				]));
	} else {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('schedule-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$li,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('select-field'),
									$elm$html$Html$Attributes$value(model.b$.fB),
									$elm$html$Html$Events$onInput($author$project$MainMsg$ChangeSchedule)
								]),
							A2(
								$elm$core$List$map,
								function (option) {
									return A2($author$project$Views$Schedule$selectField, option, model.b$.fB);
								},
								$author$project$Views$Schedule$scheduleToggleFields(model))),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('toggle-schedule-type-icon')
								]),
							_List_fromArray(
								[
									$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
								]))
						]))
				]));
	}
};
var $author$project$Views$Schedule$addEditScheduleButton = function (scheduleData) {
	return (!$elm$core$List$length(scheduleData.k)) ? A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('project-menu-header-container', true)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$ToggleScheduleForm(1))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('schedule-menu-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('NEW SCHEDULE')
					]))
			])) : A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('project-menu-header-container', true)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$ToggleScheduleForm(1))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('schedule-menu-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('REDO SCHEDULE')
					]))
			]));
};
var $author$project$Views$Schedule$backToSchedulesButton = F2(
	function (projId, model) {
		return (!_Utils_eq(model.b$.cf.gW, model.E.c$)) ? $elm$html$Html$text('') : A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('schedule-menu-header', true),
							_Utils_Tuple2('back-to-project-button', true)
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$View(
						A2($author$project$Route$SchedulePage, projId, model.b$.cf.fB)))
				]),
			_List_fromArray(
				[
					$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft),
					$elm$html$Html$text(' Back to all schedules')
				]));
	});
var $author$project$Views$Schedule$newScheduleButton = function (projectId) {
	return ($elm$core$String$length(projectId) > 0) ? A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('project-menu-header-container', true)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$ToggleScheduleForm(1))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('schedule-menu-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('NEW SCHEDULE')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Schedule$optionField = F2(
	function (project, picked) {
		return ($author$project$Project$hasAudCallDates(
			$author$project$Project$dnames(project.g6)) && project.hB) ? A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(project.c$),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(picked, project.c$))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(project.bS)
				])) : ((project.c$ === '') ? A2(
			$elm$html$Html$option,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$value(''),
					$elm$html$Html$Attributes$selected(
					_Utils_eq(picked, project.c$))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('SELECT PROJECT')
				])) : $elm$html$Html$text(''));
	});
var $author$project$Project$getDefaultScheduleTypeFromProjectId = F2(
	function (projectId, projects) {
		return $author$project$Project$defaultScheduleType(
			$author$project$Project$dnames(
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.g6;
					},
					A2(
						$elm$core$List$filter,
						A2(
							$author$project$Utils$eq,
							function ($) {
								return $.c$;
							},
							projectId),
						projects))));
	});
var $author$project$Views$Schedule$pageToView = F2(
	function (selection, projects) {
		return (selection !== '') ? A2(
			$author$project$Route$SchedulePage,
			selection,
			A2($author$project$Project$getDefaultScheduleTypeFromProjectId, selection, projects)) : $author$project$Route$ScheduleIndex;
	});
var $author$project$Views$Schedule$publishScheduleButton = function (scheduleData) {
	return (!A2(
		$elm$core$Maybe$withDefault,
		$author$project$SharedProjectRoleSchedules$emptySchedule,
		$elm$core$List$head(scheduleData.k)).bb) ? A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('project-menu-header-container', true)
					])),
				$elm$html$Html$Events$onClick($author$project$MainMsg$TogglePublishConfirmationModal)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h5,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('schedule-menu-button')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('PUBLISH SCHEDULE')
					]))
			])) : $elm$html$Html$text('');
};
var $author$project$Views$Schedule$scheduleLi = F3(
	function (schedule, projectId, viewingScheduleId) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('schedule-item', true),
							_Utils_Tuple2(
							'current-schedule-page',
							_Utils_eq(viewingScheduleId, schedule.aa))
						])),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$View(
						A2($author$project$Route$DayOfPage, projectId, schedule.aa)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(schedule.fy)
				]));
	});
var $author$project$Views$Schedule$scheduleMenuList = F4(
	function (projectId, title, schedules, viewingSchedule) {
		return ($elm$core$List$length(schedules) > 0) ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h3,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('schedule-list', true)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (schedule) {
							return A3($author$project$Views$Schedule$scheduleLi, schedule, projectId, viewingSchedule);
						},
						schedules))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Schedule$scheduleLists = F3(
	function (projectId, project, viewingSchedule) {
		var callbackSchedules = A2(
			$elm$core$List$filter,
			function (schedule) {
				return (schedule.fB === 'Callback') && schedule.bb;
			},
			project.k);
		var auditionSchedules = A2(
			$elm$core$List$filter,
			function (schedule) {
				return (schedule.fB === 'Audition') && schedule.bb;
			},
			project.k);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-schedules')
				]),
			_List_fromArray(
				[
					A4($author$project$Views$Schedule$scheduleMenuList, projectId, 'Live Audition Schedules', auditionSchedules, viewingSchedule),
					A4($author$project$Views$Schedule$scheduleMenuList, projectId, 'Live Callback Schedules', callbackSchedules, viewingSchedule)
				]));
	});
var $author$project$Views$Schedule$scheduleMenu = F2(
	function (model, projectId) {
		var _v0 = model.b$.aK;
		switch (_v0.$) {
			case 0:
				return A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$select,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('select-field'),
													$elm$html$Html$Attributes$value(projectId),
													$elm$html$Html$Events$onInput(
													function (selection) {
														return $author$project$MainMsg$View(
															A2($author$project$Views$Schedule$pageToView, selection, model.F));
													})
												]),
											A2(
												$elm$core$List$map,
												function (project) {
													return A2($author$project$Views$Schedule$optionField, project, projectId);
												},
												A2($elm$core$List$cons, $author$project$SharedProjectRoleSchedules$emptyProject, model.F))),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-drop-down-icon')
												]),
											_List_fromArray(
												[
													$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('schedule-menu-header', true),
													_Utils_Tuple2('back-to-project-button', true)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateCurrentProjectId(projectId))
										]),
									_List_fromArray(
										[
											$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft),
											$elm$html$Html$text(' Back To Project')
										])),
									$author$project$Views$Schedule$newScheduleButton(model.b$.aj.c$)
								]))
						]));
			case 3:
				var projectData = _v0.a;
				var scheduleType = _v0.b;
				return A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$select,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('select-field'),
													$elm$html$Html$Attributes$value(projectId),
													$elm$html$Html$Events$onInput(
													function (selection) {
														return $author$project$MainMsg$View(
															A2($author$project$Views$Schedule$pageToView, selection, model.F));
													})
												]),
											A2(
												$elm$core$List$map,
												function (project) {
													return A2($author$project$Views$Schedule$optionField, project, projectId);
												},
												A2($elm$core$List$cons, $author$project$SharedProjectRoleSchedules$emptyProject, model.F))),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-drop-down-icon')
												]),
											_List_fromArray(
												[
													$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('schedule-menu-header', true),
													_Utils_Tuple2('back-to-project-button', true)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$UpdateCurrentProjectId(projectData.c$))
										]),
									_List_fromArray(
										[
											$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronLeft),
											$elm$html$Html$text(' Back To Project')
										])),
									$author$project$Views$Schedule$addEditScheduleButton(model.b$),
									$author$project$Views$Schedule$publishScheduleButton(model.b$),
									A3($author$project$Views$Schedule$scheduleLists, projectId, model.b$.aj, model.b$.cf.aa)
								]))
						]));
			case 5:
				var projId = _v0.a;
				var scheduleId = _v0.b;
				return A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('day-of-schedule-project-name')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(model.b$.aj.bS)
												]))
										])),
									A2($author$project$Views$Schedule$backToSchedulesButton, projId, model),
									A3($author$project$Views$Schedule$scheduleLists, projId, model.b$.aj, model.b$.cf.aa)
								]))
						]));
			default:
				return A2(
					$elm$html$Html$section,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('project-menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('project-select')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$select,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('select-field'),
													$elm$html$Html$Attributes$value(model.b$.aj.c$),
													$elm$html$Html$Events$onInput(
													function (selection) {
														return $author$project$MainMsg$View(
															A2($author$project$Route$SchedulePage, selection, 'Audition'));
													})
												]),
											A2(
												$elm$core$List$map,
												function (project) {
													return A2($author$project$Views$Schedule$optionField, project, model.b$.aj.c$);
												},
												A2($elm$core$List$cons, $author$project$SharedProjectRoleSchedules$emptyProject, model.F))),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('project-drop-down-icon')
												]),
											_List_fromArray(
												[
													$frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$chevronDown)
												]))
										])),
									A2(
									$elm$html$Html$li,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('project-menu-header-container', true)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$ToggleScheduleForm(1))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h5,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('schedule-menu-button')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('NEW SCHEDULE')
												]))
										])),
									A2($elm$html$Html$li, _List_Nil, _List_Nil)
								]))
						]));
		}
	});
var $author$project$MainMsg$RemoveAddPublishedUser = function (a) {
	return {$: 213, a: a};
};
var $author$project$MainMsg$RemoveAddUser = function (a) {
	return {$: 211, a: a};
};
var $author$project$MainMsg$SwapPublishedUsers = function (a) {
	return {$: 212, a: a};
};
var $author$project$MainMsg$SwapUsers = function (a) {
	return {$: 210, a: a};
};
var $author$project$Views$Schedule$userSwapMenu = function (model) {
	var _v0 = function () {
		var _v1 = $author$project$Views$Schedule$schedulePublished(model.b$.k);
		if (_v1) {
			return _Utils_Tuple3('You are trying to make changes to a published Schedule!', $author$project$MainMsg$SwapPublishedUsers, $author$project$MainMsg$RemoveAddPublishedUser);
		} else {
			return _Utils_Tuple3('Looks like that time slot is taken!', $author$project$MainMsg$SwapUsers, $author$project$MainMsg$RemoveAddUser);
		}
	}();
	var modalText = _v0.a;
	var swapAction = _v0.b;
	var removeAction = _v0.c;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('user-swap-menu', true),
						_Utils_Tuple2('showing-swap-menu', model.b$.f2.a6)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(modalText)
					])),
				A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('What do you want to do?')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('swap-action-button'),
						$elm$html$Html$Events$onClick(
						swapAction(model.b$.f2))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Swap Users')
					])),
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('swap-action-button'),
						$elm$html$Html$Events$onClick(
						$author$project$MainMsg$CloseUserSwapMenu($author$project$SharedProjectRoleSchedules$emptyUserSwapData))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Cancel')
					]))
			]));
};
var $author$project$MainMsg$CreateSchedule = {$: 194};
var $author$project$Views$Schedule$autoScheduleRoles = F2(
	function (roles, autoSchedule) {
		return autoSchedule ? A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('The following Roles will be allowed to be scheduled: ')
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('auto-schedule-roles')
						]),
					A2(
						$elm$core$List$map,
						function (role) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(role)
									]));
						},
						roles))
				])) : $elm$html$Html$text('');
	});
var $author$project$Views$Schedule$findTime = function (modelTime) {
	return A2(
		$elm$core$Maybe$withDefault,
		{g: 'No Time Specified', bj: ''},
		$elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (time) {
					return _Utils_eq(time.bj, modelTime);
				},
				$author$project$InitData$timeValues))).g;
};
var $author$project$Views$Schedule$verifyScheduleView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('verify-schedule-container', true),
						_Utils_Tuple2('form-hiding', model.b$.b_ !== 2)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verify-header')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						'PLEASE VERIFY ' + ($elm$core$String$toUpper(model.b$.fB) + ' SCHEDULE'))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Schedule Dates: ' + ($author$project$Utils$formatDate(model.b$.fP) + (' - ' + $author$project$Utils$formatDate(model.b$.ee))))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Your Schedules will start at: ' + $author$project$Views$Schedule$findTime(model.b$.a2.i4))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Your Schedules will End at: ' + $author$project$Views$Schedule$findTime(model.b$.a2.hc))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'You have a break starting at: ' + $author$project$Views$Schedule$findTime(model.b$.a2.gC))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'Your break will end at: ' + $author$project$Views$Schedule$findTime(model.b$.a2.gB))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'The times will be broken up by ' + ($elm$core$String$fromInt(model.b$.a2.jk) + ' minute increments'))
					])),
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						'You can schedule a maximum of ' + ($elm$core$String$fromInt(model.b$.a2.gH) + ' talent per time slot'))
					])),
				A2($author$project$Views$Schedule$autoScheduleRoles, model.b$.a2.ft, model.b$.gz),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('verify-schedule-container-buttons')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleScheduleForm(1))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Edit Schedule')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$MainMsg$CreateSchedule)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create Schedule')
							]))
					]))
			]));
};
var $author$project$Views$Schedule$scheduleIndexView = F4(
	function (model, projectId, scheduleType, confirmationOpen) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('project-details-page')
				]),
			_List_fromArray(
				[
					A2($author$project$Views$Schedule$scheduleMenu, model, projectId),
					$author$project$Views$Schedule$scheduleFormView(model),
					$author$project$Views$Schedule$verifyScheduleView(model),
					A2(
					$author$project$Views$Schedule$modal,
					model.b$.b_ === 2,
					$author$project$MainMsg$ToggleScheduleForm(0)),
					$author$project$Views$Schedule$savingScheduleView(model),
					$author$project$Views$Schedule$scheduleHeader(model),
					$author$project$Views$Schedule$scheduleContainer(model),
					$author$project$Views$Schedule$userSwapMenu(model),
					$author$project$Views$Schedule$movePublishedUserModal(model),
					A2($author$project$Views$Schedule$modal, (!model.cv) || (model.cv === 1), $author$project$MainMsg$ClosedPublishedModal),
					A2(
					$author$project$Views$Schedule$modal,
					model.b$.f2.a6,
					$author$project$MainMsg$CloseUserSwapMenu($author$project$SharedProjectRoleSchedules$emptyUserSwapData)),
					$author$project$Views$Schedule$publishConfirmationModal(confirmationOpen),
					$author$project$Views$TalentModal$talentSearchResultModal(model.v)(model.bq)(model.B)(model.aN)(model.aJ)(model.cH)(model.A)(
					$author$project$Views$Schedule$currentPage(model.o))(
					_List_fromArray(
						[$author$project$SharedProjectRoleSchedules$emptyProject]))(
					_List_fromArray(
						[$author$project$SharedProjectRoleSchedules$emptyRole]))(model.aV)(model.d6)(model.b$.aj)(model.bd.h4)(model.aO)(model.E)(model.L.dP)(model.b$.cf.gW)(model.b$)(model.cR)(model.cB)(model.cI)(model.cj)
				]));
	});
var $author$project$Views$Auth$talentSignupForm = function (email) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserFirstName)),
								$elm$html$Html$Attributes$placeholder('First Name')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserLastName)),
								$elm$html$Html$Attributes$placeholder('Last Name')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$value(email),
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserEmail)),
								$elm$html$Html$Attributes$placeholder('Email')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPassword)),
								$elm$html$Html$Attributes$placeholder('Password'),
								$elm$html$Html$Attributes$type_('password')
							]),
						_List_Nil)
					])),
				A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Events$onInput(
								A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateUserMsg, $author$project$User$UserPasswordConfirmation)),
								$elm$html$Html$Attributes$placeholder('Confirm Password'),
								$elm$html$Html$Attributes$type_('password')
							]),
						_List_Nil)
					]))
			]));
};
var $author$project$Views$Auth$talentSignupView = F3(
	function (err, email, logoPath) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('user-form')
				]),
			_List_fromArray(
				[
					$author$project$Views$Auth$errorMessage(err),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('form-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$Views$Auth$logoImage(logoPath)
								])),
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Talent Registration Sign Up')
								])),
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('form main-form'),
									$elm$html$Html$Attributes$autocomplete(false)
								]),
							_List_fromArray(
								[
									$author$project$Views$Auth$talentSignupForm(email),
									A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													$elm$html$Html$Events$onClick($author$project$MainMsg$RegisterUser),
													$elm$html$Html$Attributes$class('button full')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('NEXT')
												]))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('signup-switch-container')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Already have an account?'),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$Login)),
											$elm$html$Html$Attributes$class('link-button signup-switch')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Login »')
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('sign-up-options')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$DirectorRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Casting Director Sign-Up »')
										])),
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Events$onClick(
											$author$project$MainMsg$View($author$project$Route$AgencyRegistration)),
											$elm$html$Html$Attributes$class('link-button signup-switch casting-signup')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Agency Sign-Up »')
										]))
								]))
						]))
				]));
	});
var $author$project$Project$BulkNew = 2;
var $author$project$Project$New = 0;
var $author$project$MainMsg$UpdateTalentFilterExpand = function (a) {
	return {$: 246, a: a};
};
var $author$project$Views$UpdatedTalentSearch$expandMenuButton = function (menuExpanded) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('expand-menu-button', true),
						_Utils_Tuple2('showing-expand-button', !menuExpanded)
					])),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$UpdateTalentFilterExpand(7))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-chevron-right')
					]),
				_List_Nil)
			]));
};
var $author$project$Views$UpdatedTalentSearch$selectedTalentView = function (selections) {
	return function (view) {
		return function (action) {
			return function (projects) {
				return function (roles) {
					return function (pipeline) {
						return function (actionSet) {
							return function (projectId) {
								return function (twilioStatus) {
									return function (userProfile) {
										return function (newMessageBody) {
											switch (view) {
												case 0:
													return A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('selection-container')
																	]),
																_List_Nil)
															]));
												case 2:
													return A2(
														$elm$html$Html$div,
														_List_Nil,
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$class('modal-open'),
																		$elm$html$Html$Events$onClick(
																		$author$project$MainMsg$ToggleCandidateScreen(1))
																	]),
																_List_Nil),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2('full-selections-container', true),
																				_Utils_Tuple2('selections-full', true)
																			]))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$elm$html$Html$h2,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$elm$html$Html$text('Selections')
																			])),
																		A2(
																		$elm$html$Html$ul,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('candidates-full-screen')
																			]),
																		A2(
																			$elm$core$List$map,
																			function (talent) {
																				return A5(
																					$author$project$Utils$talentCard,
																					talent,
																					selections,
																					A3($author$project$MainMsg$ToggleTalentResultModal, talent, $author$project$Job$emptyApplicant, ''),
																					A2($author$project$MainMsg$ToggleSelectedTalent, talent.c$, talent),
																					$author$project$MainMsg$UpdateTalentMenuOptions(
																						$author$project$User$ToggleMenuModal(talent)));
																			},
																			selections)),
																		A2(
																		$elm$html$Html$div,
																		_List_fromArray(
																			[
																				$elm$html$Html$Attributes$class('bulk-quick-actions-container')
																			]),
																		_List_fromArray(
																			[
																				$author$project$Views$TalentModal$quickActionBar(action)($author$project$User$emptySearchTalentProfile)(selections)($author$project$Job$emptyApplicant)(pipeline)(actionSet)(projects)(roles)(projectId)('')($author$project$SharedProjectRoleSchedules$emptyProject)('')(twilioStatus)(userProfile)(newMessageBody)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)
																			]))
																	]))
															]));
												default:
													return $elm$html$Html$text('');
											}
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Filter$UpdateEyeColorFilters = function (a) {
	return {$: 9, a: a};
};
var $author$project$Filter$UpdateGenderFilters = function (a) {
	return {$: 8, a: a};
};
var $author$project$Filter$UpdateMaxAge = function (a) {
	return {$: 7, a: a};
};
var $author$project$Filter$UpdateMaxHeight = function (a) {
	return {$: 2, a: a};
};
var $author$project$Filter$UpdateMaxWaistSize = function (a) {
	return {$: 5, a: a};
};
var $author$project$Filter$UpdateMaxWeight = function (a) {
	return {$: 3, a: a};
};
var $author$project$Filter$UpdateMinAge = function (a) {
	return {$: 6, a: a};
};
var $author$project$Filter$UpdateMinHeight = function (a) {
	return {$: 1, a: a};
};
var $author$project$Filter$UpdateMinWaistSize = function (a) {
	return {$: 4, a: a};
};
var $author$project$Filter$UpdateMinWeight = function (a) {
	return {$: 0, a: a};
};
var $author$project$Filter$UpdateRaceFilters = function (a) {
	return {$: 10, a: a};
};
var $author$project$InitData$ethnicity = _List_fromArray(
	['African American', 'Asian', 'Caucasian', 'East Indian', 'Latinx', 'Middle Eastern', 'Ethnically Ambiguous', 'Native American', 'Pacific Islander']);
var $author$project$Views$UpdatedTalentSearch$menuOpen = function (expanded) {
	return expanded ? $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$minus) : $frandibar$elm_font_awesome_5$FontAwesome$icon($frandibar$elm_font_awesome_5$FontAwesome$plus);
};
var $author$project$MainMsg$UpdateSearchingProject = function (a) {
	return {$: 312, a: a};
};
var $author$project$Views$UpdatedTalentSearch$projectSelection = function (model) {
	var roleOptions = A2(
		$elm$core$List$map,
		function (role) {
			return {aa: role.c$, bS: role.bS};
		},
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.gf;
			},
			A2(
				$elm$core$List$filter,
				A2(
					$author$project$Utils$eq,
					function ($) {
						return $.iw;
					},
					model.ac),
				model.aB)));
	var projectOptions = A2(
		$elm$core$List$map,
		function (project) {
			return {aa: project.c$, bS: project.bS};
		},
		A2(
			$elm$core$List$filter,
			function ($) {
				return $.hB;
			},
			model.F));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('project-search-selection')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$Views$Form$agencySelectField,
				$author$project$MainMsg$UpdateSearchingProject,
				'Project',
				A2(
					$elm$core$List$cons,
					{aa: '', bS: 'Select Project'},
					projectOptions),
				model.ac),
				A4(
				$author$project$Views$Form$agencySelectField,
				$author$project$MainMsg$UpdateSearchingRole,
				'Role',
				A2(
					$elm$core$List$cons,
					{aa: '', bS: 'Select Role'},
					roleOptions),
				model.bA)
			]));
};
var $author$project$MainMsg$UpdateTalentFilterValues = function (a) {
	return {$: 73, a: a};
};
var $author$project$Views$UpdatedTalentSearch$filterCheckboxOption = F3(
	function (option, filterType, selectedOptions) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('filter-option-container'),
					$elm$html$Html$Events$onClick(
					$author$project$MainMsg$UpdateTalentFilterValues(
						filterType(option)))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'option-selected',
									A2($elm$core$List$member, option, selectedOptions)),
									_Utils_Tuple2('check-icon', true)
								]))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('far fa-check-circle')
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(option)
						]))
				]));
	});
var $author$project$Views$UpdatedTalentSearch$talentCheckboxFilterOption = F6(
	function (filterName, options, filterMsg, selectedOptions, expanded, filterExpandMsg) {
		return A2(
			$elm$html$Html$li,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-filter-option')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('talent-filter-header'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateTalentFilterExpand(filterExpandMsg))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('filter-title-reset-container')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h5,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(filterName)
										]))
								])),
							$author$project$Views$UpdatedTalentSearch$menuOpen(expanded)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('filter-options', true),
									_Utils_Tuple2('filter-options-expanded', expanded)
								]))
						]),
					A2(
						$elm$core$List$map,
						function (option) {
							return A3($author$project$Views$UpdatedTalentSearch$filterCheckboxOption, option, filterMsg, selectedOptions);
						},
						options))
				]));
	});
var $author$project$Views$UpdatedTalentSearch$floatOptionsHigherThanMin = F2(
	function (lowValue, values) {
		return (!lowValue) ? values : A2(
			$elm$core$List$filter,
			function (option) {
				return _Utils_cmp(option.bj, lowValue) > 0;
			},
			values);
	});
var $author$project$Views$UpdatedTalentSearch$floatOptionsLowerThanMax = F2(
	function (highValue, values) {
		return (!highValue) ? values : A2(
			$elm$core$List$filter,
			function (option) {
				return _Utils_cmp(option.bj, highValue) < 0;
			},
			values);
	});
var $author$project$Views$UpdatedTalentSearch$talentFloatRangeFilterOption = F7(
	function (lowFilterTitle, highFilterTitle, options, lowFilterMsg, highFilterMsg, lowValue, highValue) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('range-option')
						]),
					A4(
						$author$project$Views$Form$selectFloatField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentFilterValues, lowFilterMsg),
						lowFilterTitle,
						A2($author$project$Views$UpdatedTalentSearch$floatOptionsLowerThanMax, highValue, options),
						lowValue)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('range-option')
						]),
					A4(
						$author$project$Views$Form$selectFloatField,
						A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentFilterValues, highFilterMsg),
						highFilterTitle,
						A2($author$project$Views$UpdatedTalentSearch$floatOptionsHigherThanMin, lowValue, options),
						highValue))
				]));
	});
var $author$project$Views$UpdatedTalentSearch$optionsHigherThanMin = F2(
	function (lowValue, values) {
		return (!lowValue) ? values : A2(
			$elm$core$List$filter,
			function (value) {
				return _Utils_cmp(value, lowValue) > 0;
			},
			values);
	});
var $author$project$Views$UpdatedTalentSearch$optionsLowerThanMax = F2(
	function (highValue, values) {
		return (!highValue) ? values : A2(
			$elm$core$List$filter,
			function (value) {
				return _Utils_cmp(value, highValue) < 0;
			},
			values);
	});
var $author$project$Views$UpdatedTalentSearch$talentRangeFilterOption = function (filterName) {
	return function (lowFilterTitle) {
		return function (highFilterTitle) {
			return function (options) {
				return function (lowFilterMsg) {
					return function (highFilterMsg) {
						return function (lowValue) {
							return function (highValue) {
								return function (expanded) {
									return function (filterExpandMsg) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('filter-range-option-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('talent-filter-header'),
															$elm$html$Html$Events$onClick(
															$author$project$MainMsg$UpdateTalentFilterExpand(filterExpandMsg))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('filter-title-reset-container')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h5,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(filterName)
																		]))
																])),
															$author$project$Views$UpdatedTalentSearch$menuOpen(expanded)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('range-options-container', true),
																	_Utils_Tuple2('range-expanded', expanded)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('range-option')
																]),
															A4(
																$author$project$Views$Form$selectIntField,
																A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentFilterValues, lowFilterMsg),
																lowFilterTitle,
																A2(
																	$author$project$Views$UpdatedTalentSearch$optionsLowerThanMax,
																	A2(
																		$elm$core$Maybe$withDefault,
																		0,
																		$elm$core$String$toInt(highValue)),
																	options),
																lowValue)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('range-option')
																]),
															A4(
																$author$project$Views$Form$selectIntField,
																A2($elm$core$Basics$composeL, $author$project$MainMsg$UpdateTalentFilterValues, highFilterMsg),
																highFilterTitle,
																A2(
																	$author$project$Views$UpdatedTalentSearch$optionsHigherThanMin,
																	A2(
																		$elm$core$Maybe$withDefault,
																		0,
																		$elm$core$String$toInt(lowValue)),
																	options),
																highValue))
														]))
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Views$UpdatedTalentSearch$heightOptionsHigherThanMin = F2(
	function (lowValue, values) {
		return (!lowValue) ? A2(
			$elm$core$List$map,
			function (value) {
				return {
					j: $elm$core$String$fromInt(value.j),
					g: value.g
				};
			},
			values) : A2(
			$elm$core$List$map,
			function (opt) {
				return {
					j: $elm$core$String$fromInt(opt.j),
					g: opt.g
				};
			},
			A2(
				$elm$core$List$filter,
				function (value) {
					return _Utils_cmp(value.j, lowValue) > 0;
				},
				values));
	});
var $author$project$Views$UpdatedTalentSearch$heightOptionsLowerThanMax = F2(
	function (highValue, values) {
		return (!highValue) ? A2(
			$elm$core$List$map,
			function (value) {
				return {
					j: $elm$core$String$fromInt(value.j),
					g: value.g
				};
			},
			values) : A2(
			$elm$core$List$map,
			function (opt) {
				return {
					j: $elm$core$String$fromInt(opt.j),
					g: opt.g
				};
			},
			A2(
				$elm$core$List$filter,
				function (value) {
					return _Utils_cmp(value.j, highValue) < 0;
				},
				values));
	});
var $author$project$Views$UpdatedTalentSearch$talentRangeHeightFilterOption = function (filterName) {
	return function (lowFilterTitle) {
		return function (highFilterTitle) {
			return function (options) {
				return function (lowFilterMsg) {
					return function (highFilterMsg) {
						return function (lowValue) {
							return function (highValue) {
								return function (expanded) {
									return function (filterExpandMsg) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('filter-range-option-container')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$class('talent-filter-header'),
															$elm$html$Html$Events$onClick(
															$author$project$MainMsg$UpdateTalentFilterExpand(filterExpandMsg))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('filter-title-reset-container')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$h5,
																	_List_Nil,
																	_List_fromArray(
																		[
																			$elm$html$Html$text(filterName)
																		]))
																])),
															$author$project$Views$UpdatedTalentSearch$menuOpen(expanded)
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$classList(
															_List_fromArray(
																[
																	_Utils_Tuple2('range-options-container', true),
																	_Utils_Tuple2('range-expanded', expanded)
																]))
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('range-option')
																]),
															A5(
																$author$project$Views$Form$selectHeightField,
																$author$project$MainMsg$UpdateTalentFilterValues,
																lowFilterMsg,
																lowFilterTitle,
																A2(
																	$author$project$Views$UpdatedTalentSearch$heightOptionsLowerThanMax,
																	A2(
																		$elm$core$Maybe$withDefault,
																		0,
																		$elm$core$String$toInt(highValue)),
																	A2(
																		$elm$core$List$map,
																		function (option) {
																			return {
																				j: A2(
																					$elm$core$Maybe$withDefault,
																					0,
																					$elm$core$String$toInt(option.j)),
																				g: option.g
																			};
																		},
																		options)),
																lowValue)),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('range-option')
																]),
															A5(
																$author$project$Views$Form$selectHeightField,
																$author$project$MainMsg$UpdateTalentFilterValues,
																highFilterMsg,
																highFilterTitle,
																A2(
																	$author$project$Views$UpdatedTalentSearch$heightOptionsHigherThanMin,
																	A2(
																		$elm$core$Maybe$withDefault,
																		0,
																		$elm$core$String$toInt(lowValue)),
																	A2(
																		$elm$core$List$map,
																		function (option) {
																			return {
																				j: A2(
																					$elm$core$Maybe$withDefault,
																					0,
																					$elm$core$String$toInt(option.j)),
																				g: option.g
																			};
																		},
																		options)),
																highValue))
														]))
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Filter$ClearAllFilters = {$: 13};
var $author$project$Views$UpdatedTalentSearch$backButton = F2(
	function (projectId, userRole) {
		switch (userRole) {
			case 3:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('back-to-project-button', true),
									_Utils_Tuple2('showing-project-button', projectId !== '')
								])),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$RedirectPage(
								$author$project$Route$Job(projectId)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Back To Jobs'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]));
			case 4:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('back-to-project-button', true),
									_Utils_Tuple2('showing-project-button', projectId !== '')
								])),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$RedirectPage(
								$author$project$Route$Job(projectId)))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Back To Jobs'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]));
			case 1:
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('back-to-project-button', true),
									_Utils_Tuple2('showing-project-button', projectId !== '')
								])),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateCurrentProjectId(projectId))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('View Project'),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-right')
								]),
							_List_Nil)
						]));
			default:
				return $elm$html$Html$text('');
		}
	});
var $author$project$Views$UpdatedTalentSearch$talentSearchMenuHeader = F2(
	function (projectId, userRole) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-search-menu-header')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('filter-collapse-container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('fas fa-chevron-left'),
									$elm$html$Html$Events$onClick(
									$author$project$MainMsg$UpdateTalentFilterExpand(7))
								]),
							_List_Nil),
							A2($author$project$Views$UpdatedTalentSearch$backButton, projectId, userRole)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('reset-button'),
							$elm$html$Html$Events$onClick(
							$author$project$MainMsg$UpdateTalentFilterValues($author$project$Filter$ClearAllFilters))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Reset all filters')
						]))
				]));
	});
var $author$project$Views$UpdatedTalentSearch$talentSearchMenu = function (model) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('talent-search-menu', true),
						_Utils_Tuple2('search-open', model.O.eN)
					]))
			]),
		_List_fromArray(
			[
				A2($author$project$Views$UpdatedTalentSearch$talentSearchMenuHeader, model.ac, model.E.V),
				$author$project$Views$UpdatedTalentSearch$projectSelection(model),
				A6($author$project$Views$UpdatedTalentSearch$talentCheckboxFilterOption, 'Gender', $author$project$InitData$genders, $author$project$Filter$UpdateGenderFilters, model.r.hr, model.O.es, 0),
				$author$project$Views$UpdatedTalentSearch$talentRangeFilterOption('Age')('Minimum Age')('Maximum Age')(
				A2($elm$core$List$range, 1, 100))($author$project$Filter$UpdateMinAge)($author$project$Filter$UpdateMaxAge)(model.r.c4)(model.r.c2)(model.O.dB)(4),
				A6($author$project$Views$UpdatedTalentSearch$talentCheckboxFilterOption, 'Eye Color', $author$project$InitData$eyeColors, $author$project$Filter$UpdateEyeColorFilters, model.r.hj, model.O.en, 5),
				A6($author$project$Views$UpdatedTalentSearch$talentCheckboxFilterOption, 'Ethnic Appearance', $author$project$InitData$ethnicity, $author$project$Filter$UpdateRaceFilters, model.r.iB, model.O.eh, 6),
				$author$project$Views$UpdatedTalentSearch$talentRangeHeightFilterOption('Height')('Minimum Height')('Maximum Height')($author$project$InitData$heightValues)($author$project$Filter$UpdateMinHeight)($author$project$Filter$UpdateMaxHeight)(model.r.hY)(model.r.hR)(model.O.ev)(1),
				$author$project$Views$UpdatedTalentSearch$talentRangeFilterOption('Weight')('Minimum Weight')('Maximum Weight')(
				A2($elm$core$List$range, 1, 500))($author$project$Filter$UpdateMinWeight)($author$project$Filter$UpdateMaxWeight)(model.r.eQ)(model.r.eM)(model.O.gb)(2),
				A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('filter-range-option-container')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-filter-header'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$UpdateTalentFilterExpand(3))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('filter-title-reset-container')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$h5,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Body Sizes')
											]))
									])),
								$author$project$Views$UpdatedTalentSearch$menuOpen(model.O.fM)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2('range-options-container', true),
								_Utils_Tuple2('range-expanded', model.O.fM)
							]))
					]),
				_List_fromArray(
					[
						A7(
						$author$project$Views$UpdatedTalentSearch$talentFloatRangeFilterOption,
						'Minimum Waist Size',
						'Maximum Waist Size',
						$author$project$Talent$waistSizes,
						$author$project$Filter$UpdateMinWaistSize,
						$author$project$Filter$UpdateMaxWaistSize,
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toFloat(model.r.hX)),
						A2(
							$elm$core$Maybe$withDefault,
							0,
							$elm$core$String$toFloat(model.r.hQ)))
					]))
			]));
};
var $author$project$MainMsg$LoadMoreTalent = function (a) {
	return {$: 248, a: a};
};
var $author$project$Views$UpdatedTalentSearch$loadMoreButton = function (talent) {
	return talent.dT ? A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('load-more-button'),
				$elm$html$Html$Events$onClick(
				$author$project$MainMsg$LoadMoreTalent(talent.d4))
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('LOAD MORE')
			])) : $elm$html$Html$text('');
};
var $author$project$Filter$UpdateSearchName = function (a) {
	return {$: 11, a: a};
};
var $author$project$Views$UpdatedTalentSearch$searchField = function (searchName) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('talent-search-field-container')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('fas fa-search search-icon')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Attributes$class('talent-search-field'),
						$elm$html$Html$Attributes$placeholder('Search by name'),
						$elm$html$Html$Attributes$value(searchName),
						$elm$html$Html$Events$onInput(
						function (val) {
							return $author$project$MainMsg$UpdateTalentFilterValues(
								$author$project$Filter$UpdateSearchName(val));
						})
					]),
				_List_Nil)
			]));
};
var $author$project$MainMsg$SelectAllTalent = {$: 247};
var $author$project$Views$UpdatedTalentSearch$selectAllButton = function (selectedTalent) {
	return (selectedTalent > 0) ? A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$RemoveAllCandidates)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('UNSELECT ALL')
			])) : A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Events$onClick($author$project$MainMsg$SelectAllTalent)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text('SELECT ALL')
			]));
};
var $author$project$Views$UpdatedTalentSearch$selectedUsersButton = F3(
	function (selectedTalent, userProfile, talent) {
		if (selectedTalent > 0) {
			var _v0 = userProfile.V;
			switch (_v0) {
				case 3:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$MoveNewCandidate, talent, ''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Submit ' + ($elm$core$String$fromInt(selectedTalent) + ' To Role'))
							]));
				case 4:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								A2($author$project$MainMsg$MoveNewCandidate, talent, ''))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								'Submit ' + ($elm$core$String$fromInt(selectedTalent) + ' To Role'))
							]));
				case 1:
					return A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('selected-users-button'),
								$elm$html$Html$Events$onClick(
								$author$project$MainMsg$ToggleCandidateScreen(2))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(selectedTalent) + ' selected users')
							]));
				default:
					return $elm$html$Html$text('');
			}
		} else {
			return $elm$html$Html$text('');
		}
	});
var $author$project$Views$UpdatedTalentSearch$searchHeader = F3(
	function (searchName, selectedTalent, userProfile) {
		var talentLength = $elm$core$List$length(selectedTalent);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('talent-search-header-container')
				]),
			_List_fromArray(
				[
					A3($author$project$Views$UpdatedTalentSearch$selectedUsersButton, talentLength, userProfile, selectedTalent),
					$author$project$Views$UpdatedTalentSearch$searchField(searchName),
					$author$project$Views$UpdatedTalentSearch$selectAllButton(talentLength)
				]));
	});
var $author$project$Views$UpdatedTalentSearch$talentSearchResults = function (model) {
	var _v0 = model.bg;
	switch (_v0.$) {
		case 1:
			return A2($elm$html$Html$div, _List_Nil, _List_Nil);
		case 2:
			return $author$project$Utils$loader;
		case 3:
			var res = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('talent-search-container')
					]),
				_List_fromArray(
					[
						A3($author$project$Views$UpdatedTalentSearch$searchHeader, model.r.iS, model.B, model.E),
						A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('talent-search-results-container')
							]),
						A2(
							$elm$core$List$map,
							function (talent) {
								return A5(
									$author$project$Utils$talentCard,
									talent,
									model.B,
									A3($author$project$MainMsg$ToggleTalentResultModal, talent, $author$project$Job$emptyApplicant, ''),
									A2($author$project$MainMsg$ToggleSelectedTalent, talent.c$, talent),
									$author$project$MainMsg$UpdateTalentMenuOptions(
										$author$project$User$ToggleMenuModal(talent)));
							},
							res)),
						$author$project$Views$UpdatedTalentSearch$loadMoreButton(
						A2(
							$elm$core$Maybe$withDefault,
							$author$project$User$emptySearchTalentProfile,
							$elm$core$List$head(
								$elm$core$List$reverse(res))))
					]));
		default:
			var err = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text('error!')
					]));
	}
};
var $author$project$Views$UpdatedTalentSearch$updatedTalentSearchView = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('talent-search-page-container')
			]),
		_List_fromArray(
			[
				$author$project$Views$UpdatedTalentSearch$talentSearchMenu(model),
				$author$project$Views$UpdatedTalentSearch$expandMenuButton(model.O.eN),
				$author$project$Views$UpdatedTalentSearch$talentSearchResults(model),
				$author$project$Views$TalentModal$talentSearchResultModal(model.v)(model.bq)(model.B)(model.aN)(model.aJ)($author$project$Job$emptyApplicant)(model.A)(0)(model.F)(model.aB)(model.aV)('')($author$project$SharedProjectRoleSchedules$emptyProject)(model.bd.h4)(model.aO)(model.E)(model.L.dP)('')($author$project$SharedProjectRoleSchedules$initialSchedulePageData)($author$project$User$emptyVideo)($author$project$SharedProjectRoleSchedules$Waiting)(false)(model.cj),
				$author$project$Views$UpdatedTalentSearch$selectedTalentView(model.B)(model.N)(model.aJ)(model.F)(model.aB)(model.A)(2)(model.aV)(model.aO)(model.E)(model.L.dP),
				A3(
				$author$project$Views$TalentOptions$talentOptionsModal,
				model.W,
				model.E,
				$author$project$Utils$roleDataOptions(
					A2(
						$elm$core$List$filter,
						function (role) {
							return _Utils_eq(role.iw, model.ac);
						},
						model.aB)))
			]));
};
var $author$project$Views$Verification$verificationView = A2(
	$elm$html$Html$div,
	_List_Nil,
	_List_fromArray(
		[
			$elm$html$Html$text('You\'re Verified!')
		]));
var $author$project$Main$showView = function (model) {
	if (model.R === 2) {
		var _v0 = model.o;
		switch (_v0.$) {
			case 6:
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			case 10:
				return $author$project$Views$Messages$inboxView(
					{F: model.F, cH: model.cH, n: model.p.n, bo: model.bo, ca: model.ca, q: model.q, t: model.p.t, bq: model.bq, d6: model.d6, ce: model.ce, cj: model.cj, hU: model.L.dP, hV: model.p.hV, L: model.L, bT: model.bT, A: model.A, aV: model.aV, aJ: model.aJ, bd: model.bd, B: model.B, aL: model.aL, aN: model.aN, aO: model.aO, E: model.E, v: model.v});
			case 13:
				return $author$project$Views$Dashboard$dashboardView(model);
			case 14:
				return $author$project$Views$Profile$talentProfileView(model.h)(model.E)(model.eg)(model.l)(model.ab)(model.cx)(model.as)(model.ad)(model.aA)(model.aE);
			case 15:
				return $author$project$Views$Profile$agencyProfileView(model);
			case 16:
				return $author$project$Views$Profile$agentProfileView(model);
			case 18:
				var a = _v0.a;
				return A2($author$project$Main$profileSettingsView, model, a);
			case 20:
				return $author$project$Views$UpdatedTalentSearch$updatedTalentSearchView(model);
			case 21:
				var i = _v0.a;
				return $author$project$Views$Project$projectView(model);
			case 19:
				var s = _v0.a;
				return A2($author$project$Main$profileSettingsViewContent, model, s);
			case 11:
				return $author$project$Views$Project$roleView(model);
			case 12:
				return $author$project$Views$Project$roleView(model);
			case 22:
				var id = _v0.a;
				var code = _v0.b;
				return $author$project$Views$Verification$verificationView;
			case 8:
				return A3($author$project$Views$Job$jobIndexView, model, model.av, model.q);
			case 7:
				return $author$project$Views$Job$jobViewListing(model);
			case 9:
				return A2($author$project$Views$Job$myJobsView, model, model.q);
			case 23:
				return A4($author$project$Views$Schedule$scheduleIndexView, model, model.d6, '', model.q);
			case 24:
				var i = _v0.a;
				var scheduleType = _v0.b;
				return A4($author$project$Views$Schedule$scheduleIndexView, model, i, scheduleType, model.q);
			case 25:
				var projectId = _v0.a;
				var scheduleId = _v0.b;
				return A4($author$project$Views$Schedule$scheduleIndexView, model, scheduleId, '', model.q);
			default:
				return $author$project$Views$Dashboard$dashboardView(model);
		}
	} else {
		if (model.R === 1) {
			var _v1 = model.o;
			if (_v1.$ === 22) {
				return $author$project$Views$Verification$verificationView;
			} else {
				return $author$project$Main$loadingView;
			}
		} else {
			var _v2 = model.o;
			switch (_v2.$) {
				case 0:
					return A2($author$project$Views$Auth$loginView, model.b0, model.aD.au);
				case 1:
					return A3($author$project$Views$Auth$talentSignupView, model.aM, model.aZ.bv, model.aD.au);
				case 5:
					return A3($author$project$Views$Auth$agencySignupView, model.aM, model.aZ.bv, model.aD.au);
				case 2:
					var email = _v2.a;
					return A3($author$project$Views$Auth$talentSignupView, model.aM, model.aZ.bv, model.aD.au);
				case 3:
					var email = _v2.a;
					return A4($author$project$Views$Auth$directorSignupView, model.q, model.aM, model.aZ.bv, model.aD.au);
				case 4:
					return A4($author$project$Views$Auth$directorSignupView, model.q, model.aM, model.aZ.bv, model.aD.au);
				case 26:
					var secretKey = _v2.a;
					return A4($author$project$Views$Auth$collaboratorsSignupView, model.q, model.aZ, model.aD.au, model.aM);
				case 27:
					var secretKey = _v2.a;
					return A4($author$project$Views$Auth$agentsSignupView, model.q, model.aZ, model.aD.au, model.aM);
				case 17:
					return $author$project$Views$Dashboard$notFoundView;
				case 22:
					return $author$project$Views$Verification$verificationView;
				default:
					return A2($author$project$Views$Auth$loginView, model.b0, model.aD.au);
			}
		}
	}
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Main$version = 'V0.0.36';
var $author$project$Main$view = function (model) {
	var _v0 = model.o;
	switch (_v0.$) {
		case 0:
			return {
				dP: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				x: model.x
			};
		case 1:
			return {
				dP: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				x: model.x
			};
		case 5:
			return {
				dP: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				x: model.x
			};
		case 2:
			var email = _v0.a;
			return {
				dP: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				x: model.x
			};
		case 3:
			var email = _v0.a;
			return {
				dP: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				x: model.x
			};
		case 4:
			return {
				dP: _List_fromArray(
					[
						$author$project$Main$messageBox(model),
						$author$project$Main$showView(model),
						A2(
						$elm$html$Html$small,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('version')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text($author$project$Main$version)
							]))
					]),
				x: model.x
			};
		default:
			return {
				dP: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('app-wrapper')
							]),
						_List_fromArray(
							[
								$author$project$Main$messageBox(model),
								$author$project$Views$Nav$navBar(model),
								$author$project$Main$showView(model),
								A2(
								$elm$html$Html$small,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('version')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text($author$project$Main$version)
									]))
							]))
					]),
				x: model.x
			};
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{
		hx: F3(
			function (flags, url, key) {
				return A3($author$project$Main$init, key, url, flags);
			}),
		$8: $author$project$MainMsg$ChangedUrl,
		ig: $author$project$MainMsg$ClickedLink,
		i8: $author$project$Main$subscriptions,
		jr: $author$project$Main$update,
		jz: $author$project$Main$view
	});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (slayt_square) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (logoPath) {
					return $elm$json$Json$Decode$succeed(
						{au: logoPath, i1: slayt_square});
				},
				A2($elm$json$Json$Decode$field, 'logoPath', $elm$json$Json$Decode$string));
		},
		A2($elm$json$Json$Decode$field, 'slayt_square', $elm$json$Json$Decode$string)))(0)}});}(this));